var zu = Object.defineProperty;
var Uu = (e, t, n) => t in e ? zu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var zs = (e, t, n) => Uu(e, typeof t != "symbol" ? t + "" : t, n);
import * as Ie from "react";
import qu, { createContext as dt, useContext as Se, useState as j, useEffect as le, useCallback as qe, forwardRef as vt, createElement as en, isValidElement as ai, useRef as We, useLayoutEffect as Hu, useId as Wu, useMemo as fn, Fragment as dl, useInsertionEffect as Ku, Component as Yu } from "react";
import { useNavigate as Be, useLocation as ul, Link as _, useParams as Ha, NavLink as ri, Navigate as At, useSearchParams as Ee, Routes as Gu, Route as de } from "react-router-dom";
var aa = { exports: {} }, ls = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ii;
function Xu() {
  if (ii) return ls;
  ii = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(a, r, i) {
    var o = null;
    if (i !== void 0 && (o = "" + i), r.key !== void 0 && (o = "" + r.key), "key" in r) {
      i = {};
      for (var l in r)
        l !== "key" && (i[l] = r[l]);
    } else i = r;
    return r = i.ref, {
      $$typeof: e,
      type: a,
      key: o,
      ref: r !== void 0 ? r : null,
      props: i
    };
  }
  return ls.Fragment = t, ls.jsx = n, ls.jsxs = n, ls;
}
var cs = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oi;
function Ju() {
  return oi || (oi = 1, process.env.NODE_ENV !== "production" && function() {
    function e(N) {
      if (N == null) return null;
      if (typeof N == "function")
        return N.$$typeof === V ? null : N.displayName || N.name || null;
      if (typeof N == "string") return N;
      switch (N) {
        case y:
          return "Fragment";
        case k:
          return "Profiler";
        case b:
          return "StrictMode";
        case w:
          return "Suspense";
        case D:
          return "SuspenseList";
        case I:
          return "Activity";
      }
      if (typeof N == "object")
        switch (typeof N.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), N.$$typeof) {
          case p:
            return "Portal";
          case v:
            return N.displayName || "Context";
          case g:
            return (N._context.displayName || "Context") + ".Consumer";
          case C:
            var L = N.render;
            return N = N.displayName, N || (N = L.displayName || L.name || "", N = N !== "" ? "ForwardRef(" + N + ")" : "ForwardRef"), N;
          case P:
            return L = N.displayName || null, L !== null ? L : e(N.type) || "Memo";
          case $:
            L = N._payload, N = N._init;
            try {
              return e(N(L));
            } catch {
            }
        }
      return null;
    }
    function t(N) {
      return "" + N;
    }
    function n(N) {
      try {
        t(N);
        var L = !1;
      } catch {
        L = !0;
      }
      if (L) {
        L = console;
        var M = L.error, F = typeof Symbol == "function" && Symbol.toStringTag && N[Symbol.toStringTag] || N.constructor.name || "Object";
        return M.call(
          L,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          F
        ), t(N);
      }
    }
    function a(N) {
      if (N === y) return "<>";
      if (typeof N == "object" && N !== null && N.$$typeof === $)
        return "<...>";
      try {
        var L = e(N);
        return L ? "<" + L + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function r() {
      var N = H.A;
      return N === null ? null : N.getOwner();
    }
    function i() {
      return Error("react-stack-top-frame");
    }
    function o(N) {
      if (K.call(N, "key")) {
        var L = Object.getOwnPropertyDescriptor(N, "key").get;
        if (L && L.isReactWarning) return !1;
      }
      return N.key !== void 0;
    }
    function l(N, L) {
      function M() {
        ne || (ne = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          L
        ));
      }
      M.isReactWarning = !0, Object.defineProperty(N, "key", {
        get: M,
        configurable: !0
      });
    }
    function d() {
      var N = e(this.type);
      return se[N] || (se[N] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), N = this.props.ref, N !== void 0 ? N : null;
    }
    function c(N, L, M, F, G, q) {
      var Z = M.ref;
      return N = {
        $$typeof: f,
        type: N,
        key: L,
        props: M,
        _owner: F
      }, (Z !== void 0 ? Z : null) !== null ? Object.defineProperty(N, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(N, "ref", { enumerable: !1, value: null }), N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(N, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(N, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: G
      }), Object.defineProperty(N, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: q
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    }
    function u(N, L, M, F, G, q) {
      var Z = L.children;
      if (Z !== void 0)
        if (F)
          if (U(Z)) {
            for (F = 0; F < Z.length; F++)
              h(Z[F]);
            Object.freeze && Object.freeze(Z);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else h(Z);
      if (K.call(L, "key")) {
        Z = e(N);
        var ge = Object.keys(L).filter(function(E) {
          return E !== "key";
        });
        F = 0 < ge.length ? "{key: someKey, " + ge.join(": ..., ") + ": ...}" : "{key: someKey}", R[Z + F] || (ge = 0 < ge.length ? "{" + ge.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          F,
          Z,
          ge,
          Z
        ), R[Z + F] = !0);
      }
      if (Z = null, M !== void 0 && (n(M), Z = "" + M), o(L) && (n(L.key), Z = "" + L.key), "key" in L) {
        M = {};
        for (var _e in L)
          _e !== "key" && (M[_e] = L[_e]);
      } else M = L;
      return Z && l(
        M,
        typeof N == "function" ? N.displayName || N.name || "Unknown" : N
      ), c(
        N,
        Z,
        M,
        r(),
        G,
        q
      );
    }
    function h(N) {
      m(N) ? N._store && (N._store.validated = 1) : typeof N == "object" && N !== null && N.$$typeof === $ && (N._payload.status === "fulfilled" ? m(N._payload.value) && N._payload.value._store && (N._payload.value._store.validated = 1) : N._store && (N._store.validated = 1));
    }
    function m(N) {
      return typeof N == "object" && N !== null && N.$$typeof === f;
    }
    var x = qu, f = Symbol.for("react.transitional.element"), p = Symbol.for("react.portal"), y = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), k = Symbol.for("react.profiler"), g = Symbol.for("react.consumer"), v = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), D = Symbol.for("react.suspense_list"), P = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), I = Symbol.for("react.activity"), V = Symbol.for("react.client.reference"), H = x.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, K = Object.prototype.hasOwnProperty, U = Array.isArray, te = console.createTask ? console.createTask : function() {
      return null;
    };
    x = {
      react_stack_bottom_frame: function(N) {
        return N();
      }
    };
    var ne, se = {}, A = x.react_stack_bottom_frame.bind(
      x,
      i
    )(), z = te(a(i)), R = {};
    cs.Fragment = y, cs.jsx = function(N, L, M) {
      var F = 1e4 > H.recentlyCreatedOwnerStacks++;
      return u(
        N,
        L,
        M,
        !1,
        F ? Error("react-stack-top-frame") : A,
        F ? te(a(N)) : z
      );
    }, cs.jsxs = function(N, L, M) {
      var F = 1e4 > H.recentlyCreatedOwnerStacks++;
      return u(
        N,
        L,
        M,
        !0,
        F ? Error("react-stack-top-frame") : A,
        F ? te(a(N)) : z
      );
    };
  }()), cs;
}
process.env.NODE_ENV === "production" ? aa.exports = Xu() : aa.exports = Ju();
var s = aa.exports;
function hl(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Zu } = Object.prototype, { getPrototypeOf: Wa } = Object, { iterator: xn, toStringTag: ml } = Symbol, pn = /* @__PURE__ */ ((e) => (t) => {
  const n = Zu.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Je = (e) => (e = e.toLowerCase(), (t) => pn(t) === e), gn = (e) => (t) => typeof t === e, { isArray: ts } = Array, Gt = gn("undefined");
function As(e) {
  return e !== null && !Gt(e) && e.constructor !== null && !Gt(e.constructor) && Fe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const fl = Je("ArrayBuffer");
function Qu(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && fl(e.buffer), t;
}
const eh = gn("string"), Fe = gn("function"), xl = gn("number"), Ps = (e) => e !== null && typeof e == "object", th = (e) => e === !0 || e === !1, Ks = (e) => {
  if (pn(e) !== "object")
    return !1;
  const t = Wa(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(ml in e) && !(xn in e);
}, sh = (e) => {
  if (!Ps(e) || As(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, nh = Je("Date"), ah = Je("File"), rh = Je("Blob"), ih = Je("FileList"), oh = (e) => Ps(e) && Fe(e.pipe), lh = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Fe(e.append) && ((t = pn(e)) === "formdata" || // detect form-data instance
  t === "object" && Fe(e.toString) && e.toString() === "[object FormData]"));
}, ch = Je("URLSearchParams"), [dh, uh, hh, mh] = ["ReadableStream", "Request", "Response", "Headers"].map(Je), fh = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Es(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let a, r;
  if (typeof e != "object" && (e = [e]), ts(e))
    for (a = 0, r = e.length; a < r; a++)
      t.call(null, e[a], a, e);
  else {
    if (As(e))
      return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let l;
    for (a = 0; a < o; a++)
      l = i[a], t.call(null, e[l], l, e);
  }
}
function pl(e, t) {
  if (As(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let a = n.length, r;
  for (; a-- > 0; )
    if (r = n[a], t === r.toLowerCase())
      return r;
  return null;
}
const Pt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, gl = (e) => !Gt(e) && e !== Pt;
function ra() {
  const { caseless: e, skipUndefined: t } = gl(this) && this || {}, n = {}, a = (r, i) => {
    const o = e && pl(n, i) || i;
    Ks(n[o]) && Ks(r) ? n[o] = ra(n[o], r) : Ks(r) ? n[o] = ra({}, r) : ts(r) ? n[o] = r.slice() : (!t || !Gt(r)) && (n[o] = r);
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && Es(arguments[r], a);
  return n;
}
const xh = (e, t, n, { allOwnKeys: a } = {}) => (Es(t, (r, i) => {
  n && Fe(r) ? e[i] = hl(r, n) : e[i] = r;
}, { allOwnKeys: a }), e), ph = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), gh = (e, t, n, a) => {
  e.prototype = Object.create(t.prototype, a), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, yh = (e, t, n, a) => {
  let r, i, o;
  const l = {};
  if (t = t || {}, e == null) return t;
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; )
      o = r[i], (!a || a(o, e, t)) && !l[o] && (t[o] = e[o], l[o] = !0);
    e = n !== !1 && Wa(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, bh = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const a = e.indexOf(t, n);
  return a !== -1 && a === n;
}, jh = (e) => {
  if (!e) return null;
  if (ts(e)) return e;
  let t = e.length;
  if (!xl(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, vh = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Wa(Uint8Array)), wh = (e, t) => {
  const a = (e && e[xn]).call(e);
  let r;
  for (; (r = a.next()) && !r.done; ) {
    const i = r.value;
    t.call(e, i[0], i[1]);
  }
}, Nh = (e, t) => {
  let n;
  const a = [];
  for (; (n = e.exec(t)) !== null; )
    a.push(n);
  return a;
}, kh = Je("HTMLFormElement"), Ch = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, a, r) {
    return a.toUpperCase() + r;
  }
), li = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Th = Je("RegExp"), yl = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), a = {};
  Es(n, (r, i) => {
    let o;
    (o = t(r, i, e)) !== !1 && (a[i] = o || r);
  }), Object.defineProperties(e, a);
}, Sh = (e) => {
  yl(e, (t, n) => {
    if (Fe(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const a = e[n];
    if (Fe(a)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Ah = (e, t) => {
  const n = {}, a = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return ts(e) ? a(e) : a(String(e).split(t)), n;
}, Ph = () => {
}, Eh = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Rh(e) {
  return !!(e && Fe(e.append) && e[ml] === "FormData" && e[xn]);
}
const Dh = (e) => {
  const t = new Array(10), n = (a, r) => {
    if (Ps(a)) {
      if (t.indexOf(a) >= 0)
        return;
      if (As(a))
        return a;
      if (!("toJSON" in a)) {
        t[r] = a;
        const i = ts(a) ? [] : {};
        return Es(a, (o, l) => {
          const d = n(o, r + 1);
          !Gt(d) && (i[l] = d);
        }), t[r] = void 0, i;
      }
    }
    return a;
  };
  return n(e, 0);
}, _h = Je("AsyncFunction"), Mh = (e) => e && (Ps(e) || Fe(e)) && Fe(e.then) && Fe(e.catch), bl = ((e, t) => e ? setImmediate : t ? ((n, a) => (Pt.addEventListener("message", ({ source: r, data: i }) => {
  r === Pt && i === n && a.length && a.shift()();
}, !1), (r) => {
  a.push(r), Pt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Fe(Pt.postMessage)
), Fh = typeof queueMicrotask < "u" ? queueMicrotask.bind(Pt) : typeof process < "u" && process.nextTick || bl, Lh = (e) => e != null && Fe(e[xn]), T = {
  isArray: ts,
  isArrayBuffer: fl,
  isBuffer: As,
  isFormData: lh,
  isArrayBufferView: Qu,
  isString: eh,
  isNumber: xl,
  isBoolean: th,
  isObject: Ps,
  isPlainObject: Ks,
  isEmptyObject: sh,
  isReadableStream: dh,
  isRequest: uh,
  isResponse: hh,
  isHeaders: mh,
  isUndefined: Gt,
  isDate: nh,
  isFile: ah,
  isBlob: rh,
  isRegExp: Th,
  isFunction: Fe,
  isStream: oh,
  isURLSearchParams: ch,
  isTypedArray: vh,
  isFileList: ih,
  forEach: Es,
  merge: ra,
  extend: xh,
  trim: fh,
  stripBOM: ph,
  inherits: gh,
  toFlatObject: yh,
  kindOf: pn,
  kindOfTest: Je,
  endsWith: bh,
  toArray: jh,
  forEachEntry: wh,
  matchAll: Nh,
  isHTMLForm: kh,
  hasOwnProperty: li,
  hasOwnProp: li,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: yl,
  freezeMethods: Sh,
  toObjectSet: Ah,
  toCamelCase: Ch,
  noop: Ph,
  toFiniteNumber: Eh,
  findKey: pl,
  global: Pt,
  isContextDefined: gl,
  isSpecCompliantForm: Rh,
  toJSONObject: Dh,
  isAsyncFn: _h,
  isThenable: Mh,
  setImmediate: bl,
  asap: Fh,
  isIterable: Lh
};
function ae(e, t, n, a, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), a && (this.request = a), r && (this.response = r, this.status = r.status ? r.status : null);
}
T.inherits(ae, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: T.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const jl = ae.prototype, vl = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  vl[e] = { value: e };
});
Object.defineProperties(ae, vl);
Object.defineProperty(jl, "isAxiosError", { value: !0 });
ae.from = (e, t, n, a, r, i) => {
  const o = Object.create(jl);
  T.toFlatObject(e, o, function(u) {
    return u !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", d = t == null && e ? e.code : t;
  return ae.call(o, l, d, n, a, r), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const $h = null;
function ia(e) {
  return T.isPlainObject(e) || T.isArray(e);
}
function wl(e) {
  return T.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ci(e, t, n) {
  return e ? e.concat(t).map(function(r, i) {
    return r = wl(r), !n && i ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function Ih(e) {
  return T.isArray(e) && !e.some(ia);
}
const Oh = T.toFlatObject(T, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function yn(e, t, n) {
  if (!T.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = T.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, y) {
    return !T.isUndefined(y[p]);
  });
  const a = n.metaTokens, r = n.visitor || u, i = n.dots, o = n.indexes, d = (n.Blob || typeof Blob < "u" && Blob) && T.isSpecCompliantForm(t);
  if (!T.isFunction(r))
    throw new TypeError("visitor must be a function");
  function c(f) {
    if (f === null) return "";
    if (T.isDate(f))
      return f.toISOString();
    if (T.isBoolean(f))
      return f.toString();
    if (!d && T.isBlob(f))
      throw new ae("Blob is not supported. Use a Buffer instead.");
    return T.isArrayBuffer(f) || T.isTypedArray(f) ? d && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function u(f, p, y) {
    let b = f;
    if (f && !y && typeof f == "object") {
      if (T.endsWith(p, "{}"))
        p = a ? p : p.slice(0, -2), f = JSON.stringify(f);
      else if (T.isArray(f) && Ih(f) || (T.isFileList(f) || T.endsWith(p, "[]")) && (b = T.toArray(f)))
        return p = wl(p), b.forEach(function(g, v) {
          !(T.isUndefined(g) || g === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? ci([p], v, i) : o === null ? p : p + "[]",
            c(g)
          );
        }), !1;
    }
    return ia(f) ? !0 : (t.append(ci(y, p, i), c(f)), !1);
  }
  const h = [], m = Object.assign(Oh, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: ia
  });
  function x(f, p) {
    if (!T.isUndefined(f)) {
      if (h.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      h.push(f), T.forEach(f, function(b, k) {
        (!(T.isUndefined(b) || b === null) && r.call(
          t,
          b,
          T.isString(k) ? k.trim() : k,
          p,
          m
        )) === !0 && x(b, p ? p.concat(k) : [k]);
      }), h.pop();
    }
  }
  if (!T.isObject(e))
    throw new TypeError("data must be an object");
  return x(e), t;
}
function di(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(a) {
    return t[a];
  });
}
function Ka(e, t) {
  this._pairs = [], e && yn(e, this, t);
}
const Nl = Ka.prototype;
Nl.append = function(t, n) {
  this._pairs.push([t, n]);
};
Nl.toString = function(t) {
  const n = t ? function(a) {
    return t.call(this, a, di);
  } : di;
  return this._pairs.map(function(r) {
    return n(r[0]) + "=" + n(r[1]);
  }, "").join("&");
};
function Vh(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function kl(e, t, n) {
  if (!t)
    return e;
  const a = n && n.encode || Vh;
  T.isFunction(n) && (n = {
    serialize: n
  });
  const r = n && n.serialize;
  let i;
  if (r ? i = r(t, n) : i = T.isURLSearchParams(t) ? t.toString() : new Ka(t, n).toString(a), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class ui {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, a) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: a ? a.synchronous : !1,
      runWhen: a ? a.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    T.forEach(this.handlers, function(a) {
      a !== null && t(a);
    });
  }
}
const Cl = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Bh = typeof URLSearchParams < "u" ? URLSearchParams : Ka, zh = typeof FormData < "u" ? FormData : null, Uh = typeof Blob < "u" ? Blob : null, qh = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Bh,
    FormData: zh,
    Blob: Uh
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ya = typeof window < "u" && typeof document < "u", oa = typeof navigator == "object" && navigator || void 0, Hh = Ya && (!oa || ["ReactNative", "NativeScript", "NS"].indexOf(oa.product) < 0), Wh = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Kh = Ya && window.location.href || "http://localhost", Yh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ya,
  hasStandardBrowserEnv: Hh,
  hasStandardBrowserWebWorkerEnv: Wh,
  navigator: oa,
  origin: Kh
}, Symbol.toStringTag, { value: "Module" })), Ae = {
  ...Yh,
  ...qh
};
function Gh(e, t) {
  return yn(e, new Ae.classes.URLSearchParams(), {
    visitor: function(n, a, r, i) {
      return Ae.isNode && T.isBuffer(n) ? (this.append(a, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function Xh(e) {
  return T.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Jh(e) {
  const t = {}, n = Object.keys(e);
  let a;
  const r = n.length;
  let i;
  for (a = 0; a < r; a++)
    i = n[a], t[i] = e[i];
  return t;
}
function Tl(e) {
  function t(n, a, r, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const l = Number.isFinite(+o), d = i >= n.length;
    return o = !o && T.isArray(r) ? r.length : o, d ? (T.hasOwnProp(r, o) ? r[o] = [r[o], a] : r[o] = a, !l) : ((!r[o] || !T.isObject(r[o])) && (r[o] = []), t(n, a, r[o], i) && T.isArray(r[o]) && (r[o] = Jh(r[o])), !l);
  }
  if (T.isFormData(e) && T.isFunction(e.entries)) {
    const n = {};
    return T.forEachEntry(e, (a, r) => {
      t(Xh(a), r, n, 0);
    }), n;
  }
  return null;
}
function Zh(e, t, n) {
  if (T.isString(e))
    try {
      return (t || JSON.parse)(e), T.trim(e);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (n || JSON.stringify)(e);
}
const Rs = {
  transitional: Cl,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const a = n.getContentType() || "", r = a.indexOf("application/json") > -1, i = T.isObject(t);
    if (i && T.isHTMLForm(t) && (t = new FormData(t)), T.isFormData(t))
      return r ? JSON.stringify(Tl(t)) : t;
    if (T.isArrayBuffer(t) || T.isBuffer(t) || T.isStream(t) || T.isFile(t) || T.isBlob(t) || T.isReadableStream(t))
      return t;
    if (T.isArrayBufferView(t))
      return t.buffer;
    if (T.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (i) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return Gh(t, this.formSerializer).toString();
      if ((l = T.isFileList(t)) || a.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return yn(
          l ? { "files[]": t } : t,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return i || r ? (n.setContentType("application/json", !1), Zh(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Rs.transitional, a = n && n.forcedJSONParsing, r = this.responseType === "json";
    if (T.isResponse(t) || T.isReadableStream(t))
      return t;
    if (t && T.isString(t) && (a && !this.responseType || r)) {
      const o = !(n && n.silentJSONParsing) && r;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (l) {
        if (o)
          throw l.name === "SyntaxError" ? ae.from(l, ae.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ae.classes.FormData,
    Blob: Ae.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
T.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Rs.headers[e] = {};
});
const Qh = T.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), em = (e) => {
  const t = {};
  let n, a, r;
  return e && e.split(`
`).forEach(function(o) {
    r = o.indexOf(":"), n = o.substring(0, r).trim().toLowerCase(), a = o.substring(r + 1).trim(), !(!n || t[n] && Qh[n]) && (n === "set-cookie" ? t[n] ? t[n].push(a) : t[n] = [a] : t[n] = t[n] ? t[n] + ", " + a : a);
  }), t;
}, hi = Symbol("internals");
function ds(e) {
  return e && String(e).trim().toLowerCase();
}
function Ys(e) {
  return e === !1 || e == null ? e : T.isArray(e) ? e.map(Ys) : String(e);
}
function tm(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let a;
  for (; a = n.exec(e); )
    t[a[1]] = a[2];
  return t;
}
const sm = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function In(e, t, n, a, r) {
  if (T.isFunction(a))
    return a.call(this, t, n);
  if (r && (t = n), !!T.isString(t)) {
    if (T.isString(a))
      return t.indexOf(a) !== -1;
    if (T.isRegExp(a))
      return a.test(t);
  }
}
function nm(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, a) => n.toUpperCase() + a);
}
function am(e, t) {
  const n = T.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((a) => {
    Object.defineProperty(e, a + n, {
      value: function(r, i, o) {
        return this[a].call(this, t, r, i, o);
      },
      configurable: !0
    });
  });
}
let Le = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, a) {
    const r = this;
    function i(l, d, c) {
      const u = ds(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const h = T.findKey(r, u);
      (!h || r[h] === void 0 || c === !0 || c === void 0 && r[h] !== !1) && (r[h || d] = Ys(l));
    }
    const o = (l, d) => T.forEach(l, (c, u) => i(c, u, d));
    if (T.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (T.isString(t) && (t = t.trim()) && !sm(t))
      o(em(t), n);
    else if (T.isObject(t) && T.isIterable(t)) {
      let l = {}, d, c;
      for (const u of t) {
        if (!T.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[c = u[0]] = (d = l[c]) ? T.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      o(l, n);
    } else
      t != null && i(n, t, a);
    return this;
  }
  get(t, n) {
    if (t = ds(t), t) {
      const a = T.findKey(this, t);
      if (a) {
        const r = this[a];
        if (!n)
          return r;
        if (n === !0)
          return tm(r);
        if (T.isFunction(n))
          return n.call(this, r, a);
        if (T.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = ds(t), t) {
      const a = T.findKey(this, t);
      return !!(a && this[a] !== void 0 && (!n || In(this, this[a], a, n)));
    }
    return !1;
  }
  delete(t, n) {
    const a = this;
    let r = !1;
    function i(o) {
      if (o = ds(o), o) {
        const l = T.findKey(a, o);
        l && (!n || In(a, a[l], l, n)) && (delete a[l], r = !0);
      }
    }
    return T.isArray(t) ? t.forEach(i) : i(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let a = n.length, r = !1;
    for (; a--; ) {
      const i = n[a];
      (!t || In(this, this[i], i, t, !0)) && (delete this[i], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, a = {};
    return T.forEach(this, (r, i) => {
      const o = T.findKey(a, i);
      if (o) {
        n[o] = Ys(r), delete n[i];
        return;
      }
      const l = t ? nm(i) : String(i).trim();
      l !== i && delete n[i], n[l] = Ys(r), a[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return T.forEach(this, (a, r) => {
      a != null && a !== !1 && (n[r] = t && T.isArray(a) ? a.join(", ") : a);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const a = new this(t);
    return n.forEach((r) => a.set(r)), a;
  }
  static accessor(t) {
    const a = (this[hi] = this[hi] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function i(o) {
      const l = ds(o);
      a[l] || (am(r, o), a[l] = !0);
    }
    return T.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
Le.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
T.reduceDescriptors(Le.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(a) {
      this[n] = a;
    }
  };
});
T.freezeMethods(Le);
function On(e, t) {
  const n = this || Rs, a = t || n, r = Le.from(a.headers);
  let i = a.data;
  return T.forEach(e, function(l) {
    i = l.call(n, i, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), i;
}
function Sl(e) {
  return !!(e && e.__CANCEL__);
}
function ss(e, t, n) {
  ae.call(this, e ?? "canceled", ae.ERR_CANCELED, t, n), this.name = "CanceledError";
}
T.inherits(ss, ae, {
  __CANCEL__: !0
});
function Al(e, t, n) {
  const a = n.config.validateStatus;
  !n.status || !a || a(n.status) ? e(n) : t(new ae(
    "Request failed with status code " + n.status,
    [ae.ERR_BAD_REQUEST, ae.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function rm(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function im(e, t) {
  e = e || 10;
  const n = new Array(e), a = new Array(e);
  let r = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(d) {
    const c = Date.now(), u = a[i];
    o || (o = c), n[r] = d, a[r] = c;
    let h = i, m = 0;
    for (; h !== r; )
      m += n[h++], h = h % e;
    if (r = (r + 1) % e, r === i && (i = (i + 1) % e), c - o < t)
      return;
    const x = u && c - u;
    return x ? Math.round(m * 1e3 / x) : void 0;
  };
}
function om(e, t) {
  let n = 0, a = 1e3 / t, r, i;
  const o = (c, u = Date.now()) => {
    n = u, r = null, i && (clearTimeout(i), i = null), e(...c);
  };
  return [(...c) => {
    const u = Date.now(), h = u - n;
    h >= a ? o(c, u) : (r = c, i || (i = setTimeout(() => {
      i = null, o(r);
    }, a - h)));
  }, () => r && o(r)];
}
const tn = (e, t, n = 3) => {
  let a = 0;
  const r = im(50, 250);
  return om((i) => {
    const o = i.loaded, l = i.lengthComputable ? i.total : void 0, d = o - a, c = r(d), u = o <= l;
    a = o;
    const h = {
      loaded: o,
      total: l,
      progress: l ? o / l : void 0,
      bytes: d,
      rate: c || void 0,
      estimated: c && l && u ? (l - o) / c : void 0,
      event: i,
      lengthComputable: l != null,
      [t ? "download" : "upload"]: !0
    };
    e(h);
  }, n);
}, mi = (e, t) => {
  const n = e != null;
  return [(a) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: a
  }), t[1]];
}, fi = (e) => (...t) => T.asap(() => e(...t)), lm = Ae.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, Ae.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Ae.origin),
  Ae.navigator && /(msie|trident)/i.test(Ae.navigator.userAgent)
) : () => !0, cm = Ae.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, a, r, i, o) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(t)}`];
      T.isNumber(n) && l.push(`expires=${new Date(n).toUTCString()}`), T.isString(a) && l.push(`path=${a}`), T.isString(r) && l.push(`domain=${r}`), i === !0 && l.push("secure"), T.isString(o) && l.push(`SameSite=${o}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function dm(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function um(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Pl(e, t, n) {
  let a = !dm(t);
  return e && (a || n == !1) ? um(e, t) : t;
}
const xi = (e) => e instanceof Le ? { ...e } : e;
function Lt(e, t) {
  t = t || {};
  const n = {};
  function a(c, u, h, m) {
    return T.isPlainObject(c) && T.isPlainObject(u) ? T.merge.call({ caseless: m }, c, u) : T.isPlainObject(u) ? T.merge({}, u) : T.isArray(u) ? u.slice() : u;
  }
  function r(c, u, h, m) {
    if (T.isUndefined(u)) {
      if (!T.isUndefined(c))
        return a(void 0, c, h, m);
    } else return a(c, u, h, m);
  }
  function i(c, u) {
    if (!T.isUndefined(u))
      return a(void 0, u);
  }
  function o(c, u) {
    if (T.isUndefined(u)) {
      if (!T.isUndefined(c))
        return a(void 0, c);
    } else return a(void 0, u);
  }
  function l(c, u, h) {
    if (h in t)
      return a(c, u);
    if (h in e)
      return a(void 0, c);
  }
  const d = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: l,
    headers: (c, u, h) => r(xi(c), xi(u), h, !0)
  };
  return T.forEach(Object.keys({ ...e, ...t }), function(u) {
    const h = d[u] || r, m = h(e[u], t[u], u);
    T.isUndefined(m) && h !== l || (n[u] = m);
  }), n;
}
const El = (e) => {
  const t = Lt({}, e);
  let { data: n, withXSRFToken: a, xsrfHeaderName: r, xsrfCookieName: i, headers: o, auth: l } = t;
  if (t.headers = o = Le.from(o), t.url = kl(Pl(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), l && o.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), T.isFormData(n)) {
    if (Ae.hasStandardBrowserEnv || Ae.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (T.isFunction(n.getHeaders)) {
      const d = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(d).forEach(([u, h]) => {
        c.includes(u.toLowerCase()) && o.set(u, h);
      });
    }
  }
  if (Ae.hasStandardBrowserEnv && (a && T.isFunction(a) && (a = a(t)), a || a !== !1 && lm(t.url))) {
    const d = r && i && cm.read(i);
    d && o.set(r, d);
  }
  return t;
}, hm = typeof XMLHttpRequest < "u", mm = hm && function(e) {
  return new Promise(function(n, a) {
    const r = El(e);
    let i = r.data;
    const o = Le.from(r.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: c } = r, u, h, m, x, f;
    function p() {
      x && x(), f && f(), r.cancelToken && r.cancelToken.unsubscribe(u), r.signal && r.signal.removeEventListener("abort", u);
    }
    let y = new XMLHttpRequest();
    y.open(r.method.toUpperCase(), r.url, !0), y.timeout = r.timeout;
    function b() {
      if (!y)
        return;
      const g = Le.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: g,
        config: e,
        request: y
      };
      Al(function(D) {
        n(D), p();
      }, function(D) {
        a(D), p();
      }, C), y = null;
    }
    "onloadend" in y ? y.onloadend = b : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, y.onabort = function() {
      y && (a(new ae("Request aborted", ae.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function(v) {
      const C = v && v.message ? v.message : "Network Error", w = new ae(C, ae.ERR_NETWORK, e, y);
      w.event = v || null, a(w), y = null;
    }, y.ontimeout = function() {
      let v = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const C = r.transitional || Cl;
      r.timeoutErrorMessage && (v = r.timeoutErrorMessage), a(new ae(
        v,
        C.clarifyTimeoutError ? ae.ETIMEDOUT : ae.ECONNABORTED,
        e,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && T.forEach(o.toJSON(), function(v, C) {
      y.setRequestHeader(C, v);
    }), T.isUndefined(r.withCredentials) || (y.withCredentials = !!r.withCredentials), l && l !== "json" && (y.responseType = r.responseType), c && ([m, f] = tn(c, !0), y.addEventListener("progress", m)), d && y.upload && ([h, x] = tn(d), y.upload.addEventListener("progress", h), y.upload.addEventListener("loadend", x)), (r.cancelToken || r.signal) && (u = (g) => {
      y && (a(!g || g.type ? new ss(null, e, y) : g), y.abort(), y = null);
    }, r.cancelToken && r.cancelToken.subscribe(u), r.signal && (r.signal.aborted ? u() : r.signal.addEventListener("abort", u)));
    const k = rm(r.url);
    if (k && Ae.protocols.indexOf(k) === -1) {
      a(new ae("Unsupported protocol " + k + ":", ae.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(i || null);
  });
}, fm = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let a = new AbortController(), r;
    const i = function(c) {
      if (!r) {
        r = !0, l();
        const u = c instanceof Error ? c : this.reason;
        a.abort(u instanceof ae ? u : new ss(u instanceof Error ? u.message : u));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new ae(`timeout ${t} of ms exceeded`, ae.ETIMEDOUT));
    }, t);
    const l = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: d } = a;
    return d.unsubscribe = () => T.asap(l), d;
  }
}, xm = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let a = 0, r;
  for (; a < n; )
    r = a + t, yield e.slice(a, r), a = r;
}, pm = async function* (e, t) {
  for await (const n of gm(e))
    yield* xm(n, t);
}, gm = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: a } = await t.read();
      if (n)
        break;
      yield a;
    }
  } finally {
    await t.cancel();
  }
}, pi = (e, t, n, a) => {
  const r = pm(e, t);
  let i = 0, o, l = (d) => {
    o || (o = !0, a && a(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: c, value: u } = await r.next();
        if (c) {
          l(), d.close();
          return;
        }
        let h = u.byteLength;
        if (n) {
          let m = i += h;
          n(m);
        }
        d.enqueue(new Uint8Array(u));
      } catch (c) {
        throw l(c), c;
      }
    },
    cancel(d) {
      return l(d), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, gi = 64 * 1024, { isFunction: Us } = T, ym = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(T.global), {
  ReadableStream: yi,
  TextEncoder: bi
} = T.global, ji = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, bm = (e) => {
  e = T.merge.call({
    skipUndefined: !0
  }, ym, e);
  const { fetch: t, Request: n, Response: a } = e, r = t ? Us(t) : typeof fetch == "function", i = Us(n), o = Us(a);
  if (!r)
    return !1;
  const l = r && Us(yi), d = r && (typeof bi == "function" ? /* @__PURE__ */ ((f) => (p) => f.encode(p))(new bi()) : async (f) => new Uint8Array(await new n(f).arrayBuffer())), c = i && l && ji(() => {
    let f = !1;
    const p = new n(Ae.origin, {
      body: new yi(),
      method: "POST",
      get duplex() {
        return f = !0, "half";
      }
    }).headers.has("Content-Type");
    return f && !p;
  }), u = o && l && ji(() => T.isReadableStream(new a("").body)), h = {
    stream: u && ((f) => f.body)
  };
  r && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((f) => {
    !h[f] && (h[f] = (p, y) => {
      let b = p && p[f];
      if (b)
        return b.call(p);
      throw new ae(`Response type '${f}' is not supported`, ae.ERR_NOT_SUPPORT, y);
    });
  });
  const m = async (f) => {
    if (f == null)
      return 0;
    if (T.isBlob(f))
      return f.size;
    if (T.isSpecCompliantForm(f))
      return (await new n(Ae.origin, {
        method: "POST",
        body: f
      }).arrayBuffer()).byteLength;
    if (T.isArrayBufferView(f) || T.isArrayBuffer(f))
      return f.byteLength;
    if (T.isURLSearchParams(f) && (f = f + ""), T.isString(f))
      return (await d(f)).byteLength;
  }, x = async (f, p) => {
    const y = T.toFiniteNumber(f.getContentLength());
    return y ?? m(p);
  };
  return async (f) => {
    let {
      url: p,
      method: y,
      data: b,
      signal: k,
      cancelToken: g,
      timeout: v,
      onDownloadProgress: C,
      onUploadProgress: w,
      responseType: D,
      headers: P,
      withCredentials: $ = "same-origin",
      fetchOptions: I
    } = El(f), V = t || fetch;
    D = D ? (D + "").toLowerCase() : "text";
    let H = fm([k, g && g.toAbortSignal()], v), K = null;
    const U = H && H.unsubscribe && (() => {
      H.unsubscribe();
    });
    let te;
    try {
      if (w && c && y !== "get" && y !== "head" && (te = await x(P, b)) !== 0) {
        let N = new n(p, {
          method: "POST",
          body: b,
          duplex: "half"
        }), L;
        if (T.isFormData(b) && (L = N.headers.get("content-type")) && P.setContentType(L), N.body) {
          const [M, F] = mi(
            te,
            tn(fi(w))
          );
          b = pi(N.body, gi, M, F);
        }
      }
      T.isString($) || ($ = $ ? "include" : "omit");
      const ne = i && "credentials" in n.prototype, se = {
        ...I,
        signal: H,
        method: y.toUpperCase(),
        headers: P.normalize().toJSON(),
        body: b,
        duplex: "half",
        credentials: ne ? $ : void 0
      };
      K = i && new n(p, se);
      let A = await (i ? V(K, I) : V(p, se));
      const z = u && (D === "stream" || D === "response");
      if (u && (C || z && U)) {
        const N = {};
        ["status", "statusText", "headers"].forEach((G) => {
          N[G] = A[G];
        });
        const L = T.toFiniteNumber(A.headers.get("content-length")), [M, F] = C && mi(
          L,
          tn(fi(C), !0)
        ) || [];
        A = new a(
          pi(A.body, gi, M, () => {
            F && F(), U && U();
          }),
          N
        );
      }
      D = D || "text";
      let R = await h[T.findKey(h, D) || "text"](A, f);
      return !z && U && U(), await new Promise((N, L) => {
        Al(N, L, {
          data: R,
          headers: Le.from(A.headers),
          status: A.status,
          statusText: A.statusText,
          config: f,
          request: K
        });
      });
    } catch (ne) {
      throw U && U(), ne && ne.name === "TypeError" && /Load failed|fetch/i.test(ne.message) ? Object.assign(
        new ae("Network Error", ae.ERR_NETWORK, f, K),
        {
          cause: ne.cause || ne
        }
      ) : ae.from(ne, ne && ne.code, f, K);
    }
  };
}, jm = /* @__PURE__ */ new Map(), Rl = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: a, Response: r } = t, i = [
    a,
    r,
    n
  ];
  let o = i.length, l = o, d, c, u = jm;
  for (; l--; )
    d = i[l], c = u.get(d), c === void 0 && u.set(d, c = l ? /* @__PURE__ */ new Map() : bm(t)), u = c;
  return c;
};
Rl();
const Ga = {
  http: $h,
  xhr: mm,
  fetch: {
    get: Rl
  }
};
T.forEach(Ga, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const vi = (e) => `- ${e}`, vm = (e) => T.isFunction(e) || e === null || e === !1;
function wm(e, t) {
  e = T.isArray(e) ? e : [e];
  const { length: n } = e;
  let a, r;
  const i = {};
  for (let o = 0; o < n; o++) {
    a = e[o];
    let l;
    if (r = a, !vm(a) && (r = Ga[(l = String(a)).toLowerCase()], r === void 0))
      throw new ae(`Unknown adapter '${l}'`);
    if (r && (T.isFunction(r) || (r = r.get(t))))
      break;
    i[l || "#" + o] = r;
  }
  if (!r) {
    const o = Object.entries(i).map(
      ([d, c]) => `adapter ${d} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = n ? o.length > 1 ? `since :
` + o.map(vi).join(`
`) : " " + vi(o[0]) : "as no adapter specified";
    throw new ae(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return r;
}
const Dl = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: wm,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Ga
};
function Vn(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ss(null, e);
}
function wi(e) {
  return Vn(e), e.headers = Le.from(e.headers), e.data = On.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Dl.getAdapter(e.adapter || Rs.adapter, e)(e).then(function(a) {
    return Vn(e), a.data = On.call(
      e,
      e.transformResponse,
      a
    ), a.headers = Le.from(a.headers), a;
  }, function(a) {
    return Sl(a) || (Vn(e), a && a.response && (a.response.data = On.call(
      e,
      e.transformResponse,
      a.response
    ), a.response.headers = Le.from(a.response.headers))), Promise.reject(a);
  });
}
const _l = "1.13.2", bn = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  bn[e] = function(a) {
    return typeof a === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ni = {};
bn.transitional = function(t, n, a) {
  function r(i, o) {
    return "[Axios v" + _l + "] Transitional option '" + i + "'" + o + (a ? ". " + a : "");
  }
  return (i, o, l) => {
    if (t === !1)
      throw new ae(
        r(o, " has been removed" + (n ? " in " + n : "")),
        ae.ERR_DEPRECATED
      );
    return n && !Ni[o] && (Ni[o] = !0, console.warn(
      r(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, l) : !0;
  };
};
bn.spelling = function(t) {
  return (n, a) => (console.warn(`${a} is likely a misspelling of ${t}`), !0);
};
function Nm(e, t, n) {
  if (typeof e != "object")
    throw new ae("options must be an object", ae.ERR_BAD_OPTION_VALUE);
  const a = Object.keys(e);
  let r = a.length;
  for (; r-- > 0; ) {
    const i = a[r], o = t[i];
    if (o) {
      const l = e[i], d = l === void 0 || o(l, i, e);
      if (d !== !0)
        throw new ae("option " + i + " must be " + d, ae.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new ae("Unknown option " + i, ae.ERR_BAD_OPTION);
  }
}
const Gs = {
  assertOptions: Nm,
  validators: bn
}, Qe = Gs.validators;
let Dt = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new ui(),
      response: new ui()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (a) {
      if (a instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          a.stack ? i && !String(a.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (a.stack += `
` + i) : a.stack = i;
        } catch {
        }
      }
      throw a;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Lt(this.defaults, n);
    const { transitional: a, paramsSerializer: r, headers: i } = n;
    a !== void 0 && Gs.assertOptions(a, {
      silentJSONParsing: Qe.transitional(Qe.boolean),
      forcedJSONParsing: Qe.transitional(Qe.boolean),
      clarifyTimeoutError: Qe.transitional(Qe.boolean)
    }, !1), r != null && (T.isFunction(r) ? n.paramsSerializer = {
      serialize: r
    } : Gs.assertOptions(r, {
      encode: Qe.function,
      serialize: Qe.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Gs.assertOptions(n, {
      baseUrl: Qe.spelling("baseURL"),
      withXsrfToken: Qe.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && T.merge(
      i.common,
      i[n.method]
    );
    i && T.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete i[f];
      }
    ), n.headers = Le.concat(o, i);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(n) === !1 || (d = d && p.synchronous, l.unshift(p.fulfilled, p.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(p) {
      c.push(p.fulfilled, p.rejected);
    });
    let u, h = 0, m;
    if (!d) {
      const f = [wi.bind(this), void 0];
      for (f.unshift(...l), f.push(...c), m = f.length, u = Promise.resolve(n); h < m; )
        u = u.then(f[h++], f[h++]);
      return u;
    }
    m = l.length;
    let x = n;
    for (; h < m; ) {
      const f = l[h++], p = l[h++];
      try {
        x = f(x);
      } catch (y) {
        p.call(this, y);
        break;
      }
    }
    try {
      u = wi.call(this, x);
    } catch (f) {
      return Promise.reject(f);
    }
    for (h = 0, m = c.length; h < m; )
      u = u.then(c[h++], c[h++]);
    return u;
  }
  getUri(t) {
    t = Lt(this.defaults, t);
    const n = Pl(t.baseURL, t.url, t.allowAbsoluteUrls);
    return kl(n, t.params, t.paramsSerializer);
  }
};
T.forEach(["delete", "get", "head", "options"], function(t) {
  Dt.prototype[t] = function(n, a) {
    return this.request(Lt(a || {}, {
      method: t,
      url: n,
      data: (a || {}).data
    }));
  };
});
T.forEach(["post", "put", "patch"], function(t) {
  function n(a) {
    return function(i, o, l) {
      return this.request(Lt(l || {}, {
        method: t,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  Dt.prototype[t] = n(), Dt.prototype[t + "Form"] = n(!0);
});
let km = class Ml {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const a = this;
    this.promise.then((r) => {
      if (!a._listeners) return;
      let i = a._listeners.length;
      for (; i-- > 0; )
        a._listeners[i](r);
      a._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const o = new Promise((l) => {
        a.subscribe(l), i = l;
      }).then(r);
      return o.cancel = function() {
        a.unsubscribe(i);
      }, o;
    }, t(function(i, o, l) {
      a.reason || (a.reason = new ss(i, o, l), n(a.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (a) => {
      t.abort(a);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ml(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
};
function Cm(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Tm(e) {
  return T.isObject(e) && e.isAxiosError === !0;
}
const la = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(la).forEach(([e, t]) => {
  la[t] = e;
});
function Fl(e) {
  const t = new Dt(e), n = hl(Dt.prototype.request, t);
  return T.extend(n, Dt.prototype, t, { allOwnKeys: !0 }), T.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Fl(Lt(e, r));
  }, n;
}
const ue = Fl(Rs);
ue.Axios = Dt;
ue.CanceledError = ss;
ue.CancelToken = km;
ue.isCancel = Sl;
ue.VERSION = _l;
ue.toFormData = yn;
ue.AxiosError = ae;
ue.Cancel = ue.CanceledError;
ue.all = function(t) {
  return Promise.all(t);
};
ue.spread = Cm;
ue.isAxiosError = Tm;
ue.mergeConfig = Lt;
ue.AxiosHeaders = Le;
ue.formToJSON = (e) => Tl(T.isHTMLForm(e) ? new FormData(e) : e);
ue.getAdapter = Dl.getAdapter;
ue.HttpStatusCode = la;
ue.default = ue;
const {
  Axios: kj,
  AxiosError: Cj,
  CanceledError: Tj,
  isCancel: Sj,
  CancelToken: Aj,
  VERSION: Pj,
  all: Ej,
  Cancel: Rj,
  isAxiosError: Dj,
  spread: _j,
  toFormData: Mj,
  AxiosHeaders: Fj,
  HttpStatusCode: Lj,
  formToJSON: $j,
  getAdapter: Ij,
  mergeConfig: Oj
} = ue;
function Ll(e) {
  var n;
  const t = (n = e.response) == null ? void 0 : n.data;
  return t != null && t.detail ? t.detail : t != null && t.message ? t.message : e.message ? e.message : "An error occurred";
}
function Sm(e) {
  return typeof e == "object" && e !== null && "isAxiosError" in e && e.isAxiosError === !0;
}
function tt(e, t = "An error occurred") {
  return Sm(e) ? Ll(e) : e instanceof Error ? e.message : typeof e == "string" ? e : t;
}
const Am = {
  maxRetries: 3,
  baseDelay: 1e3,
  maxDelay: 3e4,
  retryableStatuses: [408, 429, 500, 502, 503, 504],
  jitter: !0,
  onRetry: void 0
};
function Pm(e, t) {
  return e.response ? t.retryableStatuses.includes(e.response.status) : !0;
}
function Em(e, t) {
  let n = Math.min(
    t.baseDelay * Math.pow(2, e),
    t.maxDelay
  );
  return t.jitter && (n = n * (0.5 + Math.random())), Math.round(n);
}
function Rm(e) {
  return new Promise((t) => setTimeout(t, e));
}
function $l(e, t = {}) {
  const n = {
    ...Am,
    ...t,
    onRetry: t.onRetry
  };
  e.interceptors.request.use(
    (a) => (a.__retryConfig = n, a.__retryCount = a.__retryCount || 0, a)
  ), e.interceptors.response.use(
    (a) => a,
    async (a) => {
      const r = a.config;
      if (!r)
        return Promise.reject(a);
      const i = r.__retryConfig || n, o = r.__retryCount || 0;
      if (o >= i.maxRetries || !Pm(a, i))
        return Promise.reject(a);
      const l = Em(o, i);
      return i.onRetry && i.onRetry(a, o + 1, l), await Rm(l), r.__retryCount = o + 1, e.request(r);
    }
  );
}
function Vj(e, t = {}) {
  return $l(e, t), e;
}
class ca extends Error {
  constructor(n, a, r) {
    super(n);
    zs(this, "code", "TIMEOUT");
    zs(this, "url");
    zs(this, "timeout");
    this.name = "RequestTimeoutError", this.url = a, this.timeout = r || 0;
  }
}
function Dm(e, t = {}) {
  const n = t.request ?? 3e4;
  e.defaults.timeout = n, e.interceptors.response.use(
    (a) => a,
    (a) => {
      var r, i, o, l;
      if (a.code === "ECONNABORTED" || (r = a.message) != null && r.includes("timeout")) {
        const d = ((i = a.config) == null ? void 0 : i.url) || "unknown", c = ((o = a.config) == null ? void 0 : o.timeout) || n;
        return Promise.reject(
          new ca(
            `Request to ${d} timed out after ${c}ms`,
            d,
            c
          )
        );
      }
      if (a.code === "ETIMEDOUT" || a.code === "ECONNREFUSED") {
        const d = ((l = a.config) == null ? void 0 : l.url) || "unknown";
        return Promise.reject(
          new ca(
            `Connection to ${d} timed out`,
            d,
            t.connect || 5e3
          )
        );
      }
      return Promise.reject(a);
    }
  );
}
function Bj(e) {
  return { timeout: e };
}
function zj(e) {
  return e instanceof ca;
}
function _m(e) {
  const t = `${e}_access_token`, n = `${e}_refresh_token`;
  return {
    getAccessToken: () => localStorage.getItem(t),
    getRefreshToken: () => localStorage.getItem(n),
    setTokens: (a, r) => {
      localStorage.setItem(t, a), localStorage.setItem(n, r);
    },
    clearTokens: () => {
      localStorage.removeItem(t), localStorage.removeItem(n);
    }
  };
}
const Mm = [
  "/auth/security/",
  "/auth/devices/",
  "/reactivate-account",
  "/reactivate-product",
  "/verify-email",
  "/reset-password",
  "/forgot-password",
  "/account-deleted",
  "/farewell"
];
function Bn() {
  const e = window.location.pathname;
  return Mm.some((t) => e.startsWith(t));
}
function Fm() {
  const e = window.location.pathname.match(/^\/t\/([^/]+)/);
  return e ? e[1] : null;
}
function Lm(e) {
  const t = _m(e.storageKeyPrefix), n = e.loginPath ?? "/login", a = e.activatePath ?? "/activate", r = e.billingApiUrl ?? e.authServiceUrl, i = e.enableRetry ?? !0, o = e.enableTimeout ?? !0, l = ue.create({
    baseURL: e.productApiUrl,
    headers: { "Content-Type": "application/json" }
  }), d = ue.create({
    baseURL: e.authServiceUrl,
    headers: { "Content-Type": "application/json" }
  }), c = ue.create({
    baseURL: r,
    headers: { "Content-Type": "application/json" }
  }), u = ue.create({
    baseURL: e.authServiceUrl,
    headers: { "Content-Type": "application/json" }
  }), h = [
    l,
    d,
    c,
    u
  ];
  i && h.forEach((g) => {
    $l(g, {
      maxRetries: 3,
      baseDelay: 1e3,
      maxDelay: 1e4,
      retryableStatuses: [408, 429, 500, 502, 503, 504]
    });
  }), o && h.forEach((g) => {
    Dm(g, {
      request: 3e4,
      connect: 5e3
    });
  });
  const m = (g) => {
    const v = t.getAccessToken();
    return v && (g.headers.Authorization = `Bearer ${v}`), g;
  }, x = (g) => (e.productSlug && (g.headers["X-Product-Slug"] = e.productSlug), g), f = (g) => {
    if (e.extractTeamIdFromUrl) {
      const v = Fm();
      v && (g.headers["X-Team-Id"] = v);
    }
    return g;
  };
  h.forEach((g) => {
    g.interceptors.request.use(
      m,
      (v) => Promise.reject(v)
    );
  }), d.interceptors.request.use(
    x,
    (g) => Promise.reject(g)
  ), l.interceptors.request.use(
    f,
    (g) => Promise.reject(g)
  );
  let p = !1, y = [];
  const b = (g, v = null) => {
    y.forEach((C) => {
      g ? C.reject(g) : C.resolve(v);
    }), y = [];
  };
  return ((g) => {
    g.interceptors.response.use(
      (v) => v,
      async (v) => {
        var D, P, $, I, V, H, K;
        const C = v.config;
        if (((D = v.response) == null ? void 0 : D.status) === 401 && !C._retry) {
          if ((P = C.url) != null && P.includes("/auth/login") || ($ = C.url) != null && $.includes("/auth/register") || (I = C.url) != null && I.includes("/auth/refresh"))
            return Promise.reject(v);
          if (Bn())
            return t.clearTokens(), Promise.reject(v);
          if (p)
            return new Promise((te, ne) => {
              y.push({ resolve: te, reject: ne });
            }).then((te) => (C.headers.Authorization = `Bearer ${te}`, g(C))).catch((te) => Promise.reject(te));
          C._retry = !0, p = !0;
          const U = t.getRefreshToken();
          if (!U)
            return t.clearTokens(), Bn() || (window.location.href = n), Promise.reject(v);
          try {
            const te = await ue.post(
              `${e.authServiceUrl}/v1/auth/refresh`,
              { refresh_token: U },
              { headers: { "Content-Type": "application/json" } }
            ), { access_token: ne, refresh_token: se } = te.data;
            return t.setTokens(ne, se), b(null, ne), p = !1, C.headers.Authorization = `Bearer ${ne}`, g(C);
          } catch (te) {
            return b(te, null), p = !1, t.clearTokens(), Bn() || (window.location.href = n), Promise.reject(te);
          }
        }
        if (((V = v.response) == null ? void 0 : V.status) === 403) {
          const U = ((K = (H = v.response) == null ? void 0 : H.data) == null ? void 0 : K.detail) || "";
          if (U.includes("don't have access") || U.includes("activate your account"))
            return window.location.href = a, Promise.reject(v);
        }
        const w = Ll(v);
        return Promise.reject(new Error(w));
      }
    );
  })(l), {
    productApiClient: l,
    authApiClient: d,
    billingApiClient: c,
    platformApiClient: u,
    tokenManager: t,
    // Convenience exports for backward compatibility
    getAccessToken: t.getAccessToken,
    getRefreshToken: t.getRefreshToken,
    setTokens: t.setTokens,
    clearTokens: t.clearTokens
  };
}
function $m({
  authApiClient: e,
  tokenManager: t,
  authServiceUrl: n
}) {
  return {
    register: async (a) => (await e.post(
      "/v1/auth/register",
      a
    )).data,
    login: async (a) => {
      const r = await e.post(
        "/v1/auth/login",
        a
      ), { tokens: i } = r.data;
      return i != null && i.access_token && (i != null && i.refresh_token) && t.setTokens(i.access_token, i.refresh_token), r.data;
    },
    login2FA: async (a) => {
      const r = await e.post(
        "/v1/auth/login/2fa",
        a
      ), { tokens: i } = r.data;
      return i != null && i.access_token && (i != null && i.refresh_token) && t.setTokens(i.access_token, i.refresh_token), r.data;
    },
    selectTeam: async (a) => {
      const r = await e.post(
        "/v1/auth/select-team",
        a
      ), { access_token: i, refresh_token: o } = r.data;
      return t.setTokens(i, o), r.data;
    },
    logout: async (a) => {
      try {
        return (await e.post(
          "/v1/auth/logout",
          a ? { refresh_token: a } : null
        )).data;
      } finally {
        t.clearTokens();
      }
    },
    refreshToken: async (a) => {
      const r = await e.post(
        "/v1/auth/refresh",
        {
          refresh_token: a
        }
      ), { access_token: i, refresh_token: o } = r.data;
      return t.setTokens(i, o), r.data;
    },
    verifyEmail: async (a) => (await e.post(
      "/v1/auth/verify-email",
      { token: a }
    )).data,
    resendVerification: async () => (await e.post(
      "/v1/auth/send-verification"
    )).data,
    resendVerificationByEmail: async (a) => (await e.post(
      "/v1/auth/send-verification-email",
      { email: a }
    )).data,
    forgotPassword: async (a) => (await e.post(
      "/v1/auth/forgot-password",
      { email: a }
    )).data,
    resetPassword: async (a, r) => (await e.post(
      "/v1/auth/reset-password",
      {
        token: a,
        new_password: r
      }
    )).data,
    getCurrentUser: async () => (await e.get("/v1/auth/me")).data,
    googleAuth: () => {
      window.location.href = `${n}/v1/auth/oauth/google`;
    },
    githubAuth: () => {
      window.location.href = `${n}/v1/auth/oauth/github`;
    },
    reactivateAccount: async (a) => (await e.post("/v1/auth/reactivate-account", {
      token: a
    })).data,
    resendReactivation: async (a) => (await e.post(
      "/v1/auth/request-reactivation-email",
      { email: a }
    )).data,
    securityConfirm: async (a) => (await e.post("/v1/auth/security/confirm", {
      token: a
    })).data,
    securityDeny: async (a) => (await e.post("/v1/auth/security/deny", {
      token: a
    })).data,
    deviceConfirm: async (a) => (await e.post("/v1/auth/devices/confirm", { token: a })).data,
    deviceReport: async (a) => (await e.post("/v1/auth/devices/report", { token: a })).data,
    activateProduct: async (a) => (await e.post("/v1/auth/activate-product", { product_slug: a })).data,
    reactivateProduct: async (a, r) => (await e.post("/v1/auth/reactivate-product", { product_slug: a, token: r })).data,
    verifyEmailChange: async (a) => (await e.post(
      "/v1/auth/verify-email-change",
      { token: a }
    )).data,
    updateConsent: async (a) => (await e.patch("/v1/auth/users/me/consent", { marketing_consent: a })).data,
    getProductStatus: async (a) => (await e.get(`/v1/auth/products/${a}/status`)).data
  };
}
const Il = dt(
  void 0
);
function Uj(e) {
  const { authApiClient: t, tokenManager: n } = Lm(e), a = $m({
    authApiClient: t,
    tokenManager: n,
    authServiceUrl: e.authServiceUrl
  });
  function r({
    children: i,
    fetchUserTeams: o,
    defaultTeamPath: l = ""
  }) {
    const [d, c] = j(null), [u, h] = j([]), [m, x] = j(null), [f, p] = j(!0), y = Be(), b = ul(), k = u.find((M) => M.id === m) || null;
    le(() => {
      const M = b.pathname.match(/^\/t\/([^/]+)/);
      M && x(M[1]);
    }, [b.pathname]), le(() => {
      if (f || !d || u.length === 0) return;
      const M = b.pathname.match(/^\/t\/([^/]+)/);
      if (!M) return;
      const F = M[1];
      if (!u.some((q) => q.id === F)) {
        const q = u[0], Z = b.pathname.replace(
          `/t/${F}`,
          `/t/${q.id}`
        );
        console.warn(
          `Redirecting from inaccessible team ${F} to ${q.id}`
        ), y(Z, { replace: !0 });
      }
    }, [f, d, u, b.pathname, y]), le(() => {
      (async () => {
        if (n.getAccessToken())
          try {
            const G = await a.getCurrentUser();
            c(G);
            try {
              const q = await o();
              q.teams && q.teams.length > 0 && h(q.teams);
            } catch {
            }
          } catch {
            n.clearTokens();
          }
        p(!1);
      })();
    }, []);
    const g = async (M, F) => {
      p(!0);
      try {
        const G = await a.login({ email: M, password: F });
        if (G.requires_2fa && G.temp_token)
          return {
            requires2FA: !0,
            tempToken: G.temp_token,
            requiresTeamSelection: !1
          };
        G.user && c(G.user);
        try {
          const q = await o();
          if (q.teams && q.teams.length > 0) {
            h(q.teams);
            const Z = q.teams[0].id;
            return x(Z), {
              requires2FA: !1,
              requiresTeamSelection: !1,
              teamId: Z
            };
          }
        } catch {
        }
        return {
          requires2FA: !1,
          requiresTeamSelection: !1
        };
      } finally {
        p(!1);
      }
    }, v = async (M, F) => {
      p(!0);
      try {
        const G = await a.login2FA({
          temp_token: M,
          code: F
        });
        G.user && c(G.user);
        try {
          const q = await o();
          if (q.teams && q.teams.length > 0) {
            h(q.teams);
            const Z = q.teams[0].id;
            return x(Z), { teamId: Z };
          }
        } catch {
        }
        return { teamId: "" };
      } finally {
        p(!1);
      }
    }, C = (M) => {
      x(M);
    }, w = async () => {
      try {
        const M = await o();
        M.teams && h(M.teams);
      } catch {
      }
    }, D = async (M, F, G) => {
      p(!0);
      try {
        await a.selectTeam({
          temp_token: M,
          team_id: F
        });
        const q = await a.getCurrentUser();
        c(q), x(F), y(G || `/t/${F}${l}`);
      } finally {
        p(!1);
      }
    }, P = async (M, F, G, q, Z, ge, _e) => {
      p(!0);
      try {
        await a.register({
          email: M,
          password: F,
          name: G,
          team_name: q,
          invite_token: Z,
          product_slug: e.productSlug,
          accepted_terms: ge ?? !0,
          marketing_consent: _e ?? !1
        });
      } finally {
        p(!1);
      }
    }, $ = async (M) => {
      await a.updateConsent(M), d && c({ ...d, marketing_consent: M });
    }, I = async (M) => {
      try {
        await a.logout();
      } catch {
      } finally {
        n.clearTokens(), x(null), c(null), window.location.href = M ?? "/";
      }
    }, V = () => a.googleAuth(), H = () => a.githubAuth(), K = async (M, F, G) => {
      p(!0);
      try {
        n.setTokens(M, F);
        const q = await a.getCurrentUser();
        c(q), x(G);
        try {
          const Z = await o();
          Z.teams && h(Z.teams);
        } catch {
        }
      } finally {
        p(!1);
      }
    }, U = async (M) => {
      await a.verifyEmail(M);
    }, te = async () => {
      await a.resendVerification();
    }, ne = async (M) => {
      await a.resendVerificationByEmail(M);
    }, se = async (M) => {
      await a.forgotPassword(M);
    }, A = async (M, F) => {
      await a.resetPassword(M, F);
    }, z = async (M) => {
      p(!0);
      try {
        await a.reactivateAccount(M);
      } finally {
        p(!1);
      }
    }, R = async (M) => {
      await a.resendReactivation(M);
    }, N = async (M, F) => {
      p(!0);
      try {
        return await a.reactivateProduct(M, F);
      } finally {
        p(!1);
      }
    }, L = async (M) => {
      await a.verifyEmailChange(M);
    };
    return /* @__PURE__ */ s.jsx(
      Il.Provider,
      {
        value: {
          user: d,
          teamId: m,
          teams: u,
          currentTeam: k,
          login: g,
          login2FA: v,
          selectTeam: D,
          switchTeam: C,
          refreshTeams: w,
          signup: P,
          updateConsent: $,
          logout: I,
          googleAuth: V,
          githubAuth: H,
          handleOAuthCallback: K,
          verifyEmail: U,
          resendVerification: te,
          resendVerificationEmail: ne,
          forgotPassword: se,
          resetPassword: A,
          reactivateAccount: z,
          reactivateProduct: N,
          resendReactivation: R,
          verifyEmailChange: L,
          isLoading: f,
          isAuthenticated: !!d
        },
        children: i
      }
    );
  }
  return { AuthProvider: r, authApi: a, tokenManager: n };
}
function Ne() {
  const e = Se(Il);
  if (e === void 0)
    throw new Error("useAuth must be used within an AuthProvider");
  return e;
}
function Im(e) {
  const { apiClient: t } = e;
  return {
    getPlans: async () => (await t.get("/billing/plans")).data,
    getTeamPlans: async (n) => (await t.get(
      `/t/${n}/billing/plans`
    )).data,
    getSubscription: async (n) => (await t.get(
      `/t/${n}/billing/subscription`
    )).data,
    getUsage: async (n) => (await t.get(
      `/t/${n}/billing/usage`
    )).data,
    getCheckoutUrl: async (n, a) => (await t.post(
      `/t/${n}/billing/checkout?plan=${a}`
    )).data.url,
    getPortalUrl: async (n) => (await t.post(
      `/t/${n}/billing/portal`
    )).data.url,
    cancelSubscription: async (n) => (await t.post(
      `/t/${n}/billing/cancel`
    )).data,
    switchPlan: async (n, a) => (await t.post(
      `/t/${n}/billing/switch-plan`,
      { plan: a }
    )).data
  };
}
function Om(e) {
  switch (e) {
    case "canceled":
      return ["readonly", "no_exports", "no_create"];
    case "past_due":
      return ["limited_sending"];
    default:
      return [];
  }
}
function Vm(e, t = 14) {
  if (!e) return null;
  const n = new Date(e);
  return n.setDate(n.getDate() + t), n.toISOString();
}
const Ol = dt(void 0);
function qj(e, t) {
  const n = Im({
    apiClient: e,
    productApiUrl: t.productApiUrl
  }), a = t.gracePeriodDays ?? 14;
  function r({ children: i, getTeamId: o }) {
    var V;
    const [l, d] = j(null), [c, u] = j(null), [h, m] = j(
      null
    ), [x, f] = j(!0), [p, y] = j(null), b = o(), k = qe(async () => {
      var H, K;
      if (!b) {
        f(!1);
        return;
      }
      f(!0), y(null);
      try {
        const [U, te] = await Promise.all([
          n.getSubscription(b),
          n.getUsage(b)
        ]);
        d(U), u(te), m(U ? {
          planTier: U.plan.name,
          status: U.status,
          restrictions: Om(U.status),
          gracePeriodEnds: U.status === "past_due" ? Vm(
            U.current_period_end,
            a
          ) : null
        } : {
          planTier: "free",
          status: "none",
          restrictions: [],
          gracePeriodEnds: null
        });
      } catch (U) {
        y(
          ((K = (H = U.response) == null ? void 0 : H.data) == null ? void 0 : K.detail) || "Failed to load billing information"
        );
      } finally {
        f(!1);
      }
    }, [b]);
    le(() => {
      k();
    }, [k]);
    const g = async (H) => {
      if (b)
        try {
          const K = await n.getCheckoutUrl(b, H);
          window.location.href = K;
        } catch {
          y("Failed to open checkout");
        }
    }, v = async () => {
      if (b)
        try {
          const H = await n.getPortalUrl(b);
          window.location.href = H;
        } catch {
          y("Failed to open billing portal");
        }
    }, C = (h == null ? void 0 : h.status) === "past_due", w = (h == null ? void 0 : h.status) === "canceled", D = (h == null ? void 0 : h.status) === "active" || (h == null ? void 0 : h.status) === "trialing", P = (h == null ? void 0 : h.planTier) === "free" || (h == null ? void 0 : h.status) === "none", $ = (((V = h == null ? void 0 : h.restrictions) == null ? void 0 : V.length) ?? 0) > 0, I = (H) => {
      var K;
      return ((K = h == null ? void 0 : h.restrictions) == null ? void 0 : K.includes(H)) ?? !1;
    };
    return /* @__PURE__ */ s.jsx(
      Ol.Provider,
      {
        value: {
          subscription: l,
          usage: c,
          billingStatus: h,
          isLoading: x,
          error: p,
          refreshBilling: k,
          openCheckout: g,
          openCustomerPortal: v,
          isRestricted: $,
          hasRestriction: I,
          isPastDue: C,
          isCanceled: w,
          isActive: D,
          isFreeTier: P
        },
        children: i
      }
    );
  }
  return { BillingProvider: r, billingApi: n };
}
function Ds() {
  const e = Se(Ol);
  if (e === void 0)
    throw new Error("useBilling must be used within a BillingProvider");
  return e;
}
const Vl = {
  colors: {
    primary: "#4f46e5",
    // Indigo-600
    primaryLight: "#818cf8",
    // Indigo-400
    primaryDark: "#4338ca",
    // Indigo-700
    accent: "#818cf8"
    // Indigo-400
  }
};
function Bl(e) {
  const t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {
    r: parseInt(t[1], 16),
    g: parseInt(t[2], 16),
    b: parseInt(t[3], 16)
  } : null;
}
function Vt(e, t) {
  const n = Bl(e);
  if (!n) return e;
  const a = (l) => Math.min(255, Math.round(l + (255 - l) * t)), r = a(n.r).toString(16).padStart(2, "0"), i = a(n.g).toString(16).padStart(2, "0"), o = a(n.b).toString(16).padStart(2, "0");
  return `#${r}${i}${o}`;
}
function zn(e, t) {
  const n = Bl(e);
  if (!n) return e;
  const a = (l) => Math.max(0, Math.round(l * (1 - t))), r = a(n.r).toString(16).padStart(2, "0"), i = a(n.g).toString(16).padStart(2, "0"), o = a(n.b).toString(16).padStart(2, "0");
  return `#${r}${i}${o}`;
}
function Bm(e) {
  return {
    50: Vt(e, 0.95),
    100: Vt(e, 0.9),
    200: Vt(e, 0.75),
    300: Vt(e, 0.6),
    400: Vt(e, 0.4),
    500: Vt(e, 0.2),
    600: e,
    700: zn(e, 0.15),
    800: zn(e, 0.3),
    900: zn(e, 0.45)
  };
}
const zl = dt({ theme: Vl });
function zm({
  children: e,
  theme: t = Vl
}) {
  return le(() => {
    var a, r;
    const n = document.documentElement;
    if ((a = t.colors) != null && a.primary) {
      const i = Bm(t.colors.primary);
      Object.entries(i).forEach(([o, l]) => {
        n.style.setProperty(`--color-primary-${o}`, l);
      });
    }
    return (r = t.colors) != null && r.accent && n.style.setProperty("--color-accent", t.colors.accent), () => {
      [
        "50",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900"
      ].forEach((o) => {
        n.style.removeProperty(`--color-primary-${o}`);
      }), n.style.removeProperty("--color-accent");
    };
  }, [t]), /* @__PURE__ */ s.jsx(zl.Provider, { value: { theme: t }, children: e });
}
function Hj() {
  return Se(zl);
}
function Wj(e) {
  const { authApiClient: t, productApiClient: n } = e;
  return {
    // ==========================================================================
    // Profile endpoints (auth-service)
    // ==========================================================================
    getProfile: async () => (await t.get("/v1/auth/me")).data,
    updateProfile: async (a) => (await t.patch(
      "/v1/users/me",
      a
    )).data,
    changePassword: async (a) => (await t.post(
      "/v1/users/me/password",
      a
    )).data,
    deleteAccount: async (a) => (await t.delete(
      "/v1/users/me",
      { data: a }
    )).data,
    leaveProduct: async (a) => (await t.delete(
      `/v1/users/me/products/${a}`
    )).data,
    reactivateProduct: async (a, r) => (await t.post(
      `/v1/users/me/products/${a}/reactivate`,
      { token: r }
    )).data,
    deactivateAccount: async (a) => (await t.post(
      "/v1/users/me/deactivate",
      a
    )).data,
    cancelDeactivation: async () => (await t.post(
      "/v1/users/me/cancel-deactivation"
    )).data,
    setPassword: async (a) => (await t.post(
      "/v1/users/me/set-password",
      a
    )).data,
    disconnectOAuth: async (a) => (await t.post(
      "/v1/users/me/disconnect-oauth",
      a
    )).data,
    // ==========================================================================
    // Email Change endpoints (auth-service)
    // ==========================================================================
    requestEmailChange: async (a) => (await t.post(
      "/v1/auth/request-email-change",
      a
    )).data,
    verifyEmailChange: async (a) => (await t.post(
      "/v1/auth/verify-email-change",
      a
    )).data,
    // ==========================================================================
    // Avatar endpoints (auth-service)
    // ==========================================================================
    uploadAvatar: async (a) => {
      const r = new FormData();
      return r.append("file", a), (await t.post(
        "/v1/users/me/avatar",
        r,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      )).data;
    },
    deleteAvatar: async () => (await t.delete(
      "/v1/users/me/avatar"
    )).data,
    getAvatarUrl: async () => (await t.get(
      "/v1/users/me/avatar"
    )).data,
    // ==========================================================================
    // Team Logo endpoints (platform-service)
    // ==========================================================================
    uploadTeamLogo: async (a, r) => {
      const i = new FormData();
      return i.append("file", r), (await t.post(
        `/v1/teams/${a}/logo`,
        i,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      )).data;
    },
    deleteTeamLogo: async (a) => (await t.delete(
      `/v1/teams/${a}/logo`
    )).data,
    // ==========================================================================
    // 2FA endpoints (auth-service)
    // ==========================================================================
    setup2FA: async () => (await t.post(
      "/v1/users/me/2fa/setup"
    )).data,
    enable2FA: async (a) => (await t.post(
      "/v1/users/me/2fa/verify",
      a
    )).data,
    disable2FA: async (a) => (await t.post(
      "/v1/users/me/2fa/disable",
      a
    )).data,
    regenerateBackupCodes: async (a) => (await t.post(
      "/v1/users/me/2fa/regenerate-backup-codes",
      a
    )).data,
    get2FAStatus: async () => (await t.get(
      "/v1/users/me/2fa/status"
    )).data,
    // ==========================================================================
    // API Key endpoints (product backend, team-scoped, proxied to billing-service)
    // ==========================================================================
    listApiKeys: async (a) => (await n.get(
      `/t/${a}/api-keys`
    )).data,
    createApiKey: async (a, r) => (await n.post(
      `/t/${a}/api-keys`,
      r
    )).data,
    updateApiKey: async (a, r, i) => (await n.patch(
      `/t/${a}/api-keys/${r}`,
      i
    )).data,
    revokeApiKey: async (a, r) => (await n.delete(
      `/t/${a}/api-keys/${r}`
    )).data
  };
}
const Um = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function be(e) {
  if (!e || !Um.test(e))
    throw new Error(
      `Invalid teamId: expected a valid UUID, got "${e}". Make sure the user has a team selected before calling notification APIs.`
    );
}
function Kj(e) {
  const { platformApiClient: t } = e;
  return {
    // =========================================================================
    // Integrations
    // =========================================================================
    listIntegrations: async (n, a) => {
      be(n);
      const r = a ? { type: a } : {};
      return (await t.get("/v1/notifications/integrations", {
        params: r,
        headers: { "X-Team-Id": n }
      })).data.integrations;
    },
    getIntegration: async (n, a) => (be(n), (await t.get(
      `/v1/notifications/integrations/${a}`,
      { headers: { "X-Team-Id": n } }
    )).data),
    createIntegration: async (n, a) => (be(n), (await t.post(
      "/v1/notifications/integrations",
      a,
      { headers: { "X-Team-Id": n } }
    )).data),
    updateIntegration: async (n, a, r) => (be(n), (await t.put(
      `/v1/notifications/integrations/${a}`,
      r,
      { headers: { "X-Team-Id": n } }
    )).data),
    deleteIntegration: async (n, a) => {
      be(n), await t.delete(
        `/v1/notifications/integrations/${a}`,
        { headers: { "X-Team-Id": n } }
      );
    },
    testIntegration: async (n, a) => (be(n), (await t.post(
      `/v1/notifications/integrations/${a}/test`,
      {},
      { headers: { "X-Team-Id": n } }
    )).data),
    // =========================================================================
    // Preferences
    // =========================================================================
    getPreferences: async (n) => (be(n), (await t.get(
      "/v1/notifications/preferences",
      { headers: { "X-Team-Id": n } }
    )).data),
    updatePreferences: async (n, a) => (be(n), (await t.put(
      "/v1/notifications/preferences",
      a,
      { headers: { "X-Team-Id": n } }
    )).data),
    // =========================================================================
    // Email Recipients
    // =========================================================================
    listRecipients: async (n) => (be(n), (await t.get("/v1/notifications/recipients", { headers: { "X-Team-Id": n } })).data.recipients),
    addRecipient: async (n, a) => (be(n), (await t.post(
      "/v1/notifications/recipients",
      a,
      { headers: { "X-Team-Id": n } }
    )).data),
    removeRecipient: async (n, a) => {
      be(n), await t.delete(
        `/v1/notifications/recipients/${a}`,
        { headers: { "X-Team-Id": n } }
      );
    },
    // =========================================================================
    // Resource Overrides
    // =========================================================================
    getOverride: async (n, a) => {
      var r;
      be(n);
      try {
        return (await t.get(
          `/v1/notifications/overrides/${a}`,
          { headers: { "X-Team-Id": n } }
        )).data;
      } catch (i) {
        if (((r = i.response) == null ? void 0 : r.status) === 404)
          return null;
        throw i;
      }
    },
    setOverride: async (n, a, r) => (be(n), (await t.put(
      `/v1/notifications/overrides/${a}`,
      r,
      { headers: { "X-Team-Id": n } }
    )).data),
    deleteOverride: async (n, a) => {
      be(n), await t.delete(
        `/v1/notifications/overrides/${a}`,
        { headers: { "X-Team-Id": n } }
      );
    },
    // =========================================================================
    // Alert History
    // =========================================================================
    getAlertHistory: async (n, a) => (be(n), (await t.get(
      "/v1/notifications/history",
      { params: a, headers: { "X-Team-Id": n } }
    )).data),
    // =========================================================================
    // Alert Profiles
    // =========================================================================
    listAlertProfiles: async (n) => (be(n), (await t.get("/v1/notifications/alert-profiles", {
      headers: { "X-Team-Id": n }
    })).data.profiles),
    getAlertProfile: async (n, a) => (be(n), (await t.get(
      `/v1/notifications/alert-profiles/${a}`,
      { headers: { "X-Team-Id": n } }
    )).data),
    createAlertProfile: async (n, a) => (be(n), (await t.post(
      "/v1/notifications/alert-profiles",
      a,
      { headers: { "X-Team-Id": n } }
    )).data),
    updateAlertProfile: async (n, a, r) => (be(n), (await t.patch(
      `/v1/notifications/alert-profiles/${a}`,
      r,
      { headers: { "X-Team-Id": n } }
    )).data),
    deleteAlertProfile: async (n, a) => {
      be(n), await t.delete(
        `/v1/notifications/alert-profiles/${a}`,
        { headers: { "X-Team-Id": n } }
      );
    },
    restoreAlertProfile: async (n, a) => (be(n), (await t.post(
      `/v1/notifications/alert-profiles/${a}/restore`,
      {},
      { headers: { "X-Team-Id": n } }
    )).data),
    setDefaultAlertProfile: async (n, a) => (be(n), (await t.post(
      `/v1/notifications/alert-profiles/${a}/set-default`,
      {},
      { headers: { "X-Team-Id": n } }
    )).data)
  };
}
function qm(e) {
  const { sageApiUrl: t, formKey: n, productSlug: a } = e;
  return {
    submitContactForm: async (r) => {
      const i = await fetch(`${t}/v1/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          form_key: n,
          name: r.name,
          email: r.email,
          subject: r.subject,
          message: r.message,
          captcha_token: r.captchaToken,
          source_product: a,
          source_url: r.sourceUrl
        })
      });
      if (!i.ok)
        return {
          success: !1,
          message: (await i.json().catch(() => ({ detail: "Request failed" }))).detail || "Failed to submit contact form"
        };
      const o = await i.json();
      return {
        success: o.success,
        message: o.message,
        ticketId: o.ticket_id
      };
    }
  };
}
function Yj(e) {
  const t = qm(e);
  return async (n, a) => {
    if (!a)
      throw new Error("Please complete the captcha verification");
    const r = await t.submitContactForm({
      name: n.name,
      email: n.email,
      subject: n.subject,
      message: n.message,
      captchaToken: a,
      sourceUrl: typeof window < "u" ? window.location.href : void 0
    });
    if (!r.success)
      throw new Error(r.message);
  };
}
function Gj(e) {
  const { apiUrl: t } = e;
  return async (n, a) => {
    if (!a)
      throw new Error("Please complete the captcha verification");
    const r = await fetch(`${t}/v1/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: n.name,
        email: n.email,
        subject: n.subject,
        message: n.message,
        captcha_token: a,
        source_url: typeof window < "u" ? window.location.href : void 0
      })
    });
    if (!r.ok) {
      const o = await r.json().catch(() => ({ detail: "Request failed" }));
      throw new Error(
        o.detail || o.message || "Failed to submit contact form"
      );
    }
    const i = await r.json();
    if (!i.success)
      throw new Error(i.message);
  };
}
function Ul(e) {
  var t, n, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = Ul(e[t])) && (a && (a += " "), a += n);
  } else for (n in e) e[n] && (a && (a += " "), a += n);
  return a;
}
function Xa() {
  for (var e, t, n = 0, a = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = Ul(e)) && (a && (a += " "), a += t);
  return a;
}
const S = vt(
  ({
    className: e,
    variant: t = "primary",
    size: n = "md",
    isLoading: a,
    children: r,
    disabled: i,
    ...o
  }, l) => /* @__PURE__ */ s.jsxs(
    "button",
    {
      ref: l,
      className: Xa(
        "btn",
        `btn-${t}`,
        n !== "md" && `btn-${n}`,
        a && "is-loading",
        e
      ),
      disabled: i || a,
      ...o,
      children: [
        a && /* @__PURE__ */ s.jsx("span", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ s.jsx("span", { className: "spinner spinner-sm" }) }),
        r
      ]
    }
  )
);
S.displayName = "Button";
function Q({
  children: e,
  className: t = "",
  ...n
}) {
  return /* @__PURE__ */ s.jsx("div", { className: `form-group ${t}`, ...n, children: e });
}
function J({
  children: e,
  required: t,
  className: n = "",
  ...a
}) {
  return /* @__PURE__ */ s.jsxs("label", { className: `form-label ${n}`, ...a, children: [
    e,
    t && /* @__PURE__ */ s.jsx("span", { className: "text-red-500 ml-1", children: "*" })
  ] });
}
const re = vt(
  ({ error: e, className: t = "", ...n }, a) => /* @__PURE__ */ s.jsx(
    "input",
    {
      ref: a,
      className: `form-input ${e ? "is-error" : ""} ${t}`,
      ...n
    }
  )
);
re.displayName = "FormInput";
const Hm = vt(
  ({ error: e, className: t = "", ...n }, a) => /* @__PURE__ */ s.jsx(
    "textarea",
    {
      ref: a,
      className: `form-textarea ${e ? "is-error" : ""} ${t}`,
      ...n
    }
  )
);
Hm.displayName = "FormTextarea";
function Xj({
  children: e,
  className: t = "",
  ...n
}) {
  return e ? /* @__PURE__ */ s.jsx("p", { className: `form-error ${t}`, ...n, children: e }) : null;
}
function et({
  children: e,
  className: t = "",
  ...n
}) {
  return /* @__PURE__ */ s.jsx("p", { className: `form-hint ${t}`, ...n, children: e });
}
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wm = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), ql = (...e) => e.filter((t, n, a) => !!t && t.trim() !== "" && a.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Km = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ym = vt(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: a,
    className: r = "",
    children: i,
    iconNode: o,
    ...l
  }, d) => en(
    "svg",
    {
      ref: d,
      ...Km,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: a ? Number(n) * 24 / Number(t) : n,
      className: ql("lucide", r),
      ...l
    },
    [
      ...o.map(([c, u]) => en(c, u)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const W = (e, t) => {
  const n = vt(
    ({ className: a, ...r }, i) => en(Ym, {
      ref: i,
      iconNode: t,
      className: ql(`lucide-${Wm(e)}`, a),
      ...r
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rt = W("ArrowLeft", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xt = W("Bell", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $t = W("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jn = W("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hl = W("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $e = W("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nt = W("CircleCheckBig", [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wl = W("CircleX", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ft = W("Clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ja = W("Copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kl = W("CreditCard", [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const It = W("Crown", [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gm = W("EllipsisVertical", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xm = W("ExternalLink", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ys = W("EyeOff", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xt = W("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jm = W("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zm = W("House", [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Za = W("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sn = W("Key", [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qm = W("LifeBuoy", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yl = W("Link2", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gl = W("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pt = W("Lock", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qa = W("LogOut", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ke = W("Mail", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ef = W("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const er = W("MessageSquare", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tr = W("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jt = W("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bs = W("RefreshCw", [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xl = W("Save", [
  [
    "path",
    {
      d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      key: "1c8476"
    }
  ],
  ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7", key: "1ydtos" }],
  ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7", key: "t51u73" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tf = W("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sf = W("Send", [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jl = W("Settings", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const js = W("ShieldCheck", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const da = W("ShieldOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ns = W("Shield", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sr = W("Slack", [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nf = W("Smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nn = W("Star", [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const af = W("TestTube", [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2", key: "125lnx" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rf = W("ToggleLeft", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const of = W("ToggleRight", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ze = W("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ki = W("TrendingUp", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gt = W("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zl = W("Unlink", [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lf = W("UserPlus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const an = W("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yt = W("Users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vs = W("Webhook", [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ot = W("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ql = W("Zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]), cf = vt(
  ({ className: e = "", onChange: t, ...n }, a) => {
    const r = (i) => {
      if (t)
        if (t.length <= 1)
          try {
            t(i.target.value);
          } catch {
            t(i);
          }
        else
          t(i);
    };
    return /* @__PURE__ */ s.jsxs("div", { className: "search-input-wrapper", children: [
      /* @__PURE__ */ s.jsx(tf, { className: "search-input-icon" }),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: a,
          type: "text",
          className: `search-input ${e}`,
          onChange: r,
          ...n
        }
      )
    ] });
  }
);
cf.displayName = "SearchInput";
const df = {
  default: "",
  highlighted: "card-highlighted",
  stat: "card-stat",
  interactive: "card-interactive"
};
function rn({
  children: e,
  className: t = "",
  variant: n = "default",
  ...a
}) {
  return /* @__PURE__ */ s.jsx("div", { className: `card ${df[n]} ${t}`, ...a, children: e });
}
function Ci({
  children: e,
  className: t = "",
  ...n
}) {
  return /* @__PURE__ */ s.jsx("div", { className: `card-header ${t}`, ...n, children: e });
}
function Ti({
  children: e,
  className: t = "",
  ...n
}) {
  return /* @__PURE__ */ s.jsx("h3", { className: `card-title ${t}`, ...n, children: e });
}
function Si({
  children: e,
  className: t = "",
  ...n
}) {
  return /* @__PURE__ */ s.jsx("p", { className: `card-description ${t}`, ...n, children: e });
}
function Ai({
  children: e,
  className: t = "",
  ...n
}) {
  return /* @__PURE__ */ s.jsx("div", { className: `card-body ${t}`, ...n, children: e });
}
function Jj({
  children: e,
  className: t = "",
  ...n
}) {
  return /* @__PURE__ */ s.jsx("div", { className: `card-footer ${t}`, ...n, children: e });
}
const uf = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl"
};
function vn({
  isOpen: e,
  onClose: t,
  children: n,
  title: a,
  description: r,
  size: i = "md",
  showCloseButton: o = !0
}) {
  return le(() => {
    function l(d) {
      d.key === "Escape" && t();
    }
    return e && (document.addEventListener("keydown", l), document.body.style.overflow = "hidden"), () => {
      document.removeEventListener("keydown", l), document.body.style.overflow = "";
    };
  }, [e, t]), e ? /* @__PURE__ */ s.jsxs("div", { className: "fixed inset-0 z-50", children: [
    /* @__PURE__ */ s.jsx("div", { className: "modal-overlay", onClick: t, "aria-hidden": "true" }),
    /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4", children: /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: `bg-white rounded-xl shadow-xl w-full ${uf[i]} max-h-[90vh] overflow-y-auto relative`,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": a ? "modal-title" : void 0,
        children: [
          (a || o) && /* @__PURE__ */ s.jsxs("div", { className: "modal-header flex items-center justify-between", children: [
            /* @__PURE__ */ s.jsxs("div", { children: [
              a && /* @__PURE__ */ s.jsx("h2", { id: "modal-title", className: "modal-title", children: a }),
              r && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mt-1", children: r })
            ] }),
            o && /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: t,
                className: "p-1 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors",
                "aria-label": "Close modal",
                children: /* @__PURE__ */ s.jsx(Ot, { className: "w-5 h-5" })
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "modal-body", children: n })
        ]
      }
    ) })
  ] }) : null;
}
function nr({ children: e }) {
  return /* @__PURE__ */ s.jsx("div", { className: "modal-footer", children: e });
}
function ws({
  isOpen: e,
  onClose: t,
  onConfirm: n,
  title: a,
  message: r,
  confirmText: i,
  confirmLabel: o,
  cancelText: l = "Cancel",
  variant: d,
  confirmVariant: c,
  isLoading: u = !1
}) {
  const h = d || c || "default", m = i || o || "Confirm", x = {
    danger: "btn-danger",
    warning: "bg-amber-600 text-white hover:bg-amber-700",
    default: "btn-primary"
  };
  return /* @__PURE__ */ s.jsxs(vn, { isOpen: e, onClose: t, title: a, children: [
    /* @__PURE__ */ s.jsx("div", { className: "text-slate-600 mb-6", children: r }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: t,
          className: "btn btn-outline flex-1",
          disabled: u,
          children: l
        }
      ),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: n,
          className: `btn flex-1 ${x[h]}`,
          disabled: u,
          children: u ? "Loading..." : m
        }
      )
    ] })
  ] });
}
function hf({
  isOpen: e,
  onClose: t,
  onCreateTeam: n,
  onTeamCreated: a
}) {
  const [r, i] = j(""), [o, l] = j(!1), [d, c] = j(null), u = async (m) => {
    if (m.preventDefault(), !r.trim()) {
      c("Team name is required");
      return;
    }
    l(!0), c(null);
    try {
      const x = await n(r.trim());
      i(""), t(), a == null || a(x);
    } catch (x) {
      c(x instanceof Error ? x.message : "Failed to create team");
    } finally {
      l(!1);
    }
  }, h = () => {
    o || (i(""), c(null), t());
  };
  return /* @__PURE__ */ s.jsx(
    vn,
    {
      isOpen: e,
      onClose: h,
      title: "Create New Team",
      description: "Create a workspace for you and your team members.",
      children: /* @__PURE__ */ s.jsxs("form", { onSubmit: u, children: [
        /* @__PURE__ */ s.jsxs("div", { className: "mb-4", children: [
          /* @__PURE__ */ s.jsx("label", { htmlFor: "team-name", className: "form-label", children: "Team Name" }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              id: "team-name",
              type: "text",
              className: "form-input",
              placeholder: "My Awesome Team",
              value: r,
              onChange: (m) => i(m.target.value),
              disabled: o,
              autoFocus: !0
            }
          ),
          d && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-red-600 mt-1", children: d })
        ] }),
        /* @__PURE__ */ s.jsxs(nr, { children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              onClick: h,
              className: "btn btn-outline",
              disabled: o,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "submit",
              className: "btn btn-primary",
              disabled: o || !r.trim(),
              children: o ? "Creating..." : "Create Team"
            }
          )
        ] })
      ] })
    }
  );
}
function Zj({
  title: e,
  description: t,
  icon: n,
  children: a,
  danger: r = !1,
  className: i = ""
}) {
  const o = r ? "bg-red-50 border-red-200" : "bg-white border-slate-200", l = r ? "text-red-600" : "text-primary-600";
  return /* @__PURE__ */ s.jsxs(
    "section",
    {
      className: `${o} border rounded-2xl shadow-sm p-6 ${i}`,
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-6", children: [
          n && /* @__PURE__ */ s.jsx(n, { className: `w-6 h-6 ${l}` }),
          /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900", children: e }),
            t && /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mt-1", children: t })
          ] })
        ] }),
        a
      ]
    }
  );
}
function Qj({
  label: e,
  description: t,
  action: n,
  children: a
}) {
  return /* @__PURE__ */ s.jsxs("div", { className: "py-4 border-b border-slate-100 last:border-0 last:pb-0 first:pt-0", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
        /* @__PURE__ */ s.jsx("p", { className: "font-medium text-slate-900", children: e }),
        t && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mt-0.5", children: t })
      ] }),
      n && /* @__PURE__ */ s.jsx("div", { className: "ml-4", children: n })
    ] }),
    a && /* @__PURE__ */ s.jsx("div", { className: "mt-3", children: a })
  ] });
}
function ev({
  icon: e,
  title: t,
  subtitle: n,
  actions: a,
  active: r
}) {
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: `flex items-center justify-between p-4 rounded-lg border ${r ? "bg-primary-50 border-primary-200" : "bg-slate-50 border-slate-200"}`,
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
          e && /* @__PURE__ */ s.jsx("div", { className: "flex-shrink-0", children: e }),
          /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsx("p", { className: "font-medium text-slate-900", children: t }),
            n && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: n })
          ] })
        ] }),
        a && /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-2", children: a })
      ]
    }
  );
}
const mf = {
  info: {
    className: "alert-info",
    Icon: Za
  },
  success: {
    className: "alert-success",
    Icon: nt
  },
  warning: {
    className: "alert-warning",
    Icon: gt
  },
  error: {
    className: "alert-error",
    Icon: $e
  }
};
function Zt({
  variant: e = "info",
  title: t,
  children: n,
  dismissible: a = !1,
  onDismiss: r,
  icon: i,
  className: o = ""
}) {
  const l = mf[e], d = l.Icon;
  return /* @__PURE__ */ s.jsx("div", { className: `alert ${l.className} ${o}`, role: "alert", children: /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
    /* @__PURE__ */ s.jsx("div", { className: "flex-shrink-0", children: i || /* @__PURE__ */ s.jsx(d, { className: "w-5 h-5" }) }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
      t && /* @__PURE__ */ s.jsx("h4", { className: "font-medium mb-1", children: t }),
      /* @__PURE__ */ s.jsx("div", { className: "text-sm", children: n })
    ] }),
    a && r && /* @__PURE__ */ s.jsx(
      "button",
      {
        onClick: r,
        className: "flex-shrink-0 p-1 rounded hover:bg-black/10 transition-colors",
        "aria-label": "Dismiss alert",
        children: /* @__PURE__ */ s.jsx(Ot, { className: "w-4 h-4" })
      }
    )
  ] }) });
}
const ff = {
  primary: "badge-primary",
  success: "badge-success",
  warning: "badge-warning",
  error: "badge-error",
  gray: "badge-gray"
}, xf = {
  sm: "text-xs px-2 py-0.5",
  md: "text-sm px-2.5 py-0.5"
};
function Pi({
  variant: e = "gray",
  size: t = "sm",
  children: n,
  className: a = ""
}) {
  return /* @__PURE__ */ s.jsx(
    "span",
    {
      className: `badge ${ff[e]} ${xf[t]} ${a}`,
      children: n
    }
  );
}
const pf = {
  sm: "spinner-sm",
  md: "spinner-md",
  lg: "spinner-lg"
};
function he({ size: e = "md", className: t = "" }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: `spinner ${pf[e]} ${t}`,
      role: "status",
      "aria-label": "Loading"
    }
  );
}
function gf({ message: e = "Loading..." }) {
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen flex flex-col items-center justify-center bg-slate-50", children: [
    /* @__PURE__ */ s.jsx(he, { size: "lg" }),
    e && /* @__PURE__ */ s.jsx("p", { className: "mt-4 text-slate-500", children: e })
  ] });
}
const yf = vt(
  ({
    checked: e,
    onChange: t,
    disabled: n = !1,
    size: a = "md",
    className: r = "",
    ...i
  }, o) => {
    const d = {
      sm: {
        track: "w-9 h-5",
        thumb: "h-4 w-4",
        translate: "translate-x-4"
      },
      md: {
        track: "w-11 h-6",
        thumb: "h-5 w-5",
        translate: "translate-x-5"
      }
    }[a];
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ref: o,
        type: "button",
        role: "switch",
        "aria-checked": e,
        disabled: n,
        onClick: () => !n && t(!e),
        className: `
          relative inline-flex items-center rounded-full transition-colors
          focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2
          ${d.track}
          ${e ? "bg-accent-600" : "bg-slate-300"}
          ${n ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
          ${r}
        `,
        ...i,
        children: /* @__PURE__ */ s.jsx(
          "span",
          {
            className: `
            inline-block rounded-full bg-white shadow-sm transition-transform
            ${d.thumb}
            ${e ? d.translate : "translate-x-0.5"}
          `
          }
        )
      }
    );
  }
);
yf.displayName = "Toggle";
const bf = {
  sm: "container-sm",
  md: "container-md",
  lg: "container-lg",
  xl: "container-xl"
};
function Ve({
  children: e,
  className: t = "",
  size: n = "lg"
}) {
  return /* @__PURE__ */ s.jsx("div", { className: `container ${bf[n]} ${t}`, children: e });
}
const jf = {
  h1: "heading-1",
  h2: "heading-2",
  h3: "heading-3",
  h4: "heading-4",
  h5: "heading-5",
  h6: "heading-5"
};
function ua({
  children: e,
  className: t = "",
  as: n = "h2"
}) {
  return /* @__PURE__ */ s.jsx(n, { className: `${jf[n]} ${t}`, children: e });
}
function fs({ children: e, className: t = "", size: n = "base" }) {
  const a = n === "sm" ? "text-small" : "text-body";
  return /* @__PURE__ */ s.jsx("p", { className: `${a} ${t}`, children: e });
}
function tv({ children: e, className: t = "" }) {
  return /* @__PURE__ */ s.jsx("span", { className: `text-label ${t}`, children: e });
}
function sv({ children: e, className: t = "" }) {
  return /* @__PURE__ */ s.jsx("div", { className: `overflow-x-auto ${t}`, children: /* @__PURE__ */ s.jsx("table", { className: "table", children: e }) });
}
function nv({ children: e, className: t = "" }) {
  return /* @__PURE__ */ s.jsx("thead", { className: t, children: e });
}
function av({ children: e, className: t = "" }) {
  return /* @__PURE__ */ s.jsx("tbody", { className: t, children: e });
}
function rv({
  children: e,
  className: t = "",
  onClick: n,
  ariaLabel: a
}) {
  const r = !!n, i = (o) => {
    n && (o.key === "Enter" || o.key === " ") && (o.preventDefault(), n());
  };
  return /* @__PURE__ */ s.jsx(
    "tr",
    {
      className: `${r ? "cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary focus:ring-inset" : ""} ${t}`,
      onClick: n,
      onKeyDown: r ? i : void 0,
      tabIndex: r ? 0 : void 0,
      role: r ? "button" : void 0,
      "aria-label": r ? a : void 0,
      children: e
    }
  );
}
function iv({ children: e, className: t = "" }) {
  return /* @__PURE__ */ s.jsx("th", { className: t, children: e });
}
function ov({
  children: e,
  className: t = "",
  colSpan: n
}) {
  return /* @__PURE__ */ s.jsx("td", { className: t, colSpan: n, children: e });
}
function Ei({
  title: e,
  subtitle: t,
  backTo: n,
  backLabel: a,
  useHistoryBack: r,
  action: i,
  className: o = ""
}) {
  const l = Be(), d = () => {
    l(-1);
  }, c = n || r;
  return /* @__PURE__ */ s.jsx("header", { className: `page-header ${o}`, children: /* @__PURE__ */ s.jsx(Ve, { children: /* @__PURE__ */ s.jsxs("div", { className: "page-header-inner", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-4", children: [
      c && (r ? /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: d,
          className: "page-header-back",
          "aria-label": a || "Go back",
          children: /* @__PURE__ */ s.jsx(rt, { className: "w-5 h-5" })
        }
      ) : /* @__PURE__ */ s.jsx(
        _,
        {
          to: n,
          className: "page-header-back",
          "aria-label": a || "Go back",
          children: /* @__PURE__ */ s.jsx(rt, { className: "w-5 h-5" })
        }
      )),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("h1", { className: "page-header-title", children: e }),
        t && /* @__PURE__ */ s.jsx("p", { className: "page-header-subtitle", children: t })
      ] })
    ] }),
    i && /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-2", children: i })
  ] }) }) });
}
function lv({
  icon: e,
  title: t,
  description: n,
  action: a,
  className: r = ""
}) {
  return /* @__PURE__ */ s.jsxs("div", { className: `empty-state ${r}`, children: [
    /* @__PURE__ */ s.jsx("div", { className: "empty-state-icon", children: e }),
    /* @__PURE__ */ s.jsx("h3", { className: "empty-state-title", children: t }),
    /* @__PURE__ */ s.jsx("p", { className: "empty-state-description", children: n }),
    a && /* @__PURE__ */ s.jsx(S, { onClick: a.onClick, children: a.label })
  ] });
}
function Oe({ className: e = "" }) {
  return /* @__PURE__ */ s.jsx("div", { className: `skeleton ${e}` });
}
function mt({ className: e = "" }) {
  return /* @__PURE__ */ s.jsx(Oe, { className: `h-4 ${e}` });
}
function vf({ className: e = "" }) {
  return /* @__PURE__ */ s.jsx(Oe, { className: `h-6 w-48 ${e}` });
}
function wf({ className: e = "" }) {
  return /* @__PURE__ */ s.jsx(Oe, { className: `w-10 h-10 rounded-full ${e}` });
}
function cv({ className: e = "" }) {
  return /* @__PURE__ */ s.jsx(Oe, { className: `h-10 w-24 rounded-lg ${e}` });
}
function dv() {
  return /* @__PURE__ */ s.jsxs("div", { className: "card p-6", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-4 mb-4", children: [
      /* @__PURE__ */ s.jsx(wf, {}),
      /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
        /* @__PURE__ */ s.jsx(vf, { className: "mb-2" }),
        /* @__PURE__ */ s.jsx(mt, { className: "w-32" })
      ] })
    ] }),
    /* @__PURE__ */ s.jsx(mt, { className: "w-full mb-2" }),
    /* @__PURE__ */ s.jsx(mt, { className: "w-3/4" })
  ] });
}
function uv() {
  return /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-4 p-4 border-b border-slate-200", children: [
    /* @__PURE__ */ s.jsx(mt, { className: "w-1/4" }),
    /* @__PURE__ */ s.jsx(mt, { className: "w-1/4" }),
    /* @__PURE__ */ s.jsx(mt, { className: "w-1/4" }),
    /* @__PURE__ */ s.jsx(mt, { className: "w-1/4" })
  ] });
}
function hv() {
  return /* @__PURE__ */ s.jsxs("div", { className: "stat-card", children: [
    /* @__PURE__ */ s.jsx(mt, { className: "w-24 mb-2" }),
    /* @__PURE__ */ s.jsx(Oe, { className: "h-8 w-16" })
  ] });
}
function mv({ items: e, className: t = "" }) {
  return /* @__PURE__ */ s.jsx("nav", { className: `breadcrumbs ${t}`, "aria-label": "Breadcrumb", children: e.map((n, a) => {
    const r = a === e.length - 1;
    return /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
      n.href && !r ? /* @__PURE__ */ s.jsx(_, { to: n.href, className: "breadcrumbs-link", children: n.label }) : /* @__PURE__ */ s.jsx(
        "span",
        {
          className: r ? "breadcrumbs-current" : "breadcrumbs-link",
          children: n.label
        }
      ),
      !r && /* @__PURE__ */ s.jsx(Hl, { className: "breadcrumbs-separator" })
    ] }, a);
  }) });
}
function Nf({
  label: e,
  title: t,
  subtitle: n,
  value: a,
  suffix: r,
  icon: i,
  trend: o,
  trendDirection: l = "up",
  className: d = ""
}) {
  const c = e || t, u = () => {
    if (!i) return null;
    if (ai(i))
      return i;
    const m = i;
    return /* @__PURE__ */ s.jsx(m, { className: "w-5 h-5 text-primary-600" });
  }, h = () => {
    if (!o) return null;
    const m = l === "up" ? "text-green-600" : l === "down" ? "text-red-600" : "text-slate-500";
    if (ai(o))
      return /* @__PURE__ */ s.jsx("p", { className: `text-xs ${m}`, children: o });
    if (typeof o == "string")
      return /* @__PURE__ */ s.jsx("p", { className: `text-xs ${m}`, children: o });
    const x = o, f = l === "up" ? "+" : l === "down" ? "-" : "";
    return /* @__PURE__ */ s.jsxs("p", { className: `text-xs ${m}`, children: [
      f,
      x.value,
      " ",
      x.label
    ] });
  };
  return i ? /* @__PURE__ */ s.jsx(
    "div",
    {
      className: `bg-white border border-slate-200 rounded-xl p-4 ${d}`,
      children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx("div", { className: "p-2 bg-primary-50 rounded-lg", children: u() }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-slate-500", children: [
            c,
            n && /* @__PURE__ */ s.jsxs("span", { className: "ml-1", children: [
              "· ",
              n
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("p", { className: "text-xl font-semibold text-slate-900", children: [
            a,
            r && /* @__PURE__ */ s.jsxs("span", { className: "text-sm font-normal", children: [
              " ",
              r
            ] })
          ] }),
          h()
        ] })
      ] })
    }
  ) : /* @__PURE__ */ s.jsxs("div", { className: `stat-card ${d}`, children: [
    /* @__PURE__ */ s.jsxs("p", { className: "stat-card-label", children: [
      c,
      n && /* @__PURE__ */ s.jsxs("span", { className: "ml-1 text-slate-400", children: [
        "· ",
        n
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "stat-card-value", children: [
      a,
      r && /* @__PURE__ */ s.jsxs("span", { className: "stat-card-suffix", children: [
        " ",
        r
      ] })
    ] }),
    h()
  ] });
}
function fv({
  title: e,
  subtitle: t,
  icon: n,
  stats: a,
  metadata: r,
  className: i = ""
}) {
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: `bg-gradient-to-br from-primary-50 to-primary-100/50 border border-primary-200 rounded-2xl p-6 ${i}`,
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between mb-4", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
            n,
            /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsx("h2", { className: "text-lg font-semibold text-slate-900", children: e }),
              /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: t })
            ] })
          ] }),
          r
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: `grid grid-cols-2 md:grid-cols-${a.length} gap-4`, children: a.map((o, l) => /* @__PURE__ */ s.jsx(Nf, { ...o }, l)) })
      ]
    }
  );
}
function hs({
  title: e,
  children: t,
  icon: n,
  defaultOpen: a = !1,
  className: r = ""
}) {
  const [i, o] = j(a);
  return /* @__PURE__ */ s.jsxs("div", { className: `accordion ${r}`, children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        onClick: () => o(!i),
        className: "accordion-trigger",
        "aria-expanded": i,
        children: [
          /* @__PURE__ */ s.jsxs("span", { className: "accordion-title", children: [
            n && /* @__PURE__ */ s.jsx("span", { className: "accordion-icon-prefix", children: n }),
            e
          ] }),
          /* @__PURE__ */ s.jsx(jn, { className: `accordion-icon ${i ? "is-open" : ""}` })
        ]
      }
    ),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: "accordion-content",
        style: {
          maxHeight: i ? "2000px" : "0",
          opacity: i ? 1 : 0
        },
        children: /* @__PURE__ */ s.jsx("div", { className: "accordion-body", children: t })
      }
    )
  ] });
}
function ec({
  children: e,
  className: t = ""
}) {
  return /* @__PURE__ */ s.jsx("div", { className: t, children: e });
}
const kf = {
  1: "detail-grid-1",
  2: "detail-grid-2",
  3: "detail-grid-3"
};
function xv({
  children: e,
  columns: t = 2,
  className: n = ""
}) {
  return /* @__PURE__ */ s.jsx("dl", { className: `detail-grid ${kf[t]} ${n}`, children: e });
}
function pv({
  label: e,
  value: t,
  icon: n,
  className: a = ""
}) {
  return /* @__PURE__ */ s.jsxs("div", { className: `${n ? "flex items-start gap-3" : ""} ${a}`, children: [
    n && /* @__PURE__ */ s.jsx("div", { className: "flex-shrink-0 mt-0.5", children: n }),
    /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx("dt", { className: "detail-row-label", children: e }),
      /* @__PURE__ */ s.jsx("dd", { className: "detail-row-value", children: t })
    ] })
  ] });
}
function gv({
  name: e,
  price: t,
  period: n,
  description: a,
  features: r,
  cta: i,
  recommended: o = !1,
  badge: l,
  onClick: d,
  isLoading: c = !1,
  className: u = ""
}) {
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: `relative h-full ${o ? "lg:scale-105" : ""} ${u}`,
      children: [
        l && /* @__PURE__ */ s.jsx("div", { className: "pricing-card-badge", children: /* @__PURE__ */ s.jsx("span", { className: "pricing-card-badge-text", children: l }) }),
        /* @__PURE__ */ s.jsx("div", { className: `pricing-card ${o ? "is-recommended" : ""}`, children: /* @__PURE__ */ s.jsxs("div", { className: "space-y-6", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "space-y-2", children: [
            /* @__PURE__ */ s.jsx("h3", { className: "pricing-card-name", children: e }),
            /* @__PURE__ */ s.jsx("p", { className: "pricing-card-description", children: a })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-baseline gap-2", children: [
            /* @__PURE__ */ s.jsx("span", { className: "pricing-card-price", children: t }),
            n && /* @__PURE__ */ s.jsxs("span", { className: "pricing-card-period", children: [
              "/",
              n
            ] })
          ] }),
          /* @__PURE__ */ s.jsx(
            S,
            {
              variant: o ? "primary" : "outline",
              size: "lg",
              className: "w-full",
              onClick: d,
              disabled: c,
              children: c ? "Loading..." : i
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: "border-t border-slate-200" }),
          /* @__PURE__ */ s.jsx("ul", { className: "space-y-3", children: r.map((h, m) => /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-3", children: [
            /* @__PURE__ */ s.jsx(
              $t,
              {
                className: `w-5 h-5 flex-shrink-0 ${o ? "text-primary-600" : "text-slate-400"}`
              }
            ),
            /* @__PURE__ */ s.jsx("span", { className: "text-slate-600 text-sm", children: h })
          ] }, m)) })
        ] }) })
      ]
    }
  );
}
function yv({
  logo: e,
  productName: t,
  navItems: n = [],
  showProgress: a = !0,
  position: r = "fixed",
  variant: i = "transparent",
  shadowOnScroll: o = "sm",
  className: l = ""
}) {
  const [d, c] = j(!1), [u, h] = j(!1), [m, x] = j(0);
  le(() => {
    const g = () => {
      if (c(window.scrollY > 20), a) {
        const v = window.innerHeight, C = document.documentElement.scrollHeight, w = window.scrollY, D = C - v, P = D > 0 ? w / D * 100 : 0;
        x(P);
      }
    };
    return window.addEventListener("scroll", g), () => window.removeEventListener("scroll", g);
  }, [a]);
  const f = (g) => {
    const v = document.getElementById(g);
    v && (v.scrollIntoView({ behavior: "smooth", block: "start" }), h(!1));
  }, p = (g) => {
    g.isSection && f(g.href.replace("#", ""));
  }, y = r === "sticky" ? "public-header-sticky" : "", b = i === "light" ? "public-header-light" : "", k = o === "lg" ? "public-header-shadow-lg" : "";
  return /* @__PURE__ */ s.jsxs(
    "header",
    {
      className: `public-header ${y} ${b} ${k} ${d ? "is-scrolled" : ""} ${l}`.trim(),
      children: [
        /* @__PURE__ */ s.jsxs(Ve, { children: [
          /* @__PURE__ */ s.jsxs("nav", { className: "public-header-nav", children: [
            /* @__PURE__ */ s.jsxs(_, { to: "/", className: "flex items-center gap-2", children: [
              e,
              t && /* @__PURE__ */ s.jsx("span", { className: "text-xl font-bold text-slate-900", children: t })
            ] }),
            /* @__PURE__ */ s.jsx("div", { className: "hidden md:flex items-center gap-8", children: n.map(
              (g) => g.isSection ? /* @__PURE__ */ s.jsx(
                "button",
                {
                  onClick: () => p(g),
                  className: "public-header-link",
                  children: g.label
                },
                g.label
              ) : /* @__PURE__ */ s.jsx(
                _,
                {
                  to: g.href,
                  className: "public-header-link",
                  children: g.label
                },
                g.label
              )
            ) }),
            /* @__PURE__ */ s.jsxs("div", { className: "hidden md:flex items-center gap-4", children: [
              /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "outline", size: "sm", children: "Login" }) }),
              /* @__PURE__ */ s.jsx(_, { to: "/signup", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "sm", children: "Sign Up" }) })
            ] }),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: () => h(!u),
                className: "md:hidden p-2 public-header-link",
                "aria-label": "Toggle menu",
                children: u ? /* @__PURE__ */ s.jsx(Ot, { className: "w-6 h-6" }) : /* @__PURE__ */ s.jsx(ef, { className: "w-6 h-6" })
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx(
            "div",
            {
              className: `md:hidden overflow-hidden transition-all duration-300 ${u ? "max-h-96 pb-6" : "max-h-0"}`,
              children: /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-4 pt-4 border-t border-slate-200", children: [
                n.map(
                  (g) => g.isSection ? /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      onClick: () => p(g),
                      className: "text-left public-header-link py-2",
                      children: g.label
                    },
                    g.label
                  ) : /* @__PURE__ */ s.jsx(
                    _,
                    {
                      to: g.href,
                      className: "public-header-link py-2",
                      onClick: () => h(!1),
                      children: g.label
                    },
                    g.label
                  )
                ),
                /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-3 pt-4 border-t border-slate-200", children: [
                  /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "outline", size: "sm", className: "w-full", children: "Login" }) }),
                  /* @__PURE__ */ s.jsx(_, { to: "/signup", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "sm", className: "w-full", children: "Sign Up" }) })
                ] })
              ] })
            }
          )
        ] }),
        a && /* @__PURE__ */ s.jsx("div", { className: "public-header-progress", children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: "public-header-progress-bar",
            style: { width: `${m}%` }
          }
        ) })
      ]
    }
  );
}
function bv({
  logo: e,
  tagline: t,
  sections: n = [],
  socialLinks: a = [],
  copyright: r,
  className: i = ""
}) {
  const o = (/* @__PURE__ */ new Date()).getFullYear(), l = r || `© ${o} All rights reserved.`;
  return /* @__PURE__ */ s.jsx("footer", { className: `footer ${i}`, children: /* @__PURE__ */ s.jsx(Ve, { children: /* @__PURE__ */ s.jsxs("div", { className: "py-12 md:py-16", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "lg:col-span-2 space-y-4", children: [
        /* @__PURE__ */ s.jsx("div", { className: "flex items-center", children: e }),
        t && /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 max-w-sm", children: t }),
        a.length > 0 && /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-4 pt-2", children: a.map((d) => /* @__PURE__ */ s.jsx(
          "a",
          {
            href: d.href,
            className: "text-slate-400 hover:text-primary-600 transition-colors",
            "aria-label": d.label,
            target: "_blank",
            rel: "noopener noreferrer",
            children: d.icon
          },
          d.label
        )) })
      ] }),
      n.map((d) => /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("h3", { className: "footer-section-title", children: d.title }),
        /* @__PURE__ */ s.jsx("ul", { className: "space-y-3", children: d.links.map((c) => /* @__PURE__ */ s.jsx("li", { children: c.external ? /* @__PURE__ */ s.jsx(
          "a",
          {
            href: c.href,
            className: "footer-link",
            target: "_blank",
            rel: "noopener noreferrer",
            children: c.label
          }
        ) : /* @__PURE__ */ s.jsx(_, { to: c.href, className: "footer-link", children: c.label }) }, c.label)) })
      ] }, d.title))
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "mt-12 pt-8 border-t border-slate-200", children: /* @__PURE__ */ s.jsx("p", { className: "footer-copyright", children: l }) })
  ] }) }) });
}
const Cf = {
  readonly: "Your account is in read-only mode",
  no_exports: "Exports are disabled",
  no_create: "Creating new items is disabled",
  limited_sending: "Email sending is limited"
};
function jv({
  children: e,
  restriction: t,
  fallbackMessage: n,
  showUpgradeButton: a = !0
}) {
  const { hasRestriction: r, isCanceled: i, openCustomerPortal: o } = Ds();
  if (!r(t))
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: e });
  const d = n || Cf[t] || "This action is restricted";
  return /* @__PURE__ */ s.jsxs("div", { className: "relative group", children: [
    /* @__PURE__ */ s.jsx("div", { className: "restricted-content", children: e }),
    /* @__PURE__ */ s.jsx("div", { className: "restricted-overlay", children: /* @__PURE__ */ s.jsxs("div", { className: "text-center p-4", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-center gap-2 mb-2", children: [
        i ? /* @__PURE__ */ s.jsx(pt, { className: "w-5 h-5 text-red-400" }) : /* @__PURE__ */ s.jsx(gt, { className: "w-5 h-5 text-amber-400" }),
        /* @__PURE__ */ s.jsx(
          "span",
          {
            className: `font-medium ${i ? "text-red-700" : "text-amber-700"}`,
            children: d
          }
        )
      ] }),
      a && /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          size: "sm",
          onClick: () => o(),
          className: i ? "bg-red-500 hover:bg-red-600" : "",
          children: i ? "Reactivate" : "Update Payment"
        }
      )
    ] }) })
  ] });
}
function vv({
  children: e,
  restriction: t,
  onClick: n,
  className: a = "",
  variant: r = "primary",
  size: i = "md",
  disabled: o = !1
}) {
  const { hasRestriction: l, isCanceled: d } = Ds();
  return l(t) ? /* @__PURE__ */ s.jsxs(
    S,
    {
      variant: r,
      size: i,
      className: `${a} opacity-50 cursor-not-allowed relative group`,
      disabled: !0,
      children: [
        /* @__PURE__ */ s.jsx(pt, { className: "w-4 h-4 mr-2" }),
        e,
        /* @__PURE__ */ s.jsx("span", { className: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1 text-xs bg-slate-800 text-white rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none", children: d ? "Reactivate to unlock" : "Update payment to unlock" })
      ]
    }
  ) : /* @__PURE__ */ s.jsx(
    S,
    {
      variant: r,
      size: i,
      onClick: n,
      className: a,
      disabled: o,
      children: e
    }
  );
}
function wv({
  privacyLink: e = "/privacy",
  storageKey: t = "cookieConsent",
  onAccept: n,
  onDecline: a,
  description: r,
  className: i = ""
}) {
  const [o, l] = j(!1);
  le(() => {
    if (!localStorage.getItem(t)) {
      const h = setTimeout(() => l(!0), 500);
      return () => clearTimeout(h);
    }
  }, [t]);
  const d = () => {
    localStorage.setItem(t, "accepted"), l(!1), n == null || n();
  }, c = () => {
    localStorage.setItem(t, "declined"), l(!1), a == null || a();
  };
  return o ? /* @__PURE__ */ s.jsx(
    "div",
    {
      className: `fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 ${i}`,
      children: /* @__PURE__ */ s.jsx("div", { className: "max-w-4xl mx-auto bg-white border border-slate-200 rounded-xl shadow-2xl p-6", children: /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col md:flex-row md:items-center gap-4", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
          /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-slate-900 mb-2", children: "We use cookies" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: r || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            'We use cookies to improve your experience, analyze site traffic, and for marketing purposes. By clicking "Accept", you consent to the use of cookies. Read our',
            " ",
            /* @__PURE__ */ s.jsx(
              _,
              {
                to: e,
                className: "text-accent-600 hover:text-accent-700 underline",
                children: "Privacy Policy"
              }
            ),
            " ",
            "for more information."
          ] }) })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 flex-shrink-0", children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              onClick: c,
              className: "px-4 py-2 text-sm text-slate-500 hover:text-slate-900 transition-colors",
              children: "Decline"
            }
          ),
          /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "sm", onClick: d, children: "Accept" })
        ] })
      ] }) })
    }
  ) : null;
}
function Tf(e) {
  return e.split(" ").map((t) => t[0]).join("").toUpperCase().slice(0, 2);
}
const Ri = {
  sm: "avatar-sm",
  md: "avatar-md",
  lg: "avatar-lg",
  xl: "avatar-xl"
}, Sf = {
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-12 h-12",
  xl: "w-16 h-16"
};
function ar({
  src: e,
  name: t,
  size: n = "md",
  className: a = "",
  ...r
}) {
  const i = Tf(t);
  return e ? /* @__PURE__ */ s.jsx(
    "img",
    {
      src: e,
      alt: t,
      className: `avatar ${Ri[n]} ${Sf[n]} object-cover ${a}`,
      ...r
    }
  ) : /* @__PURE__ */ s.jsx(
    "div",
    {
      className: `avatar ${Ri[n]} ${a}`,
      title: t,
      ...r,
      children: i
    }
  );
}
function Af(e) {
  return e.split(" ").map((t) => t[0]).join("").toUpperCase().slice(0, 2);
}
const Di = {
  sm: "w-6 h-6 text-xs",
  md: "w-8 h-8 text-sm",
  lg: "w-10 h-10 text-base",
  xl: "w-12 h-12 text-lg"
};
function ha({
  src: e,
  name: t,
  size: n = "md",
  className: a = "",
  ...r
}) {
  const i = Af(t), o = "inline-flex items-center justify-center rounded-lg bg-slate-100 text-slate-600 font-medium";
  return e ? /* @__PURE__ */ s.jsx(
    "img",
    {
      src: e,
      alt: t,
      className: `${Di[n]} rounded-lg object-cover ${a}`,
      ...r
    }
  ) : /* @__PURE__ */ s.jsx(
    "div",
    {
      className: `${o} ${Di[n]} ${a}`,
      title: t,
      ...r,
      children: i
    }
  );
}
const Pf = 2, Ef = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp"
];
function tc({
  currentUrl: e,
  name: t,
  onUpload: n,
  onDelete: a,
  isLoading: r = !1,
  error: i = null,
  maxSizeMB: o = Pf,
  acceptedTypes: l = Ef,
  size: d = "xl",
  className: c = "",
  variant: u = "avatar"
}) {
  const [h, m] = j(null), [x, f] = j(!1), [p, y] = j(!1), b = We(null), k = i || h, g = r || x || p, v = async (P) => {
    var V;
    const $ = (V = P.target.files) == null ? void 0 : V[0];
    if (!$) return;
    if (m(null), !l.includes($.type)) {
      m(
        `Please upload an image file (${l.map((H) => H.split("/")[1]).join(", ")})`
      );
      return;
    }
    const I = o * 1024 * 1024;
    if ($.size > I) {
      m(`File size must be less than ${o}MB`);
      return;
    }
    try {
      f(!0), await n($);
    } catch (H) {
      m(
        H instanceof Error ? H.message : `Failed to upload ${u === "team-logo" ? "logo" : "avatar"}`
      );
    } finally {
      f(!1), b.current && (b.current.value = "");
    }
  }, C = async () => {
    if (a) {
      m(null);
      try {
        y(!0), await a();
      } catch (P) {
        m(
          P instanceof Error ? P.message : `Failed to delete ${u === "team-logo" ? "logo" : "avatar"}`
        );
      } finally {
        y(!1);
      }
    }
  }, w = () => {
    var P;
    (P = b.current) == null || P.click();
  }, D = u === "team-logo" ? ha : ar;
  return /* @__PURE__ */ s.jsxs("div", { className: `flex items-center gap-4 ${c}`, children: [
    /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ s.jsx(
        D,
        {
          src: e,
          name: t,
          size: d,
          className: g ? "opacity-50" : ""
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ s.jsx(he, { size: "sm" }) })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ s.jsx(
          S,
          {
            variant: "secondary",
            size: "sm",
            onClick: w,
            disabled: g,
            children: e ? "Change" : "Upload"
          }
        ),
        e && a && /* @__PURE__ */ s.jsx(
          S,
          {
            variant: "ghost",
            size: "sm",
            onClick: C,
            disabled: g,
            children: "Remove"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-slate-500", children: [
        "JPG, PNG, GIF or WebP. Max ",
        o,
        "MB."
      ] }),
      k && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-red-600", children: k })
    ] }),
    /* @__PURE__ */ s.jsx(
      "input",
      {
        ref: b,
        type: "file",
        accept: l.join(","),
        onChange: v,
        className: "hidden"
      }
    )
  ] });
}
function Rf(e, t) {
  if (t && e === "active")
    return {
      show: !0,
      label: "Cancels at period end",
      className: "bg-yellow-500/20 text-yellow-600"
    };
  switch (e) {
    case "past_due":
      return {
        show: !0,
        label: "past due",
        className: "bg-red-500/20 text-red-600"
      };
    case "canceled":
      return {
        show: !0,
        label: "canceled",
        className: "bg-slate-500/20 text-slate-500"
      };
    case "trialing":
      return {
        show: !0,
        label: "trial",
        className: "bg-blue-500/20 text-blue-600"
      };
    default:
      return { show: !1, label: "", className: "" };
  }
}
function Df(e) {
  return e ? new Date(e).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric"
  }) : "";
}
function Nv({
  planName: e,
  planPrice: t = 0,
  status: n,
  cancelAtPeriodEnd: a = !1,
  periodEnd: r,
  primaryUsage: i,
  usageMetrics: o = [],
  warningThreshold: l = 20,
  onUpgrade: d,
  onManageBilling: c,
  upgradeUrl: u,
  className: h = "",
  show: m = !0
}) {
  if (!m) return null;
  const x = n === "active" || n === "trialing", f = t > 0 && x, p = i.max === null, y = p || i.max === null ? null : i.max - i.current, b = p || i.max === null || y === null ? 100 : y / i.max * 100, k = !p && b <= l, g = Rf(n, a), v = () => {
    u ? window.location.href = u : d && d();
  };
  return /* @__PURE__ */ s.jsxs(
    "section",
    {
      className: `bg-gradient-to-br from-accent-50 to-accent-100/50 border border-accent-200 rounded-2xl p-6 ${h}`,
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-start justify-between mb-4", children: [
          /* @__PURE__ */ s.jsxs("div", { children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
              /* @__PURE__ */ s.jsx(Ql, { className: "w-6 h-6 text-accent-600" }),
              /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900", children: "Plan & Usage" })
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 mb-2", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-xl font-bold text-slate-900", children: e }),
              f && /* @__PURE__ */ s.jsxs("span", { className: "text-slate-400", children: [
                "$",
                t,
                "/mo"
              ] }),
              g.show && /* @__PURE__ */ s.jsx(
                "span",
                {
                  className: `text-xs px-2 py-0.5 rounded ${g.className}`,
                  children: g.label
                }
              )
            ] }),
            /* @__PURE__ */ s.jsx("p", { className: "text-slate-700", children: p ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-3xl font-bold text-accent-600", children: i.current.toLocaleString() }),
              /* @__PURE__ */ s.jsxs("span", { className: "text-slate-400", children: [
                " ",
                i.unit,
                " (unlimited)"
              ] })
            ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-3xl font-bold text-accent-600", children: i.showUsed ? i.current : y }),
              /* @__PURE__ */ s.jsxs("span", { className: "text-slate-400", children: [
                " ",
                "/ ",
                i.max.toLocaleString(),
                " ",
                i.unit,
                " ",
                i.showUsed ? "used" : "remaining"
              ] })
            ] }) }),
            r && x && /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-slate-500 mt-1", children: [
              a ? "Access until" : "Renews on",
              " ",
              Df(r)
            ] })
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "flex flex-col gap-2", children: f ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            c && /* @__PURE__ */ s.jsxs(
              "button",
              {
                onClick: c,
                className: "flex items-center gap-2 px-4 py-2 text-sm font-medium border border-slate-300 rounded-lg bg-white hover:bg-slate-50 text-slate-700 transition-colors",
                children: [
                  /* @__PURE__ */ s.jsx(Kl, { className: "w-4 h-4" }),
                  "Manage Billing"
                ]
              }
            ),
            (d || u) && /* @__PURE__ */ s.jsxs(
              "button",
              {
                onClick: v,
                className: "flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors",
                children: [
                  /* @__PURE__ */ s.jsx(ki, { className: "w-4 h-4" }),
                  "Change Plan"
                ]
              }
            )
          ] }) : (d || u) && /* @__PURE__ */ s.jsxs(
            "button",
            {
              onClick: v,
              className: "flex items-center gap-2 px-4 py-2 text-sm font-medium bg-accent-500 hover:bg-accent-600 text-white rounded-lg transition-colors",
              children: [
                /* @__PURE__ */ s.jsx(ki, { className: "w-4 h-4" }),
                "Upgrade"
              ]
            }
          ) })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "relative w-full h-2 bg-slate-200 rounded-full overflow-hidden", children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: `absolute top-0 left-0 h-full transition-all duration-500 ${k ? "bg-yellow-500" : "bg-accent-500"}`,
            style: { width: `${Math.max(0, Math.min(100, b))}%` }
          }
        ) }),
        k && (d || u) && /* @__PURE__ */ s.jsx("div", { className: "mt-4 p-3 bg-amber-50 border border-amber-300 rounded-lg", children: /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-amber-800", children: [
          "You're running low on ",
          i.unit,
          ".",
          " ",
          /* @__PURE__ */ s.jsx(
            "button",
            {
              onClick: v,
              className: "font-semibold underline text-amber-900 hover:text-amber-950 hover:bg-amber-100 rounded px-0.5",
              children: "Upgrade your plan"
            }
          ),
          " ",
          "for more ",
          i.unit,
          "."
        ] }) }),
        o.length > 0 && /* @__PURE__ */ s.jsx("div", { className: "mt-4 pt-4 border-t border-accent-200 grid grid-cols-2 sm:grid-cols-4 gap-4", children: o.map((C, w) => /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-xs text-slate-500 uppercase tracking-wider mb-1", children: C.label }),
          /* @__PURE__ */ s.jsxs("p", { className: "text-slate-900 font-medium", children: [
            C.value.toLocaleString(),
            C.showMax && C.max !== void 0 && /* @__PURE__ */ s.jsxs("span", { className: "text-slate-400", children: [
              " ",
              "/ ",
              C.max.toLocaleString()
            ] })
          ] })
        ] }, w)) })
      ]
    }
  );
}
function sc({ children: e, className: t, id: n }) {
  return /* @__PURE__ */ s.jsx("section", { id: n, className: Xa("section-padding", t), children: e });
}
function kv({
  badge: e,
  heading: t,
  description: n,
  align: a = "center",
  className: r
}) {
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: Xa(
        "section-header",
        a === "center" && "section-header-center",
        r
      ),
      children: [
        e && /* @__PURE__ */ s.jsx("div", { className: "section-badge", children: /* @__PURE__ */ s.jsx("span", { className: "section-badge-text", children: e }) }),
        /* @__PURE__ */ s.jsx("h2", { className: "section-heading", children: t }),
        n && /* @__PURE__ */ s.jsx("p", { className: "section-description", children: n })
      ]
    }
  );
}
const nc = dt({});
function _f(e) {
  const t = We(null);
  return t.current === null && (t.current = e()), t.current;
}
const rr = typeof window < "u", Mf = rr ? Hu : le, ir = /* @__PURE__ */ dt(null);
function or(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function lr(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const it = (e, t, n) => n > t ? t : n < e ? e : n;
function ma(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let as = () => {
}, ot = () => {
};
process.env.NODE_ENV !== "production" && (as = (e, t, n) => {
  !e && typeof console < "u" && console.warn(ma(t, n));
}, ot = (e, t, n) => {
  if (!e)
    throw new Error(ma(t, n));
});
const lt = {}, ac = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e);
function rc(e) {
  return typeof e == "object" && e !== null;
}
const ic = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function cr(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const Ke = /* @__NO_SIDE_EFFECTS__ */ (e) => e, Ff = (e, t) => (n) => t(e(n)), _s = (...e) => e.reduce(Ff), Ns = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const a = t - e;
  return a === 0 ? 1 : (n - e) / a;
};
class dr {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return or(this.subscriptions, t), () => lr(this.subscriptions, t);
  }
  notify(t, n, a) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](t, n, a);
      else
        for (let i = 0; i < r; i++) {
          const o = this.subscriptions[i];
          o && o(t, n, a);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Xe = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, He = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
function oc(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const _i = /* @__PURE__ */ new Set();
function ur(e, t, n) {
  e || _i.has(t) || (console.warn(ma(t, n)), _i.add(t));
}
const lc = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, Lf = 1e-7, $f = 12;
function If(e, t, n, a, r) {
  let i, o, l = 0;
  do
    o = t + (n - t) / 2, i = lc(o, a, r) - e, i > 0 ? n = o : t = o;
  while (Math.abs(i) > Lf && ++l < $f);
  return o;
}
function Ms(e, t, n, a) {
  if (e === t && n === a)
    return Ke;
  const r = (i) => If(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : lc(r(i), t, a);
}
const cc = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, dc = (e) => (t) => 1 - e(1 - t), uc = /* @__PURE__ */ Ms(0.33, 1.53, 0.69, 0.99), hr = /* @__PURE__ */ dc(uc), hc = /* @__PURE__ */ cc(hr), mc = (e) => (e *= 2) < 1 ? 0.5 * hr(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), mr = (e) => 1 - Math.sin(Math.acos(e)), fc = dc(mr), xc = cc(mr), Of = /* @__PURE__ */ Ms(0.42, 0, 1, 1), Vf = /* @__PURE__ */ Ms(0, 0, 0.58, 1), pc = /* @__PURE__ */ Ms(0.42, 0, 0.58, 1), Bf = (e) => Array.isArray(e) && typeof e[0] != "number", gc = (e) => Array.isArray(e) && typeof e[0] == "number", Mi = {
  linear: Ke,
  easeIn: Of,
  easeInOut: pc,
  easeOut: Vf,
  circIn: mr,
  circInOut: xc,
  circOut: fc,
  backIn: hr,
  backInOut: hc,
  backOut: uc,
  anticipate: mc
}, zf = (e) => typeof e == "string", Fi = (e) => {
  if (gc(e)) {
    ot(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, a, r] = e;
    return Ms(t, n, a, r);
  } else if (zf(e))
    return ot(Mi[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), Mi[e];
  return e;
}, qs = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function Uf(e, t) {
  let n = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), r = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let l = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function d(u) {
    o.has(u) && (c.schedule(u), e()), u(l);
  }
  const c = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, h = !1, m = !1) => {
      const f = m && r ? n : a;
      return h && o.add(u), f.has(u) || f.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      a.delete(u), o.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (l = u, r) {
        i = !0;
        return;
      }
      r = !0, [n, a] = [a, n], n.forEach(d), n.clear(), r = !1, i && (i = !1, c.process(u));
    }
  };
  return c;
}
const qf = 40;
function yc(e, t) {
  let n = !1, a = !0;
  const r = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, o = qs.reduce((g, v) => (g[v] = Uf(i), g), {}), { setup: l, read: d, resolveKeyframes: c, preUpdate: u, update: h, preRender: m, render: x, postRender: f } = o, p = () => {
    const g = lt.useManualTiming ? r.timestamp : performance.now();
    n = !1, lt.useManualTiming || (r.delta = a ? 1e3 / 60 : Math.max(Math.min(g - r.timestamp, qf), 1)), r.timestamp = g, r.isProcessing = !0, l.process(r), d.process(r), c.process(r), u.process(r), h.process(r), m.process(r), x.process(r), f.process(r), r.isProcessing = !1, n && t && (a = !1, e(p));
  }, y = () => {
    n = !0, a = !0, r.isProcessing || e(p);
  };
  return { schedule: qs.reduce((g, v) => {
    const C = o[v];
    return g[v] = (w, D = !1, P = !1) => (n || y(), C.schedule(w, D, P)), g;
  }, {}), cancel: (g) => {
    for (let v = 0; v < qs.length; v++)
      o[qs[v]].cancel(g);
  }, state: r, steps: o };
}
const { schedule: me, cancel: bt, state: Ce, steps: Un } = /* @__PURE__ */ yc(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Ke, !0);
let Xs;
function Hf() {
  Xs = void 0;
}
const Me = {
  now: () => (Xs === void 0 && Me.set(Ce.isProcessing || lt.useManualTiming ? Ce.timestamp : performance.now()), Xs),
  set: (e) => {
    Xs = e, queueMicrotask(Hf);
  }
}, bc = (e) => (t) => typeof t == "string" && t.startsWith(e), jc = /* @__PURE__ */ bc("--"), Wf = /* @__PURE__ */ bc("var(--"), fr = (e) => Wf(e) ? Kf.test(e.split("/*")[0].trim()) : !1, Kf = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, rs = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, ks = {
  ...rs,
  transform: (e) => it(0, 1, e)
}, Hs = {
  ...rs,
  default: 1
}, xs = (e) => Math.round(e * 1e5) / 1e5, xr = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Yf(e) {
  return e == null;
}
const Gf = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, pr = (e, t) => (n) => !!(typeof n == "string" && Gf.test(n) && n.startsWith(e) || t && !Yf(n) && Object.prototype.hasOwnProperty.call(n, t)), vc = (e, t, n) => (a) => {
  if (typeof a != "string")
    return a;
  const [r, i, o, l] = a.match(xr);
  return {
    [e]: parseFloat(r),
    [t]: parseFloat(i),
    [n]: parseFloat(o),
    alpha: l !== void 0 ? parseFloat(l) : 1
  };
}, Xf = (e) => it(0, 255, e), qn = {
  ...rs,
  transform: (e) => Math.round(Xf(e))
}, Et = {
  test: /* @__PURE__ */ pr("rgb", "red"),
  parse: /* @__PURE__ */ vc("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: a = 1 }) => "rgba(" + qn.transform(e) + ", " + qn.transform(t) + ", " + qn.transform(n) + ", " + xs(ks.transform(a)) + ")"
};
function Jf(e) {
  let t = "", n = "", a = "", r = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), a = e.substring(5, 7), r = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), a = e.substring(3, 4), r = e.substring(4, 5), t += t, n += n, a += a, r += r), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(a, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const fa = {
  test: /* @__PURE__ */ pr("#"),
  parse: Jf,
  transform: Et.transform
}, Fs = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), ut = /* @__PURE__ */ Fs("deg"), st = /* @__PURE__ */ Fs("%"), X = /* @__PURE__ */ Fs("px"), Zf = /* @__PURE__ */ Fs("vh"), Qf = /* @__PURE__ */ Fs("vw"), Li = {
  ...st,
  parse: (e) => st.parse(e) / 100,
  transform: (e) => st.transform(e * 100)
}, Bt = {
  test: /* @__PURE__ */ pr("hsl", "hue"),
  parse: /* @__PURE__ */ vc("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: a = 1 }) => "hsla(" + Math.round(e) + ", " + st.transform(xs(t)) + ", " + st.transform(xs(n)) + ", " + xs(ks.transform(a)) + ")"
}, ve = {
  test: (e) => Et.test(e) || fa.test(e) || Bt.test(e),
  parse: (e) => Et.test(e) ? Et.parse(e) : Bt.test(e) ? Bt.parse(e) : fa.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Et.transform(e) : Bt.transform(e),
  getAnimatableNone: (e) => {
    const t = ve.parse(e);
    return t.alpha = 0, ve.transform(t);
  }
}, ex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function tx(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(xr)) == null ? void 0 : t.length) || 0) + (((n = e.match(ex)) == null ? void 0 : n.length) || 0) > 0;
}
const wc = "number", Nc = "color", sx = "var", nx = "var(", $i = "${}", ax = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Cs(e) {
  const t = e.toString(), n = [], a = {
    color: [],
    number: [],
    var: []
  }, r = [];
  let i = 0;
  const l = t.replace(ax, (d) => (ve.test(d) ? (a.color.push(i), r.push(Nc), n.push(ve.parse(d))) : d.startsWith(nx) ? (a.var.push(i), r.push(sx), n.push(d)) : (a.number.push(i), r.push(wc), n.push(parseFloat(d))), ++i, $i)).split($i);
  return { values: n, split: l, indexes: a, types: r };
}
function kc(e) {
  return Cs(e).values;
}
function Cc(e) {
  const { split: t, types: n } = Cs(e), a = t.length;
  return (r) => {
    let i = "";
    for (let o = 0; o < a; o++)
      if (i += t[o], r[o] !== void 0) {
        const l = n[o];
        l === wc ? i += xs(r[o]) : l === Nc ? i += ve.transform(r[o]) : i += r[o];
      }
    return i;
  };
}
const rx = (e) => typeof e == "number" ? 0 : ve.test(e) ? ve.getAnimatableNone(e) : e;
function ix(e) {
  const t = kc(e);
  return Cc(e)(t.map(rx));
}
const jt = {
  test: tx,
  parse: kc,
  createTransformer: Cc,
  getAnimatableNone: ix
};
function Hn(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function ox({ hue: e, saturation: t, lightness: n, alpha: a }) {
  e /= 360, t /= 100, n /= 100;
  let r = 0, i = 0, o = 0;
  if (!t)
    r = i = o = n;
  else {
    const l = n < 0.5 ? n * (1 + t) : n + t - n * t, d = 2 * n - l;
    r = Hn(d, l, e + 1 / 3), i = Hn(d, l, e), o = Hn(d, l, e - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(i * 255),
    blue: Math.round(o * 255),
    alpha: a
  };
}
function on(e, t) {
  return (n) => n > 0 ? t : e;
}
const pe = (e, t, n) => e + (t - e) * n, Wn = (e, t, n) => {
  const a = e * e, r = n * (t * t - a) + a;
  return r < 0 ? 0 : Math.sqrt(r);
}, lx = [fa, Et, Bt], cx = (e) => lx.find((t) => t.test(e));
function Ii(e) {
  const t = cx(e);
  if (as(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === Bt && (n = ox(n)), n;
}
const Oi = (e, t) => {
  const n = Ii(e), a = Ii(t);
  if (!n || !a)
    return on(e, t);
  const r = { ...n };
  return (i) => (r.red = Wn(n.red, a.red, i), r.green = Wn(n.green, a.green, i), r.blue = Wn(n.blue, a.blue, i), r.alpha = pe(n.alpha, a.alpha, i), Et.transform(r));
}, xa = /* @__PURE__ */ new Set(["none", "hidden"]);
function dx(e, t) {
  return xa.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function ux(e, t) {
  return (n) => pe(e, t, n);
}
function gr(e) {
  return typeof e == "number" ? ux : typeof e == "string" ? fr(e) ? on : ve.test(e) ? Oi : fx : Array.isArray(e) ? Tc : typeof e == "object" ? ve.test(e) ? Oi : hx : on;
}
function Tc(e, t) {
  const n = [...e], a = n.length, r = e.map((i, o) => gr(i)(i, t[o]));
  return (i) => {
    for (let o = 0; o < a; o++)
      n[o] = r[o](i);
    return n;
  };
}
function hx(e, t) {
  const n = { ...e, ...t }, a = {};
  for (const r in n)
    e[r] !== void 0 && t[r] !== void 0 && (a[r] = gr(e[r])(e[r], t[r]));
  return (r) => {
    for (const i in a)
      n[i] = a[i](r);
    return n;
  };
}
function mx(e, t) {
  const n = [], a = { color: 0, var: 0, number: 0 };
  for (let r = 0; r < t.values.length; r++) {
    const i = t.types[r], o = e.indexes[i][a[i]], l = e.values[o] ?? 0;
    n[r] = l, a[i]++;
  }
  return n;
}
const fx = (e, t) => {
  const n = jt.createTransformer(t), a = Cs(e), r = Cs(t);
  return a.indexes.var.length === r.indexes.var.length && a.indexes.color.length === r.indexes.color.length && a.indexes.number.length >= r.indexes.number.length ? xa.has(e) && !r.values.length || xa.has(t) && !a.values.length ? dx(e, t) : _s(Tc(mx(a, r), r.values), n) : (as(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), on(e, t));
};
function Sc(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? pe(e, t, n) : gr(e)(e, t);
}
const xx = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => me.update(t, n),
    stop: () => bt(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Ce.isProcessing ? Ce.timestamp : Me.now()
  };
}, Ac = (e, t, n = 10) => {
  let a = "";
  const r = Math.max(Math.round(t / n), 2);
  for (let i = 0; i < r; i++)
    a += Math.round(e(i / (r - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${a.substring(0, a.length - 2)})`;
}, ln = 2e4;
function yr(e) {
  let t = 0;
  const n = 50;
  let a = e.next(t);
  for (; !a.done && t < ln; )
    t += n, a = e.next(t);
  return t >= ln ? 1 / 0 : t;
}
function px(e, t = 100, n) {
  const a = n({ ...e, keyframes: [0, t] }), r = Math.min(yr(a), ln);
  return {
    type: "keyframes",
    ease: (i) => a.next(r * i).value / t,
    duration: /* @__PURE__ */ He(r)
  };
}
const gx = 5;
function Pc(e, t, n) {
  const a = Math.max(t - gx, 0);
  return oc(n - e(a), t - a);
}
const xe = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Kn = 1e-3;
function yx({ duration: e = xe.duration, bounce: t = xe.bounce, velocity: n = xe.velocity, mass: a = xe.mass }) {
  let r, i;
  as(e <= /* @__PURE__ */ Xe(xe.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - t;
  o = it(xe.minDamping, xe.maxDamping, o), e = it(xe.minDuration, xe.maxDuration, /* @__PURE__ */ He(e)), o < 1 ? (r = (c) => {
    const u = c * o, h = u * e, m = u - n, x = pa(c, o), f = Math.exp(-h);
    return Kn - m / x * f;
  }, i = (c) => {
    const h = c * o * e, m = h * n + n, x = Math.pow(o, 2) * Math.pow(c, 2) * e, f = Math.exp(-h), p = pa(Math.pow(c, 2), o);
    return (-r(c) + Kn > 0 ? -1 : 1) * ((m - x) * f) / p;
  }) : (r = (c) => {
    const u = Math.exp(-c * e), h = (c - n) * e + 1;
    return -Kn + u * h;
  }, i = (c) => {
    const u = Math.exp(-c * e), h = (n - c) * (e * e);
    return u * h;
  });
  const l = 5 / e, d = jx(r, i, l);
  if (e = /* @__PURE__ */ Xe(e), isNaN(d))
    return {
      stiffness: xe.stiffness,
      damping: xe.damping,
      duration: e
    };
  {
    const c = Math.pow(d, 2) * a;
    return {
      stiffness: c,
      damping: o * 2 * Math.sqrt(a * c),
      duration: e
    };
  }
}
const bx = 12;
function jx(e, t, n) {
  let a = n;
  for (let r = 1; r < bx; r++)
    a = a - e(a) / t(a);
  return a;
}
function pa(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const vx = ["duration", "bounce"], wx = ["stiffness", "damping", "mass"];
function Vi(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function Nx(e) {
  let t = {
    velocity: xe.velocity,
    stiffness: xe.stiffness,
    damping: xe.damping,
    mass: xe.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Vi(e, wx) && Vi(e, vx))
    if (e.visualDuration) {
      const n = e.visualDuration, a = 2 * Math.PI / (n * 1.2), r = a * a, i = 2 * it(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(r);
      t = {
        ...t,
        mass: xe.mass,
        stiffness: r,
        damping: i
      };
    } else {
      const n = yx(e);
      t = {
        ...t,
        ...n,
        mass: xe.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function cn(e = xe.visualDuration, t = xe.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: a, restDelta: r } = n;
  const i = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], l = { done: !1, value: i }, { stiffness: d, damping: c, mass: u, duration: h, velocity: m, isResolvedFromDuration: x } = Nx({
    ...n,
    velocity: -/* @__PURE__ */ He(n.velocity || 0)
  }), f = m || 0, p = c / (2 * Math.sqrt(d * u)), y = o - i, b = /* @__PURE__ */ He(Math.sqrt(d / u)), k = Math.abs(y) < 5;
  a || (a = k ? xe.restSpeed.granular : xe.restSpeed.default), r || (r = k ? xe.restDelta.granular : xe.restDelta.default);
  let g;
  if (p < 1) {
    const C = pa(b, p);
    g = (w) => {
      const D = Math.exp(-p * b * w);
      return o - D * ((f + p * b * y) / C * Math.sin(C * w) + y * Math.cos(C * w));
    };
  } else if (p === 1)
    g = (C) => o - Math.exp(-b * C) * (y + (f + b * y) * C);
  else {
    const C = b * Math.sqrt(p * p - 1);
    g = (w) => {
      const D = Math.exp(-p * b * w), P = Math.min(C * w, 300);
      return o - D * ((f + p * b * y) * Math.sinh(P) + C * y * Math.cosh(P)) / C;
    };
  }
  const v = {
    calculatedDuration: x && h || null,
    next: (C) => {
      const w = g(C);
      if (x)
        l.done = C >= h;
      else {
        let D = C === 0 ? f : 0;
        p < 1 && (D = C === 0 ? /* @__PURE__ */ Xe(f) : Pc(g, C, w));
        const P = Math.abs(D) <= a, $ = Math.abs(o - w) <= r;
        l.done = P && $;
      }
      return l.value = l.done ? o : w, l;
    },
    toString: () => {
      const C = Math.min(yr(v), ln), w = Ac((D) => v.next(C * D).value, C, 30);
      return C + "ms " + w;
    },
    toTransition: () => {
    }
  };
  return v;
}
cn.applyToOptions = (e) => {
  const t = px(e, 100, cn);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Xe(t.duration), e.type = "keyframes", e;
};
function ga({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: a = 325, bounceDamping: r = 10, bounceStiffness: i = 500, modifyTarget: o, min: l, max: d, restDelta: c = 0.5, restSpeed: u }) {
  const h = e[0], m = {
    done: !1,
    value: h
  }, x = (P) => l !== void 0 && P < l || d !== void 0 && P > d, f = (P) => l === void 0 ? d : d === void 0 || Math.abs(l - P) < Math.abs(d - P) ? l : d;
  let p = n * t;
  const y = h + p, b = o === void 0 ? y : o(y);
  b !== y && (p = b - h);
  const k = (P) => -p * Math.exp(-P / a), g = (P) => b + k(P), v = (P) => {
    const $ = k(P), I = g(P);
    m.done = Math.abs($) <= c, m.value = m.done ? b : I;
  };
  let C, w;
  const D = (P) => {
    x(m.value) && (C = P, w = cn({
      keyframes: [m.value, f(m.value)],
      velocity: Pc(g, P, m.value),
      // TODO: This should be passing * 1000
      damping: r,
      stiffness: i,
      restDelta: c,
      restSpeed: u
    }));
  };
  return D(0), {
    calculatedDuration: null,
    next: (P) => {
      let $ = !1;
      return !w && C === void 0 && ($ = !0, v(P), D(P)), C !== void 0 && P >= C ? w.next(P - C) : (!$ && v(P), m);
    }
  };
}
function kx(e, t, n) {
  const a = [], r = n || lt.mix || Sc, i = e.length - 1;
  for (let o = 0; o < i; o++) {
    let l = r(e[o], e[o + 1]);
    if (t) {
      const d = Array.isArray(t) ? t[o] || Ke : t;
      l = _s(d, l);
    }
    a.push(l);
  }
  return a;
}
function Cx(e, t, { clamp: n = !0, ease: a, mixer: r } = {}) {
  const i = e.length;
  if (ot(i === t.length, "Both input and output ranges must be the same length", "range-length"), i === 1)
    return () => t[0];
  if (i === 2 && t[0] === t[1])
    return () => t[1];
  const o = e[0] === e[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const l = kx(t, a, r), d = l.length, c = (u) => {
    if (o && u < e[0])
      return t[0];
    let h = 0;
    if (d > 1)
      for (; h < e.length - 2 && !(u < e[h + 1]); h++)
        ;
    const m = /* @__PURE__ */ Ns(e[h], e[h + 1], u);
    return l[h](m);
  };
  return n ? (u) => c(it(e[0], e[i - 1], u)) : c;
}
function Tx(e, t) {
  const n = e[e.length - 1];
  for (let a = 1; a <= t; a++) {
    const r = /* @__PURE__ */ Ns(0, t, a);
    e.push(pe(n, 1, r));
  }
}
function Sx(e) {
  const t = [0];
  return Tx(t, e.length - 1), t;
}
function Ax(e, t) {
  return e.map((n) => n * t);
}
function Px(e, t) {
  return e.map(() => t || pc).splice(0, e.length - 1);
}
function zt({ duration: e = 300, keyframes: t, times: n, ease: a = "easeInOut" }) {
  const r = Bf(a) ? a.map(Fi) : Fi(a), i = {
    done: !1,
    value: t[0]
  }, o = Ax(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Sx(t),
    e
  ), l = Cx(o, t, {
    ease: Array.isArray(r) ? r : Px(t, r)
  });
  return {
    calculatedDuration: e,
    next: (d) => (i.value = l(d), i.done = d >= e, i)
  };
}
const Ex = (e) => e !== null;
function br(e, { repeat: t, repeatType: n = "loop" }, a, r = 1) {
  const i = e.filter(Ex), l = r < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !l || a === void 0 ? i[l] : a;
}
const Rx = {
  decay: ga,
  inertia: ga,
  tween: zt,
  keyframes: zt,
  spring: cn
};
function Ec(e) {
  typeof e.type == "string" && (e.type = Rx[e.type]);
}
class jr {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const Dx = (e) => e / 100;
class vr extends jr {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var a, r;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== Me.now() && this.tick(Me.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (r = (a = this.options).onStop) == null || r.call(a));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    Ec(t);
    const { type: n = zt, repeat: a = 0, repeatDelay: r = 0, repeatType: i, velocity: o = 0 } = t;
    let { keyframes: l } = t;
    const d = n || zt;
    process.env.NODE_ENV !== "production" && d !== zt && ot(l.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${l}`, "spring-two-frames"), d !== zt && typeof l[0] != "number" && (this.mixKeyframes = _s(Dx, Sc(l[0], l[1])), l = [0, 100]);
    const c = d({ ...t, keyframes: l });
    i === "mirror" && (this.mirroredGenerator = d({
      ...t,
      keyframes: [...l].reverse(),
      velocity: -o
    })), c.calculatedDuration === null && (c.calculatedDuration = yr(c));
    const { calculatedDuration: u } = c;
    this.calculatedDuration = u, this.resolvedDuration = u + r, this.totalDuration = this.resolvedDuration * (a + 1) - r, this.generator = c;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: a, totalDuration: r, mixKeyframes: i, mirroredGenerator: o, resolvedDuration: l, calculatedDuration: d } = this;
    if (this.startTime === null)
      return a.next(0);
    const { delay: c = 0, keyframes: u, repeat: h, repeatType: m, repeatDelay: x, type: f, onUpdate: p, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - r / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const b = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), k = this.playbackSpeed >= 0 ? b < 0 : b > r;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = r);
    let g = this.currentTime, v = a;
    if (h) {
      const P = Math.min(this.currentTime, r) / l;
      let $ = Math.floor(P), I = P % 1;
      !I && P >= 1 && (I = 1), I === 1 && $--, $ = Math.min($, h + 1), !!($ % 2) && (m === "reverse" ? (I = 1 - I, x && (I -= x / l)) : m === "mirror" && (v = o)), g = it(0, 1, I) * l;
    }
    const C = k ? { done: !1, value: u[0] } : v.next(g);
    i && (C.value = i(C.value));
    let { done: w } = C;
    !k && d !== null && (w = this.playbackSpeed >= 0 ? this.currentTime >= r : this.currentTime <= 0);
    const D = this.holdTime === null && (this.state === "finished" || this.state === "running" && w);
    return D && f !== ga && (C.value = br(u, this.options, y, this.speed)), p && p(C.value), D && this.finish(), C;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ He(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ He(t);
  }
  get time() {
    return /* @__PURE__ */ He(this.currentTime);
  }
  set time(t) {
    var n;
    t = /* @__PURE__ */ Xe(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(Me.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ He(this.currentTime));
  }
  play() {
    var r, i;
    if (this.isStopped)
      return;
    const { driver: t = xx, startTime: n } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), (i = (r = this.options).onPlay) == null || i.call(r);
    const a = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = a) : this.holdTime !== null ? this.startTime = a - this.holdTime : this.startTime || (this.startTime = n ?? a), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Me.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function _x(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const Rt = (e) => e * 180 / Math.PI, ya = (e) => {
  const t = Rt(Math.atan2(e[1], e[0]));
  return ba(t);
}, Mx = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: ya,
  rotateZ: ya,
  skewX: (e) => Rt(Math.atan(e[1])),
  skewY: (e) => Rt(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, ba = (e) => (e = e % 360, e < 0 && (e += 360), e), Bi = ya, zi = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), Ui = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), Fx = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: zi,
  scaleY: Ui,
  scale: (e) => (zi(e) + Ui(e)) / 2,
  rotateX: (e) => ba(Rt(Math.atan2(e[6], e[5]))),
  rotateY: (e) => ba(Rt(Math.atan2(-e[2], e[0]))),
  rotateZ: Bi,
  rotate: Bi,
  skewX: (e) => Rt(Math.atan(e[4])),
  skewY: (e) => Rt(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function ja(e) {
  return e.includes("scale") ? 1 : 0;
}
function va(e, t) {
  if (!e || e === "none")
    return ja(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let a, r;
  if (n)
    a = Fx, r = n;
  else {
    const l = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    a = Mx, r = l;
  }
  if (!r)
    return ja(t);
  const i = a[t], o = r[1].split(",").map($x);
  return typeof i == "function" ? i(o) : o[i];
}
const Lx = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return va(n, t);
};
function $x(e) {
  return parseFloat(e.trim());
}
const is = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], os = new Set(is), qi = (e) => e === rs || e === X, Ix = /* @__PURE__ */ new Set(["x", "y", "z"]), Ox = is.filter((e) => !Ix.has(e));
function Vx(e) {
  const t = [];
  return Ox.forEach((n) => {
    const a = e.getValue(n);
    a !== void 0 && (t.push([n, a.get()]), a.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const _t = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => va(t, "x"),
  y: (e, { transform: t }) => va(t, "y")
};
_t.translateX = _t.x;
_t.translateY = _t.y;
const Mt = /* @__PURE__ */ new Set();
let wa = !1, Na = !1, ka = !1;
function Rc() {
  if (Na) {
    const e = Array.from(Mt).filter((a) => a.needsMeasurement), t = new Set(e.map((a) => a.element)), n = /* @__PURE__ */ new Map();
    t.forEach((a) => {
      const r = Vx(a);
      r.length && (n.set(a, r), a.render());
    }), e.forEach((a) => a.measureInitialState()), t.forEach((a) => {
      a.render();
      const r = n.get(a);
      r && r.forEach(([i, o]) => {
        var l;
        (l = a.getValue(i)) == null || l.set(o);
      });
    }), e.forEach((a) => a.measureEndState()), e.forEach((a) => {
      a.suspendedScrollY !== void 0 && window.scrollTo(0, a.suspendedScrollY);
    });
  }
  Na = !1, wa = !1, Mt.forEach((e) => e.complete(ka)), Mt.clear();
}
function Dc() {
  Mt.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (Na = !0);
  });
}
function Bx() {
  ka = !0, Dc(), Rc(), ka = !1;
}
class wr {
  constructor(t, n, a, r, i, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = a, this.motionValue = r, this.element = i, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Mt.add(this), wa || (wa = !0, me.read(Dc), me.resolveKeyframes(Rc))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: a, motionValue: r } = this;
    if (t[0] === null) {
      const i = r == null ? void 0 : r.get(), o = t[t.length - 1];
      if (i !== void 0)
        t[0] = i;
      else if (a && n) {
        const l = a.readValue(n, o);
        l != null && (t[0] = l);
      }
      t[0] === void 0 && (t[0] = o), r && i === void 0 && r.set(t[0]);
    }
    _x(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), Mt.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Mt.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const zx = (e) => e.startsWith("--");
function Ux(e, t, n) {
  zx(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const qx = /* @__PURE__ */ cr(() => window.ScrollTimeline !== void 0), Hx = {};
function Wx(e, t) {
  const n = /* @__PURE__ */ cr(e);
  return () => Hx[t] ?? n();
}
const _c = /* @__PURE__ */ Wx(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), ms = ([e, t, n, a]) => `cubic-bezier(${e}, ${t}, ${n}, ${a})`, Hi = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ ms([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ ms([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ ms([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ ms([0.33, 1.53, 0.69, 0.99])
};
function Mc(e, t) {
  if (e)
    return typeof e == "function" ? _c() ? Ac(e, t) : "ease-out" : gc(e) ? ms(e) : Array.isArray(e) ? e.map((n) => Mc(n, t) || Hi.easeOut) : Hi[e];
}
function Kx(e, t, n, { delay: a = 0, duration: r = 300, repeat: i = 0, repeatType: o = "loop", ease: l = "easeOut", times: d } = {}, c = void 0) {
  const u = {
    [t]: n
  };
  d && (u.offset = d);
  const h = Mc(l, r);
  Array.isArray(h) && (u.easing = h);
  const m = {
    delay: a,
    duration: r,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: i + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return c && (m.pseudoElement = c), e.animate(u, m);
}
function Fc(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function Yx({ type: e, ...t }) {
  return Fc(e) && _c() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class Gx extends jr {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: a, keyframes: r, pseudoElement: i, allowFlatten: o = !1, finalKeyframe: l, onComplete: d } = t;
    this.isPseudoElement = !!i, this.allowFlatten = o, this.options = t, ot(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const c = Yx(t);
    this.animation = Kx(n, a, r, c, i), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !i) {
        const u = br(r, this.options, l, this.speed);
        this.updateMotionValue ? this.updateMotionValue(u) : Ux(n, a, u), this.animation.cancel();
      }
      d == null || d(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var t, n;
    this.isPseudoElement || (n = (t = this.animation).commitStyles) == null || n.call(t);
  }
  get duration() {
    var n, a;
    const t = ((a = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : a.call(n).duration) || 0;
    return /* @__PURE__ */ He(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ He(t);
  }
  get time() {
    return /* @__PURE__ */ He(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Xe(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    var a;
    return this.allowFlatten && ((a = this.animation.effect) == null || a.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && qx() ? (this.animation.timeline = t, Ke) : n(this);
  }
}
const Lc = {
  anticipate: mc,
  backInOut: hc,
  circInOut: xc
};
function Xx(e) {
  return e in Lc;
}
function Jx(e) {
  typeof e.ease == "string" && Xx(e.ease) && (e.ease = Lc[e.ease]);
}
const Wi = 10;
class Zx extends Gx {
  constructor(t) {
    Jx(t), Ec(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: a, onComplete: r, element: i, ...o } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const l = new vr({
      ...o,
      autoplay: !1
    }), d = /* @__PURE__ */ Xe(this.finishedTime ?? this.time);
    n.setWithVelocity(l.sample(d - Wi).value, l.sample(d).value, Wi), l.stop();
  }
}
const Ki = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(jt.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function Qx(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function ep(e, t, n, a) {
  const r = e[0];
  if (r === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], o = Ki(r, t), l = Ki(i, t);
  return as(o === l, `You are trying to animate ${t} from "${r}" to "${i}". "${o ? i : r}" is not an animatable value.`, "value-not-animatable"), !o || !l ? !1 : Qx(e) || (n === "spring" || Fc(n)) && a;
}
function Ca(e) {
  e.duration = 0, e.type = "keyframes";
}
const tp = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), sp = /* @__PURE__ */ cr(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function np(e) {
  var u;
  const { motionValue: t, name: n, repeatDelay: a, repeatType: r, damping: i, type: o } = e;
  if (!(((u = t == null ? void 0 : t.owner) == null ? void 0 : u.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: d, transformTemplate: c } = t.owner.getProps();
  return sp() && n && tp.has(n) && (n !== "transform" || !c) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !d && !a && r !== "mirror" && i !== 0 && o !== "inertia";
}
const ap = 40;
class rp extends jr {
  constructor({ autoplay: t = !0, delay: n = 0, type: a = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: o = "loop", keyframes: l, name: d, motionValue: c, element: u, ...h }) {
    var f;
    super(), this.stop = () => {
      var p, y;
      this._animation && (this._animation.stop(), (p = this.stopTimeline) == null || p.call(this)), (y = this.keyframeResolver) == null || y.cancel();
    }, this.createdAt = Me.now();
    const m = {
      autoplay: t,
      delay: n,
      type: a,
      repeat: r,
      repeatDelay: i,
      repeatType: o,
      name: d,
      motionValue: c,
      element: u,
      ...h
    }, x = (u == null ? void 0 : u.KeyframeResolver) || wr;
    this.keyframeResolver = new x(l, (p, y, b) => this.onKeyframesResolved(p, y, m, !b), d, c, u), (f = this.keyframeResolver) == null || f.scheduleResolve();
  }
  onKeyframesResolved(t, n, a, r) {
    this.keyframeResolver = void 0;
    const { name: i, type: o, velocity: l, delay: d, isHandoff: c, onUpdate: u } = a;
    this.resolvedAt = Me.now(), ep(t, i, o, l) || ((lt.instantAnimations || !d) && (u == null || u(br(t, a, n))), t[0] = t[t.length - 1], Ca(a), a.repeat = 0);
    const m = {
      startTime: r ? this.resolvedAt ? this.resolvedAt - this.createdAt > ap ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...a,
      keyframes: t
    }, x = !c && np(m) ? new Zx({
      ...m,
      element: m.motionValue.owner.current
    }) : new vr(m);
    x.finished.then(() => this.notifyFinished()).catch(Ke), this.pendingTimeline && (this.stopTimeline = x.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = x;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), Bx()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
const ip = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function op(e) {
  const t = ip.exec(e);
  if (!t)
    return [,];
  const [, n, a, r] = t;
  return [`--${n ?? a}`, r];
}
const lp = 4;
function $c(e, t, n = 1) {
  ot(n <= lp, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [a, r] = op(e);
  if (!a)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(a);
  if (i) {
    const o = i.trim();
    return ac(o) ? parseFloat(o) : o;
  }
  return fr(r) ? $c(r, t, n + 1) : r;
}
function Nr(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const Ic = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...is
]), cp = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Oc = (e) => (t) => t.test(e), Vc = [rs, X, st, ut, Qf, Zf, cp], Yi = (e) => Vc.find(Oc(e));
function dp(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || ic(e) : !0;
}
const up = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function hp(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [a] = n.match(xr) || [];
  if (!a)
    return e;
  const r = n.replace(a, "");
  let i = up.has(t) ? 1 : 0;
  return a !== n && (i *= 100), t + "(" + i + r + ")";
}
const mp = /\b([a-z-]*)\(.*?\)/gu, Ta = {
  ...jt,
  getAnimatableNone: (e) => {
    const t = e.match(mp);
    return t ? t.map(hp).join(" ") : e;
  }
}, Gi = {
  ...rs,
  transform: Math.round
}, fp = {
  rotate: ut,
  rotateX: ut,
  rotateY: ut,
  rotateZ: ut,
  scale: Hs,
  scaleX: Hs,
  scaleY: Hs,
  scaleZ: Hs,
  skew: ut,
  skewX: ut,
  skewY: ut,
  distance: X,
  translateX: X,
  translateY: X,
  translateZ: X,
  x: X,
  y: X,
  z: X,
  perspective: X,
  transformPerspective: X,
  opacity: ks,
  originX: Li,
  originY: Li,
  originZ: X
}, kr = {
  // Border props
  borderWidth: X,
  borderTopWidth: X,
  borderRightWidth: X,
  borderBottomWidth: X,
  borderLeftWidth: X,
  borderRadius: X,
  radius: X,
  borderTopLeftRadius: X,
  borderTopRightRadius: X,
  borderBottomRightRadius: X,
  borderBottomLeftRadius: X,
  // Positioning props
  width: X,
  maxWidth: X,
  height: X,
  maxHeight: X,
  top: X,
  right: X,
  bottom: X,
  left: X,
  // Spacing props
  padding: X,
  paddingTop: X,
  paddingRight: X,
  paddingBottom: X,
  paddingLeft: X,
  margin: X,
  marginTop: X,
  marginRight: X,
  marginBottom: X,
  marginLeft: X,
  // Misc
  backgroundPositionX: X,
  backgroundPositionY: X,
  ...fp,
  zIndex: Gi,
  // SVG
  fillOpacity: ks,
  strokeOpacity: ks,
  numOctaves: Gi
}, xp = {
  ...kr,
  // Color props
  color: ve,
  backgroundColor: ve,
  outlineColor: ve,
  fill: ve,
  stroke: ve,
  // Border props
  borderColor: ve,
  borderTopColor: ve,
  borderRightColor: ve,
  borderBottomColor: ve,
  borderLeftColor: ve,
  filter: Ta,
  WebkitFilter: Ta
}, Bc = (e) => xp[e];
function zc(e, t) {
  let n = Bc(e);
  return n !== Ta && (n = jt), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const pp = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function gp(e, t, n) {
  let a = 0, r;
  for (; a < e.length && !r; ) {
    const i = e[a];
    typeof i == "string" && !pp.has(i) && Cs(i).values.length && (r = e[a]), a++;
  }
  if (r && n)
    for (const i of t)
      e[i] = zc(n, r);
}
class yp extends wr {
  constructor(t, n, a, r, i) {
    super(t, n, a, r, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: a } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let d = 0; d < t.length; d++) {
      let c = t[d];
      if (typeof c == "string" && (c = c.trim(), fr(c))) {
        const u = $c(c, n.current);
        u !== void 0 && (t[d] = u), d === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !Ic.has(a) || t.length !== 2)
      return;
    const [r, i] = t, o = Yi(r), l = Yi(i);
    if (o !== l)
      if (qi(o) && qi(l))
        for (let d = 0; d < t.length; d++) {
          const c = t[d];
          typeof c == "string" && (t[d] = parseFloat(c));
        }
      else _t[a] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, a = [];
    for (let r = 0; r < t.length; r++)
      (t[r] === null || dp(t[r])) && a.push(r);
    a.length && gp(t, a, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: a } = this;
    if (!t || !t.current)
      return;
    a === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = _t[a](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const r = n[n.length - 1];
    r !== void 0 && t.getValue(a, r).jump(r, !1);
  }
  measureEndState() {
    var l;
    const { element: t, name: n, unresolvedKeyframes: a } = this;
    if (!t || !t.current)
      return;
    const r = t.getValue(n);
    r && r.jump(this.measuredOrigin, !1);
    const i = a.length - 1, o = a[i];
    a[i] = _t[n](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (l = this.removedTransforms) != null && l.length && this.removedTransforms.forEach(([d, c]) => {
      t.getValue(d).set(c);
    }), this.resolveNoneKeyframes();
  }
}
function bp(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let a = document;
    const r = (n == null ? void 0 : n[e]) ?? a.querySelectorAll(e);
    return r ? Array.from(r) : [];
  }
  return Array.from(e);
}
const Uc = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function jp(e) {
  return rc(e) && "offsetHeight" in e;
}
const Xi = 30, vp = (e) => !isNaN(parseFloat(e));
class wp {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (a) => {
      var i;
      const r = Me.now();
      if (this.updatedAt !== r && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(a), this.current !== this.prev && ((i = this.events.change) == null || i.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = Me.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = vp(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && ur(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new dr());
    const a = this.events[t].add(n);
    return t === "change" ? () => {
      a(), me.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : a;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, a) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - a;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = Me.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Xi)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Xi);
    return oc(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Qt(e, t) {
  return new wp(e, t);
}
const { schedule: Cr } = /* @__PURE__ */ yc(queueMicrotask, !1), Ge = {
  x: !1,
  y: !1
};
function qc() {
  return Ge.x || Ge.y;
}
function Np(e) {
  return e === "x" || e === "y" ? Ge[e] ? null : (Ge[e] = !0, () => {
    Ge[e] = !1;
  }) : Ge.x || Ge.y ? null : (Ge.x = Ge.y = !0, () => {
    Ge.x = Ge.y = !1;
  });
}
function Hc(e, t) {
  const n = bp(e), a = new AbortController(), r = {
    passive: !0,
    ...t,
    signal: a.signal
  };
  return [n, r, () => a.abort()];
}
function Ji(e) {
  return !(e.pointerType === "touch" || qc());
}
function kp(e, t, n = {}) {
  const [a, r, i] = Hc(e, n), o = (l) => {
    if (!Ji(l))
      return;
    const { target: d } = l, c = t(d, l);
    if (typeof c != "function" || !d)
      return;
    const u = (h) => {
      Ji(h) && (c(h), d.removeEventListener("pointerleave", u));
    };
    d.addEventListener("pointerleave", u, r);
  };
  return a.forEach((l) => {
    l.addEventListener("pointerenter", o, r);
  }), i;
}
const Wc = (e, t) => t ? e === t ? !0 : Wc(e, t.parentElement) : !1, Tr = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, Cp = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Tp(e) {
  return Cp.has(e.tagName) || e.tabIndex !== -1;
}
const Js = /* @__PURE__ */ new WeakSet();
function Zi(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function Yn(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const Sp = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const a = Zi(() => {
    if (Js.has(n))
      return;
    Yn(n, "down");
    const r = Zi(() => {
      Yn(n, "up");
    }), i = () => Yn(n, "cancel");
    n.addEventListener("keyup", r, t), n.addEventListener("blur", i, t);
  });
  n.addEventListener("keydown", a, t), n.addEventListener("blur", () => n.removeEventListener("keydown", a), t);
};
function Qi(e) {
  return Tr(e) && !qc();
}
function Ap(e, t, n = {}) {
  const [a, r, i] = Hc(e, n), o = (l) => {
    const d = l.currentTarget;
    if (!Qi(l))
      return;
    Js.add(d);
    const c = t(d, l), u = (x, f) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", m), Js.has(d) && Js.delete(d), Qi(x) && typeof c == "function" && c(x, { success: f });
    }, h = (x) => {
      u(x, d === window || d === document || n.useGlobalTarget || Wc(d, x.target));
    }, m = (x) => {
      u(x, !1);
    };
    window.addEventListener("pointerup", h, r), window.addEventListener("pointercancel", m, r);
  };
  return a.forEach((l) => {
    (n.useGlobalTarget ? window : l).addEventListener("pointerdown", o, r), jp(l) && (l.addEventListener("focus", (c) => Sp(c, r)), !Tp(l) && !l.hasAttribute("tabindex") && (l.tabIndex = 0));
  }), i;
}
function Kc(e) {
  return rc(e) && "ownerSVGElement" in e;
}
function Pp(e) {
  return Kc(e) && e.tagName === "svg";
}
const Pe = (e) => !!(e && e.getVelocity), Ep = [...Vc, ve, jt], Rp = (e) => Ep.find(Oc(e)), Yc = dt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function Dp(e = !0) {
  const t = Se(ir);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: a, register: r } = t, i = Wu();
  le(() => {
    if (e)
      return r(i);
  }, [e]);
  const o = qe(() => e && a && a(i), [i, a, e]);
  return !n && a ? [!1, o] : [!0];
}
const Gc = dt({ strict: !1 }), eo = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, es = {};
for (const e in eo)
  es[e] = {
    isEnabled: (t) => eo[e].some((n) => !!t[n])
  };
function _p(e) {
  for (const t in e)
    es[t] = {
      ...es[t],
      ...e[t]
    };
}
const Mp = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function dn(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || Mp.has(e);
}
let Xc = (e) => !dn(e);
function Fp(e) {
  typeof e == "function" && (Xc = (t) => t.startsWith("on") ? !dn(t) : e(t));
}
try {
  Fp(require("@emotion/is-prop-valid").default);
} catch {
}
function Lp(e, t, n) {
  const a = {};
  for (const r in e)
    r === "values" && typeof e.values == "object" || (Xc(r) || n === !0 && dn(r) || !t && !dn(r) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && r.startsWith("onDrag")) && (a[r] = e[r]);
  return a;
}
const wn = /* @__PURE__ */ dt({});
function Nn(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Ts(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Sr = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Ar = ["initial", ...Sr];
function kn(e) {
  return Nn(e.animate) || Ar.some((t) => Ts(e[t]));
}
function Jc(e) {
  return !!(kn(e) || e.variants);
}
function $p(e, t) {
  if (kn(e)) {
    const { initial: n, animate: a } = e;
    return {
      initial: n === !1 || Ts(n) ? n : void 0,
      animate: Ts(a) ? a : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Ip(e) {
  const { initial: t, animate: n } = $p(e, Se(wn));
  return fn(() => ({ initial: t, animate: n }), [to(t), to(n)]);
}
function to(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function so(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const us = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (X.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = so(e, t.target.x), a = so(e, t.target.y);
    return `${n}% ${a}%`;
  }
}, Op = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const a = e, r = jt.parse(e);
    if (r.length > 5)
      return a;
    const i = jt.createTransformer(e), o = typeof r[0] != "number" ? 1 : 0, l = n.x.scale * t.x, d = n.y.scale * t.y;
    r[0 + o] /= l, r[1 + o] /= d;
    const c = pe(l, d, 0.5);
    return typeof r[2 + o] == "number" && (r[2 + o] /= c), typeof r[3 + o] == "number" && (r[3 + o] /= c), i(r);
  }
}, Sa = {
  borderRadius: {
    ...us,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: us,
  borderTopRightRadius: us,
  borderBottomLeftRadius: us,
  borderBottomRightRadius: us,
  boxShadow: Op
};
function Zc(e, { layout: t, layoutId: n }) {
  return os.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Sa[e] || e === "opacity");
}
const Vp = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Bp = is.length;
function zp(e, t, n) {
  let a = "", r = !0;
  for (let i = 0; i < Bp; i++) {
    const o = is[i], l = e[o];
    if (l === void 0)
      continue;
    let d = !0;
    if (typeof l == "number" ? d = l === (o.startsWith("scale") ? 1 : 0) : d = parseFloat(l) === 0, !d || n) {
      const c = Uc(l, kr[o]);
      if (!d) {
        r = !1;
        const u = Vp[o] || o;
        a += `${u}(${c}) `;
      }
      n && (t[o] = c);
    }
  }
  return a = a.trim(), n ? a = n(t, r ? "" : a) : r && (a = "none"), a;
}
function Pr(e, t, n) {
  const { style: a, vars: r, transformOrigin: i } = e;
  let o = !1, l = !1;
  for (const d in t) {
    const c = t[d];
    if (os.has(d)) {
      o = !0;
      continue;
    } else if (jc(d)) {
      r[d] = c;
      continue;
    } else {
      const u = Uc(c, kr[d]);
      d.startsWith("origin") ? (l = !0, i[d] = u) : a[d] = u;
    }
  }
  if (t.transform || (o || n ? a.transform = zp(t, e.transform, n) : a.transform && (a.transform = "none")), l) {
    const { originX: d = "50%", originY: c = "50%", originZ: u = 0 } = i;
    a.transformOrigin = `${d} ${c} ${u}`;
  }
}
const Er = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Qc(e, t, n) {
  for (const a in t)
    !Pe(t[a]) && !Zc(a, n) && (e[a] = t[a]);
}
function Up({ transformTemplate: e }, t) {
  return fn(() => {
    const n = Er();
    return Pr(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function qp(e, t) {
  const n = e.style || {}, a = {};
  return Qc(a, n, e), Object.assign(a, Up(e, t)), a;
}
function Hp(e, t) {
  const n = {}, a = qp(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none", a.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = a, n;
}
const Wp = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Kp = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Yp(e, t, n = 1, a = 0, r = !0) {
  e.pathLength = 1;
  const i = r ? Wp : Kp;
  e[i.offset] = X.transform(-a);
  const o = X.transform(t), l = X.transform(n);
  e[i.array] = `${o} ${l}`;
}
function ed(e, {
  attrX: t,
  attrY: n,
  attrScale: a,
  pathLength: r,
  pathSpacing: i = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, d, c, u) {
  if (Pr(e, l, c), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: h, style: m } = e;
  h.transform && (m.transform = h.transform, delete h.transform), (m.transform || h.transformOrigin) && (m.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), m.transform && (m.transformBox = (u == null ? void 0 : u.transformBox) ?? "fill-box", delete h.transformBox), t !== void 0 && (h.x = t), n !== void 0 && (h.y = n), a !== void 0 && (h.scale = a), r !== void 0 && Yp(h, r, i, o, !1);
}
const td = () => ({
  ...Er(),
  attrs: {}
}), sd = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function Gp(e, t, n, a) {
  const r = fn(() => {
    const i = td();
    return ed(i, t, sd(a), e.transformTemplate, e.style), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    Qc(i, e.style, e), r.style = { ...i, ...r.style };
  }
  return r;
}
const Xp = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Rr(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Xp.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function Jp(e, t, n, { latestValues: a }, r, i = !1) {
  const l = (Rr(e) ? Gp : Hp)(t, a, r, e), d = Lp(t, typeof e == "string", i), c = e !== dl ? { ...d, ...l, ref: n } : {}, { children: u } = t, h = fn(() => Pe(u) ? u.get() : u, [u]);
  return en(e, {
    ...c,
    children: h
  });
}
function no(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, a) => {
    t[0][a] = n.get(), t[1][a] = n.getVelocity();
  }), t;
}
function Dr(e, t, n, a) {
  if (typeof t == "function") {
    const [r, i] = no(a);
    t = t(n !== void 0 ? n : e.custom, r, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [r, i] = no(a);
    t = t(n !== void 0 ? n : e.custom, r, i);
  }
  return t;
}
function Zs(e) {
  return Pe(e) ? e.get() : e;
}
function Zp({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, a, r) {
  return {
    latestValues: Qp(n, a, r, e),
    renderState: t()
  };
}
function Qp(e, t, n, a) {
  const r = {}, i = a(e, {});
  for (const m in i)
    r[m] = Zs(i[m]);
  let { initial: o, animate: l } = e;
  const d = kn(e), c = Jc(e);
  t && c && !d && e.inherit !== !1 && (o === void 0 && (o = t.initial), l === void 0 && (l = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || o === !1;
  const h = u ? l : o;
  if (h && typeof h != "boolean" && !Nn(h)) {
    const m = Array.isArray(h) ? h : [h];
    for (let x = 0; x < m.length; x++) {
      const f = Dr(e, m[x]);
      if (f) {
        const { transitionEnd: p, transition: y, ...b } = f;
        for (const k in b) {
          let g = b[k];
          if (Array.isArray(g)) {
            const v = u ? g.length - 1 : 0;
            g = g[v];
          }
          g !== null && (r[k] = g);
        }
        for (const k in p)
          r[k] = p[k];
      }
    }
  }
  return r;
}
const nd = (e) => (t, n) => {
  const a = Se(wn), r = Se(ir), i = () => Zp(e, t, a, r);
  return n ? i() : _f(i);
};
function _r(e, t, n) {
  var i;
  const { style: a } = e, r = {};
  for (const o in a)
    (Pe(a[o]) || t.style && Pe(t.style[o]) || Zc(o, e) || ((i = n == null ? void 0 : n.getValue(o)) == null ? void 0 : i.liveStyle) !== void 0) && (r[o] = a[o]);
  return r;
}
const e0 = /* @__PURE__ */ nd({
  scrapeMotionValuesFromProps: _r,
  createRenderState: Er
});
function ad(e, t, n) {
  const a = _r(e, t, n);
  for (const r in e)
    if (Pe(e[r]) || Pe(t[r])) {
      const i = is.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      a[i] = e[r];
    }
  return a;
}
const t0 = /* @__PURE__ */ nd({
  scrapeMotionValuesFromProps: ad,
  createRenderState: td
}), s0 = Symbol.for("motionComponentSymbol");
function Ut(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function n0(e, t, n) {
  return qe(
    (a) => {
      a && e.onMount && e.onMount(a), t && (a ? t.mount(a) : t.unmount()), n && (typeof n == "function" ? n(a) : Ut(n) && (n.current = a));
    },
    /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */
    [t]
  );
}
const Mr = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), a0 = "framerAppearId", rd = "data-" + Mr(a0), id = dt({});
function r0(e, t, n, a, r) {
  var p, y;
  const { visualElement: i } = Se(wn), o = Se(Gc), l = Se(ir), d = Se(Yc).reducedMotion, c = We(null);
  a = a || o.renderer, !c.current && a && (c.current = a(e, {
    visualState: t,
    parent: i,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: d
  }));
  const u = c.current, h = Se(id);
  u && !u.projection && r && (u.type === "html" || u.type === "svg") && i0(c.current, n, r, h);
  const m = We(!1);
  Ku(() => {
    u && m.current && u.update(n, l);
  });
  const x = n[rd], f = We(!!x && !((p = window.MotionHandoffIsComplete) != null && p.call(window, x)) && ((y = window.MotionHasOptimisedAnimation) == null ? void 0 : y.call(window, x)));
  return Mf(() => {
    u && (m.current = !0, window.MotionIsMounted = !0, u.updateFeatures(), u.scheduleRenderMicrotask(), f.current && u.animationState && u.animationState.animateChanges());
  }), le(() => {
    u && (!f.current && u.animationState && u.animationState.animateChanges(), f.current && (queueMicrotask(() => {
      var b;
      (b = window.MotionHandoffMarkAsComplete) == null || b.call(window, x);
    }), f.current = !1), u.enteringChildren = void 0);
  }), u;
}
function i0(e, t, n, a) {
  const { layoutId: r, layout: i, drag: o, dragConstraints: l, layoutScroll: d, layoutRoot: c, layoutCrossfade: u } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : od(e.parent)), e.projection.setOptions({
    layoutId: r,
    layout: i,
    alwaysMeasureLayout: !!o || l && Ut(l),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: a,
    crossfade: u,
    layoutScroll: d,
    layoutRoot: c
  });
}
function od(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : od(e.parent);
}
function Gn(e, { forwardMotionProps: t = !1 } = {}, n, a) {
  n && _p(n);
  const r = Rr(e) ? t0 : e0;
  function i(l, d) {
    let c;
    const u = {
      ...Se(Yc),
      ...l,
      layoutId: o0(l)
    }, { isStatic: h } = u, m = Ip(l), x = r(l, h);
    if (!h && rr) {
      l0(u, n);
      const f = c0(u);
      c = f.MeasureLayout, m.visualElement = r0(e, x, u, a, f.ProjectionNode);
    }
    return s.jsxs(wn.Provider, { value: m, children: [c && m.visualElement ? s.jsx(c, { visualElement: m.visualElement, ...u }) : null, Jp(e, l, n0(x, m.visualElement, d), x, h, t)] });
  }
  i.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const o = vt(i);
  return o[s0] = e, o;
}
function o0({ layoutId: e }) {
  const t = Se(nc).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function l0(e, t) {
  const n = Se(Gc).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const a = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? as(!1, a, "lazy-strict-mode") : ot(!1, a, "lazy-strict-mode");
  }
}
function c0(e) {
  const { drag: t, layout: n } = es;
  if (!t && !n)
    return {};
  const a = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? a.MeasureLayout : void 0,
    ProjectionNode: a.ProjectionNode
  };
}
function d0(e, t) {
  if (typeof Proxy > "u")
    return Gn;
  const n = /* @__PURE__ */ new Map(), a = (i, o) => Gn(i, o, e, t), r = (i, o) => (process.env.NODE_ENV !== "production" && ur(!1, "motion() is deprecated. Use motion.create() instead."), a(i, o));
  return new Proxy(r, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (i, o) => o === "create" ? a : (n.has(o) || n.set(o, Gn(o, void 0, e, t)), n.get(o))
  });
}
function ld({ top: e, left: t, right: n, bottom: a }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: a }
  };
}
function u0({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function h0(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), a = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: a.y,
    right: a.x
  };
}
function Xn(e) {
  return e === void 0 || e === 1;
}
function Aa({ scale: e, scaleX: t, scaleY: n }) {
  return !Xn(e) || !Xn(t) || !Xn(n);
}
function St(e) {
  return Aa(e) || cd(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function cd(e) {
  return ao(e.x) || ao(e.y);
}
function ao(e) {
  return e && e !== "0%";
}
function un(e, t, n) {
  const a = e - n, r = t * a;
  return n + r;
}
function ro(e, t, n, a, r) {
  return r !== void 0 && (e = un(e, r, a)), un(e, n, a) + t;
}
function Pa(e, t = 0, n = 1, a, r) {
  e.min = ro(e.min, t, n, a, r), e.max = ro(e.max, t, n, a, r);
}
function dd(e, { x: t, y: n }) {
  Pa(e.x, t.translate, t.scale, t.originPoint), Pa(e.y, n.translate, n.scale, n.originPoint);
}
const io = 0.999999999999, oo = 1.0000000000001;
function m0(e, t, n, a = !1) {
  const r = n.length;
  if (!r)
    return;
  t.x = t.y = 1;
  let i, o;
  for (let l = 0; l < r; l++) {
    i = n[l], o = i.projectionDelta;
    const { visualElement: d } = i.options;
    d && d.props.style && d.props.style.display === "contents" || (a && i.options.layoutScroll && i.scroll && i !== i.root && Ht(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), o && (t.x *= o.x.scale, t.y *= o.y.scale, dd(e, o)), a && St(i.latestValues) && Ht(e, i.latestValues));
  }
  t.x < oo && t.x > io && (t.x = 1), t.y < oo && t.y > io && (t.y = 1);
}
function qt(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function lo(e, t, n, a, r = 0.5) {
  const i = pe(e.min, e.max, r);
  Pa(e, t, n, i, a);
}
function Ht(e, t) {
  lo(e.x, t.x, t.scaleX, t.scale, t.originX), lo(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function ud(e, t) {
  return ld(h0(e.getBoundingClientRect(), t));
}
function f0(e, t, n) {
  const a = ud(e, n), { scroll: r } = t;
  return r && (qt(a.x, r.offset.x), qt(a.y, r.offset.y)), a;
}
const co = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Wt = () => ({
  x: co(),
  y: co()
}), uo = () => ({ min: 0, max: 0 }), we = () => ({
  x: uo(),
  y: uo()
}), Ea = { current: null }, hd = { current: !1 };
function x0() {
  if (hd.current = !0, !!rr)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Ea.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Ea.current = !1;
}
const p0 = /* @__PURE__ */ new WeakMap();
function g0(e, t, n) {
  for (const a in t) {
    const r = t[a], i = n[a];
    if (Pe(r))
      e.addValue(a, r);
    else if (Pe(i))
      e.addValue(a, Qt(r, { owner: e }));
    else if (i !== r)
      if (e.hasValue(a)) {
        const o = e.getValue(a);
        o.liveStyle === !0 ? o.jump(r) : o.hasAnimated || o.set(r);
      } else {
        const o = e.getStaticValue(a);
        e.addValue(a, Qt(o !== void 0 ? o : r, { owner: e }));
      }
  }
  for (const a in n)
    t[a] === void 0 && e.removeValue(a);
  return t;
}
const ho = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class y0 {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, a) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: a, reducedMotionConfig: r, blockInitialAnimation: i, visualState: o }, l = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = wr, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const m = Me.now();
      this.renderScheduledAt < m && (this.renderScheduledAt = m, me.render(this.render, !1, !0));
    };
    const { latestValues: d, renderState: c } = o;
    this.latestValues = d, this.baseTarget = { ...d }, this.initialValues = n.initial ? { ...d } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = a, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = r, this.options = l, this.blockInitialAnimation = !!i, this.isControllingVariants = kn(n), this.isVariantNode = Jc(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: u, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const m in h) {
      const x = h[m];
      d[m] !== void 0 && Pe(x) && x.set(d[m]);
    }
  }
  mount(t) {
    var n;
    this.current = t, p0.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((a, r) => this.bindToMotionValue(r, a)), hd.current || x0(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Ea.current, process.env.NODE_ENV !== "production" && ur(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (n = this.parent) == null || n.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var t;
    this.projection && this.projection.unmount(), bt(this.notifyUpdate), bt(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (t = this.parent) == null || t.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const a = this.features[n];
      a && (a.unmount(), a.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const a = os.has(t);
    a && this.onBindTransform && this.onBindTransform();
    const r = n.on("change", (o) => {
      this.latestValues[t] = o, this.props.onUpdate && me.preRender(this.notifyUpdate), a && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let i;
    window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      r(), i && i(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in es) {
      const n = es[t];
      if (!n)
        continue;
      const { isEnabled: a, Feature: r } = n;
      if (!this.features[t] && r && a(this.props) && (this.features[t] = new r(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : we();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let a = 0; a < ho.length; a++) {
      const r = ho[a];
      this.propEventSubscriptions[r] && (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r]);
      const i = "on" + r, o = t[i];
      o && (this.propEventSubscriptions[r] = this.on(r, o));
    }
    this.prevMotionValues = g0(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const a = this.values.get(t);
    n !== a && (a && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let a = this.values.get(t);
    return a === void 0 && n !== void 0 && (a = Qt(n === null ? void 0 : n, { owner: this }), this.addValue(t, a)), a;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let a = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return a != null && (typeof a == "string" && (ac(a) || ic(a)) ? a = parseFloat(a) : !Rp(a) && jt.test(n) && (a = zc(t, n)), this.setBaseTarget(t, Pe(a) ? a.get() : a)), Pe(a) ? a.get() : a;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var i;
    const { initial: n } = this.props;
    let a;
    if (typeof n == "string" || typeof n == "object") {
      const o = Dr(this.props, n, (i = this.presenceContext) == null ? void 0 : i.custom);
      o && (a = o[t]);
    }
    if (n && a !== void 0)
      return a;
    const r = this.getBaseTargetFromProps(this.props, t);
    return r !== void 0 && !Pe(r) ? r : this.initialValues[t] !== void 0 && a === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new dr()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    Cr.render(this.render);
  }
}
class md extends y0 {
  constructor() {
    super(...arguments), this.KeyframeResolver = yp;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: a }) {
    delete n[t], delete a[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Pe(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function fd(e, { style: t, vars: n }, a, r) {
  const i = e.style;
  let o;
  for (o in t)
    i[o] = t[o];
  r == null || r.applyProjectionStyles(i, a);
  for (o in n)
    i.setProperty(o, n[o]);
}
function b0(e) {
  return window.getComputedStyle(e);
}
class j0 extends md {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = fd;
  }
  readValueFromInstance(t, n) {
    var a;
    if (os.has(n))
      return (a = this.projection) != null && a.isProjecting ? ja(n) : Lx(t, n);
    {
      const r = b0(t), i = (jc(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return ud(t, n);
  }
  build(t, n, a) {
    Pr(t, n, a.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, a) {
    return _r(t, n, a);
  }
}
const xd = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function v0(e, t, n, a) {
  fd(e, t, void 0, a);
  for (const r in t.attrs)
    e.setAttribute(xd.has(r) ? r : Mr(r), t.attrs[r]);
}
class w0 extends md {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = we;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (os.has(n)) {
      const a = Bc(n);
      return a && a.default || 0;
    }
    return n = xd.has(n) ? n : Mr(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, a) {
    return ad(t, n, a);
  }
  build(t, n, a) {
    ed(t, n, this.isSVGTag, a.transformTemplate, a.style);
  }
  renderInstance(t, n, a, r) {
    v0(t, n, a, r);
  }
  mount(t) {
    this.isSVGTag = sd(t.tagName), super.mount(t);
  }
}
const N0 = (e, t) => Rr(e) ? new w0(t) : new j0(t, {
  allowProjection: e !== dl
});
function Kt(e, t, n) {
  const a = e.getProps();
  return Dr(a, t, n !== void 0 ? n : a.custom, e);
}
const Ra = (e) => Array.isArray(e);
function k0(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Qt(n));
}
function C0(e) {
  return Ra(e) ? e[e.length - 1] || 0 : e;
}
function T0(e, t) {
  const n = Kt(e, t);
  let { transitionEnd: a = {}, transition: r = {}, ...i } = n || {};
  i = { ...i, ...a };
  for (const o in i) {
    const l = C0(i[o]);
    k0(e, o, l);
  }
}
function S0(e) {
  return !!(Pe(e) && e.add);
}
function Da(e, t) {
  const n = e.getValue("willChange");
  if (S0(n))
    return n.add(t);
  if (!n && lt.WillChange) {
    const a = new lt.WillChange("auto");
    e.addValue("willChange", a), a.add(t);
  }
}
function pd(e) {
  return e.props[rd];
}
const A0 = (e) => e !== null;
function P0(e, { repeat: t, repeatType: n = "loop" }, a) {
  const r = e.filter(A0), i = t && n !== "loop" && t % 2 === 1 ? 0 : r.length - 1;
  return r[i];
}
const E0 = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, R0 = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), D0 = {
  type: "keyframes",
  duration: 0.8
}, _0 = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, M0 = (e, { keyframes: t }) => t.length > 2 ? D0 : os.has(e) ? e.startsWith("scale") ? R0(t[1]) : E0 : _0;
function F0({ when: e, delay: t, delayChildren: n, staggerChildren: a, staggerDirection: r, repeat: i, repeatType: o, repeatDelay: l, from: d, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
const Fr = (e, t, n, a = {}, r, i) => (o) => {
  const l = Nr(a, e) || {}, d = l.delay || a.delay || 0;
  let { elapsed: c = 0 } = a;
  c = c - /* @__PURE__ */ Xe(d);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...l,
    delay: -c,
    onUpdate: (m) => {
      t.set(m), l.onUpdate && l.onUpdate(m);
    },
    onComplete: () => {
      o(), l.onComplete && l.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : r
  };
  F0(l) || Object.assign(u, M0(e, u)), u.duration && (u.duration = /* @__PURE__ */ Xe(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Xe(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let h = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (Ca(u), u.delay === 0 && (h = !0)), (lt.instantAnimations || lt.skipAnimations) && (h = !0, Ca(u), u.delay = 0), u.allowFlatten = !l.type && !l.ease, h && !i && t.get() !== void 0) {
    const m = P0(u.keyframes, l);
    if (m !== void 0) {
      me.update(() => {
        u.onUpdate(m), u.onComplete();
      });
      return;
    }
  }
  return l.isSync ? new vr(u) : new rp(u);
};
function L0({ protectedKeys: e, needsAnimating: t }, n) {
  const a = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, a;
}
function gd(e, t, { delay: n = 0, transitionOverride: a, type: r } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: o, ...l } = t;
  a && (i = a);
  const d = [], c = r && e.animationState && e.animationState.getState()[r];
  for (const u in l) {
    const h = e.getValue(u, e.latestValues[u] ?? null), m = l[u];
    if (m === void 0 || c && L0(c, u))
      continue;
    const x = {
      delay: n,
      ...Nr(i || {}, u)
    }, f = h.get();
    if (f !== void 0 && !h.isAnimating && !Array.isArray(m) && m === f && !x.velocity)
      continue;
    let p = !1;
    if (window.MotionHandoffAnimation) {
      const b = pd(e);
      if (b) {
        const k = window.MotionHandoffAnimation(b, u, me);
        k !== null && (x.startTime = k, p = !0);
      }
    }
    Da(e, u), h.start(Fr(u, h, m, e.shouldReduceMotion && Ic.has(u) ? { type: !1 } : x, e, p));
    const y = h.animation;
    y && d.push(y);
  }
  return o && Promise.all(d).then(() => {
    me.update(() => {
      o && T0(e, o);
    });
  }), d;
}
function yd(e, t, n, a = 0, r = 1) {
  const i = Array.from(e).sort((c, u) => c.sortNodePosition(u)).indexOf(t), o = e.size, l = (o - 1) * a;
  return typeof n == "function" ? n(i, o) : r === 1 ? i * a : l - i * a;
}
function _a(e, t, n = {}) {
  var d;
  const a = Kt(e, t, n.type === "exit" ? (d = e.presenceContext) == null ? void 0 : d.custom : void 0);
  let { transition: r = e.getDefaultTransition() || {} } = a || {};
  n.transitionOverride && (r = n.transitionOverride);
  const i = a ? () => Promise.all(gd(e, a, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: h, staggerDirection: m } = r;
    return $0(e, t, c, u, h, m, n);
  } : () => Promise.resolve(), { when: l } = r;
  if (l) {
    const [c, u] = l === "beforeChildren" ? [i, o] : [o, i];
    return c().then(() => u());
  } else
    return Promise.all([i(), o(n.delay)]);
}
function $0(e, t, n = 0, a = 0, r = 0, i = 1, o) {
  const l = [];
  for (const d of e.variantChildren)
    d.notify("AnimationStart", t), l.push(_a(d, t, {
      ...o,
      delay: n + (typeof a == "function" ? 0 : a) + yd(e.variantChildren, d, a, r, i)
    }).then(() => d.notify("AnimationComplete", t)));
  return Promise.all(l);
}
function I0(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let a;
  if (Array.isArray(t)) {
    const r = t.map((i) => _a(e, i, n));
    a = Promise.all(r);
  } else if (typeof t == "string")
    a = _a(e, t, n);
  else {
    const r = typeof t == "function" ? Kt(e, t, n.custom) : t;
    a = Promise.all(gd(e, r, n));
  }
  return a.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function bd(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let a = 0; a < n; a++)
    if (t[a] !== e[a])
      return !1;
  return !0;
}
const O0 = Ar.length;
function jd(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? jd(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < O0; n++) {
    const a = Ar[n], r = e.props[a];
    (Ts(r) || r === !1) && (t[a] = r);
  }
  return t;
}
const V0 = [...Sr].reverse(), B0 = Sr.length;
function z0(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: a }) => I0(e, n, a)));
}
function U0(e) {
  let t = z0(e), n = mo(), a = !0;
  const r = (d) => (c, u) => {
    var m;
    const h = Kt(e, u, d === "exit" ? (m = e.presenceContext) == null ? void 0 : m.custom : void 0);
    if (h) {
      const { transition: x, transitionEnd: f, ...p } = h;
      c = { ...c, ...p, ...f };
    }
    return c;
  };
  function i(d) {
    t = d(e);
  }
  function o(d) {
    const { props: c } = e, u = jd(e.parent) || {}, h = [], m = /* @__PURE__ */ new Set();
    let x = {}, f = 1 / 0;
    for (let y = 0; y < B0; y++) {
      const b = V0[y], k = n[b], g = c[b] !== void 0 ? c[b] : u[b], v = Ts(g), C = b === d ? k.isActive : null;
      C === !1 && (f = y);
      let w = g === u[b] && g !== c[b] && v;
      if (w && a && e.manuallyAnimateOnMount && (w = !1), k.protectedKeys = { ...x }, // If it isn't active and hasn't *just* been set as inactive
      !k.isActive && C === null || // If we didn't and don't have any defined prop for this animation type
      !g && !k.prevProp || // Or if the prop doesn't define an animation
      Nn(g) || typeof g == "boolean")
        continue;
      const D = q0(k.prevProp, g);
      let P = D || // If we're making this variant active, we want to always make it active
      b === d && k.isActive && !w && v || // If we removed a higher-priority variant (i is in reverse order)
      y > f && v, $ = !1;
      const I = Array.isArray(g) ? g : [g];
      let V = I.reduce(r(b), {});
      C === !1 && (V = {});
      const { prevResolvedValues: H = {} } = k, K = {
        ...H,
        ...V
      }, U = (se) => {
        P = !0, m.has(se) && ($ = !0, m.delete(se)), k.needsAnimating[se] = !0;
        const A = e.getValue(se);
        A && (A.liveStyle = !1);
      };
      for (const se in K) {
        const A = V[se], z = H[se];
        if (x.hasOwnProperty(se))
          continue;
        let R = !1;
        Ra(A) && Ra(z) ? R = !bd(A, z) : R = A !== z, R ? A != null ? U(se) : m.add(se) : A !== void 0 && m.has(se) ? U(se) : k.protectedKeys[se] = !0;
      }
      k.prevProp = g, k.prevResolvedValues = V, k.isActive && (x = { ...x, ...V }), a && e.blockInitialAnimation && (P = !1);
      const te = w && D;
      P && (!te || $) && h.push(...I.map((se) => {
        const A = { type: b };
        if (typeof se == "string" && a && !te && e.manuallyAnimateOnMount && e.parent) {
          const { parent: z } = e, R = Kt(z, se);
          if (z.enteringChildren && R) {
            const { delayChildren: N } = R.transition || {};
            A.delay = yd(z.enteringChildren, e, N);
          }
        }
        return {
          animation: se,
          options: A
        };
      }));
    }
    if (m.size) {
      const y = {};
      if (typeof c.initial != "boolean") {
        const b = Kt(e, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        b && b.transition && (y.transition = b.transition);
      }
      m.forEach((b) => {
        const k = e.getBaseTarget(b), g = e.getValue(b);
        g && (g.liveStyle = !0), y[b] = k ?? null;
      }), h.push({ animation: y });
    }
    let p = !!h.length;
    return a && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (p = !1), a = !1, p ? t(h) : Promise.resolve();
  }
  function l(d, c) {
    var h;
    if (n[d].isActive === c)
      return Promise.resolve();
    (h = e.variantChildren) == null || h.forEach((m) => {
      var x;
      return (x = m.animationState) == null ? void 0 : x.setActive(d, c);
    }), n[d].isActive = c;
    const u = o(d);
    for (const m in n)
      n[m].protectedKeys = {};
    return u;
  }
  return {
    animateChanges: o,
    setActive: l,
    setAnimateFunction: i,
    getState: () => n,
    reset: () => {
      n = mo();
    }
  };
}
function q0(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !bd(t, e) : !1;
}
function Tt(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function mo() {
  return {
    animate: Tt(!0),
    whileInView: Tt(),
    whileHover: Tt(),
    whileTap: Tt(),
    whileDrag: Tt(),
    whileFocus: Tt(),
    exit: Tt()
  };
}
class wt {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class H0 extends wt {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = U0(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    Nn(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let W0 = 0;
class K0 extends wt {
  constructor() {
    super(...arguments), this.id = W0++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: a } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === a)
      return;
    const r = this.node.animationState.setActive("exit", !t);
    n && !t && r.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const Y0 = {
  animation: {
    Feature: H0
  },
  exit: {
    Feature: K0
  }
};
function Ss(e, t, n, a = { passive: !0 }) {
  return e.addEventListener(t, n, a), () => e.removeEventListener(t, n);
}
function Ls(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const G0 = (e) => (t) => Tr(t) && e(t, Ls(t));
function ps(e, t, n, a) {
  return Ss(e, t, G0(n), a);
}
const vd = 1e-4, X0 = 1 - vd, J0 = 1 + vd, wd = 0.01, Z0 = 0 - wd, Q0 = 0 + wd;
function De(e) {
  return e.max - e.min;
}
function eg(e, t, n) {
  return Math.abs(e - t) <= n;
}
function fo(e, t, n, a = 0.5) {
  e.origin = a, e.originPoint = pe(t.min, t.max, e.origin), e.scale = De(n) / De(t), e.translate = pe(n.min, n.max, e.origin) - e.originPoint, (e.scale >= X0 && e.scale <= J0 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= Z0 && e.translate <= Q0 || isNaN(e.translate)) && (e.translate = 0);
}
function gs(e, t, n, a) {
  fo(e.x, t.x, n.x, a ? a.originX : void 0), fo(e.y, t.y, n.y, a ? a.originY : void 0);
}
function xo(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + De(t);
}
function tg(e, t, n) {
  xo(e.x, t.x, n.x), xo(e.y, t.y, n.y);
}
function po(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + De(t);
}
function hn(e, t, n) {
  po(e.x, t.x, n.x), po(e.y, t.y, n.y);
}
function Ue(e) {
  return [e("x"), e("y")];
}
const Nd = ({ current: e }) => e ? e.ownerDocument.defaultView : null, go = (e, t) => Math.abs(e - t);
function sg(e, t) {
  const n = go(e.x, t.x), a = go(e.y, t.y);
  return Math.sqrt(n ** 2 + a ** 2);
}
class kd {
  constructor(t, n, { transformPagePoint: a, contextWindow: r = window, dragSnapToOrigin: i = !1, distanceThreshold: o = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const m = Zn(this.lastMoveEventInfo, this.history), x = this.startEvent !== null, f = sg(m.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!x && !f)
        return;
      const { point: p } = m, { timestamp: y } = Ce;
      this.history.push({ ...p, timestamp: y });
      const { onStart: b, onMove: k } = this.handlers;
      x || (b && b(this.lastMoveEvent, m), this.startEvent = this.lastMoveEvent), k && k(this.lastMoveEvent, m);
    }, this.handlePointerMove = (m, x) => {
      this.lastMoveEvent = m, this.lastMoveEventInfo = Jn(x, this.transformPagePoint), me.update(this.updatePoint, !0);
    }, this.handlePointerUp = (m, x) => {
      this.end();
      const { onEnd: f, onSessionEnd: p, resumeAnimation: y } = this.handlers;
      if (this.dragSnapToOrigin && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const b = Zn(m.type === "pointercancel" ? this.lastMoveEventInfo : Jn(x, this.transformPagePoint), this.history);
      this.startEvent && f && f(m, b), p && p(m, b);
    }, !Tr(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = a, this.distanceThreshold = o, this.contextWindow = r || window;
    const l = Ls(t), d = Jn(l, this.transformPagePoint), { point: c } = d, { timestamp: u } = Ce;
    this.history = [{ ...c, timestamp: u }];
    const { onSessionStart: h } = n;
    h && h(t, Zn(d, this.history)), this.removeListeners = _s(ps(this.contextWindow, "pointermove", this.handlePointerMove), ps(this.contextWindow, "pointerup", this.handlePointerUp), ps(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), bt(this.updatePoint);
  }
}
function Jn(e, t) {
  return t ? { point: t(e.point) } : e;
}
function yo(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Zn({ point: e }, t) {
  return {
    point: e,
    delta: yo(e, Cd(t)),
    offset: yo(e, ng(t)),
    velocity: ag(t, 0.1)
  };
}
function ng(e) {
  return e[0];
}
function Cd(e) {
  return e[e.length - 1];
}
function ag(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, a = null;
  const r = Cd(e);
  for (; n >= 0 && (a = e[n], !(r.timestamp - a.timestamp > /* @__PURE__ */ Xe(t))); )
    n--;
  if (!a)
    return { x: 0, y: 0 };
  const i = /* @__PURE__ */ He(r.timestamp - a.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (r.x - a.x) / i,
    y: (r.y - a.y) / i
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function rg(e, { min: t, max: n }, a) {
  return t !== void 0 && e < t ? e = a ? pe(t, e, a.min) : Math.max(e, t) : n !== void 0 && e > n && (e = a ? pe(n, e, a.max) : Math.min(e, n)), e;
}
function bo(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function ig(e, { top: t, left: n, bottom: a, right: r }) {
  return {
    x: bo(e.x, n, r),
    y: bo(e.y, t, a)
  };
}
function jo(e, t) {
  let n = t.min - e.min, a = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, a] = [a, n]), { min: n, max: a };
}
function og(e, t) {
  return {
    x: jo(e.x, t.x),
    y: jo(e.y, t.y)
  };
}
function lg(e, t) {
  let n = 0.5;
  const a = De(e), r = De(t);
  return r > a ? n = /* @__PURE__ */ Ns(t.min, t.max - a, e.min) : a > r && (n = /* @__PURE__ */ Ns(e.min, e.max - r, t.min)), it(0, 1, n);
}
function cg(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Ma = 0.35;
function dg(e = Ma) {
  return e === !1 ? e = 0 : e === !0 && (e = Ma), {
    x: vo(e, "left", "right"),
    y: vo(e, "top", "bottom")
  };
}
function vo(e, t, n) {
  return {
    min: wo(e, t),
    max: wo(e, n)
  };
}
function wo(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const ug = /* @__PURE__ */ new WeakMap();
class hg {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = we(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: a } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const i = (h) => {
      const { dragSnapToOrigin: m } = this.getProps();
      m ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Ls(h).point);
    }, o = (h, m) => {
      const { drag: x, dragPropagation: f, onDragStart: p } = this.getProps();
      if (x && !f && (this.openDragLock && this.openDragLock(), this.openDragLock = Np(x), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = m, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Ue((b) => {
        let k = this.getAxisMotionValue(b).get() || 0;
        if (st.test(k)) {
          const { projection: g } = this.visualElement;
          if (g && g.layout) {
            const v = g.layout.layoutBox[b];
            v && (k = De(v) * (parseFloat(k) / 100));
          }
        }
        this.originPoint[b] = k;
      }), p && me.postRender(() => p(h, m)), Da(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, l = (h, m) => {
      this.latestPointerEvent = h, this.latestPanInfo = m;
      const { dragPropagation: x, dragDirectionLock: f, onDirectionLock: p, onDrag: y } = this.getProps();
      if (!x && !this.openDragLock)
        return;
      const { offset: b } = m;
      if (f && this.currentDirection === null) {
        this.currentDirection = mg(b), this.currentDirection !== null && p && p(this.currentDirection);
        return;
      }
      this.updateAxis("x", m.point, b), this.updateAxis("y", m.point, b), this.visualElement.render(), y && y(h, m);
    }, d = (h, m) => {
      this.latestPointerEvent = h, this.latestPanInfo = m, this.stop(h, m), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, c = () => Ue((h) => {
      var m;
      return this.getAnimationState(h) === "paused" && ((m = this.getAxisMotionValue(h).animation) == null ? void 0 : m.play());
    }), { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new kd(t, {
      onSessionStart: i,
      onStart: o,
      onMove: l,
      onSessionEnd: d,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      distanceThreshold: a,
      contextWindow: Nd(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const a = t || this.latestPointerEvent, r = n || this.latestPanInfo, i = this.isDragging;
    if (this.cancel(), !i || !r || !a)
      return;
    const { velocity: o } = r;
    this.startAnimation(o);
    const { onDragEnd: l } = this.getProps();
    l && me.postRender(() => l(a, r));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: a } = this.getProps();
    !a && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, a) {
    const { drag: r } = this.getProps();
    if (!a || !Ws(t, r, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let o = this.originPoint[t] + a[t];
    this.constraints && this.constraints[t] && (o = rg(o, this.constraints[t], this.elastic[t])), i.set(o);
  }
  resolveConstraints() {
    var i;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), a = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (i = this.visualElement.projection) == null ? void 0 : i.layout, r = this.constraints;
    t && Ut(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && a ? this.constraints = ig(a.layoutBox, t) : this.constraints = !1, this.elastic = dg(n), r !== this.constraints && a && this.constraints && !this.hasMutatedConstraints && Ue((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = cg(a.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Ut(t))
      return !1;
    const a = t.current;
    ot(a !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: r } = this.visualElement;
    if (!r || !r.layout)
      return !1;
    const i = f0(a, r.root, this.visualElement.getTransformPagePoint());
    let o = og(r.layout.layoutBox, i);
    if (n) {
      const l = n(u0(o));
      this.hasMutatedConstraints = !!l, l && (o = ld(l));
    }
    return o;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: a, dragElastic: r, dragTransition: i, dragSnapToOrigin: o, onDragTransitionEnd: l } = this.getProps(), d = this.constraints || {}, c = Ue((u) => {
      if (!Ws(u, n, this.currentDirection))
        return;
      let h = d && d[u] || {};
      o && (h = { min: 0, max: 0 });
      const m = r ? 200 : 1e6, x = r ? 40 : 1e7, f = {
        type: "inertia",
        velocity: a ? t[u] : 0,
        bounceStiffness: m,
        bounceDamping: x,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...h
      };
      return this.startAxisValueAnimation(u, f);
    });
    return Promise.all(c).then(l);
  }
  startAxisValueAnimation(t, n) {
    const a = this.getAxisMotionValue(t);
    return Da(this.visualElement, t), a.start(Fr(t, a, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    Ue((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    Ue((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, a = this.visualElement.getProps(), r = a[n];
    return r || this.visualElement.getValue(t, (a.initial ? a.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    Ue((n) => {
      const { drag: a } = this.getProps();
      if (!Ws(n, a, this.currentDirection))
        return;
      const { projection: r } = this.visualElement, i = this.getAxisMotionValue(n);
      if (r && r.layout) {
        const { min: o, max: l } = r.layout.layoutBox[n];
        i.set(t[n] - pe(o, l, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: a } = this.visualElement;
    if (!Ut(n) || !a || !this.constraints)
      return;
    this.stopAnimation();
    const r = { x: 0, y: 0 };
    Ue((o) => {
      const l = this.getAxisMotionValue(o);
      if (l && this.constraints !== !1) {
        const d = l.get();
        r[o] = lg({ min: d, max: d }, this.constraints[o]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", a.root && a.root.updateScroll(), a.updateLayout(), this.resolveConstraints(), Ue((o) => {
      if (!Ws(o, t, null))
        return;
      const l = this.getAxisMotionValue(o), { min: d, max: c } = this.constraints[o];
      l.set(pe(d, c, r[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    ug.set(this.visualElement, this);
    const t = this.visualElement.current, n = ps(t, "pointerdown", (d) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(d);
    }), a = () => {
      const { dragConstraints: d } = this.getProps();
      Ut(d) && d.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: r } = this.visualElement, i = r.addEventListener("measure", a);
    r && !r.layout && (r.root && r.root.updateScroll(), r.updateLayout()), me.read(a);
    const o = Ss(window, "resize", () => this.scalePositionWithinConstraints()), l = r.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: c }) => {
      this.isDragging && c && (Ue((u) => {
        const h = this.getAxisMotionValue(u);
        h && (this.originPoint[u] += d[u].translate, h.set(h.get() + d[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), n(), i(), l && l();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: a = !1, dragPropagation: r = !1, dragConstraints: i = !1, dragElastic: o = Ma, dragMomentum: l = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: a,
      dragPropagation: r,
      dragConstraints: i,
      dragElastic: o,
      dragMomentum: l
    };
  }
}
function Ws(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function mg(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class fg extends wt {
  constructor(t) {
    super(t), this.removeGroupControls = Ke, this.removeListeners = Ke, this.controls = new hg(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Ke;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const No = (e) => (t, n) => {
  e && me.postRender(() => e(t, n));
};
class xg extends wt {
  constructor() {
    super(...arguments), this.removePointerDownListener = Ke;
  }
  onPointerDown(t) {
    this.session = new kd(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Nd(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: a, onPanEnd: r } = this.node.getProps();
    return {
      onSessionStart: No(t),
      onStart: No(n),
      onMove: a,
      onEnd: (i, o) => {
        delete this.session, r && me.postRender(() => r(i, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = ps(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Qs = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
let Qn = !1;
class pg extends Yu {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: a, layoutId: r } = this.props, { projection: i } = t;
    i && (n.group && n.group.add(i), a && a.register && r && a.register(i), Qn && i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), Qs.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: a, drag: r, isPresent: i } = this.props, { projection: o } = a;
    return o && (o.isPresent = i, Qn = !0, r || t.layoutDependency !== n || n === void 0 || t.isPresent !== i ? o.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? o.promote() : o.relegate() || me.postRender(() => {
      const l = o.getStack();
      (!l || !l.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), Cr.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: a } = this.props, { projection: r } = t;
    Qn = !0, r && (r.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(r), a && a.deregister && a.deregister(r));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Td(e) {
  const [t, n] = Dp(), a = Se(nc);
  return s.jsx(pg, { ...e, layoutGroup: a, switchLayoutGroup: Se(id), isPresent: t, safeToRemove: n });
}
function gg(e, t, n) {
  const a = Pe(e) ? e : Qt(e);
  return a.start(Fr("", a, t, n)), a.animation;
}
const yg = (e, t) => e.depth - t.depth;
class bg {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    or(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    lr(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(yg), this.isDirty = !1, this.children.forEach(t);
  }
}
function jg(e, t) {
  const n = Me.now(), a = ({ timestamp: r }) => {
    const i = r - n;
    i >= t && (bt(a), e(i - t));
  };
  return me.setup(a, !0), () => bt(a);
}
const Sd = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], vg = Sd.length, ko = (e) => typeof e == "string" ? parseFloat(e) : e, Co = (e) => typeof e == "number" || X.test(e);
function wg(e, t, n, a, r, i) {
  r ? (e.opacity = pe(0, n.opacity ?? 1, Ng(a)), e.opacityExit = pe(t.opacity ?? 1, 0, kg(a))) : i && (e.opacity = pe(t.opacity ?? 1, n.opacity ?? 1, a));
  for (let o = 0; o < vg; o++) {
    const l = `border${Sd[o]}Radius`;
    let d = To(t, l), c = To(n, l);
    if (d === void 0 && c === void 0)
      continue;
    d || (d = 0), c || (c = 0), d === 0 || c === 0 || Co(d) === Co(c) ? (e[l] = Math.max(pe(ko(d), ko(c), a), 0), (st.test(c) || st.test(d)) && (e[l] += "%")) : e[l] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = pe(t.rotate || 0, n.rotate || 0, a));
}
function To(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const Ng = /* @__PURE__ */ Ad(0, 0.5, fc), kg = /* @__PURE__ */ Ad(0.5, 0.95, Ke);
function Ad(e, t, n) {
  return (a) => a < e ? 0 : a > t ? 1 : n(/* @__PURE__ */ Ns(e, t, a));
}
function So(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ye(e, t) {
  So(e.x, t.x), So(e.y, t.y);
}
function Ao(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function Po(e, t, n, a, r) {
  return e -= t, e = un(e, 1 / n, a), r !== void 0 && (e = un(e, 1 / r, a)), e;
}
function Cg(e, t = 0, n = 1, a = 0.5, r, i = e, o = e) {
  if (st.test(t) && (t = parseFloat(t), t = pe(o.min, o.max, t / 100) - o.min), typeof t != "number")
    return;
  let l = pe(i.min, i.max, a);
  e === i && (l -= t), e.min = Po(e.min, t, n, l, r), e.max = Po(e.max, t, n, l, r);
}
function Eo(e, t, [n, a, r], i, o) {
  Cg(e, t[n], t[a], t[r], t.scale, i, o);
}
const Tg = ["x", "scaleX", "originX"], Sg = ["y", "scaleY", "originY"];
function Ro(e, t, n, a) {
  Eo(e.x, t, Tg, n ? n.x : void 0, a ? a.x : void 0), Eo(e.y, t, Sg, n ? n.y : void 0, a ? a.y : void 0);
}
function Do(e) {
  return e.translate === 0 && e.scale === 1;
}
function Pd(e) {
  return Do(e.x) && Do(e.y);
}
function _o(e, t) {
  return e.min === t.min && e.max === t.max;
}
function Ag(e, t) {
  return _o(e.x, t.x) && _o(e.y, t.y);
}
function Mo(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Ed(e, t) {
  return Mo(e.x, t.x) && Mo(e.y, t.y);
}
function Fo(e) {
  return De(e.x) / De(e.y);
}
function Lo(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class Pg {
  constructor() {
    this.members = [];
  }
  add(t) {
    or(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (lr(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((r) => t === r);
    if (n === 0)
      return !1;
    let a;
    for (let r = n; r >= 0; r--) {
      const i = this.members[r];
      if (i.isPresent !== !1) {
        a = i;
        break;
      }
    }
    return a ? (this.promote(a), !0) : !1;
  }
  promote(t, n) {
    const a = this.lead;
    if (t !== a && (this.prevLead = a, this.lead = t, t.show(), a)) {
      a.instance && a.scheduleRender(), t.scheduleRender(), t.resumeFrom = a, n && (t.resumeFrom.preserveOpacity = !0), a.snapshot && (t.snapshot = a.snapshot, t.snapshot.latestValues = a.animationValues || a.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: r } = t.options;
      r === !1 && a.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: a } = t;
      n.onExitComplete && n.onExitComplete(), a && a.options.onExitComplete && a.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Eg(e, t, n) {
  let a = "";
  const r = e.x.translate / t.x, i = e.y.translate / t.y, o = (n == null ? void 0 : n.z) || 0;
  if ((r || i || o) && (a = `translate3d(${r}px, ${i}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (a += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: u, rotateX: h, rotateY: m, skewX: x, skewY: f } = n;
    c && (a = `perspective(${c}px) ${a}`), u && (a += `rotate(${u}deg) `), h && (a += `rotateX(${h}deg) `), m && (a += `rotateY(${m}deg) `), x && (a += `skewX(${x}deg) `), f && (a += `skewY(${f}deg) `);
  }
  const l = e.x.scale * t.x, d = e.y.scale * t.y;
  return (l !== 1 || d !== 1) && (a += `scale(${l}, ${d})`), a || "none";
}
const ea = ["", "X", "Y", "Z"], Rg = 1e3;
let Dg = 0;
function ta(e, t, n, a) {
  const { latestValues: r } = t;
  r[e] && (n[e] = r[e], t.setStaticValue(e, 0), a && (a[e] = 0));
}
function Rd(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = pd(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: r, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", me, !(r || i));
  }
  const { parent: a } = e;
  a && !a.hasCheckedOptimisedAppear && Rd(a);
}
function Dd({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: a, resetTransform: r }) {
  return class {
    constructor(o = {}, l = t == null ? void 0 : t()) {
      this.id = Dg++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(Fg), this.nodes.forEach(Og), this.nodes.forEach(Vg), this.nodes.forEach(Lg);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = l ? l.root || l : this, this.path = l ? [...l.path, l] : [], this.parent = l, this.depth = l ? l.depth + 1 : 0;
      for (let d = 0; d < this.path.length; d++)
        this.path[d].shouldResetTransform = !0;
      this.root === this && (this.nodes = new bg());
    }
    addEventListener(o, l) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new dr()), this.eventHandlers.get(o).add(l);
    }
    notifyListeners(o, ...l) {
      const d = this.eventHandlers.get(o);
      d && d.notify(...l);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = Kc(o) && !Pp(o), this.instance = o;
      const { layoutId: l, layout: d, visualElement: c } = this.options;
      if (c && !c.current && c.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (d || l) && (this.isLayoutDirty = !0), e) {
        let u, h = 0;
        const m = () => this.root.updateBlockedByResize = !1;
        me.read(() => {
          h = window.innerWidth;
        }), e(o, () => {
          const x = window.innerWidth;
          x !== h && (h = x, this.root.updateBlockedByResize = !0, u && u(), u = jg(m, 250), Qs.hasAnimatedSinceResize && (Qs.hasAnimatedSinceResize = !1, this.nodes.forEach(Oo)));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && c && (l || d) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: h, hasRelativeLayoutChanged: m, layout: x }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const f = this.options.transition || c.getDefaultTransition() || Hg, { onLayoutAnimationStart: p, onLayoutAnimationComplete: y } = c.getProps(), b = !this.targetLayout || !Ed(this.targetLayout, x), k = !h && m;
        if (this.options.layoutRoot || this.resumeFrom || k || h && (b || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const g = {
            ...Nr(f, "layout"),
            onPlay: p,
            onComplete: y
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (g.delay = 0, g.type = !1), this.startAnimation(g), this.setAnimationOrigin(u, k);
        } else
          h || Oo(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = x;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), bt(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(Bg), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Rd(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const h = this.path[u];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: l, layout: d } = this.options;
      if (l === void 0 && !d)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach($o);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(Io);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(Ig), this.nodes.forEach(_g), this.nodes.forEach(Mg)) : this.nodes.forEach(Io), this.clearAllSnapshots();
      const l = Me.now();
      Ce.delta = it(0, 1e3 / 60, l - Ce.timestamp), Ce.timestamp = l, Ce.isProcessing = !0, Un.update.process(Ce), Un.preRender.process(Ce), Un.render.process(Ce), Ce.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Cr.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach($g), this.sharedNodes.forEach(zg);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, me.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      me.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !De(this.snapshot.measuredBox.x) && !De(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let d = 0; d < this.path.length; d++)
          this.path[d].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected = we(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: l } = this.options;
      l && l.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let l = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (l = !1), l && this.instance) {
        const d = a(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: d,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : d
        };
      }
    }
    resetTransform() {
      if (!r)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, l = this.projectionDelta && !Pd(this.projectionDelta), d = this.getTransformTemplate(), c = d ? d(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      o && this.instance && (l || St(this.latestValues) || u) && (r(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const l = this.measurePageBox();
      let d = this.removeElementScroll(l);
      return o && (d = this.removeTransform(d)), Wg(d), {
        animationId: this.root.animationId,
        measuredBox: l,
        layoutBox: d,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var c;
      const { visualElement: o } = this.options;
      if (!o)
        return we();
      const l = o.measureViewportBox();
      if (!(((c = this.scroll) == null ? void 0 : c.wasRoot) || this.path.some(Kg))) {
        const { scroll: u } = this.root;
        u && (qt(l.x, u.offset.x), qt(l.y, u.offset.y));
      }
      return l;
    }
    removeElementScroll(o) {
      var d;
      const l = we();
      if (Ye(l, o), (d = this.scroll) != null && d.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: h, options: m } = u;
        u !== this.root && h && m.layoutScroll && (h.wasRoot && Ye(l, o), qt(l.x, h.offset.x), qt(l.y, h.offset.y));
      }
      return l;
    }
    applyTransform(o, l = !1) {
      const d = we();
      Ye(d, o);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !l && u.options.layoutScroll && u.scroll && u !== u.root && Ht(d, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), St(u.latestValues) && Ht(d, u.latestValues);
      }
      return St(this.latestValues) && Ht(d, this.latestValues), d;
    }
    removeTransform(o) {
      const l = we();
      Ye(l, o);
      for (let d = 0; d < this.path.length; d++) {
        const c = this.path[d];
        if (!c.instance || !St(c.latestValues))
          continue;
        Aa(c.latestValues) && c.updateSnapshot();
        const u = we(), h = c.measurePageBox();
        Ye(u, h), Ro(l, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return St(this.latestValues) && Ro(l, this.latestValues), l;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Ce.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var x;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const d = !!this.resumingFrom || this !== l;
      if (!(o || d && this.isSharedProjectionDirty || this.isProjectionDirty || (x = this.parent) != null && x.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: h } = this.options;
      if (!this.layout || !(u || h))
        return;
      this.resolvedRelativeTargetAt = Ce.timestamp;
      const m = this.getClosestProjectingParent();
      m && this.linkedParentVersion !== m.layoutVersion && !m.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (m && m.layout ? this.createRelativeTarget(m, this.layout.layoutBox, m.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = we(), this.targetWithTransforms = we()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), tg(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ye(this.target, this.layout.layoutBox), dd(this.target, this.targetDelta)) : Ye(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, m && !!m.resumingFrom == !!this.resumingFrom && !m.options.layoutScroll && m.target && this.animationProgress !== 1 ? this.createRelativeTarget(m, this.target, m.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Aa(this.parent.latestValues) || cd(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(o, l, d) {
      this.relativeParent = o, this.linkedParentVersion = o.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = we(), this.relativeTargetOrigin = we(), hn(this.relativeTargetOrigin, l, d), Ye(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      var f;
      const o = this.getLead(), l = !!this.resumingFrom || this !== o;
      let d = !0;
      if ((this.isProjectionDirty || (f = this.parent) != null && f.isProjectionDirty) && (d = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (d = !1), this.resolvedRelativeTargetAt === Ce.timestamp && (d = !1), d)
        return;
      const { layout: c, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || u))
        return;
      Ye(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, m = this.treeScale.y;
      m0(this.layoutCorrected, this.treeScale, this.path, l), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = we());
      const { target: x } = o;
      if (!x) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Ao(this.prevProjectionDelta.x, this.projectionDelta.x), Ao(this.prevProjectionDelta.y, this.projectionDelta.y)), gs(this.projectionDelta, this.layoutCorrected, x, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== m || !Lo(this.projectionDelta.x, this.prevProjectionDelta.x) || !Lo(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", x));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var l;
      if ((l = this.options.visualElement) == null || l.scheduleRender(), o) {
        const d = this.getStack();
        d && d.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Wt(), this.projectionDelta = Wt(), this.projectionDeltaWithTransform = Wt();
    }
    setAnimationOrigin(o, l = !1) {
      const d = this.snapshot, c = d ? d.latestValues : {}, u = { ...this.latestValues }, h = Wt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !l;
      const m = we(), x = d ? d.source : void 0, f = this.layout ? this.layout.source : void 0, p = x !== f, y = this.getStack(), b = !y || y.members.length <= 1, k = !!(p && !b && this.options.crossfade === !0 && !this.path.some(qg));
      this.animationProgress = 0;
      let g;
      this.mixTargetDelta = (v) => {
        const C = v / 1e3;
        Vo(h.x, o.x, C), Vo(h.y, o.y, C), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (hn(m, this.layout.layoutBox, this.relativeParent.layout.layoutBox), Ug(this.relativeTarget, this.relativeTargetOrigin, m, C), g && Ag(this.relativeTarget, g) && (this.isProjectionDirty = !1), g || (g = we()), Ye(g, this.relativeTarget)), p && (this.animationValues = u, wg(u, c, this.latestValues, C, k, b)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = C;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var l, d, c;
      this.notifyListeners("animationStart"), (l = this.currentAnimation) == null || l.stop(), (c = (d = this.resumingFrom) == null ? void 0 : d.currentAnimation) == null || c.stop(), this.pendingAnimation && (bt(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = me.update(() => {
        Qs.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Qt(0)), this.currentAnimation = gg(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (u) => {
            this.mixTargetDelta(u), o.onUpdate && o.onUpdate(u);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Rg), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: l, target: d, layout: c, latestValues: u } = o;
      if (!(!l || !d || !c)) {
        if (this !== o && this.layout && c && _d(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          d = this.target || we();
          const h = De(this.layout.layoutBox.x);
          d.x.min = o.target.x.min, d.x.max = d.x.min + h;
          const m = De(this.layout.layoutBox.y);
          d.y.min = o.target.y.min, d.y.max = d.y.min + m;
        }
        Ye(l, d), Ht(l, u), gs(this.projectionDeltaWithTransform, this.layoutCorrected, l, u);
      }
    }
    registerSharedNode(o, l) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new Pg()), this.sharedNodes.get(o).add(l);
      const c = l.options.initialPromotionConfig;
      l.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(l) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var l;
      const { layoutId: o } = this.options;
      return o ? ((l = this.getStack()) == null ? void 0 : l.lead) || this : this;
    }
    getPrevLead() {
      var l;
      const { layoutId: o } = this.options;
      return o ? (l = this.getStack()) == null ? void 0 : l.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: l, preserveFollowOpacity: d } = {}) {
      const c = this.getStack();
      c && c.promote(this, d), o && (this.projectionDelta = void 0, this.needsReset = !0), l && this.setOptions({ transition: l });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let l = !1;
      const { latestValues: d } = o;
      if ((d.z || d.rotate || d.rotateX || d.rotateY || d.rotateZ || d.skewX || d.skewY) && (l = !0), !l)
        return;
      const c = {};
      d.z && ta("z", o, c, this.animationValues);
      for (let u = 0; u < ea.length; u++)
        ta(`rotate${ea[u]}`, o, c, this.animationValues), ta(`skew${ea[u]}`, o, c, this.animationValues);
      o.render();
      for (const u in c)
        o.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, l) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const d = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = Zs(l == null ? void 0 : l.pointerEvents) || "", o.transform = d ? d(this.latestValues, "") : "none";
        return;
      }
      const c = this.getLead();
      if (!this.projectionDelta || !this.layout || !c.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = Zs(l == null ? void 0 : l.pointerEvents) || ""), this.hasProjected && !St(this.latestValues) && (o.transform = d ? d({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const u = c.animationValues || c.latestValues;
      this.applyTransformsToTarget();
      let h = Eg(this.projectionDeltaWithTransform, this.treeScale, u);
      d && (h = d(u, h)), o.transform = h;
      const { x: m, y: x } = this.projectionDelta;
      o.transformOrigin = `${m.origin * 100}% ${x.origin * 100}% 0`, c.animationValues ? o.opacity = c === this ? u.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : u.opacityExit : o.opacity = c === this ? u.opacity !== void 0 ? u.opacity : "" : u.opacityExit !== void 0 ? u.opacityExit : 0;
      for (const f in Sa) {
        if (u[f] === void 0)
          continue;
        const { correct: p, applyTo: y, isCSSVariable: b } = Sa[f], k = h === "none" ? u[f] : p(u[f], c);
        if (y) {
          const g = y.length;
          for (let v = 0; v < g; v++)
            o[y[v]] = k;
        } else
          b ? this.options.visualElement.renderState.vars[f] = k : o[f] = k;
      }
      this.options.layoutId && (o.pointerEvents = c === this ? Zs(l == null ? void 0 : l.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var l;
        return (l = o.currentAnimation) == null ? void 0 : l.stop();
      }), this.root.nodes.forEach($o), this.root.sharedNodes.clear();
    }
  };
}
function _g(e) {
  e.updateLayout();
}
function Mg(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: a, measuredBox: r } = e.layout, { animationType: i } = e.options, o = t.source !== e.layout.source;
    i === "size" ? Ue((h) => {
      const m = o ? t.measuredBox[h] : t.layoutBox[h], x = De(m);
      m.min = a[h].min, m.max = m.min + x;
    }) : _d(i, t.layoutBox, a) && Ue((h) => {
      const m = o ? t.measuredBox[h] : t.layoutBox[h], x = De(a[h]);
      m.max = m.min + x, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[h].max = e.relativeTarget[h].min + x);
    });
    const l = Wt();
    gs(l, a, t.layoutBox);
    const d = Wt();
    o ? gs(d, e.applyTransform(r, !0), t.measuredBox) : gs(d, a, t.layoutBox);
    const c = !Pd(l);
    let u = !1;
    if (!e.resumeFrom) {
      const h = e.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: m, layout: x } = h;
        if (m && x) {
          const f = we();
          hn(f, t.layoutBox, m.layoutBox);
          const p = we();
          hn(p, a, x.layoutBox), Ed(f, p) || (u = !0), h.options.layoutRoot && (e.relativeTarget = p, e.relativeTargetOrigin = f, e.relativeParent = h);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: a,
      snapshot: t,
      delta: d,
      layoutDelta: l,
      hasLayoutChanged: c,
      hasRelativeLayoutChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: a } = e.options;
    a && a();
  }
  e.options.transition = void 0;
}
function Fg(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function Lg(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function $g(e) {
  e.clearSnapshot();
}
function $o(e) {
  e.clearMeasurements();
}
function Io(e) {
  e.isLayoutDirty = !1;
}
function Ig(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Oo(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function Og(e) {
  e.resolveTargetDelta();
}
function Vg(e) {
  e.calcProjection();
}
function Bg(e) {
  e.resetSkewAndRotation();
}
function zg(e) {
  e.removeLeadSnapshot();
}
function Vo(e, t, n) {
  e.translate = pe(t.translate, 0, n), e.scale = pe(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Bo(e, t, n, a) {
  e.min = pe(t.min, n.min, a), e.max = pe(t.max, n.max, a);
}
function Ug(e, t, n, a) {
  Bo(e.x, t.x, n.x, a), Bo(e.y, t.y, n.y, a);
}
function qg(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const Hg = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, zo = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Uo = zo("applewebkit/") && !zo("chrome/") ? Math.round : Ke;
function qo(e) {
  e.min = Uo(e.min), e.max = Uo(e.max);
}
function Wg(e) {
  qo(e.x), qo(e.y);
}
function _d(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !eg(Fo(t), Fo(n), 0.2);
}
function Kg(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const Yg = Dd({
  attachResizeListener: (e, t) => Ss(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), sa = {
  current: void 0
}, Md = Dd({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!sa.current) {
      const e = new Yg({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), sa.current = e;
    }
    return sa.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), Gg = {
  pan: {
    Feature: xg
  },
  drag: {
    Feature: fg,
    ProjectionNode: Md,
    MeasureLayout: Td
  }
};
function Ho(e, t, n) {
  const { props: a } = e;
  e.animationState && a.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const r = "onHover" + n, i = a[r];
  i && me.postRender(() => i(t, Ls(t)));
}
class Xg extends wt {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = kp(t, (n, a) => (Ho(this.node, a, "Start"), (r) => Ho(this.node, r, "End"))));
  }
  unmount() {
  }
}
class Jg extends wt {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = _s(Ss(this.node.current, "focus", () => this.onFocus()), Ss(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Wo(e, t, n) {
  const { props: a } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && a.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const r = "onTap" + (n === "End" ? "" : n), i = a[r];
  i && me.postRender(() => i(t, Ls(t)));
}
class Zg extends wt {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = Ap(t, (n, a) => (Wo(this.node, a, "Start"), (r, { success: i }) => Wo(this.node, r, i ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Fa = /* @__PURE__ */ new WeakMap(), na = /* @__PURE__ */ new WeakMap(), Qg = (e) => {
  const t = Fa.get(e.target);
  t && t(e);
}, ey = (e) => {
  e.forEach(Qg);
};
function ty({ root: e, ...t }) {
  const n = e || document;
  na.has(n) || na.set(n, {});
  const a = na.get(n), r = JSON.stringify(t);
  return a[r] || (a[r] = new IntersectionObserver(ey, { root: e, ...t })), a[r];
}
function sy(e, t, n) {
  const a = ty(t);
  return Fa.set(e, n), a.observe(e), () => {
    Fa.delete(e), a.unobserve(e);
  };
}
const ny = {
  some: 0,
  all: 1
};
class ay extends wt {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: a, amount: r = "some", once: i } = t, o = {
      root: n ? n.current : void 0,
      rootMargin: a,
      threshold: typeof r == "number" ? r : ny[r]
    }, l = (d) => {
      const { isIntersecting: c } = d;
      if (this.isInView === c || (this.isInView = c, i && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: h } = this.node.getProps(), m = c ? u : h;
      m && m(d);
    };
    return sy(this.node.current, o, l);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(ry(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function ry({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const iy = {
  inView: {
    Feature: ay
  },
  tap: {
    Feature: Zg
  },
  focus: {
    Feature: Jg
  },
  hover: {
    Feature: Xg
  }
}, oy = {
  layout: {
    ProjectionNode: Md,
    MeasureLayout: Td
  }
}, ly = {
  ...Y0,
  ...iy,
  ...Gg,
  ...oy
}, Ft = /* @__PURE__ */ d0(ly, N0), cy = {
  up: { y: 40 },
  down: { y: -40 },
  left: { x: 40 },
  right: { x: -40 }
};
function dy({
  children: e,
  delay: t = 0,
  direction: n = "up",
  className: a = ""
}) {
  return /* @__PURE__ */ s.jsx(
    Ft.div,
    {
      initial: {
        opacity: 0,
        ...cy[n]
      },
      whileInView: {
        opacity: 1,
        x: 0,
        y: 0
      },
      viewport: {
        once: !0,
        margin: "-100px"
      },
      transition: {
        duration: 0.6,
        delay: t,
        ease: [0.21, 0.47, 0.32, 0.98]
      },
      className: a,
      children: e
    }
  );
}
function Tv({
  children: e,
  className: t = "",
  staggerDelay: n = 0.1
}) {
  return /* @__PURE__ */ s.jsx(
    Ft.div,
    {
      className: t,
      initial: "hidden",
      whileInView: "visible",
      viewport: { once: !0, margin: "-100px" },
      variants: {
        hidden: {},
        visible: {
          transition: {
            staggerChildren: n
          }
        }
      },
      children: e
    }
  );
}
function Sv({ children: e, className: t = "" }) {
  return /* @__PURE__ */ s.jsx(
    Ft.div,
    {
      className: t,
      variants: {
        hidden: { opacity: 0, y: 40 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.6,
            ease: [0.21, 0.47, 0.32, 0.98]
          }
        }
      },
      children: e
    }
  );
}
function Av({ icon: e, title: t, description: n }) {
  return /* @__PURE__ */ s.jsx("div", { className: "feature-card group", children: /* @__PURE__ */ s.jsx("div", { className: "feature-card-inner", children: /* @__PURE__ */ s.jsxs("div", { className: "feature-card-content", children: [
    /* @__PURE__ */ s.jsx("div", { className: "feature-card-icon-wrapper", children: /* @__PURE__ */ s.jsx("div", { className: "feature-card-icon", children: e }) }),
    /* @__PURE__ */ s.jsx("h3", { className: "feature-card-title", children: t }),
    /* @__PURE__ */ s.jsx("p", { className: "feature-card-description", children: n })
  ] }) }) });
}
function Pv({
  number: e,
  title: t,
  description: n,
  visual: a
}) {
  return /* @__PURE__ */ s.jsxs("div", { className: "step-card group", children: [
    /* @__PURE__ */ s.jsx("div", { className: "step-card-badge", children: /* @__PURE__ */ s.jsx("div", { className: "step-card-badge-inner", children: /* @__PURE__ */ s.jsx("span", { className: "step-card-number", children: e }) }) }),
    /* @__PURE__ */ s.jsx("div", { className: "step-card-content", children: /* @__PURE__ */ s.jsxs("div", { className: "step-card-body", children: [
      /* @__PURE__ */ s.jsx("h3", { className: "step-card-title", children: t }),
      /* @__PURE__ */ s.jsx("p", { className: "step-card-description", children: n }),
      a && /* @__PURE__ */ s.jsx("div", { className: "step-card-visual", children: a })
    ] }) })
  ] });
}
function Ev({
  faqs: e,
  productName: t,
  gradientColor: n = "#1e293b",
  badge: a = {},
  sectionClassName: r = "bg-white",
  contactLink: i,
  bottomCta: o,
  useAccordionGroup: l = !1
}) {
  const {
    text: d = "FAQ",
    bgColor: c = "bg-slate-100",
    borderColor: u = "border-slate-300",
    textColor: h = "text-slate-900"
  } = a, m = i !== !1, x = typeof i == "object" ? i : {}, f = x.href ?? "/contact", p = x.textColor ?? "text-accent-600", y = x.hoverColor ?? "hover:text-accent-700", b = o !== !1, k = typeof o == "object" ? o : {}, g = k.iconBgColor ?? "bg-slate-100", v = k.iconBorderColor ?? "border-slate-200", C = k.iconColor ?? "text-slate-600", w = k.title ?? "Still have questions?", D = k.contactTextColor ?? p, P = k.contactHoverColor ?? y, $ = () => e.map((I, V) => /* @__PURE__ */ s.jsx(hs, { title: I.question, children: l ? /* @__PURE__ */ s.jsx(fs, { className: "text-slate-600", children: I.answer }) : I.answer }, V));
  return /* @__PURE__ */ s.jsx(sc, { className: `relative ${r}`, children: /* @__PURE__ */ s.jsx(Ve, { className: "relative z-10", children: /* @__PURE__ */ s.jsxs("div", { className: "space-y-12", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "text-center space-y-4 max-w-3xl mx-auto", children: [
      /* @__PURE__ */ s.jsx(
        "div",
        {
          className: `inline-flex items-center gap-2 px-4 py-2 rounded-full ${c} border ${u}`,
          children: /* @__PURE__ */ s.jsx("span", { className: `text-sm ${h} font-medium`, children: d })
        }
      ),
      /* @__PURE__ */ s.jsxs(ua, { as: "h2", className: "text-4xl md:text-5xl font-bold", children: [
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-900", children: "Frequently asked" }),
        /* @__PURE__ */ s.jsx("br", {}),
        /* @__PURE__ */ s.jsx(
          "span",
          {
            style: {
              backgroundImage: `linear-gradient(to right, #1e293b, ${n})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            },
            children: "questions"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs(fs, { size: "lg", className: "text-slate-600", children: [
        "Everything you need to know about ",
        t,
        ".",
        m && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          " ",
          "Can't find an answer?",
          " ",
          /* @__PURE__ */ s.jsx(
            _,
            {
              to: f,
              className: `${p} ${y} underline`,
              children: "Contact us"
            }
          ),
          "."
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "max-w-3xl mx-auto", children: l ? /* @__PURE__ */ s.jsx(ec, { className: "bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden", children: $() }) : /* @__PURE__ */ s.jsx("div", { className: "space-y-0", children: $() }) }),
    b && /* @__PURE__ */ s.jsx("div", { className: "text-center pt-8", children: /* @__PURE__ */ s.jsxs("div", { className: "inline-flex flex-col items-center gap-3 p-8 rounded-2xl bg-white border border-slate-200 shadow-sm max-w-2xl", children: [
      /* @__PURE__ */ s.jsx(
        "div",
        {
          className: `p-3 rounded-xl ${g} border ${v}`,
          children: /* @__PURE__ */ s.jsx(
            "svg",
            {
              className: `w-8 h-8 ${C}`,
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: 2,
                  d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsxs("div", { className: "space-y-2", children: [
        /* @__PURE__ */ s.jsx(
          ua,
          {
            as: "h3",
            className: "text-xl font-semibold text-slate-900",
            children: w
          }
        ),
        /* @__PURE__ */ s.jsxs(fs, { className: "text-slate-600", children: [
          "We're here to help.",
          " ",
          /* @__PURE__ */ s.jsx(
            _,
            {
              to: f,
              className: `${D} ${P} underline`,
              children: "Get in touch"
            }
          ),
          " ",
          "through our contact form."
        ] })
      ] })
    ] }) })
  ] }) }) });
}
function Rv({
  badgeText: e,
  badge: t = {},
  headingLine1: n,
  headingLine2: a,
  gradientColor: r = "#1e293b",
  description: i,
  primaryButtonText: o = "Start Free",
  primaryButtonLink: l = "/signup",
  secondaryButtonText: d = "View Pricing",
  secondaryButtonLink: c = "#pricing",
  trustIndicators: u,
  stats: h,
  statsColor: m = "text-slate-900",
  sectionClassName: x = "bg-slate-50",
  decorativeColors: f = {},
  useFadeIn: p = !1
}) {
  const {
    bgColor: y = "bg-slate-100",
    borderColor: b = "border-slate-300",
    textColor: k = "text-slate-900",
    pulseColor: g = "bg-slate-500"
  } = t, { topLeft: v = "bg-slate-500/5", bottomRight: C = "bg-slate-500/5" } = f, w = p ? dy : "div", D = (I) => I.startsWith("http") || I.startsWith("#"), P = () => /* @__PURE__ */ s.jsxs(S, { variant: "primary", size: "lg", className: "group text-lg px-8 py-4", children: [
    o,
    /* @__PURE__ */ s.jsx(
      "svg",
      {
        className: "w-5 h-5 ml-2 transition-transform group-hover:translate-x-1",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        strokeWidth: 2,
        children: /* @__PURE__ */ s.jsx(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13 7l5 5m0 0l-5 5m5-5H6"
          }
        )
      }
    )
  ] }), $ = () => /* @__PURE__ */ s.jsx(S, { variant: "outline", size: "lg", className: "text-lg px-8 py-4", children: d });
  return /* @__PURE__ */ s.jsxs(sc, { className: `relative overflow-hidden ${x}`, children: [
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: `absolute top-0 left-1/4 w-96 h-96 ${v} rounded-full blur-3xl`
      }
    ),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: `absolute bottom-0 right-1/4 w-96 h-96 ${C} rounded-full blur-3xl`
      }
    ),
    /* @__PURE__ */ s.jsx(Ve, { className: "relative z-10", children: /* @__PURE__ */ s.jsxs(w, { className: "max-w-4xl mx-auto", children: [
      /* @__PURE__ */ s.jsx("div", { className: "relative p-12 md:p-16 rounded-3xl bg-white border border-slate-200 shadow-xl", children: /* @__PURE__ */ s.jsxs("div", { className: "relative space-y-8 text-center", children: [
        /* @__PURE__ */ s.jsxs(
          "div",
          {
            className: `inline-flex items-center gap-2 px-4 py-2 rounded-full ${y} border ${b}`,
            children: [
              /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: `w-2 h-2 ${g} rounded-full animate-pulse`
                }
              ),
              /* @__PURE__ */ s.jsx("span", { className: `text-sm ${k} font-medium`, children: e })
            ]
          }
        ),
        /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
          /* @__PURE__ */ s.jsxs(
            ua,
            {
              as: "h2",
              className: "text-4xl md:text-5xl lg:text-6xl font-bold leading-tight",
              children: [
                /* @__PURE__ */ s.jsx("span", { className: "text-slate-900", children: n }),
                /* @__PURE__ */ s.jsx("br", {}),
                /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    style: {
                      backgroundImage: `linear-gradient(to right, #1e293b, ${r})`,
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent"
                    },
                    children: a
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(fs, { size: "lg", className: "text-slate-600 max-w-2xl mx-auto", children: i })
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col sm:flex-row gap-4 justify-center pt-4", children: [
          D(l) ? /* @__PURE__ */ s.jsx("a", { href: l, children: P() }) : /* @__PURE__ */ s.jsx(_, { to: l, children: P() }),
          D(c) ? /* @__PURE__ */ s.jsx("a", { href: c, children: $() }) : /* @__PURE__ */ s.jsx(_, { to: c, children: $() })
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: "pt-8 flex flex-wrap justify-center gap-8 text-sm", children: u.map((I, V) => /* @__PURE__ */ s.jsxs(
          "div",
          {
            className: "flex items-center gap-2 text-slate-600",
            children: [
              /* @__PURE__ */ s.jsx(
                "svg",
                {
                  className: "w-5 h-5 text-green-500",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  children: /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M5 13l4 4L19 7"
                    }
                  )
                }
              ),
              /* @__PURE__ */ s.jsx("span", { children: I })
            ]
          },
          V
        )) })
      ] }) }),
      /* @__PURE__ */ s.jsx("div", { className: "mt-12 grid grid-cols-1 sm:grid-cols-3 gap-8 text-center", children: h.map((I, V) => /* @__PURE__ */ s.jsxs("div", { className: "space-y-2", children: [
        /* @__PURE__ */ s.jsx("div", { className: `text-3xl md:text-4xl font-bold ${m}`, children: I.value }),
        /* @__PURE__ */ s.jsx(fs, { className: "text-slate-600 text-sm", children: I.label })
      ] }, V)) })
    ] }) })
  ] });
}
const uy = {
  slack: /* @__PURE__ */ s.jsx(sr, { className: "w-5 h-5" }),
  discord: /* @__PURE__ */ s.jsx(er, { className: "w-5 h-5" }),
  pagerduty: /* @__PURE__ */ s.jsx(gt, { className: "w-5 h-5" }),
  webhook: /* @__PURE__ */ s.jsx(vs, { className: "w-5 h-5" })
}, hy = {
  slack: "Slack",
  discord: "Discord",
  pagerduty: "PagerDuty",
  webhook: "Webhook"
}, my = {
  slack: "bg-purple-100 text-purple-700",
  discord: "bg-indigo-100 text-indigo-700",
  pagerduty: "bg-green-100 text-green-700",
  webhook: "bg-slate-100 text-slate-700"
};
function fy({
  integrations: e,
  isLoading: t = !1,
  onAdd: n,
  onEdit: a,
  onDelete: r,
  onTest: i,
  onToggle: o
}) {
  const [l, d] = j(null), [c, u] = j(null), [h, m] = j(null), [x, f] = j(null), [p, y] = j(null), b = async (v) => {
    d(v), u(null);
    try {
      const C = await i(v);
      u({ id: v, ...C });
    } catch (C) {
      u({
        id: v,
        success: !1,
        message: tt(C)
      });
    } finally {
      d(null);
    }
  }, k = async () => {
    if (x) {
      m(x);
      try {
        await r(x);
      } finally {
        m(null), f(null);
      }
    }
  }, g = async (v) => {
    y(v.id);
    try {
      await o(v.id, !v.is_active);
    } finally {
      y(null);
    }
  };
  return t ? /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center py-8", children: /* @__PURE__ */ s.jsx(he, { size: "md" }) }) : /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex flex-wrap gap-2", children: [
      /* @__PURE__ */ s.jsxs(S, { variant: "outline", size: "sm", onClick: () => n("slack"), children: [
        /* @__PURE__ */ s.jsx(sr, { className: "w-4 h-4 mr-2" }),
        "Add Slack"
      ] }),
      /* @__PURE__ */ s.jsxs(S, { variant: "outline", size: "sm", onClick: () => n("discord"), children: [
        /* @__PURE__ */ s.jsx(er, { className: "w-4 h-4 mr-2" }),
        "Add Discord"
      ] }),
      /* @__PURE__ */ s.jsxs(S, { variant: "outline", size: "sm", onClick: () => n("pagerduty"), children: [
        /* @__PURE__ */ s.jsx(gt, { className: "w-4 h-4 mr-2" }),
        "Add PagerDuty"
      ] }),
      /* @__PURE__ */ s.jsxs(S, { variant: "outline", size: "sm", onClick: () => n("webhook"), children: [
        /* @__PURE__ */ s.jsx(vs, { className: "w-4 h-4 mr-2" }),
        "Add Webhook"
      ] })
    ] }),
    e.length === 0 ? /* @__PURE__ */ s.jsxs("div", { className: "text-center py-8 text-slate-500", children: [
      /* @__PURE__ */ s.jsx(vs, { className: "w-12 h-12 mx-auto mb-3 opacity-40" }),
      /* @__PURE__ */ s.jsx("p", { children: "No integrations configured yet." }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm mt-1", children: "Add an integration above to start receiving alerts." })
    ] }) : /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: e.map((v) => /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: `flex items-center justify-between p-4 rounded-lg border ${v.is_active ? "bg-white border-slate-200" : "bg-slate-50 border-slate-200 opacity-60"}`,
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ s.jsx(
              "div",
              {
                className: `p-2 rounded-lg ${my[v.type]}`,
                children: uy[v.type]
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ s.jsx("span", { className: "font-medium text-slate-900", children: v.name }),
                /* @__PURE__ */ s.jsx(
                  Pi,
                  {
                    variant: v.is_active ? "success" : "gray",
                    size: "sm",
                    children: v.is_active ? "Active" : "Inactive"
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: hy[v.type] })
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
            (c == null ? void 0 : c.id) === v.id && /* @__PURE__ */ s.jsx(
              Pi,
              {
                variant: c.success ? "success" : "error",
                size: "sm",
                children: c.success ? "Test sent!" : c.message
              }
            ),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: () => g(v),
                disabled: p === v.id,
                className: "p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors disabled:opacity-50",
                title: v.is_active ? "Disable" : "Enable",
                children: p === v.id ? /* @__PURE__ */ s.jsx(he, { size: "sm" }) : v.is_active ? /* @__PURE__ */ s.jsx(of, { className: "w-5 h-5 text-green-600" }) : /* @__PURE__ */ s.jsx(rf, { className: "w-5 h-5" })
              }
            ),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: () => b(v.id),
                disabled: l === v.id || !v.is_active,
                className: "p-2 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors disabled:opacity-50",
                title: "Send test message",
                children: l === v.id ? /* @__PURE__ */ s.jsx(he, { size: "sm" }) : /* @__PURE__ */ s.jsx(af, { className: "w-5 h-5" })
              }
            ),
            /* @__PURE__ */ s.jsx(
              S,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => a(v),
                children: "Edit"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: () => f(v.id),
                disabled: h === v.id,
                className: "p-2 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors disabled:opacity-50",
                title: "Delete integration",
                children: h === v.id ? /* @__PURE__ */ s.jsx(he, { size: "sm" }) : /* @__PURE__ */ s.jsx(Ze, { className: "w-5 h-5" })
              }
            )
          ] })
        ]
      },
      v.id
    )) }),
    /* @__PURE__ */ s.jsx(
      ws,
      {
        isOpen: !!x,
        onClose: () => f(null),
        onConfirm: k,
        title: "Delete Integration",
        message: "Are you sure you want to delete this integration? You will no longer receive alerts through this channel.",
        confirmText: "Delete",
        variant: "danger",
        isLoading: !!h
      }
    )
  ] });
}
const xy = {
  slack: {
    icon: /* @__PURE__ */ s.jsx(sr, { className: "w-6 h-6" }),
    title: "Slack",
    description: "Receive alerts in a Slack channel using incoming webhooks.",
    docUrl: "https://api.slack.com/messaging/webhooks"
  },
  discord: {
    icon: /* @__PURE__ */ s.jsx(er, { className: "w-6 h-6" }),
    title: "Discord",
    description: "Receive alerts in a Discord channel using webhooks.",
    docUrl: "https://support.discord.com/hc/en-us/articles/228383668-Intro-to-Webhooks"
  },
  pagerduty: {
    icon: /* @__PURE__ */ s.jsx(gt, { className: "w-6 h-6" }),
    title: "PagerDuty",
    description: "Create incidents in PagerDuty for critical alerts.",
    docUrl: "https://support.pagerduty.com/docs/services-and-integrations#create-a-generic-events-api-integration"
  },
  webhook: {
    icon: /* @__PURE__ */ s.jsx(vs, { className: "w-6 h-6" }),
    title: "Webhook",
    description: "Send alerts to any HTTP endpoint with optional HMAC signing.",
    docUrl: ""
  }
};
function Ko(e, t) {
  if (t) {
    const n = t.config;
    return {
      name: t.name,
      webhookUrl: n.webhook_url || n.url || "",
      channel: n.channel || "",
      routingKey: n.routing_key || "",
      secret: n.secret || "",
      onError: t.on_error,
      onWarning: t.on_warning,
      onCritical: t.on_critical,
      onRecovery: t.on_recovery,
      onInfo: t.on_info
    };
  }
  return {
    name: "",
    webhookUrl: "",
    channel: "",
    routingKey: "",
    secret: "",
    onError: !0,
    onWarning: !0,
    onCritical: !0,
    onRecovery: !0,
    onInfo: !1
  };
}
function py(e, t) {
  switch (e) {
    case "slack":
      return {
        webhook_url: t.webhookUrl,
        channel: t.channel || null
      };
    case "discord":
      return {
        webhook_url: t.webhookUrl
      };
    case "pagerduty":
      return {
        routing_key: t.routingKey
      };
    case "webhook":
      return {
        url: t.webhookUrl,
        secret: t.secret || null
      };
  }
}
function gy({
  isOpen: e,
  onClose: t,
  type: n,
  integration: a,
  onSave: r
}) {
  const [i, o] = j(
    () => Ko(n, a)
  ), [l, d] = j(null), [c, u] = j(!1), h = xy[n], m = !!a;
  le(() => {
    e && (o(Ko(n, a)), d(null));
  }, [e, n, a]);
  const x = async (p) => {
    p.preventDefault(), d(null), u(!0);
    try {
      const y = py(n, i);
      if (m) {
        const b = {
          name: i.name,
          config: y,
          on_error: i.onError,
          on_warning: i.onWarning,
          on_critical: i.onCritical,
          on_recovery: i.onRecovery,
          on_info: i.onInfo
        };
        await r(b);
      } else {
        const b = {
          type: n,
          name: i.name,
          config: y,
          on_error: i.onError,
          on_warning: i.onWarning,
          on_critical: i.onCritical,
          on_recovery: i.onRecovery,
          on_info: i.onInfo
        };
        await r(b);
      }
      t();
    } catch (y) {
      d(tt(y));
    } finally {
      u(!1);
    }
  }, f = (p) => {
    o((y) => ({ ...y, ...p }));
  };
  return /* @__PURE__ */ s.jsx(
    vn,
    {
      isOpen: e,
      onClose: t,
      title: m ? `Edit ${h.title}` : `Add ${h.title}`,
      size: "lg",
      children: /* @__PURE__ */ s.jsxs("form", { onSubmit: x, children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3 mb-6 pb-4 border-b border-slate-200", children: [
          /* @__PURE__ */ s.jsx("div", { className: "p-2 rounded-lg bg-primary-100 text-primary-700", children: h.icon }),
          /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
            /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: h.description }),
            h.docUrl && /* @__PURE__ */ s.jsxs(
              "a",
              {
                href: h.docUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 mt-1",
                children: [
                  "View setup instructions",
                  /* @__PURE__ */ s.jsx(Xm, { className: "w-3 h-3" })
                ]
              }
            )
          ] })
        ] }),
        l && /* @__PURE__ */ s.jsx("div", { className: "mb-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm", children: l }),
        /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
          /* @__PURE__ */ s.jsxs(Q, { children: [
            /* @__PURE__ */ s.jsx(J, { htmlFor: "name", children: "Name" }),
            /* @__PURE__ */ s.jsx(
              re,
              {
                id: "name",
                value: i.name,
                onChange: (p) => f({ name: p.target.value }),
                placeholder: `My ${h.title} Integration`,
                required: !0
              }
            ),
            /* @__PURE__ */ s.jsx(et, { children: "A friendly name to identify this integration" })
          ] }),
          n === "slack" && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsxs(Q, { children: [
              /* @__PURE__ */ s.jsx(J, { htmlFor: "webhookUrl", children: "Webhook URL" }),
              /* @__PURE__ */ s.jsx(
                re,
                {
                  id: "webhookUrl",
                  type: "url",
                  value: i.webhookUrl,
                  onChange: (p) => f({ webhookUrl: p.target.value }),
                  placeholder: "https://hooks.slack.com/services/...",
                  required: !0
                }
              )
            ] }),
            /* @__PURE__ */ s.jsxs(Q, { children: [
              /* @__PURE__ */ s.jsx(J, { htmlFor: "channel", children: "Channel (optional)" }),
              /* @__PURE__ */ s.jsx(
                re,
                {
                  id: "channel",
                  value: i.channel,
                  onChange: (p) => f({ channel: p.target.value }),
                  placeholder: "#alerts"
                }
              ),
              /* @__PURE__ */ s.jsx(et, { children: "Override the default channel set in the webhook" })
            ] })
          ] }),
          n === "discord" && /* @__PURE__ */ s.jsxs(Q, { children: [
            /* @__PURE__ */ s.jsx(J, { htmlFor: "webhookUrl", children: "Webhook URL" }),
            /* @__PURE__ */ s.jsx(
              re,
              {
                id: "webhookUrl",
                type: "url",
                value: i.webhookUrl,
                onChange: (p) => f({ webhookUrl: p.target.value }),
                placeholder: "https://discord.com/api/webhooks/...",
                required: !0
              }
            )
          ] }),
          n === "pagerduty" && /* @__PURE__ */ s.jsxs(Q, { children: [
            /* @__PURE__ */ s.jsx(J, { htmlFor: "routingKey", children: "Routing Key" }),
            /* @__PURE__ */ s.jsx(
              re,
              {
                id: "routingKey",
                value: i.routingKey,
                onChange: (p) => f({ routingKey: p.target.value }),
                placeholder: "Enter your integration routing key",
                required: !0
              }
            ),
            /* @__PURE__ */ s.jsx(et, { children: "Find this in your PagerDuty service integrations" })
          ] }),
          n === "webhook" && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsxs(Q, { children: [
              /* @__PURE__ */ s.jsx(J, { htmlFor: "webhookUrl", children: "URL" }),
              /* @__PURE__ */ s.jsx(
                re,
                {
                  id: "webhookUrl",
                  type: "url",
                  value: i.webhookUrl,
                  onChange: (p) => f({ webhookUrl: p.target.value }),
                  placeholder: "https://example.com/webhook",
                  required: !0
                }
              )
            ] }),
            /* @__PURE__ */ s.jsxs(Q, { children: [
              /* @__PURE__ */ s.jsx(J, { htmlFor: "secret", children: "Secret (optional)" }),
              /* @__PURE__ */ s.jsx(
                re,
                {
                  id: "secret",
                  type: "password",
                  value: i.secret,
                  onChange: (p) => f({ secret: p.target.value }),
                  placeholder: "HMAC signing secret"
                }
              ),
              /* @__PURE__ */ s.jsx(et, { children: "Used to sign webhook payloads with HMAC-SHA256" })
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "pt-4 border-t border-slate-200", children: [
            /* @__PURE__ */ s.jsx("p", { className: "font-medium text-slate-900 mb-3", children: "Alert Types" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-4", children: "Choose which types of alerts to send to this integration." }),
            /* @__PURE__ */ s.jsx("div", { className: "grid grid-cols-2 gap-3", children: [
              { key: "onCritical", label: "Critical", color: "text-red-600" },
              { key: "onError", label: "Error", color: "text-orange-600" },
              { key: "onWarning", label: "Warning", color: "text-amber-600" },
              {
                key: "onRecovery",
                label: "Recovery",
                color: "text-green-600"
              },
              { key: "onInfo", label: "Info", color: "text-blue-600" }
            ].map(({ key: p, label: y, color: b }) => /* @__PURE__ */ s.jsxs(
              "label",
              {
                className: "flex items-center gap-2 cursor-pointer",
                children: [
                  /* @__PURE__ */ s.jsx(
                    "input",
                    {
                      type: "checkbox",
                      checked: i[p],
                      onChange: (k) => f({ [p]: k.target.checked }),
                      className: "rounded border-slate-300 text-primary-600 focus:ring-primary-500"
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: `text-sm font-medium ${b}`, children: y })
                ]
              },
              p
            )) })
          ] })
        ] }),
        /* @__PURE__ */ s.jsx(nr, { children: /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
          /* @__PURE__ */ s.jsx(
            S,
            {
              type: "button",
              variant: "outline",
              onClick: t,
              disabled: c,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ s.jsx(S, { type: "submit", isLoading: c, children: m ? "Save Changes" : "Add Integration" })
        ] }) })
      ] })
    }
  );
}
function yy({
  recipients: e,
  isLoading: t = !1,
  onAdd: n,
  onRemove: a
}) {
  const [r, i] = j(!1), [o, l] = j(""), [d, c] = j(!1), [u, h] = j(null), [m, x] = j(null), f = async (b) => {
    if (b.preventDefault(), !!o.trim()) {
      x(null), c(!0);
      try {
        await n(o.trim()), l(""), i(!1);
      } catch (k) {
        x(tt(k));
      } finally {
        c(!1);
      }
    }
  }, p = async (b) => {
    h(b);
    try {
      await a(b);
    } finally {
      h(null);
    }
  }, y = () => {
    i(!1), l(""), x(null);
  };
  return t ? /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center py-6", children: /* @__PURE__ */ s.jsx(he, { size: "md" }) }) : /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
    e.length === 0 && !r ? /* @__PURE__ */ s.jsxs("div", { className: "text-center py-6 text-slate-500", children: [
      /* @__PURE__ */ s.jsx(ke, { className: "w-10 h-10 mx-auto mb-2 opacity-40" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm", children: "No email recipients configured." })
    ] }) : /* @__PURE__ */ s.jsx("div", { className: "space-y-2", children: e.map((b) => /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: "flex items-center justify-between p-3 rounded-lg bg-slate-50 border border-slate-200",
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ s.jsx(ke, { className: "w-4 h-4 text-slate-400" }),
            /* @__PURE__ */ s.jsx("span", { className: "text-sm text-slate-700", children: b.email })
          ] }),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              onClick: () => p(b.id),
              disabled: u === b.id,
              className: "p-1.5 rounded text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors disabled:opacity-50",
              title: "Remove recipient",
              children: u === b.id ? /* @__PURE__ */ s.jsx(he, { size: "sm" }) : /* @__PURE__ */ s.jsx(Ze, { className: "w-4 h-4" })
            }
          )
        ]
      },
      b.id
    )) }),
    r ? /* @__PURE__ */ s.jsxs("form", { onSubmit: f, className: "space-y-3", children: [
      m && /* @__PURE__ */ s.jsx("div", { className: "p-2 rounded bg-red-50 text-red-700 text-sm", children: m }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ s.jsx(
          re,
          {
            type: "email",
            value: o,
            onChange: (b) => l(b.target.value),
            placeholder: "email@example.com",
            className: "flex-1",
            autoFocus: !0,
            disabled: d
          }
        ),
        /* @__PURE__ */ s.jsx(S, { type: "submit", size: "sm", isLoading: d, children: "Add" }),
        /* @__PURE__ */ s.jsx(
          "button",
          {
            type: "button",
            onClick: y,
            disabled: d,
            className: "p-2 rounded text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors",
            children: /* @__PURE__ */ s.jsx(Ot, { className: "w-5 h-5" })
          }
        )
      ] })
    ] }) : /* @__PURE__ */ s.jsxs(S, { variant: "outline", size: "sm", onClick: () => i(!0), children: [
      /* @__PURE__ */ s.jsx(Jt, { className: "w-4 h-4 mr-2" }),
      "Add Email Recipient"
    ] })
  ] });
}
function by({
  preferences: e,
  isLoading: t = !1,
  onUpdate: n
}) {
  const [a, r] = j(null), [i, o] = j(null), l = async (d, c) => {
    r(d), o(null);
    try {
      await n({ [d]: c });
    } catch (u) {
      o(tt(u));
    } finally {
      r(null);
    }
  };
  return t || !e ? /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center py-6", children: /* @__PURE__ */ s.jsx(he, { size: "md" }) }) : /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
    i && /* @__PURE__ */ s.jsx("div", { className: "p-3 rounded-lg bg-red-50 text-red-700 text-sm", children: i }),
    /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "Control global email settings. Alert-specific settings like severity filters and cooldown are configured per Alert Profile." }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between p-4 rounded-lg bg-slate-50 border border-slate-200", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx(ke, { className: "w-5 h-5 text-slate-500" }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "font-medium text-slate-900", children: "Email Alerts" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "Enable email notifications for alerts" })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: "relative inline-flex items-center cursor-pointer", children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "checkbox",
            checked: e.email_enabled,
            onChange: (d) => l("email_enabled", d.target.checked),
            disabled: a === "email_enabled",
            className: "sr-only peer"
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: "w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600" }),
        a === "email_enabled" && /* @__PURE__ */ s.jsx(he, { size: "sm", className: "ml-2" })
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between p-4 rounded-lg bg-slate-50 border border-slate-200", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx(Za, { className: "w-5 h-5 text-slate-500" }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "font-medium text-slate-900", children: "Weekly Digest" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "Receive a weekly summary of your alerts" })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: "relative inline-flex items-center cursor-pointer", children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "checkbox",
            checked: e.weekly_digest,
            onChange: (d) => l("weekly_digest", d.target.checked),
            disabled: a === "weekly_digest",
            className: "sr-only peer"
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: "w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600" }),
        a === "weekly_digest" && /* @__PURE__ */ s.jsx(he, { size: "sm", className: "ml-2" })
      ] })
    ] })
  ] });
}
const jy = [
  { value: "UTC", label: "UTC" },
  { value: "America/New_York", label: "Eastern (ET)" },
  { value: "America/Chicago", label: "Central (CT)" },
  { value: "America/Denver", label: "Mountain (MT)" },
  { value: "America/Los_Angeles", label: "Pacific (PT)" },
  { value: "Europe/London", label: "London (GMT/BST)" },
  { value: "Europe/Paris", label: "Paris (CET)" },
  { value: "Europe/Berlin", label: "Berlin (CET)" },
  { value: "Asia/Tokyo", label: "Tokyo (JST)" },
  { value: "Asia/Shanghai", label: "Shanghai (CST)" },
  { value: "Asia/Singapore", label: "Singapore (SGT)" },
  { value: "Australia/Sydney", label: "Sydney (AEST)" }
];
function vy({
  override: e,
  resourceId: t,
  productSlug: n,
  isLoading: a = !1,
  onUpdate: r
}) {
  const [i, o] = j(null), [l, d] = j(null), c = (e == null ? void 0 : e.quiet_hours_enabled) ?? !1, u = (e == null ? void 0 : e.quiet_hours_start) ?? "22:00", h = (e == null ? void 0 : e.quiet_hours_end) ?? "08:00", m = (e == null ? void 0 : e.quiet_hours_timezone) ?? "UTC", x = async (f) => {
    const p = Object.keys(f)[0];
    o(p), d(null);
    try {
      await r({
        product_slug: n,
        quiet_hours_enabled: f.quiet_hours_enabled ?? c,
        quiet_hours_start: f.quiet_hours_start ?? u,
        quiet_hours_end: f.quiet_hours_end ?? h,
        quiet_hours_timezone: f.quiet_hours_timezone ?? m
      });
    } catch (y) {
      d(tt(y));
    } finally {
      o(null);
    }
  };
  return a ? /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center py-6", children: /* @__PURE__ */ s.jsx(he, { size: "md" }) }) : /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
    l && /* @__PURE__ */ s.jsx("div", { className: "p-3 rounded-lg bg-red-50 text-red-700 text-sm", children: l }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between p-4 rounded-lg bg-slate-50 border border-slate-200", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx(tr, { className: "w-5 h-5 text-slate-500" }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "font-medium text-slate-900", children: "Quiet Hours" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "Suppress non-critical alerts during specified hours" })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: "relative inline-flex items-center cursor-pointer", children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "checkbox",
            checked: c,
            onChange: (f) => x({ quiet_hours_enabled: f.target.checked }),
            disabled: i === "quiet_hours_enabled",
            className: "sr-only peer"
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: "w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600" }),
        i === "quiet_hours_enabled" && /* @__PURE__ */ s.jsx(he, { size: "sm", className: "ml-2" })
      ] })
    ] }),
    c && /* @__PURE__ */ s.jsxs("div", { className: "p-4 rounded-lg border border-slate-200 space-y-4", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 text-sm text-slate-500", children: [
        /* @__PURE__ */ s.jsx(ft, { className: "w-4 h-4" }),
        /* @__PURE__ */ s.jsx("span", { children: "Configure quiet hours schedule" })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "quiet-start", children: "Start Time" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "quiet-start",
              type: "time",
              value: u,
              onChange: (f) => x({ quiet_hours_start: f.target.value }),
              disabled: i === "quiet_hours_start"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "quiet-end", children: "End Time" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "quiet-end",
              type: "time",
              value: h,
              onChange: (f) => x({ quiet_hours_end: f.target.value }),
              disabled: i === "quiet_hours_end"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx(J, { htmlFor: "timezone", children: "Timezone" }),
        /* @__PURE__ */ s.jsx(
          "select",
          {
            id: "timezone",
            value: m,
            onChange: (f) => x({ quiet_hours_timezone: f.target.value }),
            disabled: i === "quiet_hours_timezone",
            className: "mt-1 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 disabled:opacity-50",
            children: jy.map((f) => /* @__PURE__ */ s.jsx("option", { value: f.value, children: f.label }, f.value))
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx(et, { children: "During quiet hours, only critical alerts will be sent. Other alerts will be suppressed." })
    ] })
  ] });
}
function Dv({
  teamId: e,
  resourceId: t,
  productSlug: n,
  notificationsApi: a,
  showQuietHours: r = !0,
  title: i = "Alert Settings",
  description: o = "Configure how you receive alerts and notifications."
}) {
  const [l, d] = j([]), [c, u] = j(null), [h, m] = j([]), [x, f] = j(null), [p, y] = j({
    integrations: !0,
    preferences: !0,
    recipients: !0,
    override: !0
  }), [b, k] = j(null), [g, v] = j({
    isOpen: !1,
    type: "slack",
    integration: null
  }), C = qe(async () => {
    try {
      const R = await a.listIntegrations(e);
      d(R);
    } catch (R) {
      k(tt(R));
    } finally {
      y((R) => ({ ...R, integrations: !1 }));
    }
  }, [e, a]), w = qe(async () => {
    try {
      const R = await a.getPreferences(e);
      u(R);
    } catch (R) {
      k(tt(R));
    } finally {
      y((R) => ({ ...R, preferences: !1 }));
    }
  }, [e, a]), D = qe(async () => {
    try {
      const R = await a.listRecipients(e);
      m(R);
    } catch (R) {
      k(tt(R));
    } finally {
      y((R) => ({ ...R, recipients: !1 }));
    }
  }, [e, a]), P = qe(async () => {
    if (!t) {
      y((R) => ({ ...R, override: !1 }));
      return;
    }
    try {
      const R = await a.getOverride(e, t);
      f(R);
    } catch (R) {
      k(tt(R));
    } finally {
      y((R) => ({ ...R, override: !1 }));
    }
  }, [e, t, a]);
  le(() => {
    C(), w(), D(), P();
  }, [C, w, D, P]);
  const $ = (R) => {
    v({ isOpen: !0, type: R, integration: null });
  }, I = (R) => {
    v({ isOpen: !0, type: R.type, integration: R });
  }, V = async (R) => {
    if (g.integration) {
      const N = await a.updateIntegration(
        e,
        g.integration.id,
        R
      );
      d(
        (L) => L.map((M) => M.id === N.id ? N : M)
      );
    } else {
      const N = await a.createIntegration(
        e,
        R
      );
      d((L) => [...L, N]);
    }
  }, H = async (R) => {
    await a.deleteIntegration(e, R), d((N) => N.filter((L) => L.id !== R));
  }, K = async (R) => a.testIntegration(e, R), U = async (R, N) => {
    const L = await a.updateIntegration(
      e,
      R,
      {
        is_active: N
      }
    );
    d(
      (M) => M.map((F) => F.id === L.id ? L : F)
    );
  }, te = async (R) => {
    const N = await a.updatePreferences(e, R);
    u(N);
  }, ne = async (R) => {
    const N = await a.addRecipient(e, { email: R });
    m((L) => [...L, N]);
  }, se = async (R) => {
    await a.removeRecipient(e, R), m((N) => N.filter((L) => L.id !== R));
  }, A = async (R) => {
    if (!t) return;
    const N = await a.setOverride(
      e,
      t,
      R
    );
    f(N);
  };
  return Object.values(p).some(Boolean) ? /* @__PURE__ */ s.jsxs(rn, { children: [
    /* @__PURE__ */ s.jsxs(Ci, { children: [
      /* @__PURE__ */ s.jsx(Ti, { children: i }),
      /* @__PURE__ */ s.jsx(Si, { children: o })
    ] }),
    /* @__PURE__ */ s.jsx(Ai, { children: /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center py-12", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }) })
  ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(rn, { children: [
      /* @__PURE__ */ s.jsx(Ci, { children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx(Xt, { className: "w-6 h-6 text-primary-600" }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx(Ti, { children: i }),
          /* @__PURE__ */ s.jsx(Si, { children: o })
        ] })
      ] }) }),
      /* @__PURE__ */ s.jsxs(Ai, { children: [
        b && /* @__PURE__ */ s.jsx("div", { className: "mb-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm", children: b }),
        /* @__PURE__ */ s.jsxs(ec, { children: [
          /* @__PURE__ */ s.jsx(
            hs,
            {
              title: "Integrations",
              icon: /* @__PURE__ */ s.jsx(vs, { className: "w-5 h-5" }),
              defaultOpen: !0,
              children: /* @__PURE__ */ s.jsx(
                fy,
                {
                  integrations: l,
                  onAdd: $,
                  onEdit: I,
                  onDelete: H,
                  onTest: K,
                  onToggle: U
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx(
            hs,
            {
              title: "Email Recipients",
              icon: /* @__PURE__ */ s.jsx(ke, { className: "w-5 h-5" }),
              children: /* @__PURE__ */ s.jsx(
                yy,
                {
                  recipients: h,
                  onAdd: ne,
                  onRemove: se
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx(
            hs,
            {
              title: "Email Settings",
              icon: /* @__PURE__ */ s.jsx(Jl, { className: "w-5 h-5" }),
              children: /* @__PURE__ */ s.jsx(
                by,
                {
                  preferences: c,
                  onUpdate: te
                }
              )
            }
          ),
          r && t && /* @__PURE__ */ s.jsx(
            hs,
            {
              title: "Quiet Hours",
              icon: /* @__PURE__ */ s.jsx(tr, { className: "w-5 h-5" }),
              children: /* @__PURE__ */ s.jsx(
                vy,
                {
                  override: x,
                  resourceId: t,
                  productSlug: n,
                  onUpdate: A
                }
              )
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s.jsx(
      gy,
      {
        isOpen: g.isOpen,
        onClose: () => v((R) => ({ ...R, isOpen: !1 })),
        type: g.type,
        integration: g.integration,
        onSave: V
      }
    )
  ] });
}
const wy = {
  high: "bg-red-100 text-red-700",
  medium: "bg-yellow-100 text-yellow-700",
  low: "bg-blue-100 text-blue-700"
}, Ny = {
  high: "High Priority",
  medium: "Medium",
  low: "Low Priority"
};
function ky(e) {
  return e ? e.join(", ") : "All severities";
}
function _v({
  profiles: e,
  isLoading: t = !1,
  onSelect: n,
  onCreateNew: a,
  onDelete: r,
  onSetDefault: i
}) {
  const [o, l] = j(null), [d, c] = j(null), [u, h] = j(null), [m, x] = j(null), f = async () => {
    if (d) {
      l(d);
      try {
        await r(d);
      } finally {
        l(null), c(null);
      }
    }
  }, p = async (b) => {
    h(b), x(null);
    try {
      await i(b);
    } finally {
      h(null);
    }
  }, y = e.find((b) => b.id === d);
  return t ? /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center py-12", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }) : /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("h2", { className: "text-lg font-semibold text-slate-900", children: "Alert Profiles" }),
        /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "Reusable alert configurations for severity filtering, quiet hours, and escalation." })
      ] }),
      /* @__PURE__ */ s.jsxs(S, { onClick: a, size: "sm", children: [
        /* @__PURE__ */ s.jsx(Jt, { className: "w-4 h-4 mr-2" }),
        "New Profile"
      ] })
    ] }),
    e.length === 0 ? /* @__PURE__ */ s.jsxs("div", { className: "text-center py-12 border rounded-lg bg-slate-50", children: [
      /* @__PURE__ */ s.jsx(Xt, { className: "w-12 h-12 mx-auto text-slate-300 mb-4" }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-medium text-slate-900 mb-2", children: "No Alert Profiles" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-4", children: "Create your first alert profile to customize how alerts are handled." }),
      /* @__PURE__ */ s.jsxs(S, { onClick: a, children: [
        /* @__PURE__ */ s.jsx(Jt, { className: "w-4 h-4 mr-2" }),
        "Create Profile"
      ] })
    ] }) : /* @__PURE__ */ s.jsx("div", { className: "divide-y", children: e.map((b) => /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: "flex items-center justify-between p-4 hover:bg-slate-50 transition-colors",
        children: [
          /* @__PURE__ */ s.jsxs(
            "button",
            {
              onClick: () => n(b),
              className: "flex items-center gap-3 flex-1 text-left",
              children: [
                /* @__PURE__ */ s.jsx("div", { className: "p-2 rounded-lg bg-slate-100", children: /* @__PURE__ */ s.jsx(Xt, { className: "w-5 h-5 text-slate-600" }) }),
                /* @__PURE__ */ s.jsxs("div", { className: "min-w-0 flex-1", children: [
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 flex-wrap", children: [
                    /* @__PURE__ */ s.jsx("span", { className: "font-medium text-slate-900", children: b.name }),
                    b.is_default && /* @__PURE__ */ s.jsxs("span", { className: "inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-yellow-100 text-yellow-700", children: [
                      /* @__PURE__ */ s.jsx(nn, { className: "w-3 h-3 fill-current" }),
                      "Default"
                    ] }),
                    /* @__PURE__ */ s.jsx(
                      "span",
                      {
                        className: `px-2 py-0.5 text-xs font-medium rounded-full ${wy[b.priority]}`,
                        children: Ny[b.priority]
                      }
                    )
                  ] }),
                  b.description && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 truncate mt-0.5", children: b.description }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3 mt-1 text-xs text-slate-400 flex-wrap", children: [
                    /* @__PURE__ */ s.jsxs("span", { children: [
                      "Severities: ",
                      ky(b.severity_filter)
                    ] }),
                    b.quiet_hours_enabled && /* @__PURE__ */ s.jsxs("span", { children: [
                      "Quiet hours: ",
                      b.quiet_hours_start,
                      " -",
                      " ",
                      b.quiet_hours_end
                    ] }),
                    b.escalation_enabled && /* @__PURE__ */ s.jsxs("span", { children: [
                      "Escalation: ",
                      b.escalation_delay_minutes,
                      "min"
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ s.jsx(Hl, { className: "w-5 h-5 text-slate-400 flex-shrink-0" })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: "relative ml-2", children: [
            /* @__PURE__ */ s.jsx(
              "button",
              {
                onClick: (k) => {
                  k.stopPropagation(), x(
                    m === b.id ? null : b.id
                  );
                },
                className: "p-2 hover:bg-slate-100 rounded-lg",
                disabled: u === b.id || o === b.id,
                children: u === b.id || o === b.id ? /* @__PURE__ */ s.jsx(he, { size: "sm" }) : /* @__PURE__ */ s.jsx(Gm, { className: "w-4 h-4 text-slate-400" })
              }
            ),
            m === b.id && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: "fixed inset-0 z-10",
                  onClick: () => x(null)
                }
              ),
              /* @__PURE__ */ s.jsxs("div", { className: "absolute right-0 top-full mt-1 w-48 bg-white rounded-lg shadow-lg border z-20 py-1", children: [
                !b.is_default && /* @__PURE__ */ s.jsxs(
                  "button",
                  {
                    onClick: () => p(b.id),
                    className: "w-full flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50",
                    children: [
                      /* @__PURE__ */ s.jsx(nn, { className: "w-4 h-4" }),
                      "Set as Default"
                    ]
                  }
                ),
                !b.is_default && /* @__PURE__ */ s.jsxs(
                  "button",
                  {
                    onClick: () => {
                      x(null), c(b.id);
                    },
                    className: "w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50",
                    children: [
                      /* @__PURE__ */ s.jsx(Ze, { className: "w-4 h-4" }),
                      "Delete"
                    ]
                  }
                ),
                b.is_default && /* @__PURE__ */ s.jsx("div", { className: "px-4 py-2 text-sm text-slate-400", children: "Default profile cannot be deleted" })
              ] })
            ] })
          ] })
        ]
      },
      b.id
    )) }),
    /* @__PURE__ */ s.jsx(
      ws,
      {
        isOpen: !!d,
        onClose: () => c(null),
        onConfirm: f,
        isLoading: !!o,
        title: "Delete Alert Profile",
        message: `Are you sure you want to delete "${y == null ? void 0 : y.name}"? This action cannot be undone.`,
        confirmText: "Delete",
        variant: "danger"
      }
    )
  ] });
}
const Cy = {
  high: "bg-red-100 text-red-700",
  medium: "bg-yellow-100 text-yellow-700",
  low: "bg-blue-100 text-blue-700"
};
function Mv({
  profiles: e,
  selectedId: t,
  onSelect: n,
  label: a = "Alert Profile",
  placeholder: r = "Select profile",
  disabled: i = !1,
  error: o,
  className: l = ""
}) {
  const [d, c] = j(!1), u = We(null), h = e.find((f) => f.id === t), m = e.find((f) => f.is_default);
  le(() => {
    function f(p) {
      u.current && !u.current.contains(p.target) && c(!1);
    }
    return document.addEventListener("mousedown", f), () => document.removeEventListener("mousedown", f);
  }, []), le(() => {
    function f(p) {
      p.key === "Escape" && c(!1);
    }
    return document.addEventListener("keydown", f), () => document.removeEventListener("keydown", f);
  }, []);
  const x = t === null ? `Team Default${m ? ` (${m.name})` : ""}` : (h == null ? void 0 : h.name) || r;
  return /* @__PURE__ */ s.jsxs("div", { className: `relative ${l}`, ref: u, children: [
    a && /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-1.5", children: a }),
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        onClick: () => !i && c(!d),
        disabled: i,
        className: `
          w-full flex items-center justify-between gap-2 px-3 py-2
          border rounded-lg bg-white text-left
          transition-colors duration-150
          ${i ? "opacity-50 cursor-not-allowed bg-slate-50" : "hover:border-slate-400 cursor-pointer"}
          ${o ? "border-red-300 focus:ring-red-500" : "border-slate-300 focus:ring-primary-500"}
          focus:outline-none focus:ring-2 focus:ring-offset-0
        `,
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 min-w-0", children: [
            /* @__PURE__ */ s.jsx(Xt, { className: "w-4 h-4 text-slate-400 flex-shrink-0" }),
            /* @__PURE__ */ s.jsx(
              "span",
              {
                className: `truncate ${t === null ? "text-slate-500" : "text-slate-900"}`,
                children: x
              }
            ),
            (h == null ? void 0 : h.is_default) && /* @__PURE__ */ s.jsx(nn, { className: "w-3.5 h-3.5 text-yellow-500 fill-yellow-500 flex-shrink-0" })
          ] }),
          /* @__PURE__ */ s.jsx(
            jn,
            {
              className: `w-4 h-4 text-slate-400 transition-transform ${d ? "rotate-180" : ""}`
            }
          )
        ]
      }
    ),
    o && /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-sm text-red-600", children: o }),
    d && /* @__PURE__ */ s.jsxs("div", { className: "absolute z-50 top-full left-0 right-0 mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-auto", children: [
      /* @__PURE__ */ s.jsxs(
        "button",
        {
          type: "button",
          onClick: () => {
            n(null), c(!1);
          },
          className: `
              w-full flex items-center justify-between gap-2 px-3 py-2.5
              text-left hover:bg-slate-50 transition-colors
              ${t === null ? "bg-primary-50" : ""}
            `,
          children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ s.jsx("span", { className: "font-medium text-slate-900", children: "Use Team Default" }),
              m && /* @__PURE__ */ s.jsxs("span", { className: "text-sm text-slate-500", children: [
                "(",
                m.name,
                ")"
              ] })
            ] }),
            t === null && /* @__PURE__ */ s.jsx($t, { className: "w-4 h-4 text-primary-600" })
          ]
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: "border-t my-1" }),
      e.map((f) => /* @__PURE__ */ s.jsxs(
        "button",
        {
          type: "button",
          onClick: () => {
            n(f.id), c(!1);
          },
          className: `
                w-full flex items-center justify-between gap-2 px-3 py-2.5
                text-left hover:bg-slate-50 transition-colors
                ${t === f.id ? "bg-primary-50" : ""}
              `,
          children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 min-w-0", children: [
              /* @__PURE__ */ s.jsx("span", { className: "font-medium text-slate-900", children: f.name }),
              f.is_default && /* @__PURE__ */ s.jsx(nn, { className: "w-3.5 h-3.5 text-yellow-500 fill-yellow-500 flex-shrink-0" }),
              /* @__PURE__ */ s.jsx(
                "span",
                {
                  className: `px-1.5 py-0.5 text-xs font-medium rounded ${Cy[f.priority]}`,
                  children: f.priority
                }
              )
            ] }),
            t === f.id && /* @__PURE__ */ s.jsx($t, { className: "w-4 h-4 text-primary-600 flex-shrink-0" })
          ]
        },
        f.id
      )),
      e.length === 0 && /* @__PURE__ */ s.jsx("div", { className: "px-3 py-4 text-sm text-slate-500 text-center", children: "No profiles available" })
    ] })
  ] });
}
const Ty = [
  {
    value: "high",
    label: "High Priority",
    description: "Immediate attention required"
  },
  {
    value: "medium",
    label: "Medium Priority",
    description: "Standard alert handling"
  },
  {
    value: "low",
    label: "Low Priority",
    description: "Non-urgent notifications"
  }
], Sy = [
  { value: "critical", label: "Critical", color: "text-red-600" },
  { value: "error", label: "Error", color: "text-orange-600" },
  { value: "warning", label: "Warning", color: "text-amber-600" },
  { value: "info", label: "Info", color: "text-blue-600" },
  { value: "recovery", label: "Recovery", color: "text-green-600" }
], Ay = [
  { value: "UTC", label: "UTC" },
  { value: "America/New_York", label: "Eastern (ET)" },
  { value: "America/Chicago", label: "Central (CT)" },
  { value: "America/Denver", label: "Mountain (MT)" },
  { value: "America/Los_Angeles", label: "Pacific (PT)" },
  { value: "Europe/London", label: "London (GMT/BST)" },
  { value: "Europe/Paris", label: "Paris (CET)" },
  { value: "Europe/Berlin", label: "Berlin (CET)" },
  { value: "Asia/Tokyo", label: "Tokyo (JST)" },
  { value: "Asia/Shanghai", label: "Shanghai (CST)" },
  { value: "Asia/Singapore", label: "Singapore (SGT)" },
  { value: "Australia/Sydney", label: "Sydney (AEST)" }
], Py = [
  {
    value: "suppress",
    label: "Suppress",
    description: "Discard alerts during quiet hours"
  },
  {
    value: "queue",
    label: "Queue",
    description: "Queue alerts for delivery after quiet hours"
  }
];
function Yo(e) {
  var t;
  return e ? {
    name: e.name,
    description: e.description || "",
    priority: e.priority,
    severityFilter: e.severity_filter || [],
    errorCountThreshold: ((t = e.error_count_threshold) == null ? void 0 : t.toString()) || "",
    thresholdWindowMinutes: e.threshold_window_minutes.toString(),
    cooldownMinutes: e.cooldown_minutes.toString(),
    quietHoursEnabled: e.quiet_hours_enabled,
    quietHoursStart: e.quiet_hours_start || "22:00",
    quietHoursEnd: e.quiet_hours_end || "08:00",
    quietHoursTimezone: e.quiet_hours_timezone,
    quietHoursAction: e.quiet_hours_action,
    escalationEnabled: e.escalation_enabled,
    escalationDelayMinutes: e.escalation_delay_minutes.toString(),
    escalationEmail: e.escalation_email || "",
    integrationIds: e.integration_ids || []
  } : {
    name: "",
    description: "",
    priority: "medium",
    severityFilter: [],
    errorCountThreshold: "",
    thresholdWindowMinutes: "60",
    cooldownMinutes: "5",
    quietHoursEnabled: !1,
    quietHoursStart: "22:00",
    quietHoursEnd: "08:00",
    quietHoursTimezone: "UTC",
    quietHoursAction: "suppress",
    escalationEnabled: !1,
    escalationDelayMinutes: "30",
    escalationEmail: "",
    integrationIds: []
  };
}
function Fv({
  isOpen: e,
  onClose: t,
  profile: n,
  integrations: a,
  onSave: r,
  severityOptions: i,
  hideThresholdSection: o = !1
}) {
  const [l, d] = j(() => Yo(n)), [c, u] = j(null), [h, m] = j(!1), x = !!n, f = i || Sy;
  le(() => {
    e && (d(Yo(n)), u(null));
  }, [e, n]);
  const p = async (g) => {
    g.preventDefault(), u(null), m(!0);
    try {
      const v = {
        name: l.name,
        description: l.description || null,
        priority: l.priority,
        severity_filter: l.severityFilter.length > 0 ? l.severityFilter : null,
        error_count_threshold: l.errorCountThreshold ? parseInt(l.errorCountThreshold, 10) : null,
        threshold_window_minutes: parseInt(l.thresholdWindowMinutes, 10) || 60,
        cooldown_minutes: parseInt(l.cooldownMinutes, 10) || 5,
        quiet_hours_enabled: l.quietHoursEnabled,
        quiet_hours_start: l.quietHoursEnabled ? l.quietHoursStart : null,
        quiet_hours_end: l.quietHoursEnabled ? l.quietHoursEnd : null,
        quiet_hours_timezone: l.quietHoursTimezone,
        quiet_hours_action: l.quietHoursAction,
        escalation_enabled: l.escalationEnabled,
        escalation_delay_minutes: parseInt(l.escalationDelayMinutes, 10) || 30,
        escalation_email: l.escalationEnabled && l.escalationEmail ? l.escalationEmail : null,
        integration_ids: l.integrationIds.length > 0 ? l.integrationIds : null
      };
      await r(v), t();
    } catch (v) {
      u(tt(v));
    } finally {
      m(!1);
    }
  }, y = (g) => {
    d((v) => ({ ...v, ...g }));
  }, b = (g) => {
    d((v) => ({
      ...v,
      severityFilter: v.severityFilter.includes(g) ? v.severityFilter.filter((C) => C !== g) : [...v.severityFilter, g]
    }));
  }, k = (g) => {
    d((v) => ({
      ...v,
      integrationIds: v.integrationIds.includes(g) ? v.integrationIds.filter((C) => C !== g) : [...v.integrationIds, g]
    }));
  };
  return /* @__PURE__ */ s.jsx(
    vn,
    {
      isOpen: e,
      onClose: t,
      title: x ? "Edit Alert Profile" : "Create Alert Profile",
      size: "lg",
      children: /* @__PURE__ */ s.jsxs("form", { onSubmit: p, children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3 mb-6 pb-4 border-b border-slate-200", children: [
          /* @__PURE__ */ s.jsx("div", { className: "p-2 rounded-lg bg-primary-100 text-primary-700", children: /* @__PURE__ */ s.jsx(Xt, { className: "w-6 h-6" }) }),
          /* @__PURE__ */ s.jsx("div", { className: "flex-1", children: /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: "Alert profiles define how alerts are filtered, routed, and escalated. Configure severity filters, quiet hours, and notification channels." }) })
        ] }),
        c && /* @__PURE__ */ s.jsx("div", { className: "mb-4 p-3 rounded-lg bg-red-50 text-red-700 text-sm", children: c }),
        /* @__PURE__ */ s.jsxs("div", { className: "space-y-6 max-h-[60vh] overflow-y-auto pr-2", children: [
          /* @__PURE__ */ s.jsxs("section", { children: [
            /* @__PURE__ */ s.jsxs("h3", { className: "font-medium text-slate-900 mb-3 flex items-center gap-2", children: [
              /* @__PURE__ */ s.jsx(Za, { className: "w-4 h-4 text-slate-500" }),
              "Basic Information"
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "space-y-4 pl-6", children: [
              /* @__PURE__ */ s.jsxs(Q, { children: [
                /* @__PURE__ */ s.jsx(J, { htmlFor: "name", children: "Name" }),
                /* @__PURE__ */ s.jsx(
                  re,
                  {
                    id: "name",
                    value: l.name,
                    onChange: (g) => y({ name: g.target.value }),
                    placeholder: "e.g., High Priority Alerts",
                    required: !0
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(Q, { children: [
                /* @__PURE__ */ s.jsx(J, { htmlFor: "description", children: "Description" }),
                /* @__PURE__ */ s.jsx(
                  re,
                  {
                    id: "description",
                    value: l.description,
                    onChange: (g) => y({ description: g.target.value }),
                    placeholder: "Optional description"
                  }
                ),
                /* @__PURE__ */ s.jsx(et, { children: "Help your team understand when to use this profile" })
              ] }),
              /* @__PURE__ */ s.jsxs(Q, { children: [
                /* @__PURE__ */ s.jsx(J, { htmlFor: "priority", children: "Priority" }),
                /* @__PURE__ */ s.jsx(
                  "select",
                  {
                    id: "priority",
                    value: l.priority,
                    onChange: (g) => y({ priority: g.target.value }),
                    className: "mt-1 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500",
                    children: Ty.map((g) => /* @__PURE__ */ s.jsxs("option", { value: g.value, children: [
                      g.label,
                      " - ",
                      g.description
                    ] }, g.value))
                  }
                )
              ] })
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("section", { className: "pt-4 border-t border-slate-200", children: [
            /* @__PURE__ */ s.jsxs("h3", { className: "font-medium text-slate-900 mb-3 flex items-center gap-2", children: [
              /* @__PURE__ */ s.jsx(gt, { className: "w-4 h-4 text-slate-500" }),
              "Severity Filter"
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "pl-6", children: [
              /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-3", children: "Only process alerts matching these severities. Leave empty to allow all." }),
              /* @__PURE__ */ s.jsx("div", { className: "grid grid-cols-2 gap-3", children: f.map(({ value: g, label: v, color: C }) => /* @__PURE__ */ s.jsxs(
                "label",
                {
                  className: "flex items-center gap-2 cursor-pointer",
                  children: [
                    /* @__PURE__ */ s.jsx(
                      "input",
                      {
                        type: "checkbox",
                        checked: l.severityFilter.includes(
                          g
                        ),
                        onChange: () => b(g),
                        className: "rounded border-slate-300 text-primary-600 focus:ring-primary-500"
                      }
                    ),
                    /* @__PURE__ */ s.jsx("span", { className: `text-sm font-medium ${C}`, children: v })
                  ]
                },
                g
              )) })
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("section", { className: "pt-4 border-t border-slate-200", children: [
            /* @__PURE__ */ s.jsxs("h3", { className: "font-medium text-slate-900 mb-3 flex items-center gap-2", children: [
              /* @__PURE__ */ s.jsx(ft, { className: "w-4 h-4 text-slate-500" }),
              "Rate Limiting"
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "pl-6 space-y-4", children: [
              /* @__PURE__ */ s.jsxs(Q, { children: [
                /* @__PURE__ */ s.jsx(J, { htmlFor: "cooldownMinutes", children: "Alert Cooldown (minutes)" }),
                /* @__PURE__ */ s.jsx(
                  re,
                  {
                    id: "cooldownMinutes",
                    type: "number",
                    min: "0",
                    max: "1440",
                    value: l.cooldownMinutes,
                    onChange: (g) => y({ cooldownMinutes: g.target.value })
                  }
                ),
                /* @__PURE__ */ s.jsx(et, { children: "Minimum time between repeated alerts for the same issue. Set to 0 for no cooldown." })
              ] }),
              !o && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
                /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 pt-2 border-t border-slate-100", children: "Only trigger alerts after seeing a threshold of events within a time window." }),
                /* @__PURE__ */ s.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
                  /* @__PURE__ */ s.jsxs(Q, { children: [
                    /* @__PURE__ */ s.jsx(J, { htmlFor: "errorCountThreshold", children: "Error Count Threshold" }),
                    /* @__PURE__ */ s.jsx(
                      re,
                      {
                        id: "errorCountThreshold",
                        type: "number",
                        min: "1",
                        value: l.errorCountThreshold,
                        onChange: (g) => y({ errorCountThreshold: g.target.value }),
                        placeholder: "e.g., 5"
                      }
                    ),
                    /* @__PURE__ */ s.jsx(et, { children: "Leave empty for immediate alerts" })
                  ] }),
                  /* @__PURE__ */ s.jsxs(Q, { children: [
                    /* @__PURE__ */ s.jsx(J, { htmlFor: "thresholdWindowMinutes", children: "Window (minutes)" }),
                    /* @__PURE__ */ s.jsx(
                      re,
                      {
                        id: "thresholdWindowMinutes",
                        type: "number",
                        min: "1",
                        value: l.thresholdWindowMinutes,
                        onChange: (g) => y({ thresholdWindowMinutes: g.target.value })
                      }
                    )
                  ] })
                ] })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("section", { className: "pt-4 border-t border-slate-200", children: [
            /* @__PURE__ */ s.jsxs("h3", { className: "font-medium text-slate-900 mb-3 flex items-center gap-2", children: [
              /* @__PURE__ */ s.jsx(tr, { className: "w-4 h-4 text-slate-500" }),
              "Quiet Hours"
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "pl-6 space-y-4", children: [
              /* @__PURE__ */ s.jsxs("label", { className: "flex items-center gap-2 cursor-pointer", children: [
                /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    type: "checkbox",
                    checked: l.quietHoursEnabled,
                    onChange: (g) => y({ quietHoursEnabled: g.target.checked }),
                    className: "rounded border-slate-300 text-primary-600 focus:ring-primary-500"
                  }
                ),
                /* @__PURE__ */ s.jsx("span", { className: "text-sm text-slate-700", children: "Enable quiet hours" })
              ] }),
              l.quietHoursEnabled && /* @__PURE__ */ s.jsxs("div", { className: "p-4 rounded-lg border border-slate-200 space-y-4", children: [
                /* @__PURE__ */ s.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
                  /* @__PURE__ */ s.jsxs(Q, { children: [
                    /* @__PURE__ */ s.jsx(J, { htmlFor: "quietStart", children: "Start Time" }),
                    /* @__PURE__ */ s.jsx(
                      re,
                      {
                        id: "quietStart",
                        type: "time",
                        value: l.quietHoursStart,
                        onChange: (g) => y({ quietHoursStart: g.target.value })
                      }
                    )
                  ] }),
                  /* @__PURE__ */ s.jsxs(Q, { children: [
                    /* @__PURE__ */ s.jsx(J, { htmlFor: "quietEnd", children: "End Time" }),
                    /* @__PURE__ */ s.jsx(
                      re,
                      {
                        id: "quietEnd",
                        type: "time",
                        value: l.quietHoursEnd,
                        onChange: (g) => y({ quietHoursEnd: g.target.value })
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ s.jsxs(Q, { children: [
                  /* @__PURE__ */ s.jsx(J, { htmlFor: "quietTimezone", children: "Timezone" }),
                  /* @__PURE__ */ s.jsx(
                    "select",
                    {
                      id: "quietTimezone",
                      value: l.quietHoursTimezone,
                      onChange: (g) => y({ quietHoursTimezone: g.target.value }),
                      className: "mt-1 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500",
                      children: Ay.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value))
                    }
                  )
                ] }),
                /* @__PURE__ */ s.jsxs(Q, { children: [
                  /* @__PURE__ */ s.jsx(J, { children: "Quiet Hours Action" }),
                  /* @__PURE__ */ s.jsx("div", { className: "mt-2 space-y-2", children: Py.map(
                    ({ value: g, label: v, description: C }) => /* @__PURE__ */ s.jsxs(
                      "label",
                      {
                        className: "flex items-start gap-2 cursor-pointer",
                        children: [
                          /* @__PURE__ */ s.jsx(
                            "input",
                            {
                              type: "radio",
                              name: "quietHoursAction",
                              value: g,
                              checked: l.quietHoursAction === g,
                              onChange: (w) => y({
                                quietHoursAction: w.target.value
                              }),
                              className: "mt-0.5 border-slate-300 text-primary-600 focus:ring-primary-500"
                            }
                          ),
                          /* @__PURE__ */ s.jsxs("div", { children: [
                            /* @__PURE__ */ s.jsx("span", { className: "text-sm font-medium text-slate-700", children: v }),
                            /* @__PURE__ */ s.jsx("p", { className: "text-xs text-slate-500", children: C })
                          ] })
                        ]
                      },
                      g
                    )
                  ) })
                ] })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ s.jsxs("section", { className: "pt-4 border-t border-slate-200", children: [
            /* @__PURE__ */ s.jsxs("h3", { className: "font-medium text-slate-900 mb-3 flex items-center gap-2", children: [
              /* @__PURE__ */ s.jsx(ke, { className: "w-4 h-4 text-slate-500" }),
              "Escalation"
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "pl-6 space-y-4", children: [
              /* @__PURE__ */ s.jsxs("label", { className: "flex items-center gap-2 cursor-pointer", children: [
                /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    type: "checkbox",
                    checked: l.escalationEnabled,
                    onChange: (g) => y({ escalationEnabled: g.target.checked }),
                    className: "rounded border-slate-300 text-primary-600 focus:ring-primary-500"
                  }
                ),
                /* @__PURE__ */ s.jsx("span", { className: "text-sm text-slate-700", children: "Enable escalation" })
              ] }),
              l.escalationEnabled && /* @__PURE__ */ s.jsxs("div", { className: "p-4 rounded-lg border border-slate-200 space-y-4", children: [
                /* @__PURE__ */ s.jsxs(Q, { children: [
                  /* @__PURE__ */ s.jsx(J, { htmlFor: "escalationDelay", children: "Escalation Delay (minutes)" }),
                  /* @__PURE__ */ s.jsx(
                    re,
                    {
                      id: "escalationDelay",
                      type: "number",
                      min: "1",
                      value: l.escalationDelayMinutes,
                      onChange: (g) => y({ escalationDelayMinutes: g.target.value })
                    }
                  ),
                  /* @__PURE__ */ s.jsx(et, { children: "Time to wait before escalating unacknowledged alerts" })
                ] }),
                /* @__PURE__ */ s.jsxs(Q, { children: [
                  /* @__PURE__ */ s.jsx(J, { htmlFor: "escalationEmail", children: "Escalation Email" }),
                  /* @__PURE__ */ s.jsx(
                    re,
                    {
                      id: "escalationEmail",
                      type: "email",
                      value: l.escalationEmail,
                      onChange: (g) => y({ escalationEmail: g.target.value }),
                      placeholder: "escalation@example.com"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(et, { children: "Additional email to notify on escalation" })
                ] })
              ] })
            ] })
          ] }),
          a.length > 0 && /* @__PURE__ */ s.jsxs("section", { className: "pt-4 border-t border-slate-200", children: [
            /* @__PURE__ */ s.jsxs("h3", { className: "font-medium text-slate-900 mb-3 flex items-center gap-2", children: [
              /* @__PURE__ */ s.jsx(Yl, { className: "w-4 h-4 text-slate-500" }),
              "Route to Integrations"
            ] }),
            /* @__PURE__ */ s.jsxs("div", { className: "pl-6", children: [
              /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-3", children: "Select which integrations receive alerts for this profile. Leave empty to use all active integrations." }),
              /* @__PURE__ */ s.jsx("div", { className: "space-y-2", children: a.filter((g) => g.is_active).map((g) => /* @__PURE__ */ s.jsxs(
                "label",
                {
                  className: "flex items-center gap-2 cursor-pointer p-2 rounded hover:bg-slate-50",
                  children: [
                    /* @__PURE__ */ s.jsx(
                      "input",
                      {
                        type: "checkbox",
                        checked: l.integrationIds.includes(g.id),
                        onChange: () => k(g.id),
                        className: "rounded border-slate-300 text-primary-600 focus:ring-primary-500"
                      }
                    ),
                    /* @__PURE__ */ s.jsx("span", { className: "text-sm text-slate-700", children: g.name }),
                    /* @__PURE__ */ s.jsx("span", { className: "text-xs text-slate-400 uppercase", children: g.type })
                  ]
                },
                g.id
              )) })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ s.jsx(nr, { children: /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
          /* @__PURE__ */ s.jsx(
            S,
            {
              type: "button",
              variant: "outline",
              onClick: t,
              disabled: h,
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ s.jsx(S, { type: "submit", isLoading: h, children: x ? "Save Changes" : "Create Profile" })
        ] }) })
      ] })
    }
  );
}
function Lv({
  apiKey: e,
  teamId: t,
  apiUrl: n,
  primaryColor: a = "#6366f1",
  position: r = "bottom-right",
  visitor: i,
  onOpen: o,
  onClose: l,
  onMessage: d,
  enabled: c = !0,
  metadata: u,
  product: h
}) {
  const m = We(null), x = We(!1), f = e || t;
  return le(() => {
    if (!c || !f) return;
    const p = {
      ...u,
      ...h && { product: h }
    }, y = () => {
      if (!window.SageChat || m.current) return;
      const b = window.SageChat.SageChat || window.SageChat.default || window.SageChat;
      if (!(b != null && b.init))
        return;
      const k = n == null ? void 0 : n.replace(/^http/, "ws"), g = b.init({
        apiKey: f,
        wsUrl: k,
        primaryColor: a,
        position: r,
        visitor: i,
        metadata: Object.keys(p).length > 0 ? p : void 0
      });
      m.current = g, o && g.on("open", o), l && g.on("close", l), d && g.on("message", d);
    };
    if (window.SageChat) {
      y();
      return;
    }
    if (!x.current) {
      x.current = !0;
      const b = document.createElement("script"), k = `v=${Date.now()}`;
      b.src = n ? `${n.replace("/api", "")}/sage-chat.min.js?${k}` : `https://cdn.roselabs.io/sage-chat.min.js?${k}`, b.async = !0, b.onload = y, b.onerror = () => {
        console.error(
          "[SageChatWidget] Failed to load script from",
          b.src
        ), x.current = !1;
      }, document.body.appendChild(b);
    }
    return () => {
      m.current && (o && m.current.off("open", o), l && m.current.off("close", l), d && m.current.off(
        "message",
        d
      ), m.current.destroy(), m.current = null);
    };
  }, [
    c,
    f,
    n,
    a,
    r,
    i,
    u,
    h,
    o,
    l,
    d
  ]), le(() => {
    m.current && i && m.current.identify(i);
  }, [i == null ? void 0 : i.email, i == null ? void 0 : i.name]), null;
}
function Ey({
  user: e,
  teamId: t,
  onLogout: n,
  settingsPath: a,
  adminPath: r = "/admin",
  supportPath: i = "/contact",
  showSupport: o = !0
}) {
  const [l, d] = j(!1), c = We(null);
  le(() => {
    function h(m) {
      c.current && !c.current.contains(m.target) && d(!1);
    }
    return l && document.addEventListener("mousedown", h), () => {
      document.removeEventListener("mousedown", h);
    };
  }, [l]);
  const u = a || (t ? `/t/${t}/settings` : "/settings");
  return /* @__PURE__ */ s.jsxs("div", { className: "user-menu", ref: c, children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: "user-menu-button",
        onClick: () => d(!l),
        "aria-expanded": l,
        "aria-haspopup": "true",
        children: [
          /* @__PURE__ */ s.jsx(ar, { src: e.avatarUrl, name: e.name, size: "sm" }),
          /* @__PURE__ */ s.jsx(jn, { className: "w-4 h-4 text-slate-500" })
        ]
      }
    ),
    l && /* @__PURE__ */ s.jsxs("div", { className: "dropdown-menu", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "px-4 py-3 border-b border-slate-100", children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-sm font-medium text-slate-900", children: e.name }),
        /* @__PURE__ */ s.jsx("p", { className: "text-xs text-slate-500 truncate", children: e.email })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "py-1", children: [
        /* @__PURE__ */ s.jsxs(
          _,
          {
            to: u,
            className: "dropdown-item flex items-center gap-2",
            onClick: () => d(!1),
            children: [
              /* @__PURE__ */ s.jsx(Jl, { className: "w-4 h-4" }),
              "Settings"
            ]
          }
        ),
        o && /* @__PURE__ */ s.jsxs(
          _,
          {
            to: i,
            className: "dropdown-item flex items-center gap-2",
            onClick: () => d(!1),
            children: [
              /* @__PURE__ */ s.jsx(Qm, { className: "w-4 h-4" }),
              "Contact Support"
            ]
          }
        ),
        e.isAdmin && /* @__PURE__ */ s.jsxs(
          _,
          {
            to: r,
            className: "dropdown-item flex items-center gap-2",
            onClick: () => d(!1),
            children: [
              /* @__PURE__ */ s.jsx(ns, { className: "w-4 h-4" }),
              "Admin"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "dropdown-divider" }),
      /* @__PURE__ */ s.jsx("div", { className: "py-1", children: /* @__PURE__ */ s.jsxs(
        "button",
        {
          onClick: () => {
            d(!1), n();
          },
          className: "dropdown-item flex items-center gap-2 text-red-600 hover:bg-red-50",
          children: [
            /* @__PURE__ */ s.jsx(Qa, { className: "w-4 h-4" }),
            "Sign out"
          ]
        }
      ) })
    ] })
  ] });
}
function Ry({
  teams: e,
  currentTeam: t,
  onTeamSwitch: n,
  onCreateTeam: a,
  allowCreate: r = !0
}) {
  const [i, o] = j(!1), l = We(null);
  le(() => {
    function c(u) {
      l.current && !l.current.contains(u.target) && o(!1);
    }
    return i && document.addEventListener("mousedown", c), () => {
      document.removeEventListener("mousedown", c);
    };
  }, [i]);
  const d = (c) => {
    o(!1), c.id !== (t == null ? void 0 : t.id) && n(c);
  };
  return t ? /* @__PURE__ */ s.jsxs("div", { className: "team-switcher", ref: l, children: [
    /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: "team-switcher-button",
        onClick: () => o(!i),
        "aria-expanded": i,
        "aria-haspopup": "listbox",
        children: [
          /* @__PURE__ */ s.jsx(
            ha,
            {
              src: t.logo_url,
              name: t.name,
              size: "sm"
            }
          ),
          /* @__PURE__ */ s.jsx("span", { className: "team-switcher-name", children: t.name }),
          /* @__PURE__ */ s.jsx(jn, { className: "w-4 h-4 text-slate-400" })
        ]
      }
    ),
    i && /* @__PURE__ */ s.jsxs("div", { className: "team-switcher-dropdown", role: "listbox", children: [
      /* @__PURE__ */ s.jsx("div", { className: "max-h-64 overflow-y-auto", children: e.map((c) => /* @__PURE__ */ s.jsxs(
        "button",
        {
          className: `team-switcher-item w-full ${c.id === t.id ? "is-active" : ""}`,
          onClick: () => d(c),
          role: "option",
          "aria-selected": c.id === t.id,
          children: [
            /* @__PURE__ */ s.jsx(ha, { src: c.logo_url, name: c.name, size: "sm" }),
            /* @__PURE__ */ s.jsxs("div", { className: "flex-1 text-left", children: [
              /* @__PURE__ */ s.jsx("p", { className: "text-sm font-medium text-slate-900", children: c.name }),
              c.role && /* @__PURE__ */ s.jsx("p", { className: "text-xs text-slate-500 capitalize", children: c.role })
            ] }),
            c.id === t.id && /* @__PURE__ */ s.jsx($t, { className: "w-4 h-4 text-accent-600" })
          ]
        },
        c.id
      )) }),
      r && a && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("div", { className: "border-t border-slate-200 my-2" }),
        /* @__PURE__ */ s.jsxs(
          "button",
          {
            className: "team-switcher-item w-full text-accent-600 hover:bg-accent-50",
            onClick: () => {
              o(!1), a();
            },
            children: [
              /* @__PURE__ */ s.jsx(Jt, { className: "w-4 h-4" }),
              /* @__PURE__ */ s.jsx("span", { className: "text-sm font-medium", children: "Create new team" })
            ]
          }
        )
      ] })
    ] })
  ] }) : null;
}
function Go({
  logo: e,
  logoLink: t,
  user: n,
  teams: a,
  currentTeam: r,
  onTeamSwitch: i,
  onCreateTeam: o,
  onLogout: l,
  settingsPath: d,
  adminPath: c,
  allowCreateTeam: u = !0,
  rightContent: h
}) {
  return /* @__PURE__ */ s.jsx("header", { className: "app-header", children: /* @__PURE__ */ s.jsxs("div", { className: "header-inner", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "header-left", children: [
      e && (t ? /* @__PURE__ */ s.jsx(_, { to: t, className: "header-logo flex items-center", children: e }) : /* @__PURE__ */ s.jsx("div", { className: "header-logo flex items-center", children: e })),
      a.length > 0 && r && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        e && /* @__PURE__ */ s.jsx("div", { className: "h-6 w-px bg-slate-200" }),
        /* @__PURE__ */ s.jsx(
          Ry,
          {
            teams: a,
            currentTeam: r,
            onTeamSwitch: i,
            onCreateTeam: o,
            allowCreate: u
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "header-right", children: [
      h,
      /* @__PURE__ */ s.jsx(
        Ey,
        {
          user: n,
          teamId: r == null ? void 0 : r.id,
          onLogout: l,
          settingsPath: d,
          adminPath: c
        }
      )
    ] })
  ] }) });
}
function Xo({
  items: e,
  variant: t = "horizontal",
  className: n = ""
}) {
  const { teamId: a } = Ha(), r = (i) => a ? i.replace(":teamId", a) : i;
  return t === "vertical" ? /* @__PURE__ */ s.jsx("nav", { className: `sidebar-nav ${n}`, children: e.map((i) => {
    const o = i.icon;
    return /* @__PURE__ */ s.jsxs(
      ri,
      {
        to: r(i.path),
        className: ({ isActive: l }) => `sidebar-item ${l ? "is-active" : ""}`,
        children: [
          o && /* @__PURE__ */ s.jsx(o, { className: "sidebar-item-icon" }),
          /* @__PURE__ */ s.jsx("span", { children: i.label })
        ]
      },
      i.id
    );
  }) }) : /* @__PURE__ */ s.jsx("nav", { className: `border-b border-slate-200 bg-white ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "max-w-6xl mx-auto px-6", children: /* @__PURE__ */ s.jsx("div", { className: "flex items-center gap-1", children: e.map((i) => {
    const o = i.icon;
    return /* @__PURE__ */ s.jsxs(
      ri,
      {
        to: r(i.path),
        className: ({ isActive: l }) => `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${l ? "border-accent-600 text-accent-600" : "border-transparent text-slate-600 hover:text-slate-900 hover:border-slate-300"}`,
        children: [
          o && /* @__PURE__ */ s.jsx(o, { className: "w-4 h-4" }),
          i.label
        ]
      },
      i.id
    );
  }) }) }) });
}
function Dy({
  children: e,
  navigation: t,
  navVariant: n = "horizontal",
  banner: a,
  headerRight: r,
  contentClassName: i = "",
  // AppHeader props
  logo: o,
  logoLink: l,
  user: d,
  teams: c,
  currentTeam: u,
  onTeamSwitch: h,
  onCreateTeam: m,
  onLogout: x,
  settingsPath: f,
  adminPath: p,
  allowCreateTeam: y
}) {
  return n === "vertical" ? /* @__PURE__ */ s.jsxs("div", { className: "shell", children: [
    a,
    /* @__PURE__ */ s.jsxs("div", { className: "shell-container", children: [
      /* @__PURE__ */ s.jsxs("aside", { className: "sidebar", children: [
        /* @__PURE__ */ s.jsx("div", { className: "sidebar-header", children: o }),
        /* @__PURE__ */ s.jsx(Xo, { items: t, variant: "vertical" }),
        /* @__PURE__ */ s.jsx("div", { className: "sidebar-footer" })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "shell-content", children: [
        /* @__PURE__ */ s.jsx(
          Go,
          {
            logo: null,
            logoLink: l,
            user: d,
            teams: c,
            currentTeam: u,
            onTeamSwitch: h,
            onCreateTeam: m,
            onLogout: x,
            settingsPath: f,
            adminPath: p,
            allowCreateTeam: y,
            rightContent: r
          }
        ),
        /* @__PURE__ */ s.jsx("main", { className: `shell-main ${i}`, children: e })
      ] })
    ] })
  ] }) : /* @__PURE__ */ s.jsxs("div", { className: "shell", children: [
    a,
    /* @__PURE__ */ s.jsx(
      Go,
      {
        logo: o,
        logoLink: l,
        user: d,
        teams: c,
        currentTeam: u,
        onTeamSwitch: h,
        onCreateTeam: m,
        onLogout: x,
        settingsPath: f,
        adminPath: p,
        allowCreateTeam: y,
        rightContent: r
      }
    ),
    /* @__PURE__ */ s.jsx(Xo, { items: t, variant: "horizontal" }),
    /* @__PURE__ */ s.jsx("main", { className: `shell-main ${i}`, children: e })
  ] });
}
const _y = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg"
};
function My({
  children: e,
  logo: t,
  logoLink: n = "/",
  title: a,
  subtitle: r,
  footer: i,
  showBackLink: o = !0,
  maxWidth: l = "md",
  className: d = ""
}) {
  return /* @__PURE__ */ s.jsxs("div", { className: `auth-layout ${d}`, children: [
    /* @__PURE__ */ s.jsx("div", { className: "absolute top-0 left-1/4 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl" }),
    /* @__PURE__ */ s.jsx("div", { className: "absolute bottom-0 right-1/4 w-96 h-96 bg-slate-500/5 rounded-full blur-3xl" }),
    /* @__PURE__ */ s.jsx("div", { className: `relative z-10 w-full ${_y[l]}`, children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
      /* @__PURE__ */ s.jsx(_, { to: n, className: "block auth-logo", children: t }),
      /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: a }),
      r && /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: r }),
      e,
      i && /* @__PURE__ */ s.jsx("div", { className: "auth-footer", children: i }),
      o && /* @__PURE__ */ s.jsx("div", { className: "mt-6 text-center", children: /* @__PURE__ */ s.jsx(
        _,
        {
          to: n,
          className: "text-sm text-slate-500 hover:text-slate-700 transition-colors",
          children: "← Back to home"
        }
      ) })
    ] }) })
  ] });
}
function Fd({ text: e = "or" }) {
  return /* @__PURE__ */ s.jsx("div", { className: "auth-divider", children: /* @__PURE__ */ s.jsx("span", { children: e }) });
}
function mn({
  provider: e,
  onClick: t,
  disabled: n,
  children: a
}) {
  return e === "google" ? /* @__PURE__ */ s.jsxs(
    "button",
    {
      type: "button",
      onClick: t,
      disabled: n,
      className: "oauth-button",
      children: [
        /* @__PURE__ */ s.jsxs("svg", { className: "oauth-button-icon", viewBox: "0 0 24 24", children: [
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#4285F4",
              d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#34A853",
              d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#FBBC05",
              d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#EA4335",
              d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            }
          )
        ] }),
        a || "Continue with Google"
      ]
    }
  ) : /* @__PURE__ */ s.jsxs(
    "button",
    {
      type: "button",
      onClick: t,
      disabled: n,
      className: "w-full flex items-center justify-center gap-3 px-4 py-2.5 bg-slate-900 border border-slate-900 rounded-lg text-white font-medium hover:bg-slate-800 transition-colors",
      children: [
        /* @__PURE__ */ s.jsx(
          "svg",
          {
            className: "oauth-button-icon",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s.jsx(
              "path",
              {
                fillRule: "evenodd",
                d: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
                clipRule: "evenodd"
              }
            )
          }
        ),
        a || "Continue with GitHub"
      ]
    }
  );
}
function $v({
  title: e,
  lastUpdated: t,
  header: n,
  footer: a,
  children: r,
  backLink: i = "/",
  backLinkText: o = "Back to home",
  className: l = ""
}) {
  return /* @__PURE__ */ s.jsxs("div", { className: `min-h-screen bg-white ${l}`, children: [
    n,
    /* @__PURE__ */ s.jsx("main", { className: "pt-32 pb-20", children: /* @__PURE__ */ s.jsx(Ve, { children: /* @__PURE__ */ s.jsxs(
      Ft.div,
      {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 },
        children: [
          /* @__PURE__ */ s.jsxs(
            _,
            {
              to: i,
              className: "inline-flex items-center gap-2 text-accent-600 hover:text-accent-700 transition-colors mb-8",
              children: [
                /* @__PURE__ */ s.jsx(rt, { className: "w-5 h-5" }),
                o
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("h1", { className: "text-4xl sm:text-5xl font-bold mb-4 text-slate-900", children: e }),
          /* @__PURE__ */ s.jsxs("p", { className: "text-slate-500 mb-12", children: [
            "Last updated: ",
            t
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "prose prose-slate max-w-none", children: r })
        ]
      }
    ) }) }),
    a
  ] });
}
function Iv({ number: e, title: t, children: n }) {
  return /* @__PURE__ */ s.jsxs("section", { className: "mb-12", children: [
    /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900 mb-4", children: e ? `${e}. ${t}` : t }),
    n
  ] });
}
function Ov({
  number: e,
  title: t,
  children: n
}) {
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-semibold text-slate-900 mb-3 mt-6", children: e ? `${e} ${t}` : t }),
    n
  ] });
}
function Vv({ children: e }) {
  return /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 leading-relaxed mb-4", children: e });
}
function Bv({ children: e }) {
  return /* @__PURE__ */ s.jsx("ul", { className: "list-disc list-inside text-slate-600 space-y-2 ml-4", children: e });
}
function Ld({
  children: e,
  loginPath: t = "/login",
  requireEmailVerified: n = !1,
  verifyEmailPath: a = "/verify-email-required",
  requireAdmin: r = !1,
  unauthorizedPath: i = "/",
  loadingComponent: o
}) {
  const { user: l, isLoading: d } = Ne(), c = ul();
  if (d)
    return o ? /* @__PURE__ */ s.jsx(s.Fragment, { children: o }) : /* @__PURE__ */ s.jsx(gf, {});
  if (!l) {
    const u = encodeURIComponent(c.pathname + c.search);
    return /* @__PURE__ */ s.jsx(At, { to: `${t}?redirect=${u}`, replace: !0 });
  }
  return n && !l.email_verified ? /* @__PURE__ */ s.jsx(At, { to: a, replace: !0 }) : r && !l.is_admin ? /* @__PURE__ */ s.jsx(At, { to: i, replace: !0 }) : /* @__PURE__ */ s.jsx(s.Fragment, { children: e });
}
function zv({
  children: e,
  loginPath: t = "/login",
  unauthorizedPath: n = "/",
  loadingComponent: a
}) {
  return /* @__PURE__ */ s.jsx(
    Ld,
    {
      loginPath: t,
      requireAdmin: !0,
      unauthorizedPath: n,
      loadingComponent: a,
      children: e
    }
  );
}
function Fy({
  teamId: e,
  pricingPath: t,
  billingPath: n
}) {
  const { billingStatus: a, isPastDue: r, isCanceled: i, subscription: o } = Ds();
  if (!e)
    return null;
  const l = (u, h) => (u || h).replace(":teamId", e), d = l(t, "/t/:teamId/pricing"), c = l(n, "/t/:teamId/settings");
  return r ? /* @__PURE__ */ s.jsx("div", { className: "bg-amber-50 border-b border-amber-200", children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-6xl mx-auto px-6 py-3 flex items-center justify-between", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ s.jsx(gt, { className: "w-5 h-5 text-amber-600" }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-sm font-medium text-amber-900", children: "Payment past due" }),
        /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-amber-700", children: [
          "Please update your payment method to avoid service interruption.",
          (a == null ? void 0 : a.gracePeriodEnds) && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            " ",
            "Grace period ends",
            " ",
            new Date(
              a.gracePeriodEnds
            ).toLocaleDateString(),
            "."
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs(
      _,
      {
        to: c,
        className: "flex items-center gap-2 px-4 py-2 bg-amber-600 text-white rounded-lg text-sm font-medium hover:bg-amber-700 transition-colors",
        children: [
          /* @__PURE__ */ s.jsx(Kl, { className: "w-4 h-4" }),
          "Update payment"
        ]
      }
    )
  ] }) }) : i && (o != null && o.current_period_end) ? /* @__PURE__ */ s.jsx("div", { className: "bg-slate-100 border-b border-slate-200", children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-6xl mx-auto px-6 py-3 flex items-center justify-between", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ s.jsx(gt, { className: "w-5 h-5 text-slate-600" }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-slate-700", children: [
        "Your subscription ends on",
        " ",
        /* @__PURE__ */ s.jsx("span", { className: "font-medium", children: new Date(o.current_period_end).toLocaleDateString() }),
        ". Resubscribe to keep access."
      ] })
    ] }),
    /* @__PURE__ */ s.jsx(
      _,
      {
        to: d,
        className: "px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 transition-colors",
        children: "Resubscribe"
      }
    )
  ] }) }) : null;
}
let Ly = { data: "" }, $y = (e) => {
  if (typeof window == "object") {
    let t = (e ? e.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), { innerHTML: " ", id: "_goober" });
    return t.nonce = window.__nonce__, t.parentNode || (e || document.head).appendChild(t), t.firstChild;
  }
  return e || Ly;
}, Iy = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, Oy = /\/\*[^]*?\*\/|  +/g, Jo = /\n+/g, ht = (e, t) => {
  let n = "", a = "", r = "";
  for (let i in e) {
    let o = e[i];
    i[0] == "@" ? i[1] == "i" ? n = i + " " + o + ";" : a += i[1] == "f" ? ht(o, i) : i + "{" + ht(o, i[1] == "k" ? "" : t) + "}" : typeof o == "object" ? a += ht(o, t ? t.replace(/([^,])+/g, (l) => i.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (d) => /&/.test(d) ? d.replace(/&/g, l) : l ? l + " " + d : d)) : i) : o != null && (i = /^--/.test(i) ? i : i.replace(/[A-Z]/g, "-$&").toLowerCase(), r += ht.p ? ht.p(i, o) : i + ":" + o + ";");
  }
  return n + (t && r ? t + "{" + r + "}" : r) + a;
}, at = {}, $d = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let n in e) t += n + $d(e[n]);
    return t;
  }
  return e;
}, Vy = (e, t, n, a, r) => {
  let i = $d(e), o = at[i] || (at[i] = ((d) => {
    let c = 0, u = 11;
    for (; c < d.length; ) u = 101 * u + d.charCodeAt(c++) >>> 0;
    return "go" + u;
  })(i));
  if (!at[o]) {
    let d = i !== e ? e : ((c) => {
      let u, h, m = [{}];
      for (; u = Iy.exec(c.replace(Oy, "")); ) u[4] ? m.shift() : u[3] ? (h = u[3].replace(Jo, " ").trim(), m.unshift(m[0][h] = m[0][h] || {})) : m[0][u[1]] = u[2].replace(Jo, " ").trim();
      return m[0];
    })(e);
    at[o] = ht(r ? { ["@keyframes " + o]: d } : d, n ? "" : "." + o);
  }
  let l = n && at.g ? at.g : null;
  return n && (at.g = at[o]), ((d, c, u, h) => {
    h ? c.data = c.data.replace(h, d) : c.data.indexOf(d) === -1 && (c.data = u ? d + c.data : c.data + d);
  })(at[o], t, a, l), o;
}, By = (e, t, n) => e.reduce((a, r, i) => {
  let o = t[i];
  if (o && o.call) {
    let l = o(n), d = l && l.props && l.props.className || /^go/.test(l) && l;
    o = d ? "." + d : l && typeof l == "object" ? l.props ? "" : ht(l, "") : l === !1 ? "" : l;
  }
  return a + r + (o ?? "");
}, "");
function Cn(e) {
  let t = this || {}, n = e.call ? e(t.p) : e;
  return Vy(n.unshift ? n.raw ? By(n, [].slice.call(arguments, 1), t.p) : n.reduce((a, r) => Object.assign(a, r && r.call ? r(t.p) : r), {}) : n, $y(t.target), t.g, t.o, t.k);
}
let Id, La, $a;
Cn.bind({ g: 1 });
let ct = Cn.bind({ k: 1 });
function zy(e, t, n, a) {
  ht.p = t, Id = e, La = n, $a = a;
}
function Nt(e, t) {
  let n = this || {};
  return function() {
    let a = arguments;
    function r(i, o) {
      let l = Object.assign({}, i), d = l.className || r.className;
      n.p = Object.assign({ theme: La && La() }, l), n.o = / *go\d+/.test(d), l.className = Cn.apply(n, a) + (d ? " " + d : "");
      let c = e;
      return e[0] && (c = l.as || e, delete l.as), $a && c[0] && $a(l), Id(c, l);
    }
    return r;
  };
}
var Uy = (e) => typeof e == "function", Ia = (e, t) => Uy(e) ? e(t) : e, qy = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), Hy = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), Wy = 20, Od = "default", Vd = (e, t) => {
  let { toastLimit: n } = e.settings;
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, n) };
    case 1:
      return { ...e, toasts: e.toasts.map((o) => o.id === t.toast.id ? { ...o, ...t.toast } : o) };
    case 2:
      let { toast: a } = t;
      return Vd(e, { type: e.toasts.find((o) => o.id === a.id) ? 1 : 0, toast: a });
    case 3:
      let { toastId: r } = t;
      return { ...e, toasts: e.toasts.map((o) => o.id === r || r === void 0 ? { ...o, dismissed: !0, visible: !1 } : o) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((o) => o.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let i = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((o) => ({ ...o, pauseDuration: o.pauseDuration + i })) };
  }
}, Ky = [], Yy = { toasts: [], pausedAt: void 0, settings: { toastLimit: Wy } }, Yt = {}, Bd = (e, t = Od) => {
  Yt[t] = Vd(Yt[t] || Yy, e), Ky.forEach(([n, a]) => {
    n === t && a(Yt[t]);
  });
}, zd = (e) => Object.keys(Yt).forEach((t) => Bd(e, t)), Gy = (e) => Object.keys(Yt).find((t) => Yt[t].toasts.some((n) => n.id === e)), Lr = (e = Od) => (t) => {
  Bd(t, e);
}, Xy = (e, t = "blank", n) => ({ createdAt: Date.now(), visible: !0, dismissed: !1, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...n, id: (n == null ? void 0 : n.id) || qy() }), $s = (e) => (t, n) => {
  let a = Xy(t, e, n);
  return Lr(a.toasterId || Gy(a.id))({ type: 2, toast: a }), a.id;
}, Te = (e, t) => $s("blank")(e, t);
Te.error = $s("error");
Te.success = $s("success");
Te.loading = $s("loading");
Te.custom = $s("custom");
Te.dismiss = (e, t) => {
  let n = { type: 3, toastId: e };
  t ? Lr(t)(n) : zd(n);
};
Te.dismissAll = (e) => Te.dismiss(void 0, e);
Te.remove = (e, t) => {
  let n = { type: 4, toastId: e };
  t ? Lr(t)(n) : zd(n);
};
Te.removeAll = (e) => Te.remove(void 0, e);
Te.promise = (e, t, n) => {
  let a = Te.loading(t.loading, { ...n, ...n == null ? void 0 : n.loading });
  return typeof e == "function" && (e = e()), e.then((r) => {
    let i = t.success ? Ia(t.success, r) : void 0;
    return i ? Te.success(i, { id: a, ...n, ...n == null ? void 0 : n.success }) : Te.dismiss(a), r;
  }).catch((r) => {
    let i = t.error ? Ia(t.error, r) : void 0;
    i ? Te.error(i, { id: a, ...n, ...n == null ? void 0 : n.error }) : Te.dismiss(a);
  }), e;
};
var Jy = ct`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, Zy = ct`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, Qy = ct`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, eb = Nt("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${Jy} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${Zy} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${Qy} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, tb = ct`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, sb = Nt("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${tb} 1s linear infinite;
`, nb = ct`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, ab = ct`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, rb = Nt("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${nb} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${ab} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, ib = Nt("div")`
  position: absolute;
`, ob = Nt("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, lb = ct`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, cb = Nt("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${lb} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, db = ({ toast: e }) => {
  let { icon: t, type: n, iconTheme: a } = e;
  return t !== void 0 ? typeof t == "string" ? Ie.createElement(cb, null, t) : t : n === "blank" ? null : Ie.createElement(ob, null, Ie.createElement(sb, { ...a }), n !== "loading" && Ie.createElement(ib, null, n === "error" ? Ie.createElement(eb, { ...a }) : Ie.createElement(rb, { ...a })));
}, ub = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, hb = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, mb = "0%{opacity:0;} 100%{opacity:1;}", fb = "0%{opacity:1;} 100%{opacity:0;}", xb = Nt("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, pb = Nt("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, gb = (e, t) => {
  let n = e.includes("top") ? 1 : -1, [a, r] = Hy() ? [mb, fb] : [ub(n), hb(n)];
  return { animation: t ? `${ct(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${ct(r)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
};
Ie.memo(({ toast: e, position: t, style: n, children: a }) => {
  let r = e.height ? gb(e.position || t || "top-center", e.visible) : { opacity: 0 }, i = Ie.createElement(db, { toast: e }), o = Ie.createElement(pb, { ...e.ariaProps }, Ia(e.message, e));
  return Ie.createElement(xb, { className: e.className, style: { ...r, ...n, ...e.style } }, typeof a == "function" ? a({ icon: i, message: o }) : Ie.createElement(Ie.Fragment, null, i, o));
});
zy(Ie.createElement);
Cn`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`;
var ee = Te;
function yb({
  logo: e,
  productName: t,
  dashboardPath: n = "/dashboard",
  teamDashboardPath: a = "/t/:teamId/dashboard",
  showGoogleAuth: r = !0,
  showGithubAuth: i = !0,
  homePath: o = "/",
  className: l = ""
}) {
  const [d] = Ee(), c = d.get("invite"), u = d.get("redirect"), [h, m] = j(""), [x, f] = j(""), [p, y] = j(""), [b, k] = j(!1), [g, v] = j(""), [C, w] = j(""), [D, P] = j(!1), [$, I] = j(0), [V, H] = j([]), [K, U] = j(!1), { login: te, login2FA: ne, selectTeam: se, googleAuth: A, githubAuth: z, isLoading: R } = Ne(), N = Be(), L = (E) => u ? u.includes(":teamId") && E ? u.replace(":teamId", E) : u.includes(":teamId") ? E ? a.replace(":teamId", E) : n : u : c ? `/invites/${c}` : E ? a.replace(":teamId", E) : n, M = async (E) => {
    var ie, je;
    E.preventDefault(), y("");
    try {
      const oe = await te(h, x);
      oe.requires2FA && oe.tempToken ? (v(oe.tempToken), k(!0)) : oe.requiresTeamSelection && oe.teams && oe.tempToken ? (H(oe.teams), v(oe.tempToken), U(!0)) : oe.teamId ? (ee.success("Welcome back!"), window.location.href = L(oe.teamId)) : c ? window.location.href = `/invites/${c}` : (ee.success("Welcome!"), window.location.href = n);
    } catch (oe) {
      const ce = (je = (ie = oe.response) == null ? void 0 : ie.data) == null ? void 0 : je.detail;
      if (ce === "EMAIL_NOT_VERIFIED")
        N(`/verify-email-required?email=${encodeURIComponent(h)}`);
      else if (ce != null && ce.startsWith("ACCOUNT_DELETED:") || ce != null && ce.startsWith("PRODUCT_DELETED:")) {
        const Re = ce.split(":")[1] || "0";
        N(
          `/account-deleted?email=${encodeURIComponent(h)}&days=${Re}`
        );
      } else if (ce === "ACCOUNT_PERMANENTLY_DELETED" || ce === "PRODUCT_PERMANENTLY_DELETED")
        y(
          "This account has been permanently deleted and cannot be recovered."
        ), ee.error("Account permanently deleted");
      else if (ce === "SECURITY_LOCKED")
        y(
          "Your account has been locked for security. Please reset your password to regain access."
        ), ee.error("Account security locked");
      else if (ce != null && ce.startsWith("LOGIN_LOCKED:")) {
        const Re = parseInt(ce.split(":")[1] || "15", 10);
        P(!0), I(Re), y("");
      } else {
        const Re = ce || "Login failed. Please check your credentials.";
        y(Re), ee.error(Re);
      }
    }
  }, F = async (E) => {
    var ie, je, oe, ze;
    E.preventDefault(), y("");
    try {
      const ce = await ne(g, C);
      ce.teamId ? (ee.success("Welcome back!"), window.location.href = L(ce.teamId)) : c ? window.location.href = `/invites/${c}` : (ee.success("Welcome! Let's set up your team."), window.location.href = "/no-teams");
    } catch (ce) {
      const Re = ce, kt = ((je = (ie = Re.response) == null ? void 0 : ie.data) == null ? void 0 : je.detail) || "Invalid verification code";
      if (((oe = Re.response) == null ? void 0 : oe.status) === 429) {
        P(!0);
        const Is = kt.match(/(\d+)\s*minutes?/);
        I(Is ? parseInt(Is[1], 10) : 15);
      }
      y(kt), ((ze = Re.response) == null ? void 0 : ze.status) !== 429 && ee.error(kt);
    }
  }, G = () => {
    k(!1), U(!1), v(""), w(""), y(""), P(!1), I(0), H([]);
  }, q = async (E) => {
    var ie, je;
    try {
      const oe = c ? `/invites/${c}` : void 0;
      await se(g, E, oe), ee.success("Welcome back!");
    } catch (oe) {
      const ce = ((je = (ie = oe.response) == null ? void 0 : ie.data) == null ? void 0 : je.detail) || "Failed to select team";
      y(ce), ee.error(ce);
    }
  }, Z = (E) => {
    switch (E) {
      case "owner":
        return /* @__PURE__ */ s.jsx(It, { className: "w-4 h-4 text-yellow-500" });
      case "admin":
        return /* @__PURE__ */ s.jsx(an, { className: "w-4 h-4 text-purple-500" });
      case "viewer":
        return /* @__PURE__ */ s.jsx(xt, { className: "w-4 h-4 text-slate-500" });
      default:
        return /* @__PURE__ */ s.jsx(an, { className: "w-4 h-4 text-blue-500" });
    }
  }, ge = () => b ? "Two-Factor Authentication" : K ? "Select a Team" : "Welcome back", _e = () => b ? "Enter the code from your authenticator app" : K ? "You belong to multiple teams. Choose which one to access." : `Sign in to your ${t} account`;
  return /* @__PURE__ */ s.jsxs(My, { logo: e, logoLink: o, className: l, children: [
    /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-8", children: [
      /* @__PURE__ */ s.jsx("h1", { className: "text-3xl font-bold text-slate-900 mb-2", children: ge() }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-600", children: _e() })
    ] }),
    D && /* @__PURE__ */ s.jsx(Zt, { variant: "warning", className: "mb-6", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0", children: /* @__PURE__ */ s.jsx(pt, { className: "w-6 h-6 text-amber-600" }) }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
        /* @__PURE__ */ s.jsx("h3", { className: "font-semibold text-amber-900 mb-1", children: "Account Temporarily Locked" }),
        /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-amber-700 mb-3", children: [
          b ? "Too many failed verification code attempts." : "Too many failed login attempts.",
          " ",
          "Your account has been temporarily locked for security."
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 text-sm text-amber-800", children: [
          /* @__PURE__ */ s.jsx(ft, { className: "w-4 h-4" }),
          /* @__PURE__ */ s.jsxs("span", { children: [
            "Try again in ",
            /* @__PURE__ */ s.jsx("strong", { children: $ }),
            " minute",
            $ !== 1 ? "s" : ""
          ] })
        ] })
      ] })
    ] }) }),
    p && !D && /* @__PURE__ */ s.jsx(Zt, { variant: "error", className: "mb-6", children: p }),
    b ? (
      /* 2FA Verification form */
      /* @__PURE__ */ s.jsxs("form", { onSubmit: F, className: "space-y-6", children: [
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "code", children: "Verification Code" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "code",
              type: "text",
              value: C,
              onChange: (E) => w(
                E.target.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 8)
              ),
              required: !0,
              className: "text-center text-2xl tracking-widest",
              placeholder: "000000",
              maxLength: 8,
              autoFocus: !0
            }
          ),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xs text-slate-500", children: "Enter the 6-digit code from your authenticator app, or a backup code." })
        ] }),
        /* @__PURE__ */ s.jsx(
          S,
          {
            type: "submit",
            variant: "primary",
            size: "lg",
            className: "w-full",
            disabled: R || C.length < 6 || D,
            children: R ? "Verifying..." : D ? "Account Locked" : "Verify"
          }
        ),
        /* @__PURE__ */ s.jsxs(
          "button",
          {
            type: "button",
            onClick: G,
            className: "w-full flex items-center justify-center gap-2 text-slate-500 hover:text-slate-900 transition-colors",
            children: [
              /* @__PURE__ */ s.jsx(rt, { className: "w-4 h-4" }),
              "Back to login"
            ]
          }
        )
      ] })
    ) : K ? (
      /* Team selector */
      /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
        V.map((E) => /* @__PURE__ */ s.jsx(
          "button",
          {
            onClick: () => q(E.id),
            disabled: R,
            className: "w-full p-4 bg-slate-50 hover:bg-slate-100 border border-slate-200 hover:border-accent-300 rounded-lg text-left transition-all group disabled:opacity-50 disabled:cursor-not-allowed",
            children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ s.jsxs("div", { children: [
                /* @__PURE__ */ s.jsx("p", { className: "text-slate-900 font-medium group-hover:text-accent-600 transition-colors", children: E.name }),
                /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-1.5 mt-1", children: [
                  Z(E.role),
                  /* @__PURE__ */ s.jsx("span", { className: "text-sm text-slate-500 capitalize", children: E.role })
                ] })
              ] }),
              /* @__PURE__ */ s.jsx(rt, { className: "w-4 h-4 text-slate-400 group-hover:text-accent-600 transition-colors rotate-180" })
            ] })
          },
          E.id
        )),
        /* @__PURE__ */ s.jsxs(
          "button",
          {
            type: "button",
            onClick: G,
            className: "w-full flex items-center justify-center gap-2 text-slate-500 hover:text-slate-900 transition-colors mt-4",
            children: [
              /* @__PURE__ */ s.jsx(rt, { className: "w-4 h-4" }),
              "Back to login"
            ]
          }
        )
      ] })
    ) : (
      /* Login form */
      /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsxs("form", { onSubmit: M, className: "space-y-6", children: [
          /* @__PURE__ */ s.jsxs(Q, { children: [
            /* @__PURE__ */ s.jsx(J, { htmlFor: "email", children: "Email" }),
            /* @__PURE__ */ s.jsx(
              re,
              {
                id: "email",
                type: "email",
                value: h,
                onChange: (E) => m(E.target.value),
                required: !0,
                placeholder: "you@example.com"
              }
            )
          ] }),
          /* @__PURE__ */ s.jsxs(Q, { children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between mb-2", children: [
              /* @__PURE__ */ s.jsx(J, { htmlFor: "password", children: "Password" }),
              /* @__PURE__ */ s.jsx(
                _,
                {
                  to: "/forgot-password",
                  className: "text-sm text-accent-600 hover:text-accent-700 transition-colors",
                  children: "Forgot password?"
                }
              )
            ] }),
            /* @__PURE__ */ s.jsx(
              re,
              {
                id: "password",
                type: "password",
                value: x,
                onChange: (E) => f(E.target.value),
                required: !0,
                placeholder: "••••••••"
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx(
            S,
            {
              type: "submit",
              variant: "primary",
              size: "lg",
              className: "w-full",
              disabled: R || D,
              children: R ? "Signing in..." : D ? "Account Locked" : "Sign in"
            }
          )
        ] }),
        (r || i) && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(Fd, {}),
          /* @__PURE__ */ s.jsxs("div", { className: "space-y-3 mb-6", children: [
            r && /* @__PURE__ */ s.jsx(mn, { provider: "google", onClick: A, children: "Continue with Google" }),
            i && /* @__PURE__ */ s.jsx(mn, { provider: "github", onClick: z, children: "Continue with GitHub" })
          ] })
        ] }),
        /* @__PURE__ */ s.jsxs("p", { className: "text-center text-slate-600", children: [
          "Don't have an account?",
          " ",
          /* @__PURE__ */ s.jsx(
            _,
            {
              to: "/signup",
              className: "text-accent-600 hover:text-accent-700 font-semibold transition-colors",
              children: "Sign up"
            }
          )
        ] })
      ] })
    )
  ] });
}
function bb({
  logo: e,
  productName: t,
  plans: n = {},
  showGoogleAuth: a = !0,
  showGithubAuth: r = !0,
  homePath: i = "/",
  termsUrl: o = "/terms",
  privacyUrl: l = "/privacy",
  showMarketingConsent: d = !0,
  marketingConsentLabel: c,
  className: u = ""
}) {
  const [h] = Ee(), m = h.get("plan"), x = h.get("invite"), f = h.get("email"), [p, y] = j(""), [b, k] = j(f || ""), [g, v] = j(""), [C, w] = j(""), [D, P] = j(""), [$, I] = j(!1), [V, H] = j(!1), [K, U] = j(""), [te, ne] = j(!1), [se, A] = j(!1), [z, R] = j(!1), { signup: N, googleAuth: L, githubAuth: M } = Ne(), F = Be(), G = async (q) => {
    var Z, ge;
    if (q.preventDefault(), U(""), C.length < 8) {
      U("Password must be at least 8 characters"), ee.error("Password must be at least 8 characters");
      return;
    }
    if (C !== D) {
      U("Passwords do not match"), ee.error("Passwords do not match");
      return;
    }
    A(!0);
    try {
      await N(
        b,
        C,
        p,
        g || `${p}'s Team`,
        x || void 0,
        $,
        V
      ), ne(!0), x ? ee.success(
        "Account created and team invite accepted! Check your email to verify."
      ) : ee.success("Account created! Check your email to verify.");
    } catch (_e) {
      const ie = ((ge = (Z = _e.response) == null ? void 0 : Z.data) == null ? void 0 : ge.detail) || "Failed to create account";
      if (ie.toLowerCase().includes("email already exists") || ie.toLowerCase().includes("already registered")) {
        R(!0);
        return;
      }
      U(ie), ee.error(ie);
    } finally {
      A(!1);
    }
  };
  return z ? /* @__PURE__ */ s.jsxs("div", { className: `auth-layout ${u}`, children: [
    /* @__PURE__ */ s.jsx("div", { className: "absolute top-0 left-1/4 w-96 h-96 bg-accent-500/5 rounded-full blur-3xl" }),
    /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-gradient-to-br from-rose-500 to-pink-600 rounded-2xl flex items-center justify-center mb-6 shadow-lg", children: /* @__PURE__ */ s.jsx(
        "svg",
        {
          className: "w-8 h-8 text-white",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children: /* @__PURE__ */ s.jsx(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
            }
          )
        }
      ) }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm font-medium text-rose-600 mb-2", children: "Rose Labs" }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-4", children: "You already have an account" }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-slate-600 mb-6", children: [
        "The email",
        " ",
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-900 font-medium", children: b }),
        " is already registered. Sign in to activate ",
        t,
        " and get started."
      ] }),
      /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "primary",
          onClick: () => F("/login"),
          className: "w-full mb-3",
          children: [
            "Sign in to activate ",
            t
          ]
        }
      ),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: () => R(!1),
          className: "text-sm text-slate-500 hover:text-slate-700 transition-colors",
          children: "Use a different email"
        }
      )
    ] }) })
  ] }) : te ? /* @__PURE__ */ s.jsxs("div", { className: `auth-layout ${u}`, children: [
    /* @__PURE__ */ s.jsx("div", { className: "absolute top-0 left-1/4 w-96 h-96 bg-accent-500/5 rounded-full blur-3xl" }),
    /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-100 rounded-2xl flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(ke, { className: "w-8 h-8 text-green-600" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-4", children: x ? "Welcome to the team!" : "Check your email" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 mb-6", children: x ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        "Your team invite has been accepted. We've sent a verification link to",
        " ",
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-900 font-medium", children: b }),
        ". Please verify your email to get started."
      ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        "We've sent a verification link to",
        " ",
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-900 font-medium", children: b }),
        ". Please check your inbox and click the link to verify your account."
      ] }) }),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          onClick: () => F("/login"),
          className: "w-full",
          children: "Go to login"
        }
      )
    ] }) })
  ] }) : /* @__PURE__ */ s.jsxs("div", { className: `auth-layout ${u}`, children: [
    /* @__PURE__ */ s.jsx("div", { className: "absolute top-0 left-1/4 w-96 h-96 bg-accent-500/5 rounded-full blur-3xl" }),
    /* @__PURE__ */ s.jsx("div", { className: "absolute bottom-0 right-1/4 w-96 h-96 bg-slate-500/5 rounded-full blur-3xl" }),
    /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
      /* @__PURE__ */ s.jsx(_, { to: i, className: "block auth-logo", children: e }),
      /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: "Get started" }),
      m && n[m] ? /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-slate-600", children: "Create your account to get started with" }),
        /* @__PURE__ */ s.jsxs("div", { className: "inline-flex items-center gap-2 px-3 py-1.5 bg-accent-50 border border-accent-200 rounded-lg mt-2", children: [
          /* @__PURE__ */ s.jsx("span", { className: "text-accent-700 font-semibold", children: n[m].name }),
          /* @__PURE__ */ s.jsx("span", { className: "text-slate-400", children: "•" }),
          /* @__PURE__ */ s.jsx("span", { className: "text-slate-600", children: n[m].price })
        ] })
      ] }) : /* @__PURE__ */ s.jsxs("p", { className: "auth-subtitle", children: [
        "Create your free ",
        t,
        " account"
      ] }),
      K && /* @__PURE__ */ s.jsx(Zt, { variant: "error", className: "mb-6", children: K }),
      /* @__PURE__ */ s.jsxs("form", { onSubmit: G, className: "space-y-5", children: [
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "name", children: "Full Name" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "name",
              type: "text",
              value: p,
              onChange: (q) => y(q.target.value),
              required: !0,
              placeholder: "John Doe"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "email", children: "Email" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "email",
              type: "email",
              value: b,
              onChange: (q) => k(q.target.value),
              required: !0,
              readOnly: !!f,
              className: f ? "opacity-75 cursor-not-allowed" : "",
              placeholder: "you@example.com"
            }
          ),
          f && /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xs text-slate-500", children: "Email is pre-filled from your invitation" })
        ] }),
        !x && /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "teamName", children: "Team Name" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "teamName",
              type: "text",
              value: g,
              onChange: (q) => v(q.target.value),
              placeholder: `${p || "Your"}'s Team`
            }
          ),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xs text-slate-500", children: "Leave empty to use your name" })
        ] }),
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "password", children: "Password" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "password",
              type: "password",
              value: C,
              onChange: (q) => w(q.target.value),
              required: !0,
              minLength: 8,
              placeholder: "••••••••"
            }
          ),
          /* @__PURE__ */ s.jsx("p", { className: "mt-2 text-xs text-slate-500", children: "Must be at least 8 characters" })
        ] }),
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "confirmPassword", children: "Confirm Password" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "confirmPassword",
              type: "password",
              value: D,
              onChange: (q) => P(q.target.value),
              required: !0,
              minLength: 8,
              placeholder: "••••••••"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(Q, { children: /* @__PURE__ */ s.jsxs("label", { className: "flex items-start gap-3 cursor-pointer", children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              type: "checkbox",
              checked: $,
              onChange: (q) => I(q.target.checked),
              className: "mt-1 h-4 w-4 rounded border-slate-300 text-accent-600 focus:ring-accent-500"
            }
          ),
          /* @__PURE__ */ s.jsxs("span", { className: "text-sm text-slate-600", children: [
            "I agree to the",
            " ",
            /* @__PURE__ */ s.jsx(
              _,
              {
                to: o,
                className: "text-accent-600 hover:underline",
                target: "_blank",
                rel: "noopener noreferrer",
                children: "Terms of Service"
              }
            ),
            " ",
            "and",
            " ",
            /* @__PURE__ */ s.jsx(
              _,
              {
                to: l,
                className: "text-accent-600 hover:underline",
                target: "_blank",
                rel: "noopener noreferrer",
                children: "Privacy Policy"
              }
            )
          ] })
        ] }) }),
        d && /* @__PURE__ */ s.jsx(Q, { children: /* @__PURE__ */ s.jsxs("label", { className: "flex items-start gap-3 cursor-pointer", children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              type: "checkbox",
              checked: V,
              onChange: (q) => H(q.target.checked),
              className: "mt-1 h-4 w-4 rounded border-slate-300 text-accent-600 focus:ring-accent-500"
            }
          ),
          /* @__PURE__ */ s.jsx("span", { className: "text-sm text-slate-600", children: c || "I'd like to receive product updates and announcements" })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          S,
          {
            type: "submit",
            variant: "primary",
            size: "lg",
            className: "w-full",
            disabled: se || !$,
            children: se ? "Creating account..." : "Create account"
          }
        )
      ] }),
      (a || r) && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(Fd, {}),
        /* @__PURE__ */ s.jsxs("div", { className: "space-y-3 mb-6", children: [
          a && /* @__PURE__ */ s.jsx(mn, { provider: "google", onClick: L }),
          r && /* @__PURE__ */ s.jsx(mn, { provider: "github", onClick: M })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-center text-slate-600", children: [
        "Already have an account?",
        " ",
        /* @__PURE__ */ s.jsx(
          _,
          {
            to: "/login",
            className: "text-accent-600 hover:text-accent-700 font-semibold transition-colors",
            children: "Sign in"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "mt-6 text-center", children: /* @__PURE__ */ s.jsx(
        _,
        {
          to: i,
          className: "text-sm text-slate-500 hover:text-slate-700 transition-colors",
          children: "← Back to home"
        }
      ) })
    ] }) })
  ] });
}
function jb({
  logo: e,
  className: t = ""
}) {
  const [n, a] = j(""), [r, i] = j(!1), [o, l] = j(!1), { forgotPassword: d } = Ne(), c = async (u) => {
    var h, m;
    u.preventDefault(), i(!0);
    try {
      await d(n), l(!0), ee.success("Password reset link sent!");
    } catch (x) {
      const f = x;
      ee.error(
        ((m = (h = f.response) == null ? void 0 : h.data) == null ? void 0 : m.detail) || "Failed to send reset link"
      );
    } finally {
      i(!1);
    }
  };
  return /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: "Reset password" }),
    /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: o ? "Check your email for reset instructions" : "Enter your email and we'll send you a reset link" }),
    o ? /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(nt, { className: "w-8 h-8 text-green-500" }) }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700 mb-6", children: [
        "We've sent a password reset link to",
        " ",
        /* @__PURE__ */ s.jsx("span", { className: "font-semibold text-slate-900", children: n })
      ] }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-slate-500 mb-6", children: [
        "Didn't receive the email? Check your spam folder or",
        " ",
        /* @__PURE__ */ s.jsx(
          "button",
          {
            onClick: () => l(!1),
            className: "text-primary-600 hover:text-primary-700 transition-colors",
            children: "try again"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Back to login" }) })
    ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsxs("form", { onSubmit: c, className: "space-y-6", children: [
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "email", children: "Email address" }),
          /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ s.jsx(ke, { className: "absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" }),
            /* @__PURE__ */ s.jsx(
              re,
              {
                id: "email",
                type: "email",
                value: n,
                onChange: (u) => a(u.target.value),
                required: !0,
                className: "pl-12",
                placeholder: "you@example.com"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ s.jsx(
          S,
          {
            type: "submit",
            variant: "primary",
            size: "lg",
            className: "w-full",
            disabled: r,
            children: r ? "Sending..." : "Send reset link"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "mt-6 text-center", children: /* @__PURE__ */ s.jsxs(
        _,
        {
          to: "/login",
          className: "inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 transition-colors",
          children: [
            /* @__PURE__ */ s.jsx(rt, { className: "w-4 h-4" }),
            "Back to login"
          ]
        }
      ) })
    ] })
  ] }) }) });
}
function vb({
  logo: e,
  className: t = ""
}) {
  const [n, a] = j(""), [r, i] = j(""), [o, l] = j(!1), [d, c] = j(!1), [u, h] = j(!1), [m, x] = j(!1), [f, p] = j(""), y = Be(), [b] = Ee(), { resetPassword: k } = Ne(), g = b.get("token"), v = [
    { label: "At least 8 characters", valid: n.length >= 8 },
    { label: "Contains uppercase letter", valid: /[A-Z]/.test(n) },
    { label: "Contains lowercase letter", valid: /[a-z]/.test(n) },
    { label: "Contains number", valid: /[0-9]/.test(n) }
  ], C = v.every((P) => P.valid), w = n === r && r.length > 0, D = async (P) => {
    var $, I;
    if (P.preventDefault(), p(""), !C) {
      p("Please meet all password requirements");
      return;
    }
    if (!w) {
      p("Passwords do not match");
      return;
    }
    h(!0);
    try {
      await k(g, n), x(!0), ee.success("Password reset successfully!");
    } catch (V) {
      p(((I = ($ = V.response) == null ? void 0 : $.data) == null ? void 0 : I.detail) || "Failed to reset password");
    } finally {
      h(!1);
    }
  };
  return g ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: m ? "Password reset!" : "Create new password" }),
    /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: m ? "Your password has been successfully reset" : "Enter your new password below" }),
    m ? /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(nt, { className: "w-8 h-8 text-green-500" }) }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 mb-6", children: "You can now sign in with your new password." }),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          size: "lg",
          className: "w-full",
          onClick: () => y("/login"),
          children: "Go to login"
        }
      )
    ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      f && /* @__PURE__ */ s.jsx(Zt, { variant: "error", className: "mb-6", children: f }),
      /* @__PURE__ */ s.jsxs("form", { onSubmit: D, className: "space-y-6", children: [
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "password", children: "New password" }),
          /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ s.jsx(pt, { className: "absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" }),
            /* @__PURE__ */ s.jsx(
              re,
              {
                id: "password",
                type: o ? "text" : "password",
                value: n,
                onChange: (P) => a(P.target.value),
                required: !0,
                className: "pl-12 pr-12",
                placeholder: "••••••••"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                type: "button",
                onClick: () => l(!o),
                className: "absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors",
                children: o ? /* @__PURE__ */ s.jsx(ys, { className: "w-5 h-5" }) : /* @__PURE__ */ s.jsx(xt, { className: "w-5 h-5" })
              }
            )
          ] }),
          /* @__PURE__ */ s.jsx("div", { className: "mt-3 space-y-1", children: v.map((P) => /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: `flex items-center gap-2 text-xs ${P.valid ? "text-green-600" : "text-slate-400"}`,
              children: [
                /* @__PURE__ */ s.jsx(
                  nt,
                  {
                    className: `w-3 h-3 ${P.valid ? "opacity-100" : "opacity-30"}`
                  }
                ),
                P.label
              ]
            },
            P.label
          )) })
        ] }),
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "confirmPassword", children: "Confirm new password" }),
          /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ s.jsx(pt, { className: "absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" }),
            /* @__PURE__ */ s.jsx(
              re,
              {
                id: "confirmPassword",
                type: d ? "text" : "password",
                value: r,
                onChange: (P) => i(P.target.value),
                required: !0,
                className: `pl-12 pr-12 ${r && !w ? "border-red-500 focus:ring-red-500" : r && w ? "border-green-500 focus:ring-green-500" : ""}`,
                placeholder: "••••••••"
              }
            ),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                type: "button",
                onClick: () => c(!d),
                className: "absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors",
                children: d ? /* @__PURE__ */ s.jsx(ys, { className: "w-5 h-5" }) : /* @__PURE__ */ s.jsx(xt, { className: "w-5 h-5" })
              }
            )
          ] }),
          r && !w && /* @__PURE__ */ s.jsx("p", { className: "mt-1 text-xs text-red-500", children: "Passwords do not match" })
        ] }),
        /* @__PURE__ */ s.jsx(
          S,
          {
            type: "submit",
            variant: "primary",
            size: "lg",
            className: "w-full",
            disabled: u || !C || !w,
            children: u ? "Resetting..." : "Reset password"
          }
        )
      ] })
    ] })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Invalid Reset Link" }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 mb-6", children: "This password reset link is invalid or has expired. Please request a new one." }),
    /* @__PURE__ */ s.jsx(_, { to: "/forgot-password", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Request new link" }) })
  ] }) }) });
}
const Oa = "verified_email_tokens";
function Zo(e) {
  try {
    const t = sessionStorage.getItem(Oa);
    return t ? JSON.parse(t).includes(e) : !1;
  } catch {
    return !1;
  }
}
function wb(e) {
  try {
    const t = sessionStorage.getItem(Oa), n = t ? JSON.parse(t) : [];
    n.includes(e) || (n.push(e), sessionStorage.setItem(Oa, JSON.stringify(n)));
  } catch {
  }
}
function Nb({
  logo: e,
  className: t = ""
}) {
  const [n, a] = j(!0), [r, i] = j(!1), [o, l] = j(""), [d] = Ee(), { verifyEmail: c } = Ne(), u = d.get("token");
  return le(() => {
    u && !Zo(u) ? (wb(u), (async () => {
      var m, x;
      try {
        await c(u), a(!1), i(!0), ee.success("Email verified successfully!");
      } catch (f) {
        const p = f;
        a(!1), i(!1), l(
          ((x = (m = p.response) == null ? void 0 : m.data) == null ? void 0 : x.detail) || "This verification link is invalid or has expired. Please request a new one."
        ), ee.error("Verification failed");
      }
    })()) : u && Zo(u) ? (a(!1), i(!0)) : u || a(!1);
  }, [u, c]), n && u ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto mb-6", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Verifying your email" }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500", children: "Please wait while we verify your email address..." })
  ] }) }) }) : u ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    r ? /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(nt, { className: "w-8 h-8 text-green-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Email verified!" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: "Your email has been successfully verified. You can now sign in to your account." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] }) : /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Verification failed" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: o || "This verification link is invalid or has expired. Please request a new one." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Back to login" }) })
    ] })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: "Verify your email" }),
    /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: "Check your inbox for a verification link" }),
    /* @__PURE__ */ s.jsx("div", { className: "w-20 h-20 mx-auto bg-accent-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(ke, { className: "w-10 h-10 text-accent-500" }) }),
    /* @__PURE__ */ s.jsx("p", { className: "text-center text-slate-600 mb-6", children: "We've sent a verification email to your inbox. Click the link in the email to verify your account." }),
    /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Back to login" }) }),
    /* @__PURE__ */ s.jsx("p", { className: "mt-6 text-center text-sm text-slate-400", children: "Didn't receive the email? Check your spam folder." })
  ] }) }) });
}
function kb({
  logo: e,
  className: t = ""
}) {
  const [n, a] = j(!1), [r] = Ee(), i = r.get("email") || "", { resendVerificationEmail: o } = Ne(), l = async () => {
    var d, c;
    if (!i) {
      ee.error("Email address not provided");
      return;
    }
    a(!0);
    try {
      await o(i), ee.success("Verification email sent! Please check your inbox.");
    } catch (u) {
      const m = ((c = (d = u.response) == null ? void 0 : d.data) == null ? void 0 : c.detail) || "Failed to send verification email";
      ee.error(m);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: "Verify your email" }),
    /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: "Email verification required to continue" }),
    /* @__PURE__ */ s.jsx("div", { className: "w-20 h-20 mx-auto bg-amber-500/10 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(ke, { className: "w-10 h-10 text-amber-400" }) }),
    /* @__PURE__ */ s.jsx("p", { className: "text-center text-slate-700 mb-2", children: "Please verify your email address before logging in." }),
    i && /* @__PURE__ */ s.jsxs("p", { className: "text-center text-slate-600 text-sm mb-6", children: [
      "We'll send a verification link to",
      " ",
      /* @__PURE__ */ s.jsx("span", { className: "text-slate-900 font-medium", children: i })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          size: "lg",
          className: "w-full flex items-center justify-center gap-2",
          onClick: l,
          disabled: n || !i,
          children: n ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(bs, { className: "w-4 h-4 animate-spin" }),
            "Sending..."
          ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(bs, { className: "w-4 h-4" }),
            "Send verification email"
          ] })
        }
      ),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "outline", size: "lg", className: "w-full", children: "Back to login" }) })
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "mt-6 text-center text-sm text-slate-500", children: [
      "Already verified?",
      " ",
      /* @__PURE__ */ s.jsx(_, { to: "/login", className: "text-accent-600 hover:text-accent-700", children: "Try logging in again" })
    ] })
  ] }) }) });
}
const Va = "verified_email_change_tokens";
function Qo(e) {
  try {
    const t = sessionStorage.getItem(Va);
    return t ? JSON.parse(t).includes(e) : !1;
  } catch {
    return !1;
  }
}
function Cb(e) {
  try {
    const t = sessionStorage.getItem(Va), n = t ? JSON.parse(t) : [];
    n.includes(e) || (n.push(e), sessionStorage.setItem(Va, JSON.stringify(n)));
  } catch {
  }
}
function Tb({
  logo: e,
  className: t = "",
  loginPath: n = "/login"
}) {
  const { verifyEmailChange: a } = Ne(), [r, i] = j(!0), [o, l] = j(!1), [d, c] = j(""), [u] = Ee(), h = u.get("token");
  return le(() => {
    h && !Qo(h) ? (Cb(h), (async () => {
      var x, f;
      try {
        await a(h), i(!1), l(!0), ee.success("Email changed successfully!");
      } catch (p) {
        const y = p;
        i(!1), l(!1), c(
          ((f = (x = y.response) == null ? void 0 : x.data) == null ? void 0 : f.detail) || "This verification link is invalid or has expired."
        ), ee.error("Verification failed");
      }
    })()) : h && Qo(h) ? (i(!1), l(!0)) : h || i(!1);
  }, [h, a]), r && h ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto mb-6", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Verifying your new email" }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500", children: "Please wait while we verify your new email address..." })
  ] }) }) }) : h ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    o ? /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(nt, { className: "w-8 h-8 text-green-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Email changed!" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: "Your email address has been successfully updated. You can now sign in with your new email." }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-400 mb-6", children: "For security, all your active sessions have been signed out." }),
      /* @__PURE__ */ s.jsx(_, { to: n, children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] }) : /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Verification failed" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: d || "This verification link is invalid or has expired." }),
      /* @__PURE__ */ s.jsx(_, { to: n, children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Back to login" }) })
    ] })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: "Verify your new email" }),
    /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: "Click the link in your verification email" }),
    /* @__PURE__ */ s.jsx("div", { className: "w-20 h-20 mx-auto bg-accent-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(ke, { className: "w-10 h-10 text-accent-500" }) }),
    /* @__PURE__ */ s.jsx("p", { className: "text-center text-slate-600 mb-6", children: "We've sent a verification email to your new email address. Click the link in the email to complete the change." }),
    /* @__PURE__ */ s.jsx(_, { to: n, children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Back to login" }) }),
    /* @__PURE__ */ s.jsx("p", { className: "mt-6 text-center text-sm text-slate-400", children: "Didn't receive the email? Check your spam folder or request a new one from your account settings." })
  ] }) }) });
}
function Sb({
  logo: e,
  dashboardPath: t = "/dashboard"
}) {
  const n = Be(), [a] = Ee(), { handleOAuthCallback: r } = Ne(), [i, o] = j(null);
  return le(() => {
    const l = a.get("access_token"), d = a.get("refresh_token");
    if (!l || !d) {
      o("Missing authentication tokens");
      return;
    }
    (async () => {
      try {
        await r(l, d, ""), n(t, { replace: !0 });
      } catch (u) {
        console.error("Impersonation failed:", u), o("Failed to authenticate. Please try again.");
      }
    })();
  }, [a, r, n, t]), i ? /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4", children: [
    e && /* @__PURE__ */ s.jsx("div", { className: "mb-8", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "bg-white p-8 rounded-xl shadow-sm border border-slate-200 max-w-md w-full text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4", children: /* @__PURE__ */ s.jsx(
        "svg",
        {
          className: "w-6 h-6 text-red-600",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children: /* @__PURE__ */ s.jsx(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M6 18L18 6M6 6l12 12"
            }
          )
        }
      ) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-xl font-semibold text-slate-900 mb-2", children: "Impersonation Failed" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 mb-6", children: i }),
      /* @__PURE__ */ s.jsx(
        "a",
        {
          href: "/login",
          className: "inline-flex items-center justify-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors",
          children: "Go to Login"
        }
      )
    ] })
  ] }) : /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4", children: [
    e && /* @__PURE__ */ s.jsx("div", { className: "mb-8", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "bg-white p-8 rounded-xl shadow-sm border border-slate-200 max-w-md w-full text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "spinner spinner-lg mx-auto mb-4" }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-xl font-semibold text-slate-900 mb-2", children: "Authenticating..." }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-600", children: "Please wait while we log you in." })
    ] })
  ] });
}
const Ba = "processed_security_confirm_tokens";
function el(e) {
  try {
    const t = sessionStorage.getItem(Ba);
    return t ? JSON.parse(t).includes(e) : !1;
  } catch {
    return !1;
  }
}
function Ab(e) {
  try {
    const t = sessionStorage.getItem(Ba), n = t ? JSON.parse(t) : [];
    n.includes(e) || (n.push(e), sessionStorage.setItem(Ba, JSON.stringify(n)));
  } catch {
  }
}
function Pb({
  logo: e,
  securityConfirm: t,
  className: n = ""
}) {
  const [a, r] = j(!0), [i, o] = j(!1), [l, d] = j(""), [c, u] = j(null), [h] = Ee(), m = h.get("token");
  return le(() => {
    m && !el(m) ? (Ab(m), (async () => {
      var f, p;
      try {
        const y = await t(m);
        r(!1), o(!0), y.lockout_expires_in_minutes && u(y.lockout_expires_in_minutes), ee.success("Thanks for confirming!");
      } catch (y) {
        const b = y;
        r(!1), o(!1), d(
          ((p = (f = b.response) == null ? void 0 : f.data) == null ? void 0 : p.detail) || "This link is invalid or has expired."
        ), ee.error("Confirmation failed");
      }
    })()) : m && el(m) ? (r(!1), o(!0)) : m || r(!1);
  }, [m, t]), a && m ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto mb-6", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Processing your response" }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500", children: "Please wait..." })
  ] }) }) }) : m ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    i ? /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(nt, { className: "w-8 h-8 text-green-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Thanks for confirming" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-4", children: "We've noted that the login attempts were yours." }),
      c && c > 0 && /* @__PURE__ */ s.jsx("div", { className: "bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 text-amber-700", children: [
        /* @__PURE__ */ s.jsx(ft, { className: "w-5 h-5" }),
        /* @__PURE__ */ s.jsxs("span", { className: "font-medium", children: [
          "Your temporary lockout will expire in ",
          c,
          " ",
          "minute",
          c !== 1 ? "s" : "",
          "."
        ] })
      ] }) }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] }) : /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Unable to process" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: l || "This link is invalid or has expired." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Invalid link" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: "This security link is missing required information." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] })
  ] }) }) });
}
const za = "processed_security_deny_tokens";
function tl(e) {
  try {
    const t = sessionStorage.getItem(za);
    return t ? JSON.parse(t).includes(e) : !1;
  } catch {
    return !1;
  }
}
function Eb(e) {
  try {
    const t = sessionStorage.getItem(za), n = t ? JSON.parse(t) : [];
    n.includes(e) || (n.push(e), sessionStorage.setItem(za, JSON.stringify(n)));
  } catch {
  }
}
function Rb({
  logo: e,
  securityDeny: t,
  className: n = ""
}) {
  const [a, r] = j(!0), [i, o] = j(!1), [l, d] = j(""), [c] = Ee(), u = c.get("token");
  return le(() => {
    u && !tl(u) ? (Eb(u), (async () => {
      var m, x;
      try {
        await t(u), r(!1), o(!0), ee.success("Account secured");
      } catch (f) {
        const p = f;
        r(!1), o(!1), d(
          ((x = (m = p.response) == null ? void 0 : m.data) == null ? void 0 : x.detail) || "This link is invalid or has expired."
        ), ee.error("Unable to secure account");
      }
    })()) : u && tl(u) ? (r(!1), o(!0)) : u || r(!1);
  }, [u, t]), a && u ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto mb-6", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Securing your account" }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500", children: "Please wait..." })
  ] }) }) }) : u ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    i ? /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(js, { className: "w-8 h-8 text-green-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Account secured" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-4", children: "Your account has been locked for your protection. All active sessions have been revoked." }),
      /* @__PURE__ */ s.jsx("div", { className: "bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6", children: /* @__PURE__ */ s.jsx("p", { className: "text-blue-700 text-sm", children: "To regain access, please reset your password using the link below." }) }),
      /* @__PURE__ */ s.jsx(_, { to: "/forgot-password", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Reset password" }) })
    ] }) : /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Unable to process" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: l || "This link is invalid or has expired." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Invalid link" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: "This security link is missing required information." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] })
  ] }) }) });
}
const Ua = "processed_device_confirm_tokens";
function sl(e) {
  try {
    const t = sessionStorage.getItem(Ua);
    return t ? JSON.parse(t).includes(e) : !1;
  } catch {
    return !1;
  }
}
function Db(e) {
  try {
    const t = sessionStorage.getItem(Ua), n = t ? JSON.parse(t) : [];
    n.includes(e) || (n.push(e), sessionStorage.setItem(Ua, JSON.stringify(n)));
  } catch {
  }
}
function _b({
  logo: e,
  deviceConfirm: t,
  className: n = ""
}) {
  const [a, r] = j(!0), [i, o] = j(!1), [l, d] = j(null), [c, u] = j(""), [h] = Ee(), m = h.get("token");
  return le(() => {
    m && !sl(m) ? (Db(m), (async () => {
      var f, p;
      try {
        const y = await t(m);
        r(!1), o(!0), d(y.device_name), ee.success("Device confirmed");
      } catch (y) {
        const b = y;
        r(!1), o(!1), u(
          ((p = (f = b.response) == null ? void 0 : f.data) == null ? void 0 : p.detail) || "This link is invalid or has expired."
        ), ee.error("Unable to confirm device");
      }
    })()) : m && sl(m) ? (r(!1), o(!0)) : m || r(!1);
  }, [m, t]), a && m ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto mb-6", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Confirming device" }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500", children: "Please wait..." })
  ] }) }) }) : m ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    i ? /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(nt, { className: "w-8 h-8 text-green-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Device confirmed" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-4", children: "You've confirmed that the login was you. This device is now trusted." }),
      l && /* @__PURE__ */ s.jsxs("div", { className: "bg-slate-50 border border-slate-200 rounded-lg p-4 mb-6 flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx(nf, { className: "w-5 h-5 text-slate-400" }),
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-700", children: l })
      ] }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Continue to login" }) })
    ] }) : /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Unable to confirm" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: c || "This link is invalid or has expired." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Invalid link" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: "This confirmation link is missing required information." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] })
  ] }) }) });
}
const qa = "processed_device_report_tokens";
function nl(e) {
  try {
    const t = sessionStorage.getItem(qa);
    return t ? JSON.parse(t).includes(e) : !1;
  } catch {
    return !1;
  }
}
function Mb(e) {
  try {
    const t = sessionStorage.getItem(qa), n = t ? JSON.parse(t) : [];
    n.includes(e) || (n.push(e), sessionStorage.setItem(qa, JSON.stringify(n)));
  } catch {
  }
}
function Fb({
  logo: e,
  deviceReport: t,
  className: n = ""
}) {
  const [a, r] = j(!0), [i, o] = j(!1), [l, d] = j(""), [c] = Ee(), u = c.get("token");
  return le(() => {
    u && !nl(u) ? (Mb(u), (async () => {
      var m, x;
      try {
        await t(u), r(!1), o(!0), ee.success("Account secured");
      } catch (f) {
        const p = f;
        r(!1), o(!1), d(
          ((x = (m = p.response) == null ? void 0 : m.data) == null ? void 0 : x.detail) || "This link is invalid or has expired."
        ), ee.error("Unable to secure account");
      }
    })()) : u && nl(u) ? (r(!1), o(!0)) : u || r(!1);
  }, [u, t]), a && u ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto mb-6", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Securing your account" }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500", children: "Please wait..." })
  ] }) }) }) : u ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    i ? /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-green-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(js, { className: "w-8 h-8 text-green-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Account secured" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-4", children: "We've flagged this login as suspicious and taken security measures to protect your account." }),
      /* @__PURE__ */ s.jsx("div", { className: "bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6", children: /* @__PURE__ */ s.jsx("p", { className: "text-amber-700 text-sm", children: "All active sessions have been revoked. Please reset your password to continue using your account." }) }),
      /* @__PURE__ */ s.jsx(_, { to: "/forgot-password", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Reset password" }) })
    ] }) : /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Unable to process" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: l || "This link is invalid or has expired." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${n}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Invalid link" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: "This security link is missing required information." }),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Go to login" }) })
    ] })
  ] }) }) });
}
function Lb({
  logo: e,
  productName: t,
  deletionDays: n = 30,
  className: a = ""
}) {
  const [r] = Ee(), i = r.get("type") === "product", o = parseInt(
    r.get("days") || String(n),
    10
  );
  return /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${a}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: i ? `You've left ${t}` : "We're sad to see you go" }),
    /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: i ? "Your deletion has been scheduled" : "Your account deletion has been scheduled" }),
    /* @__PURE__ */ s.jsx(
      "div",
      {
        className: `w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6 ${i ? "bg-amber-50" : "bg-primary-50"}`,
        children: i ? /* @__PURE__ */ s.jsx(Qa, { className: "w-10 h-10 text-amber-600" }) : /* @__PURE__ */ s.jsx(Jm, { className: "w-10 h-10 text-primary-600" })
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: "space-y-4 text-center mb-6", children: i ? (
      // Product-scoped message - scheduled deletion with grace period
      /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700", children: [
          "Your ",
          t,
          " data and teams will be permanently deleted in",
          " ",
          /* @__PURE__ */ s.jsxs("span", { className: "font-bold text-slate-900", children: [
            o,
            " days"
          ] }),
          ". Your account with other Rose Labs products remains active."
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-lg p-4 text-left", children: [
          /* @__PURE__ */ s.jsx(ke, { className: "w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" }),
          /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-amber-900", children: [
            "We've sent you an email with a reactivation link. If you change your mind, you can reactivate your ",
            t,
            " ",
            "account at any time during this period."
          ] }) })
        ] })
      ] })
    ) : (
      // Account deletion message
      /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700", children: [
          "Your account will be permanently deleted in",
          " ",
          /* @__PURE__ */ s.jsxs("span", { className: "font-bold text-slate-900", children: [
            n,
            " days"
          ] }),
          "."
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-lg p-4 text-left", children: [
          /* @__PURE__ */ s.jsx(ke, { className: "w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" }),
          /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("p", { className: "text-sm text-amber-900", children: "We've sent you an email with a reactivation link. If you change your mind, you can reactivate your account at any time during this period." }) })
        ] })
      ] })
    ) }),
    /* @__PURE__ */ s.jsx(_, { to: "/", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Return to home" }) }),
    /* @__PURE__ */ s.jsxs("p", { className: "mt-6 text-center text-sm text-slate-500", children: [
      "Thank you for using ",
      t,
      ". We hope to see you again!"
    ] })
  ] }) }) });
}
function $b({
  logo: e,
  className: t = ""
}) {
  const [n, a] = j(
    "loading"
  ), [r, i] = j(""), [o] = Ee(), l = Be(), { reactivateAccount: d } = Ne(), c = o.get("token") || "";
  return le(() => {
    let u = !0;
    return (async () => {
      var m, x;
      if (!c) {
        a("error"), i("Invalid reactivation link. No token provided.");
        return;
      }
      try {
        if (await d(c), !u) return;
        a("success"), ee.success("Account reactivated! Please log in."), setTimeout(() => {
          u && l("/login");
        }, 2e3);
      } catch (f) {
        if (!u) return;
        const y = ((x = (m = f.response) == null ? void 0 : m.data) == null ? void 0 : x.detail) || "Failed to reactivate account";
        a("error"), i(y), ee.error(y);
      }
    })(), () => {
      u = !1;
    };
  }, [c]), /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("h1", { className: "auth-title", children: [
      n === "loading" && "Reactivating Account",
      n === "success" && "Welcome Back!",
      n === "error" && "Reactivation Failed"
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "auth-subtitle", children: [
      n === "loading" && "Please wait while we restore your account...",
      n === "success" && "Your account has been restored",
      n === "error" && "Unable to reactivate your account"
    ] }),
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: `w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6 ${n === "loading" ? "bg-primary-50" : n === "success" ? "bg-green-50" : "bg-red-50"}`,
        children: [
          n === "loading" && /* @__PURE__ */ s.jsx(Gl, { className: "w-10 h-10 text-primary-600 animate-spin" }),
          n === "success" && /* @__PURE__ */ s.jsx(nt, { className: "w-10 h-10 text-green-600" }),
          n === "error" && /* @__PURE__ */ s.jsx(Wl, { className: "w-10 h-10 text-red-600" })
        ]
      }
    ),
    n === "loading" && /* @__PURE__ */ s.jsx("p", { className: "text-center text-slate-700 mb-6", children: "Verifying your reactivation token..." }),
    n === "success" && /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "Your account has been successfully reactivated. All your data has been restored." }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: "Redirecting to login..." })
    ] }),
    n === "error" && /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-2", children: r }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: "The link may have expired or already been used." })
    ] }),
    n !== "loading" && /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: n === "success" ? /* @__PURE__ */ s.jsx(
      S,
      {
        variant: "primary",
        size: "lg",
        className: "w-full",
        onClick: () => l("/login"),
        children: "Go to Login"
      }
    ) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Back to Login" }) }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-center text-sm text-slate-500", children: [
        "Need help?",
        " ",
        /* @__PURE__ */ s.jsx(
          _,
          {
            to: "/contact",
            className: "text-primary-600 hover:text-primary-700",
            children: "Contact support"
          }
        )
      ] })
    ] }) })
  ] }) }) });
}
function Ib({
  logo: e,
  productName: t,
  successRedirectPath: n = "/dashboard",
  className: a = ""
}) {
  const [r, i] = j(
    "loading"
  ), [o, l] = j(""), [d, c] = j(0), [u] = Ee(), h = Be(), { reactivateProduct: m } = Ne(), x = u.get("token") || "", f = u.get("product") || "";
  return le(() => {
    let p = !0;
    return (async () => {
      var b, k;
      if (!x) {
        i("error"), l("Invalid reactivation link. No token provided.");
        return;
      }
      if (!f) {
        i("error"), l("Invalid reactivation link. No product specified.");
        return;
      }
      try {
        const g = await m(f, x);
        if (!p) return;
        i("success"), c(g.teams_restored), ee.success(`${t} account reactivated!`), setTimeout(() => {
          p && h(n);
        }, 2e3);
      } catch (g) {
        if (!p) return;
        const C = ((k = (b = g.response) == null ? void 0 : b.data) == null ? void 0 : k.detail) || "Failed to reactivate product";
        i("error"), l(C), ee.error(C);
      }
    })(), () => {
      p = !1;
    };
  }, [x, f]), /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${a}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("h1", { className: "auth-title", children: [
      r === "loading" && `Reactivating ${t}`,
      r === "success" && "Welcome Back!",
      r === "error" && "Reactivation Failed"
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "auth-subtitle", children: [
      r === "loading" && `Please wait while we restore your ${t} access...`,
      r === "success" && `Your ${t} account has been restored`,
      r === "error" && `Unable to reactivate your ${t} access`
    ] }),
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: `w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6 ${r === "loading" ? "bg-primary-50" : r === "success" ? "bg-green-50" : "bg-red-50"}`,
        children: [
          r === "loading" && /* @__PURE__ */ s.jsx(Gl, { className: "w-10 h-10 text-primary-600 animate-spin" }),
          r === "success" && /* @__PURE__ */ s.jsx(nt, { className: "w-10 h-10 text-green-600" }),
          r === "error" && /* @__PURE__ */ s.jsx(Wl, { className: "w-10 h-10 text-red-600" })
        ]
      }
    ),
    r === "loading" && /* @__PURE__ */ s.jsx("p", { className: "text-center text-slate-700 mb-6", children: "Verifying your reactivation token..." }),
    r === "success" && /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
      /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700 mb-4", children: [
        "Your ",
        t,
        " account has been successfully reactivated.",
        d > 0 && ` ${d} team${d === 1 ? "" : "s"} restored.`
      ] }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: n === "/login" || n.includes("/login") ? "Redirecting to sign in..." : "Redirecting..." })
    ] }),
    r === "error" && /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-2", children: o }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: "The link may have expired or already been used." })
    ] }),
    r !== "loading" && /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: r === "success" ? /* @__PURE__ */ s.jsx(
      S,
      {
        variant: "primary",
        size: "lg",
        className: "w-full",
        onClick: () => h(n),
        children: "Go to Dashboard"
      }
    ) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "primary", size: "lg", className: "w-full", children: "Back to Login" }) }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-center text-sm text-slate-500", children: [
        "Need help?",
        " ",
        /* @__PURE__ */ s.jsx(
          _,
          {
            to: "/contact",
            className: "text-primary-600 hover:text-primary-700",
            children: "Contact support"
          }
        )
      ] })
    ] }) })
  ] }) }) });
}
function Ob({
  logo: e,
  className: t = ""
}) {
  const [n, a] = j(!1), [r] = Ee(), i = r.get("email") || "", o = parseInt(r.get("days") || "0", 10), { resendReactivation: l } = Ne(), d = async () => {
    var c, u;
    if (!i) {
      ee.error("Email address not provided");
      return;
    }
    a(!0);
    try {
      await l(i), ee.success("Reactivation email sent! Please check your inbox.");
    } catch (h) {
      const x = ((u = (c = h.response) == null ? void 0 : c.data) == null ? void 0 : u.detail) || "Failed to send reactivation email";
      ee.error(x);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${t}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsx("h1", { className: "auth-title", children: "Account Deleted" }),
    /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: "Your account is scheduled for deletion" }),
    /* @__PURE__ */ s.jsx("div", { className: "w-20 h-20 mx-auto bg-red-500/10 rounded-full flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx(Ze, { className: "w-10 h-10 text-red-400" }) }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-4 text-center mb-6", children: [
      /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700", children: [
        "This account will be permanently deleted in",
        " ",
        /* @__PURE__ */ s.jsxs("span", { className: "font-bold text-slate-900", children: [
          o,
          " day",
          o !== 1 ? "s" : ""
        ] }),
        "."
      ] }),
      i && /* @__PURE__ */ s.jsxs("p", { className: "text-slate-600 text-sm", children: [
        "Account:",
        " ",
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-900 font-medium", children: i })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-3 bg-primary-50 border border-primary-200 rounded-lg p-4 text-left", children: [
        /* @__PURE__ */ s.jsx(ke, { className: "w-5 h-5 text-primary-600 flex-shrink-0 mt-0.5" }),
        /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("p", { className: "text-sm text-primary-900", children: "To reactivate your account, click the reactivation link in your email. If you didn't receive it or need a new one, click the button below." }) })
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          size: "lg",
          className: "w-full flex items-center justify-center gap-2",
          onClick: d,
          disabled: n || !i,
          children: n ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(bs, { className: "w-4 h-4 animate-spin" }),
            "Sending..."
          ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(bs, { className: "w-4 h-4" }),
            "Resend reactivation email"
          ] })
        }
      ),
      /* @__PURE__ */ s.jsx(_, { to: "/login", children: /* @__PURE__ */ s.jsx(S, { variant: "outline", size: "lg", className: "w-full", children: "Back to login" }) })
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "mt-6 text-center text-sm text-slate-500", children: [
      "Changed your mind?",
      " ",
      /* @__PURE__ */ s.jsx(
        "button",
        {
          onClick: d,
          disabled: n || !i,
          className: "text-primary-600 hover:text-primary-700 disabled:opacity-50",
          children: "Click here to get a reactivation link"
        }
      )
    ] })
  ] }) }) });
}
const al = {
  owner: "Owner",
  admin: "Admin",
  member: "Member",
  viewer: "Viewer"
}, Vb = {
  owner: It,
  admin: ns,
  member: an,
  viewer: xt
}, Bb = {
  owner: "Full control over the team",
  admin: "Can manage members and billing",
  member: "Can create and manage resources",
  viewer: "Read-only access to team resources"
};
function zb({
  logo: e,
  getInviteDetails: t,
  acceptInvite: n,
  successRedirectPath: a = "/t/:teamId/dashboard",
  roleDescriptions: r,
  className: i = ""
}) {
  const { token: o } = Ha(), { user: l, isAuthenticated: d, refreshTeams: c } = Ne(), u = Be(), [h, m] = j(!0), [x, f] = j(!1), [p, y] = j(
    null
  ), [b, k] = j(null), g = {
    ...Bb,
    ...r
  };
  le(() => {
    o && v();
  }, [o]);
  const v = async () => {
    var P, $;
    if (o) {
      m(!0);
      try {
        const I = await t(o);
        y(I);
      } catch (I) {
        k(
          (($ = (P = I.response) == null ? void 0 : P.data) == null ? void 0 : $.detail) || "Invalid or expired invitation"
        );
      } finally {
        m(!1);
      }
    }
  }, C = async () => {
    var P, $;
    if (o) {
      f(!0);
      try {
        const I = await n(o);
        ee.success(`Welcome to ${p == null ? void 0 : p.team_name}!`), await c();
        const V = a.replace(
          ":teamId",
          I.team_id
        );
        u(V);
      } catch (I) {
        const V = I;
        ee.error(
          (($ = (P = V.response) == null ? void 0 : P.data) == null ? void 0 : $.detail) || "Failed to accept invitation"
        ), f(!1);
      }
    }
  }, w = (P) => new Date(P).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
  if (h)
    return /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${i}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsx("div", { className: "auth-card text-center", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }) }) });
  if (b)
    return /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${i}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-50 border border-red-200 rounded-2xl flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-500" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-4", children: "Invalid Invitation" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 mb-6", children: b }),
      /* @__PURE__ */ s.jsx(_, { to: "/", children: /* @__PURE__ */ s.jsx(S, { variant: "outline", className: "w-full", children: "Go to Home" }) })
    ] }) }) });
  if (!p)
    return null;
  const D = Vb[p.role];
  return d ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${i}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center shadow-lg mb-4", children: /* @__PURE__ */ s.jsx(yt, { className: "w-8 h-8 text-white" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Join Team" }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-slate-600", children: [
        p.invited_by_name,
        " has invited you to join"
      ] }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-900 font-semibold text-lg mt-1", children: p.team_name })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "bg-slate-50 border border-slate-200 rounded-lg p-4 mb-4", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "Signed in as" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-900 font-medium", children: l == null ? void 0 : l.email })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "bg-slate-50 border border-slate-200 rounded-lg p-4 mb-6", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
        /* @__PURE__ */ s.jsx(D, { className: "w-5 h-5 text-primary-600" }),
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-900 font-medium", children: al[p.role] })
      ] }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: g[p.role] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-center gap-2 text-sm text-slate-500 mb-6", children: [
      /* @__PURE__ */ s.jsx(ft, { className: "w-4 h-4" }),
      /* @__PURE__ */ s.jsxs("span", { children: [
        "Expires ",
        w(p.expires_at)
      ] })
    ] }),
    /* @__PURE__ */ s.jsx(
      S,
      {
        variant: "primary",
        onClick: C,
        disabled: x,
        className: "w-full",
        children: x ? "Joining..." : "Accept Invitation"
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: "mt-4 text-center", children: /* @__PURE__ */ s.jsx(
      _,
      {
        to: "/",
        className: "text-sm text-slate-500 hover:text-slate-700 transition-colors",
        children: "Decline and go home"
      }
    ) })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${i}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center shadow-lg mb-4", children: /* @__PURE__ */ s.jsx(yt, { className: "w-8 h-8 text-white" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "You're Invited!" }),
      /* @__PURE__ */ s.jsxs("p", { className: "text-slate-600", children: [
        p.invited_by_name,
        " has invited you to join"
      ] }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-900 font-semibold text-lg mt-1", children: p.team_name })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "bg-slate-50 border border-slate-200 rounded-lg p-4 mb-6", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
        /* @__PURE__ */ s.jsx(D, { className: "w-5 h-5 text-primary-600" }),
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-900 font-medium", children: al[p.role] })
      ] }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-600", children: g[p.role] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-center gap-2 text-sm text-slate-500 mb-6", children: [
      /* @__PURE__ */ s.jsx(ft, { className: "w-4 h-4" }),
      /* @__PURE__ */ s.jsxs("span", { children: [
        "Expires ",
        w(p.expires_at)
      ] })
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: p.user_exists ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(_, { to: `/login?invite=${o}`, children: /* @__PURE__ */ s.jsx(S, { variant: "primary", className: "w-full", children: "Sign in to Accept" }) }),
      /* @__PURE__ */ s.jsx("p", { className: "text-center text-sm text-slate-500", children: "Already have an account? Sign in to accept this invitation." })
    ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        _,
        {
          to: `/signup?invite=${o}&email=${encodeURIComponent(p.email)}`,
          children: /* @__PURE__ */ s.jsx(S, { variant: "primary", className: "w-full", children: "Create Account to Accept" })
        }
      ),
      /* @__PURE__ */ s.jsxs("p", { className: "text-center text-sm text-slate-500", children: [
        "Create a free account with ",
        p.email,
        " to join the team."
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx("div", { className: "mt-6 text-center", children: /* @__PURE__ */ s.jsx(
      _,
      {
        to: "/",
        className: "text-sm text-slate-500 hover:text-slate-700 transition-colors",
        children: "← Back to home"
      }
    ) })
  ] }) }) });
}
function Ub({
  logo: e,
  acceptOwnershipTransfer: t,
  successRedirectPath: n = "/t/:teamId/settings",
  dashboardPath: a = "/dashboard",
  className: r = ""
}) {
  const { token: i } = Ha(), { isAuthenticated: o, isLoading: l } = Ne(), d = Be(), [c, u] = j(!1), [h, m] = j(null);
  le(() => {
    if (!l && !o) {
      const f = `/transfer/accept/${i}`;
      d(`/login?redirect=${encodeURIComponent(f)}`);
    }
  }, [o, l, i, d]);
  const x = async () => {
    var f, p;
    if (i) {
      u(!0);
      try {
        const y = await t(i);
        ee.success(`You are now the owner of ${y.team_name}!`);
        const b = n.replace(
          ":teamId",
          y.team_id
        );
        d(b);
      } catch (y) {
        const k = ((p = (f = y.response) == null ? void 0 : f.data) == null ? void 0 : p.detail) || "Failed to accept ownership transfer";
        ee.error(k), m(k), u(!1);
      }
    }
  };
  return l || !o ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${r}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsx("div", { className: "auth-card text-center", children: /* @__PURE__ */ s.jsx(he, { size: "lg" }) }) }) }) : h ? /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${r}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card text-center", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-red-500/10 border border-red-500/30 rounded-2xl flex items-center justify-center mb-6", children: /* @__PURE__ */ s.jsx($e, { className: "w-8 h-8 text-red-400" }) }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-4", children: "Transfer Failed" }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-6", children: h }),
    /* @__PURE__ */ s.jsx(_, { to: a, children: /* @__PURE__ */ s.jsx(S, { variant: "outline", className: "w-full", children: "Go to Dashboard" }) })
  ] }) }) }) : /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${r}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: "/", className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center shadow-lg mb-4", children: /* @__PURE__ */ s.jsx(It, { className: "w-8 h-8 text-white" }) }),
      /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: "Accept Team Ownership" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-500", children: "You've been asked to become the owner of a team" })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "bg-slate-100 rounded-lg p-4 mb-6", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-2", children: [
        /* @__PURE__ */ s.jsx(yt, { className: "w-5 h-5 text-primary-400" }),
        /* @__PURE__ */ s.jsx("span", { className: "text-slate-900 font-medium", children: "Team Ownership" })
      ] }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "As the owner, you'll have full control over the team, including managing members, billing, and team settings. The current owner will become an admin." })
    ] }),
    /* @__PURE__ */ s.jsx(
      S,
      {
        variant: "primary",
        onClick: x,
        disabled: c,
        className: "w-full",
        children: c ? "Accepting..." : "Accept Ownership"
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: "mt-4 text-center", children: /* @__PURE__ */ s.jsx(
      _,
      {
        to: a,
        className: "text-sm text-slate-500 hover:text-slate-400 transition-colors",
        children: "Decline and go to dashboard"
      }
    ) })
  ] }) }) });
}
function qb({
  logo: e,
  productName: t,
  onCreateTeam: n,
  teamDashboardPath: a = "/t/:teamId/dashboard",
  homePath: r = "/",
  className: i = ""
}) {
  const { user: o, logout: l } = Ne(), [d, c] = j(""), [u, h] = j(!1), [m, x] = j(""), f = async (p) => {
    if (p.preventDefault(), !!d.trim()) {
      h(!0), x("");
      try {
        const y = await n(d.trim()), b = a.replace(":teamId", y.id);
        window.location.href = b;
      } catch {
        x("Failed to create team. Please try again."), h(!1);
      }
    }
  };
  return /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${i}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx(_, { to: r, className: "block auth-logo", children: e }),
    /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-6", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-16 h-16 mx-auto bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl flex items-center justify-center shadow-lg mb-4", children: /* @__PURE__ */ s.jsx(yt, { className: "w-8 h-8 text-white" }) }),
      /* @__PURE__ */ s.jsxs("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: [
        "Welcome to ",
        t,
        "!"
      ] }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-600", children: "Create a team to get started. Teams let you organize your work and collaborate with others." })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "bg-slate-50 border border-slate-200 rounded-lg p-4 mb-6", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "Signed in as" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-900 font-medium", children: o == null ? void 0 : o.email })
    ] }),
    /* @__PURE__ */ s.jsxs("form", { onSubmit: f, className: "space-y-4", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx(
          "label",
          {
            htmlFor: "teamName",
            className: "block text-sm font-medium text-slate-700 mb-2",
            children: "Team Name"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            id: "teamName",
            type: "text",
            value: d,
            onChange: (p) => c(p.target.value),
            placeholder: "My Team",
            className: "w-full px-4 py-3 border border-slate-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all",
            required: !0,
            autoFocus: !0
          }
        )
      ] }),
      m && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-red-600", children: m }),
      /* @__PURE__ */ s.jsx(
        S,
        {
          type: "submit",
          variant: "primary",
          className: "w-full",
          disabled: u || !d.trim(),
          children: u ? "Creating..." : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(Jt, { className: "w-4 h-4 mr-2" }),
            "Create Team"
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("div", { className: "mt-6 p-4 bg-blue-50 border border-blue-100 rounded-lg", children: /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-blue-800", children: [
      /* @__PURE__ */ s.jsx("strong", { children: "Tip:" }),
      " You can invite team members and manage your team settings after creating your team."
    ] }) }),
    /* @__PURE__ */ s.jsx("div", { className: "mt-6 text-center", children: /* @__PURE__ */ s.jsx(
      "button",
      {
        onClick: () => l(),
        className: "text-sm text-slate-500 hover:text-slate-700 transition-colors",
        children: "Sign out"
      }
    ) })
  ] }) }) });
}
function Hb({
  logo: e,
  className: t = "",
  contactPath: n = "/contact",
  showContactLink: a = !0
}) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: `min-h-screen bg-slate-50 flex flex-col items-center justify-center py-20 ${t}`,
      children: /* @__PURE__ */ s.jsx(Ve, { children: /* @__PURE__ */ s.jsxs("div", { className: "text-center max-w-2xl mx-auto", children: [
        e && /* @__PURE__ */ s.jsx(_, { to: "/", className: "block mb-8", children: e }),
        /* @__PURE__ */ s.jsx("div", { className: "mb-8", children: /* @__PURE__ */ s.jsx("span", { className: "text-8xl md:text-9xl font-bold bg-gradient-to-r from-primary-500 to-primary-400 bg-clip-text text-transparent", children: "404" }) }),
        /* @__PURE__ */ s.jsx("h1", { className: "text-3xl md:text-4xl font-bold text-slate-900 mb-4", children: "Page not found" }),
        /* @__PURE__ */ s.jsx("p", { className: "text-lg text-slate-600 mb-8", children: "Sorry, we couldn't find the page you're looking for. It might have been moved or doesn't exist." }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col sm:flex-row items-center justify-center gap-4", children: [
          /* @__PURE__ */ s.jsx(_, { to: "/", children: /* @__PURE__ */ s.jsxs(S, { variant: "primary", className: "flex items-center gap-2", children: [
            /* @__PURE__ */ s.jsx(Zm, { className: "w-5 h-5" }),
            "Go to Homepage"
          ] }) }),
          /* @__PURE__ */ s.jsxs(
            "button",
            {
              onClick: () => window.history.back(),
              className: "flex items-center gap-2 px-6 py-3 text-slate-500 hover:text-slate-900 transition-colors",
              children: [
                /* @__PURE__ */ s.jsx(rt, { className: "w-5 h-5" }),
                "Go Back"
              ]
            }
          )
        ] }),
        a && /* @__PURE__ */ s.jsxs("p", { className: "mt-12 text-sm text-slate-500", children: [
          "Need help?",
          " ",
          /* @__PURE__ */ s.jsx(
            _,
            {
              to: n,
              className: "text-primary-600 hover:text-primary-700 underline",
              children: "Contact us"
            }
          )
        ] })
      ] }) })
    }
  );
}
function Wb({
  logo: e,
  productName: t,
  productSlug: n,
  description: a,
  features: r = [],
  activateProduct: i,
  successRedirectPath: o = "/t/:teamId/dashboard",
  className: l = ""
}) {
  const [d, c] = j(!1), { user: u, logout: h, refreshTeams: m } = Ne(), x = Be(), f = async () => {
    var y, b;
    c(!0);
    try {
      const k = await i(n);
      ee.success(k.message), await m();
      const g = o.replace(
        ":teamId",
        k.team_id
      );
      x(g);
    } catch (k) {
      const v = ((b = (y = k.response) == null ? void 0 : y.data) == null ? void 0 : b.detail) || `Failed to activate ${t}`;
      ee.error(v);
    } finally {
      c(!1);
    }
  }, p = () => {
    h("/login");
  };
  return /* @__PURE__ */ s.jsx("div", { className: `auth-layout ${l}`, children: /* @__PURE__ */ s.jsx("div", { className: "relative z-10 w-full max-w-md", children: /* @__PURE__ */ s.jsxs("div", { className: "auth-card", children: [
    /* @__PURE__ */ s.jsx("div", { className: "flex justify-center mb-6", children: e }),
    /* @__PURE__ */ s.jsxs("h1", { className: "auth-title", children: [
      "Welcome to ",
      t
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "auth-subtitle", children: "Activate your account to get started" }),
    /* @__PURE__ */ s.jsx("div", { className: "bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 mb-6", children: /* @__PURE__ */ s.jsxs("p", { className: "text-blue-800 text-sm", children: [
      /* @__PURE__ */ s.jsxs("span", { className: "font-semibold", children: [
        "Hi ",
        (u == null ? void 0 : u.name) || "there",
        "!"
      ] }),
      " ",
      a || `You have an existing account, but haven't activated ${t} yet. Click below to get started.`
    ] }) }),
    r.length > 0 && /* @__PURE__ */ s.jsx("div", { className: "space-y-3 mb-6", children: r.map((y, b) => /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: "flex items-center gap-3 text-slate-700",
        children: [
          /* @__PURE__ */ s.jsx("div", { className: "w-8 h-8 rounded-lg bg-primary-500/20 flex items-center justify-center", children: y.icon || /* @__PURE__ */ s.jsx(Ql, { className: "w-4 h-4 text-primary-600" }) }),
          /* @__PURE__ */ s.jsx("span", { className: "text-sm", children: y.text })
        ]
      },
      b
    )) }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          size: "lg",
          className: "w-full",
          onClick: f,
          disabled: d,
          children: d ? "Activating..." : `Activate ${t}`
        }
      ),
      /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "outline",
          size: "lg",
          className: "w-full flex items-center justify-center gap-2",
          onClick: p,
          children: [
            /* @__PURE__ */ s.jsx(Qa, { className: "w-4 h-4" }),
            "Use a different account"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "mt-6 text-center text-sm text-slate-500", children: "By activating, you agree to our Terms of Service and Privacy Policy." })
  ] }) }) });
}
const Kb = ({ className: e }) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    className: e,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      }
    )
  }
), Yb = ({ className: e }) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    className: e,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
      }
    )
  }
), Gb = ({ className: e }) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    className: e,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
      }
    )
  }
);
function Xb({
  code: e = 500,
  title: t = "Something went wrong",
  description: n = "We encountered an unexpected error. Please try again later.",
  showRetry: a = !0,
  showHomeLink: r = !0,
  homePath: i = "/",
  onRetry: o,
  illustration: l
}) {
  return /* @__PURE__ */ s.jsx("div", { className: "min-h-screen bg-slate-50 flex items-center justify-center p-4", children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-md w-full text-center", children: [
    l || /* @__PURE__ */ s.jsx("div", { className: "mb-8", children: /* @__PURE__ */ s.jsx("div", { className: "w-24 h-24 mx-auto bg-red-100 rounded-full flex items-center justify-center", children: /* @__PURE__ */ s.jsx(Kb, { className: "w-12 h-12 text-red-500" }) }) }),
    /* @__PURE__ */ s.jsx("div", { className: "text-6xl font-bold text-slate-300 mb-4", children: e }),
    /* @__PURE__ */ s.jsx("h1", { className: "text-2xl font-bold text-slate-900 mb-2", children: t }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-8", children: n }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col sm:flex-row gap-3 justify-center", children: [
      a && /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "primary",
          onClick: o || (() => window.location.reload()),
          className: "flex items-center justify-center gap-2",
          children: [
            /* @__PURE__ */ s.jsx(Yb, { className: "w-4 h-4" }),
            "Try Again"
          ]
        }
      ),
      r && /* @__PURE__ */ s.jsx(_, { to: i, children: /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "outline",
          className: "w-full flex items-center justify-center gap-2",
          children: [
            /* @__PURE__ */ s.jsx(Gb, { className: "w-4 h-4" }),
            "Go Home"
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "mt-8 text-xs text-slate-400", children: [
      "Error code: ",
      e,
      " • If this persists, please contact support."
    ] })
  ] }) });
}
function Jb({ config: e }) {
  var M;
  const t = Be(), { user: n, teams: a, currentTeam: r, switchTeam: i, logout: o, refreshTeams: l } = Ne();
  Ds();
  const [d, c] = j(!1), {
    productSlug: u,
    productName: h,
    logo: m,
    navigation: x,
    navVariant: f = "horizontal",
    routes: p,
    hooks: y,
    showBillingBanner: b = !0,
    oauth: k = { google: !0, github: !0 },
    activation: g,
    teamApi: v,
    securityApi: C,
    paths: w = {}
  } = e, D = w.login || "/login", P = w.pricing || "/pricing", $ = w.settings || "/t/:teamId/settings", I = w.admin || "/admin", V = w.teamDashboard || ((M = x[0]) == null ? void 0 : M.path) || "/t/:teamId/dashboard", H = w.home || "/", K = qe(
    (F) => {
      var Z;
      const G = {
        id: F.id,
        name: F.name,
        slug: F.slug || F.id,
        role: F.role || "member"
      };
      i(F.id), (Z = y == null ? void 0 : y.onTeamSwitch) == null || Z.call(y, G);
      const q = x[0];
      if (q) {
        const ge = q.path.replace(":teamId", F.id);
        t(ge);
      }
    },
    [i, y, x, t]
  ), U = qe(() => {
    var G;
    const F = (G = y == null ? void 0 : y.onLogout) == null ? void 0 : G.call(y);
    o(typeof F == "string" ? F : void 0);
  }, [o, y]), te = qe(() => {
    if (v != null && v.createTeam)
      c(!0);
    else if (r != null && r.id) {
      const F = $.replace(":teamId", r.id);
      t(F);
    }
  }, [v == null ? void 0 : v.createTeam, t, $, r == null ? void 0 : r.id]), ne = qe(
    async (F) => {
      await l();
      const G = x[0];
      if (G) {
        const q = G.path.replace(":teamId", F.id);
        t(q);
      }
    },
    [l, x, t]
  ), se = a.map((F) => ({
    id: F.id,
    name: F.name,
    slug: F.slug || F.id,
    role: F.role,
    logo_url: F.logo_url
  })), A = r ? {
    id: r.id,
    name: r.name,
    slug: r.slug || r.id,
    role: r.role,
    logo_url: r.logo_url
  } : null, z = n ? {
    name: n.name,
    email: n.email,
    avatarUrl: n.avatar_url,
    isAdmin: n.is_admin
  } : { name: "", email: "" }, R = {
    owner: 4,
    admin: 3,
    member: 2,
    viewer: 1
  }, N = x.filter((F) => {
    if (!F.minRole) return !0;
    const G = R[(r == null ? void 0 : r.role) || "viewer"] || 1, q = R[F.minRole] || 1;
    return G >= q;
  }), L = (F, G) => /* @__PURE__ */ s.jsx(
    Ld,
    {
      loginPath: D,
      requireAdmin: G,
      unauthorizedPath: "/",
      children: /* @__PURE__ */ s.jsx(
        Dy,
        {
          logo: m,
          logoLink: r ? V.replace(":teamId", r.id) : "/",
          user: z,
          teams: se,
          currentTeam: A,
          onTeamSwitch: K,
          onCreateTeam: te,
          onLogout: U,
          navigation: N,
          navVariant: f,
          settingsPath: r != null && r.id ? $.replace(":teamId", r.id) : void 0,
          adminPath: I,
          banner: b ? /* @__PURE__ */ s.jsx(Fy, { teamId: r == null ? void 0 : r.id, pricingPath: P }) : void 0,
          children: F
        }
      )
    }
  );
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    (v == null ? void 0 : v.createTeam) && /* @__PURE__ */ s.jsx(
      hf,
      {
        isOpen: d,
        onClose: () => c(!1),
        onCreateTeam: v.createTeam,
        onTeamCreated: ne
      }
    ),
    /* @__PURE__ */ s.jsxs(Gu, { children: [
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/login",
          element: /* @__PURE__ */ s.jsx(
            yb,
            {
              logo: m,
              productName: h,
              dashboardPath: "/dashboard",
              teamDashboardPath: V,
              showGoogleAuth: k.google,
              showGithubAuth: k.github,
              homePath: H
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/signup",
          element: /* @__PURE__ */ s.jsx(
            bb,
            {
              logo: m,
              productName: h,
              showGoogleAuth: k.google,
              showGithubAuth: k.github,
              homePath: H
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/forgot-password",
          element: /* @__PURE__ */ s.jsx(jb, { logo: m })
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/reset-password",
          element: /* @__PURE__ */ s.jsx(vb, { logo: m })
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/verify-email",
          element: /* @__PURE__ */ s.jsx(Nb, { logo: m })
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/verify-email-required",
          element: /* @__PURE__ */ s.jsx(kb, { logo: m })
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/verify-email-change",
          element: /* @__PURE__ */ s.jsx(Tb, { logo: m })
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/impersonate",
          element: /* @__PURE__ */ s.jsx(Sb, { logo: m, dashboardPath: "/dashboard" })
        }
      ),
      C && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(
          de,
          {
            path: "/auth/security/confirm",
            element: /* @__PURE__ */ s.jsx(
              Pb,
              {
                logo: m,
                securityConfirm: C.securityConfirm
              }
            )
          }
        ),
        /* @__PURE__ */ s.jsx(
          de,
          {
            path: "/auth/security/deny",
            element: /* @__PURE__ */ s.jsx(
              Rb,
              {
                logo: m,
                securityDeny: C.securityDeny
              }
            )
          }
        ),
        C.deviceConfirm && /* @__PURE__ */ s.jsx(
          de,
          {
            path: "/auth/devices/confirm",
            element: /* @__PURE__ */ s.jsx(
              _b,
              {
                logo: m,
                deviceConfirm: C.deviceConfirm
              }
            )
          }
        ),
        C.deviceReport && /* @__PURE__ */ s.jsx(
          de,
          {
            path: "/auth/devices/report",
            element: /* @__PURE__ */ s.jsx(
              Fb,
              {
                logo: m,
                deviceReport: C.deviceReport
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/farewell",
          element: /* @__PURE__ */ s.jsx(Lb, { logo: m, productName: h })
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/reactivate-account",
          element: /* @__PURE__ */ s.jsx($b, { logo: m })
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/reactivate-product",
          element: /* @__PURE__ */ s.jsx(
            Ib,
            {
              logo: m,
              productName: h,
              successRedirectPath: "/login"
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/account-deleted",
          element: /* @__PURE__ */ s.jsx(Ob, { logo: m })
        }
      ),
      (v == null ? void 0 : v.getInviteDetails) && (v == null ? void 0 : v.acceptInvite) && /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/invites/:token",
          element: /* @__PURE__ */ s.jsx(
            zb,
            {
              logo: m,
              getInviteDetails: v.getInviteDetails,
              acceptInvite: v.acceptInvite,
              successRedirectPath: V
            }
          )
        }
      ),
      (v == null ? void 0 : v.acceptOwnershipTransfer) && /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/transfer/:token",
          element: /* @__PURE__ */ s.jsx(
            Ub,
            {
              logo: m,
              acceptOwnershipTransfer: v.acceptOwnershipTransfer,
              successRedirectPath: $
            }
          )
        }
      ),
      (v == null ? void 0 : v.createTeam) && /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/no-teams",
          element: /* @__PURE__ */ s.jsx(
            qb,
            {
              logo: m,
              productName: h,
              onCreateTeam: v.createTeam,
              teamDashboardPath: V,
              homePath: H
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/activate",
          element: /* @__PURE__ */ s.jsx(
            Wb,
            {
              logo: m,
              productName: h,
              productSlug: u,
              description: g == null ? void 0 : g.description,
              features: g == null ? void 0 : g.features,
              activateProduct: (g == null ? void 0 : g.activateProduct) || (async () => ({ message: "Activated", team_id: "new-team" })),
              successRedirectPath: V
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(de, { path: "/error", element: /* @__PURE__ */ s.jsx(Xb, {}) }),
      p.map((F) => {
        const G = F.protected !== !1 ? L(F.element, F.adminOnly) : F.element;
        return /* @__PURE__ */ s.jsx(de, { path: F.path, element: G }, F.path);
      }),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/",
          element: /* @__PURE__ */ s.jsx(
            rl,
            {
              teams: a,
              navigation: x,
              loginPath: D,
              getProductStatus: g == null ? void 0 : g.getProductStatus
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "/dashboard",
          element: /* @__PURE__ */ s.jsx(
            rl,
            {
              teams: a,
              navigation: x,
              loginPath: D,
              getProductStatus: g == null ? void 0 : g.getProductStatus
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          path: "*",
          element: /* @__PURE__ */ s.jsx(Hb, { logo: m, contactPath: "/contact" })
        }
      )
    ] })
  ] });
}
function rl({
  teams: e,
  navigation: t,
  loginPath: n,
  getProductStatus: a
}) {
  const { user: r, isLoading: i } = Ne(), [o, l] = j("loading");
  if (le(() => {
    if (!(i || !r || e.length > 0)) {
      if (!a) {
        l("active");
        return;
      }
      a().then((d) => l(d.status)).catch(() => l("active"));
    }
  }, [i, r, e.length, a]), i)
    return /* @__PURE__ */ s.jsx("div", { className: "min-h-screen flex items-center justify-center bg-slate-50", children: /* @__PURE__ */ s.jsx("div", { className: "spinner spinner-lg" }) });
  if (!r)
    return /* @__PURE__ */ s.jsx(At, { to: n, replace: !0 });
  if (e.length > 0 && t.length > 0) {
    const d = e[0], c = t[0].path.replace(":teamId", d.id);
    return /* @__PURE__ */ s.jsx(At, { to: c, replace: !0 });
  }
  return o === "loading" ? /* @__PURE__ */ s.jsx("div", { className: "min-h-screen flex items-center justify-center bg-slate-50", children: /* @__PURE__ */ s.jsx("div", { className: "spinner spinner-lg" }) }) : o === "none" ? /* @__PURE__ */ s.jsx(At, { to: "/activate", replace: !0 }) : /* @__PURE__ */ s.jsx(At, { to: "/no-teams", replace: !0 });
}
function Uv({ config: e }) {
  return /* @__PURE__ */ s.jsx(zm, { theme: e.theme, children: /* @__PURE__ */ s.jsx(Jb, { config: e }) });
}
function qv() {
  var l;
  const { user: e, teams: t, currentTeam: n, isLoading: a } = Ne(), { subscription: r, billingStatus: i } = Ds(), o = r ? {
    id: r.id || "",
    plan: ((l = r.plan) == null ? void 0 : l.name) || "free",
    status: r.status,
    currentPeriodEnd: r.current_period_end || ""
  } : null;
  return {
    user: e,
    team: n,
    teams: t,
    subscription: o,
    billingStatus: i,
    isLoading: a
  };
}
const il = {
  owner: "Owner",
  admin: "Admin",
  member: "Member",
  viewer: "Viewer"
}, ol = {
  owner: It,
  admin: ns,
  member: an,
  viewer: xt
}, ll = {
  owner: "text-yellow-700 bg-yellow-50 border-yellow-200",
  admin: "text-purple-700 bg-purple-50 border-purple-200",
  member: "text-blue-700 bg-blue-50 border-blue-200",
  viewer: "text-slate-600 bg-slate-100 border-slate-200"
};
function Hv({
  teamId: e,
  currentUserId: t,
  header: n,
  navigation: a,
  getMembers: r,
  getInvites: i,
  createInvite: o,
  updateMemberRole: l,
  removeMember: d,
  cancelInvite: c,
  resendInvite: u,
  onToast: h,
  onError: m
}) {
  const [x, f] = j(!0), [p, y] = j([]), [b, k] = j([]), [g, v] = j(null), [C, w] = j(!1), [D, P] = j(""), [$, I] = j("member"), [V, H] = j(!1), [K, U] = j(null), [te, ne] = j(null), [se, A] = j(
    null
  ), z = (E, ie) => {
    h == null || h(E, ie);
  }, R = (E) => m ? m(E) : E instanceof Error ? E.message : "An error occurred";
  le(() => {
    e && N();
  }, [e]);
  const N = async () => {
    if (e) {
      f(!0);
      try {
        const [E, ie] = await Promise.all([
          r(e),
          i(e)
        ]);
        y(E.members), k(ie.invites);
        const je = E.members.find(
          (oe) => oe.user_id === t
        );
        je && v(je.role);
      } catch {
        z("Failed to load team members", "error");
      } finally {
        f(!1);
      }
    }
  }, L = g === "owner" || g === "admin", M = async (E) => {
    if (E.preventDefault(), !(!e || !D.trim())) {
      H(!0);
      try {
        const ie = await o(e, {
          email: D.trim(),
          role: $
        });
        k([...b, ie]), P(""), I("member"), w(!1), z(`Invitation sent to ${D}`, "success");
      } catch (ie) {
        z(R(ie), "error");
      } finally {
        H(!1);
      }
    }
  }, F = async (E, ie, je) => {
    if (e)
      try {
        await l(e, ie, { role: je }), y(
          p.map((oe) => oe.id === E ? { ...oe, role: je } : oe)
        ), z("Role updated", "success");
      } catch (oe) {
        z(R(oe), "error");
      }
  }, G = async () => {
    if (!(!e || !K))
      try {
        await d(e, K.user_id), y(p.filter((E) => E.id !== K.id)), z("Member removed", "success");
      } catch (E) {
        z(R(E), "error");
      } finally {
        U(null);
      }
  }, q = async () => {
    if (!(!e || !te))
      try {
        await c(e, te.id), k(b.filter((E) => E.id !== te.id)), z("Invitation cancelled", "success");
      } catch (E) {
        z(R(E), "error");
      } finally {
        ne(null);
      }
  }, Z = async (E) => {
    if (e) {
      A(E.id);
      try {
        await u(e, E.id), z(`Invitation resent to ${E.email}`, "success");
      } catch (ie) {
        z(R(ie), "error");
      } finally {
        A(null);
      }
    }
  }, ge = (E) => new Date(E).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  }), _e = (E) => {
    if (!E) return "Never";
    const ie = new Date(E), oe = (/* @__PURE__ */ new Date()).getTime() - ie.getTime(), ze = Math.floor(oe / (1e3 * 60)), ce = Math.floor(oe / (1e3 * 60 * 60)), Re = Math.floor(oe / (1e3 * 60 * 60 * 24));
    return ze < 1 ? "Just now" : ze < 60 ? `${ze}m ago` : ce < 24 ? `${ce}h ago` : Re < 7 ? `${Re}d ago` : ge(E);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-slate-50", children: [
    n,
    a,
    /* @__PURE__ */ s.jsx(Ve, { className: "py-8", children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-4xl", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between mb-8", children: [
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("h2", { className: "text-3xl font-bold text-slate-900", children: "Team Members" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mt-1", children: "Manage your team members and invitations" })
        ] }),
        L && /* @__PURE__ */ s.jsxs(S, { onClick: () => w(!0), children: [
          /* @__PURE__ */ s.jsx(lf, { className: "w-4 h-4 mr-2" }),
          "Invite Member"
        ] })
      ] }),
      x ? /* @__PURE__ */ s.jsx("div", { className: "flex items-center justify-center py-12", children: /* @__PURE__ */ s.jsx("div", { className: "w-8 h-8 border-4 border-accent-500 border-t-transparent rounded-full animate-spin" }) }) : /* @__PURE__ */ s.jsxs("div", { className: "space-y-8", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm", children: [
          /* @__PURE__ */ s.jsx("div", { className: "p-4 border-b border-slate-200", children: /* @__PURE__ */ s.jsxs("h3", { className: "text-lg font-semibold text-slate-900 flex items-center gap-2", children: [
            /* @__PURE__ */ s.jsx(yt, { className: "w-5 h-5 text-accent-600" }),
            "Members (",
            p.length,
            ")"
          ] }) }),
          /* @__PURE__ */ s.jsx("div", { className: "divide-y divide-slate-100", children: p.map((E) => {
            const ie = ol[E.role], je = E.user_id === t, oe = L && !je && E.role !== "owner", ze = L && !je && E.role !== "owner";
            return /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: "p-4 flex items-center justify-between",
                children: [
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                    /* @__PURE__ */ s.jsx(
                      ar,
                      {
                        src: E.avatar_url,
                        name: E.name,
                        size: "md"
                      }
                    ),
                    /* @__PURE__ */ s.jsxs("div", { children: [
                      /* @__PURE__ */ s.jsxs("p", { className: "text-slate-900 font-medium", children: [
                        E.name,
                        je && /* @__PURE__ */ s.jsx("span", { className: "text-slate-500 text-sm ml-2", children: "(you)" })
                      ] }),
                      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: E.email }),
                      /* @__PURE__ */ s.jsxs("p", { className: "text-xs text-slate-400 flex items-center gap-1 mt-0.5", children: [
                        /* @__PURE__ */ s.jsx(ft, { className: "w-3 h-3" }),
                        "Last seen: ",
                        _e(E.last_seen_at)
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                    oe ? /* @__PURE__ */ s.jsxs(
                      "select",
                      {
                        value: E.role,
                        onChange: (ce) => F(
                          E.id,
                          E.user_id,
                          ce.target.value
                        ),
                        className: "px-3 py-1.5 bg-white border border-slate-300 rounded-lg text-sm text-slate-900 focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20",
                        children: [
                          /* @__PURE__ */ s.jsx("option", { value: "admin", children: "Admin" }),
                          /* @__PURE__ */ s.jsx("option", { value: "member", children: "Member" }),
                          /* @__PURE__ */ s.jsx("option", { value: "viewer", children: "Viewer" })
                        ]
                      }
                    ) : /* @__PURE__ */ s.jsxs(
                      "span",
                      {
                        className: `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium border ${ll[E.role]}`,
                        children: [
                          /* @__PURE__ */ s.jsx(ie, { className: "w-3.5 h-3.5" }),
                          il[E.role]
                        ]
                      }
                    ),
                    ze && /* @__PURE__ */ s.jsx(
                      S,
                      {
                        variant: "ghost",
                        size: "sm",
                        onClick: () => U(E),
                        className: "text-red-400 hover:text-red-300 hover:bg-red-500/10",
                        children: /* @__PURE__ */ s.jsx(Ze, { className: "w-4 h-4" })
                      }
                    )
                  ] })
                ]
              },
              E.id
            );
          }) })
        ] }),
        L && b.length > 0 && /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm", children: [
          /* @__PURE__ */ s.jsx("div", { className: "p-4 border-b border-slate-200", children: /* @__PURE__ */ s.jsxs("h3", { className: "text-lg font-semibold text-slate-900 flex items-center gap-2", children: [
            /* @__PURE__ */ s.jsx(ke, { className: "w-5 h-5 text-accent-600" }),
            "Pending Invitations (",
            b.length,
            ")"
          ] }) }),
          /* @__PURE__ */ s.jsx("div", { className: "divide-y divide-slate-100", children: b.map((E) => {
            const ie = ol[E.role];
            return /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: "p-4 flex items-center justify-between",
                children: [
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                    /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center", children: /* @__PURE__ */ s.jsx(ke, { className: "w-5 h-5 text-slate-500" }) }),
                    /* @__PURE__ */ s.jsxs("div", { children: [
                      /* @__PURE__ */ s.jsx("p", { className: "text-slate-900 font-medium", children: E.email }),
                      /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-slate-500 flex items-center gap-1", children: [
                        /* @__PURE__ */ s.jsx(ft, { className: "w-3 h-3" }),
                        "Expires ",
                        ge(E.expires_at)
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
                    /* @__PURE__ */ s.jsxs(
                      "span",
                      {
                        className: `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium border ${ll[E.role]}`,
                        children: [
                          /* @__PURE__ */ s.jsx(ie, { className: "w-3.5 h-3.5" }),
                          il[E.role]
                        ]
                      }
                    ),
                    /* @__PURE__ */ s.jsx(
                      S,
                      {
                        variant: "ghost",
                        size: "sm",
                        onClick: () => Z(E),
                        disabled: se === E.id,
                        className: "text-accent-600 hover:text-accent-700 hover:bg-accent-50",
                        title: "Resend invitation",
                        children: /* @__PURE__ */ s.jsx(
                          bs,
                          {
                            className: `w-4 h-4 ${se === E.id ? "animate-spin" : ""}`
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ s.jsx(
                      S,
                      {
                        variant: "ghost",
                        size: "sm",
                        onClick: () => ne(E),
                        className: "text-red-400 hover:text-red-300 hover:bg-red-500/10",
                        title: "Cancel invitation",
                        children: /* @__PURE__ */ s.jsx(Ot, { className: "w-4 h-4" })
                      }
                    )
                  ] })
                ]
              },
              E.id
            );
          }) })
        ] })
      ] })
    ] }) }),
    C && /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-xl max-w-md w-full shadow-xl", children: [
      /* @__PURE__ */ s.jsx("div", { className: "p-4 border-b border-slate-200", children: /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-slate-900", children: "Invite Team Member" }) }),
      /* @__PURE__ */ s.jsxs("form", { onSubmit: M, className: "p-4 space-y-4", children: [
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "email", children: "Email Address" }),
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "email",
              type: "email",
              value: D,
              onChange: (E) => P(E.target.value),
              required: !0,
              className: "px-4 py-3",
              placeholder: "colleague@example.com"
            }
          )
        ] }),
        /* @__PURE__ */ s.jsxs(Q, { children: [
          /* @__PURE__ */ s.jsx(J, { htmlFor: "role", children: "Role" }),
          /* @__PURE__ */ s.jsxs(
            "select",
            {
              id: "role",
              value: $,
              onChange: (E) => I(E.target.value),
              className: "w-full px-4 py-3 bg-white border border-slate-300 rounded-lg text-slate-900 focus:outline-none focus:ring-2 focus:ring-accent-500 focus:border-accent-500",
              children: [
                /* @__PURE__ */ s.jsx("option", { value: "admin", children: "Admin - Can manage members and billing" }),
                /* @__PURE__ */ s.jsx("option", { value: "member", children: "Member - Can create and manage content" }),
                /* @__PURE__ */ s.jsx("option", { value: "viewer", children: "Viewer - Read-only access" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-end gap-3 pt-2", children: [
          /* @__PURE__ */ s.jsx(
            S,
            {
              type: "button",
              variant: "outline",
              onClick: () => {
                w(!1), P(""), I("member");
              },
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ s.jsx(S, { type: "submit", disabled: V, children: V ? "Sending..." : "Send Invitation" })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ s.jsx(
      ws,
      {
        isOpen: !!K,
        onClose: () => U(null),
        onConfirm: G,
        title: "Remove Team Member",
        message: `Are you sure you want to remove ${K == null ? void 0 : K.name} from the team? They will lose access to all team resources.`,
        confirmText: "Remove",
        variant: "danger"
      }
    ),
    /* @__PURE__ */ s.jsx(
      ws,
      {
        isOpen: !!te,
        onClose: () => ne(null),
        onConfirm: q,
        title: "Cancel Invitation",
        message: `Are you sure you want to cancel the invitation to ${te == null ? void 0 : te.email}?`,
        confirmText: "Cancel Invitation",
        variant: "danger"
      }
    )
  ] });
}
function Zb({
  name: e,
  email: t,
  avatarUrl: n,
  hasPassword: a,
  isSaving: r,
  isRequestingPasswordReset: i,
  isAvatarLoading: o,
  avatarError: l,
  onNameChange: d,
  onSave: c,
  onChangePassword: u,
  onChangeEmail: h,
  onAvatarUpload: m,
  onAvatarDelete: x
}) {
  return /* @__PURE__ */ s.jsxs("section", { className: "bg-white border border-slate-200 rounded-2xl shadow-sm p-6", children: [
    /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900 mb-6", children: "Profile" }),
    m && /* @__PURE__ */ s.jsx("div", { className: "mb-6 pb-6 border-b border-slate-200", children: /* @__PURE__ */ s.jsx(
      tc,
      {
        currentUrl: n,
        name: e,
        onUpload: m,
        onDelete: n ? x : void 0,
        isLoading: o,
        error: l,
        size: "xl"
      }
    ) }),
    /* @__PURE__ */ s.jsxs("form", { onSubmit: c, className: "space-y-4", children: [
      /* @__PURE__ */ s.jsxs(Q, { children: [
        /* @__PURE__ */ s.jsx(J, { htmlFor: "name", children: "Name" }),
        /* @__PURE__ */ s.jsx(
          re,
          {
            id: "name",
            type: "text",
            value: e,
            onChange: (f) => d(f.target.value),
            className: "px-4 py-2"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs(Q, { children: [
        /* @__PURE__ */ s.jsx(J, { htmlFor: "email", children: "Email" }),
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ s.jsx("div", { className: "flex-1 px-4 py-2 bg-slate-50 border border-slate-300 rounded-lg text-slate-600", children: t }),
          h && a && /* @__PURE__ */ s.jsxs(
            S,
            {
              type: "button",
              variant: "outline",
              size: "sm",
              onClick: h,
              className: "flex items-center gap-2 shrink-0",
              children: [
                /* @__PURE__ */ s.jsx(ke, { className: "w-4 h-4" }),
                "Change"
              ]
            }
          )
        ] })
      ] }),
      a && u && /* @__PURE__ */ s.jsxs("div", { className: "pt-2", children: [
        /* @__PURE__ */ s.jsxs(
          S,
          {
            type: "button",
            variant: "outline",
            size: "sm",
            onClick: u,
            disabled: i,
            className: "flex items-center gap-2",
            children: [
              /* @__PURE__ */ s.jsx(pt, { className: "w-4 h-4" }),
              i ? "Sending..." : "Change Password"
            ]
          }
        ),
        /* @__PURE__ */ s.jsx("p", { className: "text-xs text-slate-500 mt-2", children: "We'll send a password reset link to your email" })
      ] }),
      /* @__PURE__ */ s.jsxs(
        S,
        {
          type: "submit",
          variant: "primary",
          className: "flex items-center gap-2",
          disabled: r,
          children: [
            /* @__PURE__ */ s.jsx(Xl, { className: "w-4 h-4" }),
            r ? "Saving..." : "Save Changes"
          ]
        }
      )
    ] })
  ] });
}
function Qb({
  apiKeys: e,
  newlyGeneratedKey: t,
  copied: n,
  onCopyKey: a,
  onCreateKey: r,
  onRevokeKey: i,
  availablePermissions: o,
  defaultPermissions: l
}) {
  const [d, c] = j(!1), [u, h] = j(""), [m, x] = j(
    l ?? (o == null ? void 0 : o.map((w) => w.value)) ?? []
  ), [f, p] = j(!1), y = async () => {
    if (u.trim()) {
      p(!0);
      try {
        await r({
          name: u.trim(),
          permissions: o ? m : void 0
        }), h(""), x(
          l ?? (o == null ? void 0 : o.map((w) => w.value)) ?? []
        ), c(!1);
      } finally {
        p(!1);
      }
    }
  }, b = () => {
    h(""), x(
      l ?? (o == null ? void 0 : o.map((w) => w.value)) ?? []
    ), c(!1);
  }, k = (w) => {
    x(
      (D) => D.includes(w) ? D.filter((P) => P !== w) : [...D, w]
    );
  }, g = () => {
    x((o == null ? void 0 : o.map((w) => w.value)) ?? []);
  }, v = () => {
    x([]);
  }, C = (w) => {
    const D = o == null ? void 0 : o.find((P) => P.value === w);
    return (D == null ? void 0 : D.label) ?? w;
  };
  return /* @__PURE__ */ s.jsxs("section", { className: "bg-white border border-slate-200 rounded-2xl shadow-sm p-6", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between mb-6", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ s.jsx(sn, { className: "w-6 h-6 text-accent-600" }),
        /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900", children: "API Keys" })
      ] }),
      !d && /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "primary",
          size: "sm",
          onClick: () => c(!0),
          className: "flex items-center gap-2",
          children: [
            /* @__PURE__ */ s.jsx(Jt, { className: "w-4 h-4" }),
            "Create Key"
          ]
        }
      )
    ] }),
    d && /* @__PURE__ */ s.jsxs("div", { className: "mb-4 p-4 bg-slate-50 border border-slate-200 rounded-lg", children: [
      /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "Key Name" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-3", children: 'Give your API key a name to help you identify it (e.g., "Production", "Staging", "Development")' }),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          type: "text",
          value: u,
          onChange: (w) => h(w.target.value),
          placeholder: "e.g., Production API Key",
          className: "w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-accent-500 focus:border-accent-500 mb-4",
          autoFocus: !0,
          onKeyDown: (w) => {
            w.key === "Enter" && u.trim() && m.length > 0 && y(), w.key === "Escape" && b();
          }
        }
      ),
      o && o.length > 0 && /* @__PURE__ */ s.jsxs("div", { className: "mb-4", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between mb-2", children: [
          /* @__PURE__ */ s.jsxs("label", { className: "block text-sm font-medium text-slate-700 flex items-center gap-2", children: [
            /* @__PURE__ */ s.jsx(ns, { className: "w-4 h-4" }),
            "Permissions"
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "flex gap-2 text-xs", children: [
            /* @__PURE__ */ s.jsx(
              "button",
              {
                type: "button",
                onClick: g,
                className: "text-accent-600 hover:text-accent-700 underline",
                children: "Select all"
              }
            ),
            /* @__PURE__ */ s.jsx("span", { className: "text-slate-300", children: "|" }),
            /* @__PURE__ */ s.jsx(
              "button",
              {
                type: "button",
                onClick: v,
                className: "text-accent-600 hover:text-accent-700 underline",
                children: "Clear all"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-3", children: "Select which operations this API key can perform" }),
        /* @__PURE__ */ s.jsx("div", { className: "space-y-2", children: o.map((w) => /* @__PURE__ */ s.jsxs(
          "label",
          {
            className: "flex items-start gap-3 p-2 rounded-lg hover:bg-slate-100 cursor-pointer",
            children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  type: "checkbox",
                  checked: m.includes(w.value),
                  onChange: () => k(w.value),
                  className: "mt-0.5 h-4 w-4 rounded border-slate-300 text-accent-600 focus:ring-accent-500"
                }
              ),
              /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
                /* @__PURE__ */ s.jsx("div", { className: "text-sm font-medium text-slate-700", children: w.label }),
                w.description && /* @__PURE__ */ s.jsx("div", { className: "text-xs text-slate-500", children: w.description })
              ] })
            ]
          },
          w.value
        )) }),
        m.length === 0 && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-red-500 mt-2", children: "At least one permission is required" })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ s.jsx(
          S,
          {
            variant: "primary",
            size: "sm",
            onClick: y,
            disabled: !u.trim() || f || o && m.length === 0,
            children: f ? "Creating..." : "Create API Key"
          }
        ),
        /* @__PURE__ */ s.jsxs(
          S,
          {
            variant: "outline",
            size: "sm",
            onClick: b,
            className: "flex items-center",
            children: [
              /* @__PURE__ */ s.jsx(Ot, { className: "w-4 h-4 mr-1" }),
              "Cancel"
            ]
          }
        )
      ] })
    ] }),
    t && /* @__PURE__ */ s.jsxs("div", { className: "mb-4 p-4 bg-yellow-500/10 border border-yellow-500/30 rounded-lg", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-yellow-600 font-medium mb-3", children: "Make sure to copy your API key now. You won't be able to see it again!" }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ s.jsx("code", { className: "flex-1 px-3 py-2 bg-slate-100 rounded text-sm text-slate-900 font-mono overflow-x-auto", children: t }),
        /* @__PURE__ */ s.jsx(
          S,
          {
            variant: "outline",
            size: "sm",
            onClick: a,
            className: "flex items-center gap-2",
            children: n ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx($t, { className: "w-4 h-4" }),
              "Copied"
            ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(Ja, { className: "w-4 h-4" }),
              "Copy"
            ] })
          }
        )
      ] })
    ] }),
    e.length === 0 ? /* @__PURE__ */ s.jsx("p", { className: "text-slate-400", children: "No API keys yet. Create one to integrate with the API." }) : /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: e.map((w) => /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: "p-4 bg-slate-50 rounded-lg border border-slate-200",
        children: [
          /* @__PURE__ */ s.jsx("div", { className: "flex items-start justify-between mb-2", children: /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
            /* @__PURE__ */ s.jsx("h3", { className: "font-medium text-slate-900", children: w.name || "API Key" }),
            /* @__PURE__ */ s.jsxs("div", { className: "text-sm text-slate-500", children: [
              "Created ",
              new Date(w.created_at).toLocaleDateString(),
              w.last_used_at && ` • Last used ${new Date(w.last_used_at).toLocaleString()}`,
              w.expires_at && ` • Expires ${new Date(w.expires_at).toLocaleDateString()}`
            ] }),
            o && w.permissions && w.permissions.length > 0 && /* @__PURE__ */ s.jsx("div", { className: "flex flex-wrap gap-1 mt-2", children: w.permissions.map((D, P) => /* @__PURE__ */ s.jsx(
              "span",
              {
                className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700",
                children: C(D)
              },
              `${w.id}-perm-${P}`
            )) })
          ] }) }),
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ s.jsxs("code", { className: "flex-1 px-3 py-2 bg-slate-100 rounded text-sm text-slate-900 font-mono", children: [
              w.key_prefix,
              "••••••••"
            ] }),
            /* @__PURE__ */ s.jsxs(
              S,
              {
                variant: "outline",
                size: "sm",
                onClick: () => i(w.id),
                className: "flex items-center gap-2 border-red-500 text-red-500 hover:bg-red-500/10",
                children: [
                  /* @__PURE__ */ s.jsx(Ze, { className: "w-4 h-4" }),
                  "Revoke"
                ]
              }
            )
          ] })
        ]
      },
      w.id
    )) })
  ] });
}
function ej({
  userProfile: e,
  onSetPassword: t,
  onDisconnect: n
}) {
  if (!(e != null && e.oauth_provider)) return null;
  const a = (r) => r === "google" ? /* @__PURE__ */ s.jsxs("svg", { className: "w-5 h-5", viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fill: "#4285F4",
        d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fill: "#34A853",
        d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fill: "#FBBC05",
        d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fill: "#EA4335",
        d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      }
    )
  ] }) : r === "github" ? /* @__PURE__ */ s.jsx("svg", { className: "w-5 h-5", fill: "currentColor", viewBox: "0 0 24 24", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
      clipRule: "evenodd"
    }
  ) }) : null;
  return /* @__PURE__ */ s.jsxs("section", { className: "bg-white border border-slate-200 rounded-2xl shadow-sm p-6", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-6", children: [
      /* @__PURE__ */ s.jsx(Yl, { className: "w-6 h-6 text-accent-600" }),
      /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900", children: "Social Connection" })
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-slate-500 mb-4", children: [
      "You signed in with",
      " ",
      e.oauth_provider === "google" ? "Google" : "GitHub",
      "."
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
        a(e.oauth_provider),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-slate-900 font-medium", children: e.oauth_provider === "google" ? "Google" : "GitHub" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: "Connected" })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "outline",
          size: "sm",
          onClick: () => {
            e.has_password ? n() : t();
          },
          disabled: !e.has_password,
          className: `flex items-center gap-2 ${e.has_password ? "text-red-600 border-red-500/50 hover:bg-red-500/10" : "text-slate-400 border-slate-300 cursor-not-allowed"}`,
          children: [
            /* @__PURE__ */ s.jsx(Zl, { className: "w-4 h-4" }),
            "Disconnect"
          ]
        }
      )
    ] }),
    !e.has_password && /* @__PURE__ */ s.jsxs("div", { className: "mt-4 p-4 bg-amber-50 border border-amber-200 rounded-lg", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-amber-700 mb-3", children: "Set a password to enable email/password login and to disconnect your social account." }),
      /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "outline",
          size: "sm",
          onClick: t,
          className: "flex items-center gap-2",
          children: [
            /* @__PURE__ */ s.jsx(pt, { className: "w-4 h-4" }),
            "Set Password"
          ]
        }
      )
    ] })
  ] });
}
function tj({
  isEnabled: e,
  isSettingUp: t,
  onSetup: n,
  onDisable: a,
  onRegenerateBackupCodes: r
}) {
  return /* @__PURE__ */ s.jsxs("section", { className: "bg-white border border-slate-200 rounded-2xl shadow-sm p-6", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-6", children: [
      /* @__PURE__ */ s.jsx(ns, { className: "w-6 h-6 text-accent-600" }),
      /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900", children: "Two-Factor Authentication" })
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 mb-4", children: "Add an extra layer of security to your account by requiring a verification code in addition to your password." }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3", children: [
        e ? /* @__PURE__ */ s.jsx(js, { className: "w-5 h-5 text-green-400" }) : /* @__PURE__ */ s.jsx(da, { className: "w-5 h-5 text-slate-400" }),
        /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-slate-900 font-medium", children: e ? "Enabled" : "Disabled" }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: e ? "Your account is protected with 2FA" : "Protect your account with an authenticator app" })
        ] })
      ] }),
      e ? /* @__PURE__ */ s.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ s.jsxs(
          S,
          {
            variant: "outline",
            size: "sm",
            onClick: r,
            className: "flex items-center gap-2",
            children: [
              /* @__PURE__ */ s.jsx(sn, { className: "w-4 h-4" }),
              "Backup Codes"
            ]
          }
        ),
        /* @__PURE__ */ s.jsxs(
          S,
          {
            variant: "outline",
            size: "sm",
            onClick: a,
            className: "flex items-center gap-2 text-red-600 border-red-500/50 hover:bg-red-500/10",
            children: [
              /* @__PURE__ */ s.jsx(da, { className: "w-4 h-4" }),
              "Disable"
            ]
          }
        )
      ] }) : /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "primary",
          size: "sm",
          onClick: n,
          disabled: t,
          className: "flex items-center gap-2",
          children: [
            /* @__PURE__ */ s.jsx(js, { className: "w-4 h-4" }),
            t ? "Setting up..." : "Enable 2FA"
          ]
        }
      )
    ] })
  ] });
}
function sj({
  isOpen: e,
  onClose: t,
  onConfirm: n,
  hasActiveSubscription: a,
  subscriptionEndDate: r,
  isLoading: i
}) {
  const [o, l] = j("");
  if (!e) return null;
  const d = () => {
    l(""), t();
  };
  return /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-red-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(Ze, { className: "w-5 h-5 text-red-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Delete Account" })
    ] }),
    a ? /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "Your account will be scheduled for deletion after your subscription ends." }) : /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "Your account will be scheduled for deletion. You'll have 30 days to reactivate it." }),
    /* @__PURE__ */ s.jsx("div", { className: "mb-6", children: /* @__PURE__ */ s.jsxs(Q, { children: [
      /* @__PURE__ */ s.jsx(J, { htmlFor: "deletePassword", children: "Enter your password to confirm" }),
      /* @__PURE__ */ s.jsx(
        re,
        {
          id: "deletePassword",
          type: "password",
          value: o,
          onChange: (c) => l(c.target.value),
          className: "px-4 py-2",
          placeholder: "••••••••"
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: d,
          className: "flex-1",
          disabled: i,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: () => n(o),
          className: "flex-1 border-red-500 text-red-600 hover:bg-red-500/10",
          disabled: i || !o,
          children: i ? "Deleting..." : "Delete Account"
        }
      )
    ] })
  ] }) });
}
function nj({
  isOpen: e,
  onClose: t,
  onSubmit: n,
  isLoading: a
}) {
  const [r, i] = j(""), [o, l] = j(""), [d, c] = j(!1), [u, h] = j(!1);
  if (!e) return null;
  const m = () => {
    i(""), l(""), t();
  };
  return /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-primary-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(pt, { className: "w-5 h-5 text-accent-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Set Password" })
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "Create a password to enable email/password login." }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-4 mb-6", children: [
      /* @__PURE__ */ s.jsxs(Q, { children: [
        /* @__PURE__ */ s.jsx(J, { htmlFor: "newPassword", children: "New Password" }),
        /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "newPassword",
              type: d ? "text" : "password",
              value: r,
              onChange: (x) => i(x.target.value),
              className: "px-4 py-2 pr-10",
              placeholder: "••••••••"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              onClick: () => c(!d),
              className: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600",
              children: d ? /* @__PURE__ */ s.jsx(ys, { className: "w-4 h-4" }) : /* @__PURE__ */ s.jsx(xt, { className: "w-4 h-4" })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs(Q, { children: [
        /* @__PURE__ */ s.jsx(J, { htmlFor: "confirmNewPassword", children: "Confirm Password" }),
        /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "confirmNewPassword",
              type: u ? "text" : "password",
              value: o,
              onChange: (x) => l(x.target.value),
              className: "px-4 py-2 pr-10",
              placeholder: "••••••••"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              onClick: () => h(!u),
              className: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600",
              children: u ? /* @__PURE__ */ s.jsx(ys, { className: "w-4 h-4" }) : /* @__PURE__ */ s.jsx(xt, { className: "w-4 h-4" })
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: m,
          className: "flex-1",
          disabled: a,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          onClick: () => n(r),
          className: "flex-1",
          disabled: a || !r || !o || r !== o,
          children: a ? "Setting..." : "Set Password"
        }
      )
    ] })
  ] }) });
}
function aj({
  isOpen: e,
  onClose: t,
  onConfirm: n,
  provider: a,
  isLoading: r
}) {
  const [i, o] = j("");
  if (!e) return null;
  const l = () => {
    o(""), t();
  };
  return /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-red-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(Zl, { className: "w-5 h-5 text-red-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Disconnect Social Account" })
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700 mb-4", children: [
      "This will disconnect your ",
      a,
      " account."
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "mb-6", children: [
      /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "Enter your password to confirm" }),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          type: "password",
          value: i,
          onChange: (d) => o(d.target.value),
          className: "w-full px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 focus:outline-none focus:ring-2 focus:ring-red-500",
          placeholder: "••••••••"
        }
      )
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: l,
          className: "flex-1",
          disabled: r,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: () => n(i),
          className: "flex-1 border-red-500 text-red-600 hover:bg-red-500/10",
          disabled: r || !i,
          children: r ? "Disconnecting..." : "Disconnect"
        }
      )
    ] })
  ] }) });
}
function rj({
  isOpen: e,
  onClose: t,
  onEnable: n,
  setup: a,
  isEnabling: r,
  showSuccessView: i,
  onDone: o
}) {
  const [l, d] = j(""), [c, u] = j(!1);
  if (!e || !a) return null;
  const h = () => {
    d(""), u(!1), t();
  }, m = () => {
    navigator.clipboard.writeText(a.backup_codes.join(`
`)), u(!0);
  };
  return i ? /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-lg w-full max-h-[90vh] overflow-y-auto", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(js, { className: "w-5 h-5 text-green-400" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Two-Factor Authentication Enabled" })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "mb-6 p-4 bg-yellow-500/10 border border-yellow-500/30 rounded-lg", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-yellow-600 font-medium mb-3", children: "Save these backup codes in a secure place." }),
      /* @__PURE__ */ s.jsx("div", { className: "grid grid-cols-2 gap-2 mb-3", children: a.backup_codes.map((x, f) => /* @__PURE__ */ s.jsx(
        "code",
        {
          className: "px-2 py-1 bg-slate-100 rounded text-xs text-slate-900 font-mono text-center",
          children: x
        },
        f
      )) }),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          size: "sm",
          onClick: m,
          className: "w-full flex items-center justify-center gap-2",
          children: c ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx($t, { className: "w-4 h-4" }),
            "Copied"
          ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(Ja, { className: "w-4 h-4" }),
            "Copy Backup Codes"
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(S, { variant: "primary", onClick: o, className: "w-full", children: "Done" })
  ] }) }) : /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-lg w-full max-h-[90vh] overflow-y-auto", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-primary-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(ns, { className: "w-5 h-5 text-accent-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Set Up Two-Factor Authentication" })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "mb-6", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "Scan this QR code with your authenticator app." }),
      /* @__PURE__ */ s.jsx("div", { className: "flex justify-center mb-4", children: /* @__PURE__ */ s.jsx("div", { className: "bg-white p-4 rounded-lg", children: /* @__PURE__ */ s.jsx(
        "img",
        {
          src: `data:image/png;base64,${a.qr_code}`,
          alt: "2FA QR Code",
          className: "w-48 h-48"
        }
      ) }) }),
      /* @__PURE__ */ s.jsxs("div", { className: "text-center", children: [
        /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-2", children: "Or enter this code manually:" }),
        /* @__PURE__ */ s.jsx("code", { className: "px-3 py-2 bg-slate-100 rounded text-sm text-slate-900 font-mono", children: a.secret })
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "mb-6", children: [
      /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "Enter the 6-digit code from your authenticator app" }),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          type: "text",
          value: l,
          onChange: (x) => d(x.target.value.replace(/\D/g, "").slice(0, 6)),
          className: "w-full px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 text-center text-2xl tracking-widest focus:outline-none focus:ring-2 focus:ring-accent-500",
          placeholder: "000000",
          maxLength: 6
        }
      )
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: h,
          className: "flex-1",
          disabled: r,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          onClick: () => n(l),
          className: "flex-1",
          disabled: r || l.length !== 6,
          children: r ? "Enabling..." : "Enable 2FA"
        }
      )
    ] })
  ] }) });
}
function ij({
  isOpen: e,
  onClose: t,
  onDisable: n,
  isLoading: a
}) {
  const [r, i] = j(""), [o, l] = j("");
  if (!e) return null;
  const d = () => {
    i(""), l(""), t();
  };
  return /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-red-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(da, { className: "w-5 h-5 text-red-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Disable Two-Factor Authentication" })
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "This will remove the extra security from your account." }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-4 mb-6", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "Password" }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "password",
            value: r,
            onChange: (c) => i(c.target.value),
            className: "w-full px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 focus:outline-none focus:ring-2 focus:ring-red-500",
            placeholder: "••••••••"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "Verification Code" }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "text",
            value: o,
            onChange: (c) => l(c.target.value.replace(/\D/g, "").slice(0, 8)),
            className: "w-full px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 text-center tracking-widest focus:outline-none focus:ring-2 focus:ring-red-500",
            placeholder: "000000",
            maxLength: 8
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: d,
          className: "flex-1",
          disabled: a,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: () => n(r, o),
          className: "flex-1 border-red-500 text-red-600 hover:bg-red-500/10",
          disabled: a || !r || !o,
          children: a ? "Disabling..." : "Disable 2FA"
        }
      )
    ] })
  ] }) });
}
function oj({
  isOpen: e,
  onClose: t,
  onRegenerate: n,
  regeneratedCodes: a,
  isLoading: r
}) {
  const [i, o] = j(""), [l, d] = j(""), [c, u] = j(!1);
  if (!e) return null;
  const h = () => {
    o(""), d(""), u(!1), t();
  }, m = () => {
    a && (navigator.clipboard.writeText(a.join(`
`)), u(!0));
  };
  return a ? /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full max-h-[90vh] overflow-y-auto", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-primary-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(sn, { className: "w-5 h-5 text-accent-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "New Backup Codes" })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "mb-6 p-4 bg-yellow-500/10 border border-yellow-500/30 rounded-lg", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-yellow-600 font-medium mb-3", children: "Save these backup codes in a secure place." }),
      /* @__PURE__ */ s.jsx("div", { className: "grid grid-cols-2 gap-2 mb-3", children: a.map((x, f) => /* @__PURE__ */ s.jsx(
        "code",
        {
          className: "px-2 py-1 bg-slate-100 rounded text-xs text-slate-900 font-mono text-center",
          children: x
        },
        f
      )) }),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          size: "sm",
          onClick: m,
          className: "w-full flex items-center justify-center gap-2",
          children: c ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx($t, { className: "w-4 h-4" }),
            "Copied"
          ] }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(Ja, { className: "w-4 h-4" }),
            "Copy Backup Codes"
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ s.jsx(S, { variant: "primary", onClick: h, className: "w-full", children: "Done" })
  ] }) }) : /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full max-h-[90vh] overflow-y-auto", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-primary-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(sn, { className: "w-5 h-5 text-accent-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Regenerate Backup Codes" })
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "This will generate new backup codes and invalidate all existing ones." }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-4 mb-6", children: [
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "Password" }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "password",
            value: i,
            onChange: (x) => o(x.target.value),
            className: "w-full px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 focus:outline-none focus:ring-2 focus:ring-accent-500",
            placeholder: "••••••••"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "Verification Code" }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "text",
            value: l,
            onChange: (x) => d(x.target.value.replace(/\D/g, "").slice(0, 6)),
            className: "w-full px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 text-center tracking-widest focus:outline-none focus:ring-2 focus:ring-accent-500",
            placeholder: "000000",
            maxLength: 6
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: h,
          className: "flex-1",
          disabled: r,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          onClick: () => n(i, l),
          className: "flex-1",
          disabled: r || !i || l.length !== 6,
          children: r ? "Regenerating..." : "Regenerate"
        }
      )
    ] })
  ] }) });
}
function lj({
  isOpen: e,
  onClose: t,
  onTransfer: n,
  members: a,
  currentUserId: r,
  isLoading: i
}) {
  const [o, l] = j("");
  if (!e) return null;
  const d = () => {
    l(""), t();
  };
  return /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(It, { className: "w-5 h-5 text-yellow-400" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Transfer Ownership" })
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "Select a team member to become the new owner." }),
    /* @__PURE__ */ s.jsx("div", { className: "space-y-4 mb-6", children: /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "New Owner" }),
      /* @__PURE__ */ s.jsxs(
        "select",
        {
          value: o,
          onChange: (c) => l(c.target.value),
          className: "w-full px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 focus:outline-none focus:ring-2 focus:ring-accent-500",
          children: [
            /* @__PURE__ */ s.jsx("option", { value: "", children: "Select a member" }),
            a.filter((c) => c.user_id !== r).map((c) => /* @__PURE__ */ s.jsxs("option", { value: c.user_id, children: [
              c.name,
              " (",
              c.email,
              ")"
            ] }, c.user_id))
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: d,
          className: "flex-1",
          disabled: i,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          onClick: () => n(o),
          className: "flex-1",
          disabled: i || !o,
          children: i ? "Sending..." : "Send Transfer Request"
        }
      )
    ] })
  ] }) });
}
function cj({
  isOpen: e,
  onClose: t,
  onDelete: n,
  teamName: a,
  isLoading: r
}) {
  const [i, o] = j("");
  if (!e) return null;
  const l = () => {
    o(""), t();
  };
  return /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-red-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(Ze, { className: "w-5 h-5 text-red-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Delete Team" })
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700 mb-4", children: [
      "This will permanently delete the team",
      " ",
      /* @__PURE__ */ s.jsx("span", { className: "font-semibold text-slate-900", children: a }),
      " and all its data."
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-red-600 text-sm mb-4 font-medium", children: "This action cannot be undone." }),
    /* @__PURE__ */ s.jsxs("div", { className: "mb-6", children: [
      /* @__PURE__ */ s.jsx("label", { className: "block text-sm font-medium text-slate-700 mb-2", children: "Enter your password to confirm" }),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          type: "password",
          value: i,
          onChange: (d) => o(d.target.value),
          className: "w-full px-4 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 focus:outline-none focus:ring-2 focus:ring-red-500",
          placeholder: "••••••••"
        }
      )
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: l,
          className: "flex-1",
          disabled: r,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: () => n(i),
          className: "flex-1 border-red-500 text-red-600 hover:bg-red-500/10",
          disabled: r || !i,
          children: r ? "Deleting..." : "Delete Team"
        }
      )
    ] })
  ] }) });
}
function dj({
  isOpen: e,
  onClose: t,
  onLeave: n,
  teamName: a,
  isLoading: r
}) {
  return e ? /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(yt, { className: "w-5 h-5 text-amber-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Leave Team" })
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700 mb-4", children: [
      "Are you sure you want to leave",
      " ",
      /* @__PURE__ */ s.jsx("span", { className: "font-semibold text-slate-900", children: a }),
      "?"
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-amber-600 text-sm mb-6", children: "You will no longer have access to team resources." }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: t,
          className: "flex-1",
          disabled: r,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: n,
          className: "flex-1 border-amber-500 text-amber-600 hover:bg-amber-500/10",
          disabled: r,
          children: r ? "Leaving..." : "Leave Team"
        }
      )
    ] })
  ] }) }) : null;
}
function uj({
  isOpen: e,
  onClose: t,
  onSubmit: n,
  currentEmail: a,
  isLoading: r
}) {
  const [i, o] = j(""), [l, d] = j(""), [c, u] = j(!1);
  if (!e) return null;
  const h = () => {
    o(""), d(""), t();
  }, m = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(i), x = i.toLowerCase() !== a.toLowerCase();
  return /* @__PURE__ */ s.jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm", children: /* @__PURE__ */ s.jsxs("div", { className: "bg-white border border-slate-200 rounded-2xl shadow-xl p-8 max-w-md w-full", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-primary-500/20 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ s.jsx(ke, { className: "w-5 h-5 text-accent-600" }) }),
      /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: "Change Email" })
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-4", children: "A verification email will be sent to your new email address." }),
    /* @__PURE__ */ s.jsxs("div", { className: "p-3 bg-slate-100 rounded-lg mb-4", children: [
      /* @__PURE__ */ s.jsx("p", { className: "text-xs text-slate-500 mb-1", children: "Current email" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm font-medium text-slate-900", children: a })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "space-y-4 mb-6", children: [
      /* @__PURE__ */ s.jsxs(Q, { children: [
        /* @__PURE__ */ s.jsx(J, { htmlFor: "newEmail", children: "New Email Address" }),
        /* @__PURE__ */ s.jsx(
          re,
          {
            id: "newEmail",
            type: "email",
            value: i,
            onChange: (f) => o(f.target.value),
            className: "px-4 py-2",
            placeholder: "you@example.com"
          }
        ),
        i && !x && /* @__PURE__ */ s.jsx("p", { className: "text-xs text-amber-600 mt-1", children: "New email must be different from current email" })
      ] }),
      /* @__PURE__ */ s.jsxs(Q, { children: [
        /* @__PURE__ */ s.jsx(J, { htmlFor: "changeEmailPassword", children: "Password (for verification)" }),
        /* @__PURE__ */ s.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ s.jsx(
            re,
            {
              id: "changeEmailPassword",
              type: c ? "text" : "password",
              value: l,
              onChange: (f) => d(f.target.value),
              className: "px-4 py-2 pr-10",
              placeholder: "••••••••"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              onClick: () => u(!c),
              className: "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600",
              children: c ? /* @__PURE__ */ s.jsx(ys, { className: "w-4 h-4" }) : /* @__PURE__ */ s.jsx(xt, { className: "w-4 h-4" })
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          onClick: h,
          className: "flex-1",
          disabled: r,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "primary",
          onClick: () => n(i, l),
          className: "flex-1",
          disabled: r || !m || !x || !l,
          children: r ? "Sending..." : "Send Verification"
        }
      )
    ] })
  ] }) });
}
function hj({
  transfer: e,
  onResend: t,
  onCancel: n,
  isResending: a,
  isCancelling: r
}) {
  return /* @__PURE__ */ s.jsxs("div", { className: "bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-4", children: [
    /* @__PURE__ */ s.jsx("div", { className: "flex items-start justify-between mb-3", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ s.jsx(It, { className: "w-5 h-5 text-amber-600" }),
      /* @__PURE__ */ s.jsx("h4", { className: "font-semibold text-slate-900", children: "Transfer In Progress" })
    ] }) }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-slate-700 mb-3", children: [
      "Waiting for",
      " ",
      /* @__PURE__ */ s.jsx("span", { className: "font-semibold text-slate-900", children: e.to_user_name }),
      " ",
      "(",
      e.to_user_email,
      ") to accept ownership."
    ] }),
    /* @__PURE__ */ s.jsxs("p", { className: "text-xs text-slate-500 mb-4", children: [
      "Expires on",
      " ",
      new Date(e.expires_at).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
      })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "outline",
          size: "sm",
          onClick: t,
          disabled: a,
          className: "flex items-center gap-2",
          children: [
            /* @__PURE__ */ s.jsx(ke, { className: "w-4 h-4" }),
            a ? "Resending..." : "Resend Email"
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "outline",
          size: "sm",
          onClick: n,
          disabled: r,
          className: "flex items-center gap-2 border-red-500 text-red-600 hover:bg-red-500/10",
          children: [
            /* @__PURE__ */ s.jsx(Ot, { className: "w-4 h-4" }),
            r ? "Cancelling..." : "Cancel Transfer"
          ]
        }
      )
    ] })
  ] });
}
function mj({
  team: e,
  teamName: t,
  currentUserRole: n,
  teamMembers: a,
  pendingTransfer: r,
  isSavingTeam: i,
  isResending: o,
  isCancelling: l,
  isLogoLoading: d,
  logoError: c,
  onTeamNameChange: u,
  onSaveTeamName: h,
  onTransferOwnership: m,
  onDeleteTeam: x,
  onLeaveTeam: f,
  onResendTransfer: p,
  onCancelTransfer: y,
  onLogoUpload: b,
  onLogoDelete: k
}) {
  const g = n === "owner";
  return !e || !(n === "owner" || n === "admin") ? null : /* @__PURE__ */ s.jsxs("section", { className: "bg-white border border-slate-200 rounded-2xl shadow-sm p-6", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-6", children: [
      /* @__PURE__ */ s.jsx(yt, { className: "w-6 h-6 text-accent-600" }),
      /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900", children: "Team Settings" })
    ] }),
    b && /* @__PURE__ */ s.jsxs("div", { className: "mb-6 pb-6 border-b border-slate-200", children: [
      /* @__PURE__ */ s.jsx("h3", { className: "text-sm font-medium text-slate-700 mb-3", children: "Team Logo" }),
      /* @__PURE__ */ s.jsx(
        tc,
        {
          currentUrl: e.logo_url,
          name: e.name,
          onUpload: b,
          onDelete: e.logo_url ? k : void 0,
          isLoading: d,
          error: c,
          size: "xl",
          variant: "team-logo"
        }
      )
    ] }),
    /* @__PURE__ */ s.jsxs("form", { onSubmit: h, className: "space-y-4 mb-6", children: [
      /* @__PURE__ */ s.jsxs(Q, { children: [
        /* @__PURE__ */ s.jsx(J, { htmlFor: "teamName", children: "Team Name" }),
        /* @__PURE__ */ s.jsx(
          re,
          {
            id: "teamName",
            type: "text",
            value: t,
            onChange: (C) => u(C.target.value),
            className: "px-4 py-2",
            placeholder: "My Team"
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs(
        S,
        {
          type: "submit",
          variant: "primary",
          className: "flex items-center gap-2",
          disabled: i || t === e.name,
          children: [
            /* @__PURE__ */ s.jsx(Xl, { className: "w-4 h-4" }),
            i ? "Saving..." : "Save Team Name"
          ]
        }
      )
    ] }),
    g && /* @__PURE__ */ s.jsxs("div", { className: "pt-6 border-t border-slate-200 space-y-4", children: [
      r && /* @__PURE__ */ s.jsx(
        hj,
        {
          transfer: r,
          onResend: p,
          onCancel: y,
          isResending: o,
          isCancelling: l
        }
      ),
      /* @__PURE__ */ s.jsxs("div", { children: [
        /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-slate-900 mb-2", children: "Transfer Ownership" }),
        /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-3", children: "Transfer this team to another member. You will become an admin." }),
        /* @__PURE__ */ s.jsxs(
          S,
          {
            variant: "outline",
            onClick: m,
            className: "flex items-center gap-2",
            disabled: a.length <= 1 || !!r,
            children: [
              /* @__PURE__ */ s.jsx(It, { className: "w-4 h-4" }),
              "Transfer Ownership"
            ]
          }
        ),
        a.length <= 1 && /* @__PURE__ */ s.jsx("p", { className: "text-xs text-slate-500 mt-2", children: "You need at least one other team member to transfer ownership." })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "pt-4 border-t border-slate-200", children: [
        /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-red-600 mb-2", children: "Delete Team" }),
        /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-3", children: "Permanently delete this team and all its data. This action cannot be undone." }),
        /* @__PURE__ */ s.jsxs(
          S,
          {
            variant: "outline",
            onClick: x,
            className: "flex items-center gap-2 border-red-500 text-red-600 hover:bg-red-500/10",
            children: [
              /* @__PURE__ */ s.jsx(Ze, { className: "w-4 h-4" }),
              "Delete Team"
            ]
          }
        )
      ] })
    ] }),
    !g && e && /* @__PURE__ */ s.jsxs("div", { className: "pt-6 border-t border-slate-200", children: [
      /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-amber-600 mb-2", children: "Leave Team" }),
      /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mb-3", children: "Leave this team. You will no longer have access to team resources." }),
      /* @__PURE__ */ s.jsxs(
        S,
        {
          variant: "outline",
          onClick: f,
          className: "flex items-center gap-2 border-amber-500 text-amber-600 hover:bg-amber-500/10",
          children: [
            /* @__PURE__ */ s.jsx(yt, { className: "w-4 h-4" }),
            "Leave Team"
          ]
        }
      )
    ] })
  ] });
}
function fj({
  subscription: e,
  onDeleteAccount: t
}) {
  return /* @__PURE__ */ s.jsxs("section", { className: "bg-red-50 border border-red-200 rounded-2xl p-6", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
      /* @__PURE__ */ s.jsx(Ze, { className: "w-6 h-6 text-red-600" }),
      /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900", children: "Danger Zone" })
    ] }),
    (e == null ? void 0 : e.status) === "active" ? /* @__PURE__ */ s.jsxs("p", { className: "text-slate-700 mb-6", children: [
      "Your account will be deleted after your subscription ends on",
      " ",
      /* @__PURE__ */ s.jsx("span", { className: "font-medium", children: e.current_period_end && new Date(e.current_period_end).toLocaleDateString(
        "en-US",
        { month: "long", day: "numeric", year: "numeric" }
      ) }),
      ". You'll have full access until then."
    ] }) : /* @__PURE__ */ s.jsx("p", { className: "text-slate-700 mb-6", children: "Once you delete your account, there is no going back. Please be certain." }),
    /* @__PURE__ */ s.jsx(
      S,
      {
        variant: "outline",
        onClick: t,
        className: "border-red-500 text-red-600 hover:bg-red-500/10",
        children: "Delete Account"
      }
    )
  ] });
}
function xj({
  scheduledDate: e,
  subscription: t,
  onCancel: n
}) {
  return /* @__PURE__ */ s.jsx("section", { className: "bg-yellow-50 border border-yellow-300 rounded-2xl p-6", children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-4", children: [
    /* @__PURE__ */ s.jsx("div", { className: "w-10 h-10 bg-yellow-500/20 rounded-lg flex items-center justify-center flex-shrink-0", children: /* @__PURE__ */ s.jsx(Ze, { className: "w-5 h-5 text-yellow-600" }) }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ s.jsx("h3", { className: "font-semibold text-yellow-800 mb-1", children: "Account Scheduled for Deletion" }),
      (t == null ? void 0 : t.status) === "active" && t.current_period_end ? /* @__PURE__ */ s.jsxs("p", { className: "text-yellow-700 text-sm mb-3", children: [
        "Your account will be deleted after your subscription ends on",
        " ",
        /* @__PURE__ */ s.jsx("span", { className: "font-medium", children: new Date(t.current_period_end).toLocaleDateString(
          "en-US",
          { month: "long", day: "numeric", year: "numeric" }
        ) }),
        ". You'll have full access until then."
      ] }) : /* @__PURE__ */ s.jsxs("p", { className: "text-yellow-700 text-sm mb-3", children: [
        "Your account is scheduled for deletion on",
        " ",
        /* @__PURE__ */ s.jsx("span", { className: "font-medium", children: new Date(e).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric"
        }) }),
        "."
      ] }),
      /* @__PURE__ */ s.jsx(
        S,
        {
          variant: "outline",
          size: "sm",
          onClick: n,
          className: "border-yellow-500 text-yellow-700 hover:bg-yellow-100",
          children: "Cancel Deletion"
        }
      )
    ] })
  ] }) });
}
function pj({
  marketingConsent: e,
  onUpdateConsent: t
}) {
  const [n, a] = j(
    e
  ), [r, i] = j(!1), o = async () => {
    const l = !n;
    i(!0);
    try {
      await t(l), a(l);
    } finally {
      i(!1);
    }
  };
  return /* @__PURE__ */ s.jsxs("section", { className: "bg-white border border-slate-200 rounded-2xl shadow-sm p-6", children: [
    /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-6", children: [
      /* @__PURE__ */ s.jsx(Xt, { className: "w-6 h-6 text-slate-600" }),
      /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900", children: "Email Preferences" })
    ] }),
    /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 mb-6", children: "Manage your email notification settings" }),
    /* @__PURE__ */ s.jsx("div", { className: "space-y-4", children: /* @__PURE__ */ s.jsxs("label", { className: "flex items-center justify-between p-4 bg-slate-50 rounded-lg cursor-pointer hover:bg-slate-100 transition-colors", children: [
      /* @__PURE__ */ s.jsxs("div", { className: "flex-1", children: [
        /* @__PURE__ */ s.jsx("p", { className: "font-medium text-slate-900", children: "Product updates and announcements" }),
        /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500 mt-1", children: "Receive emails about new features, improvements, and company news" })
      ] }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          type: "button",
          role: "switch",
          "aria-checked": n,
          disabled: r,
          onClick: o,
          className: `
              relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent
              transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2
              ${n ? "bg-accent-600" : "bg-slate-200"}
              ${r ? "opacity-50 cursor-not-allowed" : ""}
            `,
          children: /* @__PURE__ */ s.jsx(
            "span",
            {
              className: `
                pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0
                transition duration-200 ease-in-out
                ${n ? "translate-x-5" : "translate-x-0"}
              `
            }
          )
        }
      )
    ] }) })
  ] });
}
function Wv({
  teamId: e,
  user: t,
  productSlug: n,
  header: a,
  navigation: r,
  planUsageCard: i,
  transformUsage: o,
  pricingPath: l = "/pricing",
  onUserUpdate: d,
  api: c,
  apiKeyPermissions: u,
  onToast: h,
  onError: m
}) {
  const x = Be(), [f, p] = j(!0), [y, b] = j(!1), [k, g] = j(!1), [v, C] = j(!1), [w, D] = j(null), [P, $] = j(
    (t == null ? void 0 : t.avatar_url) ?? null
  ), [I, V] = j(!1), [H, K] = j(null), [U, te] = j((t == null ? void 0 : t.name) || ""), [ne, se] = j(null), [A, z] = j(
    null
  ), [R, N] = j([]), [L, M] = j(
    null
  ), [F, G] = j(!1), [q, Z] = j(!1), [ge, _e] = j(null), [E, ie] = j(null), [je, oe] = j(!1), [ze, ce] = j(!1), [Re, kt] = j(!1), [Is, $r] = j(!1), [Ud, Tn] = j(!1), [qd, Ir] = j(!1), [Hd, Sn] = j(!1), [Wd, Or] = j(!1), [Kd, An] = j(!1), [Yd, Pn] = j(!1), [Gd, Vr] = j(!1), [Xd, En] = j(null), [Jd, Br] = j(null), [Zd, Rn] = j(!1), [Qd, zr] = j(!1), [eu, Ur] = j(!1), [tu, qr] = j(!1), [su, Hr] = j(!1), [Ct, Os] = j(null), [Wr, nu] = j([]), [Kr, au] = j(null), [Dn, Yr] = j(""), [ru, Gr] = j(!1), [iu, _n] = j(!1), [ou, Mn] = j(!1), [lu, Fn] = j(!1), [cu, Xr] = j(!1), [du, Jr] = j(!1), [uu, Zr] = j(!1), [hu, Vs] = j(null), [mu, Qr] = j(!1), [fu, ei] = j(!1), Y = (O, B) => {
    h == null || h(O, B);
  }, ye = (O) => m ? m(O) : O instanceof Error ? O.message : "An error occurred";
  le(() => {
    (async () => {
      if (e) {
        p(!0);
        try {
          const [
            B,
            fe,
            Bs,
            Bu,
            si,
            ni
          ] = await Promise.all([
            c.listApiKeys(e),
            c.getUsage(e),
            c.getSubscription(e),
            c.getProfile(),
            c.getTeam(e),
            c.getMembers(e)
          ]);
          N(B.keys), se(fe), z(Bs), ie(Bu), Os(si), Yr(si.name), nu(ni.members);
          const Ln = ni.members.find(
            ($n) => $n.user_id === (t == null ? void 0 : t.id)
          );
          if (Ln && (au(Ln.role), Ln.role === "owner"))
            try {
              const $n = await c.getPendingTransfer(e);
              Vs($n);
            } catch {
              Vs(null);
            }
        } catch (B) {
          console.error("Failed to load user data:", B), Y("Failed to load account settings", "error");
        } finally {
          p(!1);
        }
      }
    })();
  }, [e, t == null ? void 0 : t.id]);
  const xu = async (O) => {
    O.preventDefault(), b(!0);
    try {
      await c.updateProfile({ name: U }), Y("Profile updated successfully!", "success");
    } catch (B) {
      Y(ye(B), "error");
    } finally {
      b(!1);
    }
  }, pu = async () => {
    if (t != null && t.email) {
      g(!0);
      try {
        await c.forgotPassword(t.email), Y("Password reset email sent! Check your inbox.", "success");
      } catch (O) {
        Y(ye(O), "error");
      } finally {
        g(!1);
      }
    }
  }, gu = async (O) => {
    if (c.uploadAvatar) {
      C(!0), D(null);
      try {
        const B = await c.uploadAvatar(O);
        $(`${B.avatar_url}?t=${Date.now()}`), Y("Avatar updated successfully!", "success"), d == null || d();
      } catch (B) {
        const fe = ye(B);
        D(fe), Y(fe, "error");
      } finally {
        C(!1);
      }
    }
  }, yu = async () => {
    if (c.deleteAvatar) {
      C(!0), D(null);
      try {
        await c.deleteAvatar(), $(null), Y("Avatar removed successfully!", "success"), d == null || d();
      } catch (O) {
        const B = ye(O);
        D(B), Y(B, "error");
      } finally {
        C(!1);
      }
    }
  }, bu = async (O) => {
    if (!(!c.uploadTeamLogo || !e)) {
      V(!0), K(null);
      try {
        const fe = `${(await c.uploadTeamLogo(e, O)).logo_url}?t=${Date.now()}`;
        Os((Bs) => Bs ? { ...Bs, logo_url: fe } : null), Y("Team logo updated successfully!", "success");
      } catch (B) {
        const fe = ye(B);
        K(fe), Y(fe, "error");
      } finally {
        V(!1);
      }
    }
  }, ju = async () => {
    if (!(!c.deleteTeamLogo || !e)) {
      V(!0), K(null);
      try {
        await c.deleteTeamLogo(e), Os((O) => O ? { ...O, logo_url: null } : null), Y("Team logo removed successfully!", "success");
      } catch (O) {
        const B = ye(O);
        K(B), Y(B, "error");
      } finally {
        V(!1);
      }
    }
  }, vu = () => {
    L && (navigator.clipboard.writeText(L), G(!0), setTimeout(() => G(!1), 2e3), Y("API key copied to clipboard", "success"));
  }, wu = (O) => {
    _e(O), Z(!0);
  }, Nu = async () => {
    if (!(!ge || !e))
      try {
        await c.revokeApiKey(e, ge), N((O) => O.filter((B) => B.id !== ge)), Y("API key revoked successfully", "success");
      } catch (O) {
        Y(ye(O), "error");
      } finally {
        Z(!1), _e(null);
      }
  }, ku = async (O) => {
    if (e)
      try {
        const B = await c.createApiKey(e, O);
        M(B.key), N((fe) => [
          ...fe,
          {
            id: B.id,
            key_prefix: B.key_prefix,
            name: B.name,
            permissions: B.permissions,
            expires_at: B.expires_at,
            created_at: B.created_at,
            last_used_at: null,
            is_active: !0
          }
        ]), G(!1), Y("API key created! Make sure to copy it now.", "success");
      } catch (B) {
        Y(ye(B), "error");
      }
  }, Cu = async (O) => {
    ce(!0);
    try {
      if (ti && (A == null ? void 0 : A.status) === "active" && A.current_period_end && e) {
        await c.cancelSubscription(e), await c.deactivateAccount({
          soft_delete_at: A.current_period_end
        });
        const [B, fe] = await Promise.all([
          c.getProfile(),
          c.getSubscription(e)
        ]);
        ie(B), z(fe), Y(
          "Subscription cancelled. Account scheduled for deletion at end of billing period.",
          "success"
        ), oe(!1);
      } else
        await c.leaveProduct(n), c.logout("/farewell?type=product");
    } catch (B) {
      Y(ye(B), "error");
    } finally {
      ce(!1);
    }
  }, Tu = async (O) => {
    if (O.length < 8) {
      Y("Password must be at least 8 characters", "error");
      return;
    }
    $r(!0);
    try {
      await c.setPassword({ password: O }), Y("Password set successfully!", "success"), kt(!1);
      const B = await c.getProfile();
      ie(B);
    } catch (B) {
      Y(ye(B), "error");
    } finally {
      $r(!1);
    }
  }, Su = async (O) => {
    Ir(!0);
    try {
      await c.disconnectOAuth({ password: O }), Y("Social account disconnected!", "success"), Tn(!1);
      const B = await c.getProfile();
      ie(B);
    } catch (B) {
      Y(ye(B), "error");
    } finally {
      Ir(!1);
    }
  }, Au = async (O, B) => {
    if (c.requestEmailChange) {
      Or(!0);
      try {
        await c.requestEmailChange({ new_email: O, password: B }), Y(
          "Verification email sent! Check your new email address.",
          "success"
        ), Sn(!1);
      } catch (fe) {
        Y(ye(fe), "error");
      } finally {
        Or(!1);
      }
    }
  }, Pu = async () => {
    zr(!0);
    try {
      const O = await c.setup2FA();
      En(O), An(!0);
    } catch (O) {
      Y(ye(O), "error");
    } finally {
      zr(!1);
    }
  }, Eu = async (O) => {
    if (!O || O.length !== 6) {
      Y("Please enter a 6-digit code", "error");
      return;
    }
    Ur(!0);
    try {
      await c.enable2FA({ code: O }), Y("Two-factor authentication enabled!", "success"), Rn(!0);
      const B = await c.getProfile();
      ie(B);
    } catch (B) {
      Y(ye(B), "error");
    } finally {
      Ur(!1);
    }
  }, Ru = async (O, B) => {
    qr(!0);
    try {
      await c.disable2FA({ password: O, code: B }), Y("Two-factor authentication disabled!", "success"), Pn(!1);
      const fe = await c.getProfile();
      ie(fe);
    } catch (fe) {
      Y(ye(fe), "error");
    } finally {
      qr(!1);
    }
  }, Du = async (O, B) => {
    Hr(!0);
    try {
      const fe = await c.regenerateBackupCodes({ password: O, code: B });
      Br(fe.backup_codes), Y("Backup codes regenerated successfully", "success");
    } catch (fe) {
      Y(ye(fe), "error");
    } finally {
      Hr(!1);
    }
  }, _u = async (O) => {
    if (O.preventDefault(), !(!e || !Dn.trim())) {
      Gr(!0);
      try {
        const B = await c.updateTeam(e, {
          name: Dn.trim()
        });
        Os(B), Y("Team name updated successfully!", "success");
      } catch (B) {
        Y(ye(B), "error");
      } finally {
        Gr(!1);
      }
    }
  }, Mu = async (O) => {
    if (e) {
      Xr(!0);
      try {
        await c.transferOwnership(e, { new_owner_id: O }), Y(
          "Transfer request sent! The new owner will receive an email to accept.",
          "success"
        ), _n(!1);
        const B = await c.getPendingTransfer(e);
        Vs(B);
      } catch (B) {
        Y(ye(B), "error");
      } finally {
        Xr(!1);
      }
    }
  }, Fu = async () => {
    if (e) {
      Qr(!0);
      try {
        await c.resendTransferEmail(e), Y("Transfer email resent!", "success");
      } catch (O) {
        Y(ye(O), "error");
      } finally {
        Qr(!1);
      }
    }
  }, Lu = async () => {
    if (e) {
      ei(!0);
      try {
        await c.cancelPendingTransfer(e), Y("Transfer cancelled", "success"), Vs(null);
      } catch (O) {
        Y(ye(O), "error");
      } finally {
        ei(!1);
      }
    }
  }, $u = async (O) => {
    if (e) {
      Jr(!0);
      try {
        await c.deleteTeam(e), Y("Team deleted successfully", "success"), x("/"), c.logout();
      } catch (B) {
        Y(ye(B), "error");
      } finally {
        Jr(!1), Mn(!1);
      }
    }
  }, Iu = async () => {
    if (e) {
      Zr(!0);
      try {
        const O = await c.leaveTeam(e);
        Y(O.message, "success"), x("/"), window.location.reload();
      } catch (O) {
        Y(ye(O), "error");
      } finally {
        Zr(!1), Fn(!1);
      }
    }
  }, Ou = async () => {
    try {
      await c.cancelDeactivation();
      const O = await c.getProfile();
      ie(O), Y("Account deletion cancelled", "success");
    } catch {
      Y("Failed to cancel deletion", "error");
    }
  }, Vu = async () => {
    if (e)
      try {
        const O = await c.getPortalUrl(e);
        window.location.href = O;
      } catch {
        Y("Failed to open billing portal", "error");
      }
  }, ti = Kr === "owner";
  return f ? /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-slate-50", children: [
    a,
    r,
    /* @__PURE__ */ s.jsx(Ve, { className: "py-8", children: /* @__PURE__ */ s.jsx("div", { className: "max-w-3xl mx-auto space-y-8", children: [...Array(4)].map((O, B) => /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: "bg-white border border-slate-200 rounded-2xl shadow-sm p-6",
        children: [
          /* @__PURE__ */ s.jsx(Oe, { className: "h-8 w-48 mb-6" }),
          /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
            /* @__PURE__ */ s.jsx(Oe, { className: "h-10 w-full" }),
            /* @__PURE__ */ s.jsx(Oe, { className: "h-10 w-full" })
          ] })
        ]
      },
      B
    )) }) })
  ] }) : /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-slate-50", children: [
    a,
    r,
    /* @__PURE__ */ s.jsx(Ve, { className: "py-8", children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-3xl mx-auto space-y-8", children: [
      (E == null ? void 0 : E.soft_delete_scheduled_at) && /* @__PURE__ */ s.jsx(
        xj,
        {
          scheduledDate: E.soft_delete_scheduled_at,
          subscription: A,
          onCancel: Ou
        }
      ),
      ti && ne && i && (() => {
        const O = o ? o(ne, A) : {
          primaryUsage: {
            current: ne.emails_this_month ?? 0,
            max: ne.max_emails_monthly ?? 0,
            unit: "emails"
          },
          usageMetrics: [
            {
              label: "Emails This Month",
              value: ne.emails_this_month ?? 0
            }
          ]
        };
        return i({
          planName: A != null && A.plan && (A.status === "active" || A.status === "trialing") ? A.plan.display_name : "Free",
          planPrice: A != null && A.plan && (A.status === "active" || A.status === "trialing") ? parseFloat(A.plan.price_monthly) : 0,
          status: (A == null ? void 0 : A.status) || "none",
          cancelAtPeriodEnd: A == null ? void 0 : A.cancel_at_period_end,
          periodEnd: A == null ? void 0 : A.current_period_end,
          primaryUsage: O.primaryUsage,
          usageMetrics: O.usageMetrics,
          onUpgrade: () => x(`/t/${e}${l}`),
          onManageBilling: (A == null ? void 0 : A.status) === "active" ? Vu : void 0
        });
      })(),
      /* @__PURE__ */ s.jsx(
        Qb,
        {
          apiKeys: R,
          newlyGeneratedKey: L,
          copied: F,
          onCopyKey: vu,
          onCreateKey: ku,
          onRevokeKey: wu,
          availablePermissions: u
        }
      ),
      /* @__PURE__ */ s.jsx(
        Zb,
        {
          name: U,
          email: t == null ? void 0 : t.email,
          avatarUrl: P,
          hasPassword: E == null ? void 0 : E.has_password,
          isSaving: y,
          isRequestingPasswordReset: k,
          isAvatarLoading: v,
          avatarError: w,
          onNameChange: te,
          onSave: xu,
          onChangePassword: pu,
          onChangeEmail: c.requestEmailChange ? () => Sn(!0) : void 0,
          onAvatarUpload: c.uploadAvatar ? gu : void 0,
          onAvatarDelete: c.deleteAvatar ? yu : void 0
        }
      ),
      c.updateConsent && /* @__PURE__ */ s.jsx(
        pj,
        {
          marketingConsent: (t == null ? void 0 : t.marketing_consent) ?? !1,
          onUpdateConsent: async (O) => {
            await c.updateConsent(O), Y("Email preferences updated", "success");
          }
        }
      ),
      /* @__PURE__ */ s.jsx(
        ej,
        {
          userProfile: E,
          onSetPassword: () => kt(!0),
          onDisconnect: () => Tn(!0)
        }
      ),
      /* @__PURE__ */ s.jsx(
        tj,
        {
          isEnabled: E == null ? void 0 : E.totp_enabled,
          isSettingUp: Qd,
          onSetup: Pu,
          onDisable: () => Pn(!0),
          onRegenerateBackupCodes: () => Vr(!0)
        }
      ),
      /* @__PURE__ */ s.jsx(
        mj,
        {
          team: Ct,
          teamName: Dn,
          currentUserRole: Kr,
          teamMembers: Wr,
          pendingTransfer: hu,
          isSavingTeam: ru,
          isResending: mu,
          isCancelling: fu,
          isLogoLoading: I,
          logoError: H,
          onTeamNameChange: Yr,
          onSaveTeamName: _u,
          onTransferOwnership: () => _n(!0),
          onDeleteTeam: () => Mn(!0),
          onLeaveTeam: () => Fn(!0),
          onResendTransfer: Fu,
          onCancelTransfer: Lu,
          onLogoUpload: c.uploadTeamLogo ? bu : void 0,
          onLogoDelete: c.deleteTeamLogo ? ju : void 0
        }
      ),
      /* @__PURE__ */ s.jsx(
        fj,
        {
          subscription: A,
          onDeleteAccount: () => oe(!0)
        }
      )
    ] }) }),
    /* @__PURE__ */ s.jsx(
      ws,
      {
        isOpen: q,
        onClose: () => Z(!1),
        onConfirm: Nu,
        title: "Revoke API Key",
        message: "This will permanently revoke this API key. Any applications using this key will stop working immediately. This action cannot be undone.",
        confirmText: "Revoke",
        variant: "danger"
      }
    ),
    /* @__PURE__ */ s.jsx(
      sj,
      {
        isOpen: je,
        onClose: () => oe(!1),
        onConfirm: Cu,
        hasActiveSubscription: (A == null ? void 0 : A.status) === "active",
        subscriptionEndDate: A == null ? void 0 : A.current_period_end,
        isLoading: ze
      }
    ),
    /* @__PURE__ */ s.jsx(
      nj,
      {
        isOpen: Re,
        onClose: () => kt(!1),
        onSubmit: Tu,
        isLoading: Is
      }
    ),
    /* @__PURE__ */ s.jsx(
      aj,
      {
        isOpen: Ud,
        onClose: () => Tn(!1),
        onConfirm: Su,
        provider: E == null ? void 0 : E.oauth_provider,
        isLoading: qd
      }
    ),
    /* @__PURE__ */ s.jsx(
      rj,
      {
        isOpen: Kd,
        onClose: () => {
          An(!1), En(null), Rn(!1);
        },
        onEnable: Eu,
        setup: Xd,
        isEnabling: eu,
        showSuccessView: Zd,
        onDone: () => {
          An(!1), En(null), Rn(!1);
        }
      }
    ),
    /* @__PURE__ */ s.jsx(
      ij,
      {
        isOpen: Yd,
        onClose: () => Pn(!1),
        onDisable: Ru,
        isLoading: tu
      }
    ),
    /* @__PURE__ */ s.jsx(
      oj,
      {
        isOpen: Gd,
        onClose: () => {
          Vr(!1), Br(null);
        },
        onRegenerate: Du,
        regeneratedCodes: Jd,
        isLoading: su
      }
    ),
    /* @__PURE__ */ s.jsx(
      lj,
      {
        isOpen: iu,
        onClose: () => _n(!1),
        onTransfer: Mu,
        members: Wr,
        currentUserId: t == null ? void 0 : t.id,
        isLoading: cu
      }
    ),
    /* @__PURE__ */ s.jsx(
      cj,
      {
        isOpen: ou,
        onClose: () => Mn(!1),
        onDelete: $u,
        teamName: Ct == null ? void 0 : Ct.name,
        isLoading: du
      }
    ),
    /* @__PURE__ */ s.jsx(
      dj,
      {
        isOpen: lu,
        onClose: () => Fn(!1),
        onLeave: Iu,
        teamName: Ct == null ? void 0 : Ct.name,
        isLoading: uu
      }
    ),
    /* @__PURE__ */ s.jsx(
      uj,
      {
        isOpen: Hd,
        onClose: () => Sn(!1),
        onSubmit: Au,
        currentEmail: (t == null ? void 0 : t.email) || "",
        isLoading: Wd
      }
    )
  ] });
}
function Kv({
  productName: e,
  header: t,
  footer: n,
  onSubmit: a,
  turnstileSiteKey: r,
  TurnstileComponent: i,
  description: o,
  infoCards: l,
  backLink: d = "/",
  dashboardLink: c,
  className: u = "",
  user: h
}) {
  const m = !!(h != null && h.email), x = m && c || d, f = m ? "Back to Dashboard" : "Back to home", [p, y] = j({
    name: (h == null ? void 0 : h.name) || "",
    email: (h == null ? void 0 : h.email) || "",
    subject: "",
    message: ""
  }), [b, k] = j("idle"), [g, v] = j(null), C = We(null), w = r && i, D = async (V) => {
    var H;
    if (V.preventDefault(), w && !g) {
      k("error");
      return;
    }
    k("sending");
    try {
      a && await a(p, g || void 0), k("success"), y({
        name: (h == null ? void 0 : h.name) || "",
        email: (h == null ? void 0 : h.email) || "",
        subject: "",
        message: ""
      }), v(null), (H = C.current) == null || H.reset(), setTimeout(() => k("idle"), 5e3);
    } catch {
      k("error");
    }
  }, P = (V) => {
    v(V);
  }, $ = () => {
    v(null);
  }, I = (V) => {
    y((H) => ({
      ...H,
      [V.target.name]: V.target.value
    }));
  };
  return /* @__PURE__ */ s.jsxs("div", { className: `min-h-screen bg-white ${u}`, children: [
    t,
    /* @__PURE__ */ s.jsx("main", { className: "pt-32 pb-20", children: /* @__PURE__ */ s.jsx(Ve, { children: /* @__PURE__ */ s.jsxs(
      Ft.div,
      {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 },
        children: [
          /* @__PURE__ */ s.jsxs(
            _,
            {
              to: x,
              className: "inline-flex items-center gap-2 text-accent-600 hover:text-accent-700 transition-colors mb-8",
              children: [
                /* @__PURE__ */ s.jsx(rt, { className: "w-5 h-5" }),
                f
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: "text-center mb-16", children: [
            /* @__PURE__ */ s.jsx("h1", { className: "text-4xl sm:text-5xl font-bold mb-4 text-slate-900", children: "Get in Touch" }),
            /* @__PURE__ */ s.jsx("p", { className: "text-xl text-slate-600 max-w-2xl mx-auto", children: o || `Have questions about ${e}? We'd love to hear from you. Send us a message and we'll respond as soon as possible.` })
          ] }),
          /* @__PURE__ */ s.jsxs("div", { className: "grid md:grid-cols-2 gap-12 max-w-6xl mx-auto", children: [
            /* @__PURE__ */ s.jsx(
              Ft.div,
              {
                initial: { opacity: 0, x: -20 },
                animate: { opacity: 1, x: 0 },
                transition: { duration: 0.6, delay: 0.2 },
                children: /* @__PURE__ */ s.jsxs("div", { className: "bg-slate-50 border border-slate-200 rounded-2xl p-8", children: [
                  /* @__PURE__ */ s.jsx("h2", { className: "text-2xl font-bold text-slate-900 mb-6", children: "Send us a message" }),
                  /* @__PURE__ */ s.jsxs("form", { onSubmit: D, className: "space-y-6", children: [
                    /* @__PURE__ */ s.jsxs(Q, { children: [
                      /* @__PURE__ */ s.jsx(J, { htmlFor: "name", children: "Name" }),
                      /* @__PURE__ */ s.jsx(
                        re,
                        {
                          id: "name",
                          name: "name",
                          type: "text",
                          value: p.name,
                          onChange: I,
                          required: !0,
                          placeholder: "Your name",
                          className: "bg-white"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ s.jsxs(Q, { children: [
                      /* @__PURE__ */ s.jsx(J, { htmlFor: "email", children: "Email" }),
                      /* @__PURE__ */ s.jsx(
                        re,
                        {
                          id: "email",
                          name: "email",
                          type: "email",
                          value: p.email,
                          onChange: I,
                          required: !0,
                          placeholder: "you@example.com",
                          disabled: m,
                          className: m ? "bg-slate-100 cursor-not-allowed" : "bg-white"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ s.jsxs(Q, { children: [
                      /* @__PURE__ */ s.jsx(J, { htmlFor: "subject", children: "Subject" }),
                      /* @__PURE__ */ s.jsx(
                        re,
                        {
                          id: "subject",
                          name: "subject",
                          type: "text",
                          value: p.subject,
                          onChange: I,
                          required: !0,
                          placeholder: "What's this about?",
                          className: "bg-white"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ s.jsxs(Q, { children: [
                      /* @__PURE__ */ s.jsx(J, { htmlFor: "message", children: "Message" }),
                      /* @__PURE__ */ s.jsx(
                        "textarea",
                        {
                          id: "message",
                          name: "message",
                          value: p.message,
                          onChange: I,
                          required: !0,
                          rows: 6,
                          className: "form-input resize-none bg-white",
                          placeholder: "Tell us more..."
                        }
                      )
                    ] }),
                    b === "success" && /* @__PURE__ */ s.jsxs(Zt, { variant: "success", children: [
                      /* @__PURE__ */ s.jsx("span", { children: "Message sent successfully! We'll get back to you soon." }),
                      m && c && /* @__PURE__ */ s.jsx(
                        _,
                        {
                          to: c,
                          className: "block mt-2 text-sm font-medium text-green-700 hover:text-green-800 underline",
                          children: "Return to Dashboard →"
                        }
                      )
                    ] }),
                    b === "error" && /* @__PURE__ */ s.jsx(Zt, { variant: "error", children: w && !g ? "Please complete the captcha verification." : "Failed to send message. Please try again." }),
                    w && i && /* @__PURE__ */ s.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ s.jsx(
                      i,
                      {
                        ref: C,
                        siteKey: r,
                        onSuccess: P,
                        onExpire: $
                      }
                    ) }),
                    /* @__PURE__ */ s.jsxs(
                      S,
                      {
                        type: "submit",
                        variant: "primary",
                        size: "lg",
                        className: "w-full",
                        disabled: b === "sending",
                        children: [
                          /* @__PURE__ */ s.jsx(sf, { className: "w-5 h-5" }),
                          b === "sending" ? "Sending..." : "Send Message"
                        ]
                      }
                    )
                  ] })
                ] })
              }
            ),
            /* @__PURE__ */ s.jsx(
              Ft.div,
              {
                initial: { opacity: 0, x: 20 },
                animate: { opacity: 1, x: 0 },
                transition: { duration: 0.6, delay: 0.4 },
                className: "space-y-8",
                children: l || /* @__PURE__ */ s.jsxs("div", { className: "p-6 bg-slate-50 border border-slate-200 rounded-xl", children: [
                  /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-slate-900 mb-3", children: "Response Time" }),
                  /* @__PURE__ */ s.jsx("p", { className: "text-slate-600 text-sm leading-relaxed", children: "We typically respond within 24-48 hours during business days." })
                ] })
              }
            )
          ] })
        ]
      }
    ) }) }),
    n
  ] });
}
const cl = ({ className: e }) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    className: e,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    children: /* @__PURE__ */ s.jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M5 13l4 4L19 7" })
  }
), gj = ({ className: e }) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    className: e,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 10V3L4 14h7v7l9-11h-7z"
      }
    )
  }
), yj = ({ className: e }) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    className: e,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
      }
    )
  }
);
function Yv({
  teamId: e,
  backPath: t,
  backLabel: n = "Back",
  contactPath: a = "/contact",
  getPlans: r,
  getSubscription: i,
  getUsage: o,
  getCheckoutUrl: l,
  getPortalUrl: d,
  switchPlan: c,
  onToast: u,
  usageCard: h,
  faqItems: m,
  trustIndicators: x = [
    "Cancel anytime",
    "Secure payment via Stripe",
    "Instant activation"
  ]
}) {
  const [f, p] = Ee(), [y, b] = j(!0), [k, g] = j(!1), [v, C] = j([]), [w, D] = j(
    null
  ), [P, $] = j(null), I = We(!1), V = qe(async () => {
    try {
      const [A, z, R] = await Promise.all([
        r(),
        i(),
        o()
      ]);
      return C(A), D(z), $(R), z;
    } catch (A) {
      return console.error("Failed to load pricing data:", A), u == null || u("Failed to load pricing information", "error"), null;
    }
  }, [r, i, o, u]);
  le(() => {
    (async () => {
      b(!0), await V(), b(!1);
    })();
  }, [V]), le(() => {
    if (!(f.get("success") === "1") || y || I.current) return;
    I.current = !0, f.delete("success"), p(f, { replace: !0 }), u == null || u("Payment successful! Updating your plan...", "success");
    let z = 0;
    const R = 10, N = 1e3, L = async () => {
      z++;
      const M = await V();
      if (M && (M.status === "active" || M.status === "trialing") && M.plan.name !== "free" && M.plan.name !== "no_plan") {
        u == null || u(
          `You're now on the ${M.plan.display_name} plan!`,
          "success"
        );
        return;
      }
      z < R && setTimeout(L, N);
    };
    setTimeout(L, N);
  }, [y, V, u, f, p]);
  const H = () => w != null && w.plan && (w.status === "active" || w.status === "trialing") ? w.plan.name : "free", K = (A) => A.name === H(), U = (w == null ? void 0 : w.cancel_at_period_end) && w.status === "active", te = async (A) => {
    var z, R;
    if (K(A)) {
      if (U) {
        try {
          const N = await d();
          window.location.href = N;
        } catch {
          u == null || u("Failed to open billing portal", "error");
        }
        return;
      }
      u == null || u("You are already on this plan", "success");
      return;
    }
    if (A.name === "free") {
      if (w && w.status === "active")
        try {
          const N = await d();
          window.location.href = N;
        } catch {
          u == null || u("Failed to open billing portal", "error");
        }
      else
        u == null || u("You are already on the Free plan", "success");
      return;
    }
    if (w && w.status === "active" && w.plan.name !== "no_plan" && w.plan.name !== "free") {
      g(!0);
      try {
        const N = await c(A.name);
        u == null || u(N.message, "success");
        const [L, M] = await Promise.all([
          i(),
          o()
        ]);
        D(L), $(M);
      } catch (N) {
        const L = N;
        u == null || u(
          ((R = (z = L.response) == null ? void 0 : z.data) == null ? void 0 : R.detail) || "Failed to switch plan",
          "error"
        );
      } finally {
        g(!1);
      }
      return;
    }
    try {
      const N = await l(A.name);
      window.location.href = N;
    } catch {
      u == null || u("Failed to open checkout", "error");
    }
  }, ne = async () => {
    try {
      const A = await d();
      window.location.href = A;
    } catch {
      u == null || u("Failed to open billing portal", "error");
    }
  }, se = (A) => {
    if (K(A))
      return U ? "Reactivate" : "Current Plan";
    if (A.name === "free") return "Free Plan";
    if (w && w.status === "active" && w.plan.name !== "no_plan" && w.plan.name !== "free") {
      const z = parseFloat(w.plan.price_monthly);
      return parseFloat(A.price_monthly) > z ? "Upgrade" : "Downgrade";
    }
    return "Get Started";
  };
  return y ? /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-slate-50", children: [
    /* @__PURE__ */ s.jsx(Ei, { title: "Pricing", backTo: t, backLabel: n }),
    /* @__PURE__ */ s.jsx(Ve, { className: "py-8", children: /* @__PURE__ */ s.jsx("div", { className: "max-w-6xl mx-auto", children: /* @__PURE__ */ s.jsx("div", { className: "grid md:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center max-w-4xl mx-auto", children: [...Array(3)].map((A, z) => /* @__PURE__ */ s.jsxs(rn, { children: [
      /* @__PURE__ */ s.jsx(Oe, { className: "h-8 w-24 mb-4" }),
      /* @__PURE__ */ s.jsx(Oe, { className: "h-12 w-32 mb-4" }),
      /* @__PURE__ */ s.jsx(Oe, { className: "h-4 w-full mb-6" }),
      /* @__PURE__ */ s.jsx(Oe, { className: "h-10 w-full mb-6" }),
      /* @__PURE__ */ s.jsx("div", { className: "space-y-3", children: [...Array(5)].map((R, N) => /* @__PURE__ */ s.jsx(Oe, { className: "h-4 w-full" }, N)) })
    ] }, z)) }) }) })
  ] }) : /* @__PURE__ */ s.jsxs("div", { className: "min-h-screen bg-slate-50", children: [
    /* @__PURE__ */ s.jsx(
      Ei,
      {
        title: "Pricing",
        backTo: t,
        backLabel: n,
        action: w && (w.status === "active" || w.status === "trialing") && w.plan.name !== "no_plan" && w.plan.name !== "free" ? /* @__PURE__ */ s.jsxs(
          S,
          {
            variant: "outline",
            size: "sm",
            onClick: ne,
            className: "flex items-center gap-2",
            children: [
              /* @__PURE__ */ s.jsx(yj, { className: "w-4 h-4" }),
              "Manage Billing"
            ]
          }
        ) : void 0
      }
    ),
    /* @__PURE__ */ s.jsx(Ve, { className: "py-8", children: /* @__PURE__ */ s.jsxs("div", { className: "max-w-6xl mx-auto space-y-8", children: [
      P && h && h({ usage: P, subscription: w }),
      P && !h && /* @__PURE__ */ s.jsxs("div", { className: "bg-gradient-to-br from-accent-50 to-accent-100/50 border border-accent-200 rounded-2xl p-6", children: [
        /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-3 mb-4", children: [
          /* @__PURE__ */ s.jsx(gj, { className: "w-6 h-6 text-accent-600" }),
          /* @__PURE__ */ s.jsx("h2", { className: "text-xl font-bold text-slate-900", children: "Current Usage" }),
          /* @__PURE__ */ s.jsxs("span", { className: "px-3 py-1 bg-accent-100 text-accent-700 text-sm rounded-full font-medium", children: [
            w != null && w.plan && (w.status === "active" || w.status === "trialing") ? w.plan.display_name : "Free",
            " ",
            "Plan"
          ] })
        ] }),
        (w == null ? void 0 : w.current_period_end) && w.status === "active" && /* @__PURE__ */ s.jsxs("p", { className: "text-sm text-slate-500 mb-4", children: [
          "Renews",
          " ",
          new Date(
            w.current_period_end
          ).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric"
          })
        ] })
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: "text-center space-y-4", children: [
        /* @__PURE__ */ s.jsx("h2", { className: "text-3xl md:text-4xl font-bold text-slate-900", children: "Choose Your Plan" }),
        /* @__PURE__ */ s.jsx("p", { className: "text-slate-500 max-w-2xl mx-auto", children: "All plans include the same features. Choose based on your usage needs." })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: "grid md:grid-cols-2 lg:grid-cols-3 gap-6 justify-items-center max-w-4xl mx-auto", children: v.map((A) => {
        const z = K(A), R = A.recommended;
        return /* @__PURE__ */ s.jsxs(
          "div",
          {
            className: `relative w-full ${R ? "lg:scale-105" : ""}`,
            children: [
              (A.badge || z) && /* @__PURE__ */ s.jsx("div", { className: "absolute -top-3 left-1/2 -translate-x-1/2 z-10", children: /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: `px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide ${z ? U ? "bg-yellow-500 text-white shadow-lg shadow-yellow-500/50" : "bg-primary-500 text-white shadow-lg shadow-primary-500/50" : "bg-gradient-to-r from-primary-500 to-sky-600 text-white shadow-lg shadow-primary-500/50"}`,
                  children: z ? U ? "Cancelling" : "Current Plan" : A.badge
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: `relative h-full p-6 rounded-2xl border transition-all duration-300 shadow-sm ${z ? "bg-primary-500/10 border-primary-500/50" : R ? "bg-white border-accent-300 shadow-xl shadow-accent-500/10" : "bg-white border-slate-200 hover:border-slate-300"}`,
                  children: /* @__PURE__ */ s.jsxs("div", { className: "space-y-4", children: [
                    /* @__PURE__ */ s.jsx("h3", { className: "text-xl font-bold text-slate-900", children: A.display_name }),
                    /* @__PURE__ */ s.jsxs("div", { className: "flex items-baseline gap-1", children: [
                      /* @__PURE__ */ s.jsxs("span", { className: "text-4xl font-bold text-slate-900", children: [
                        "$",
                        parseFloat(A.price_monthly).toFixed(0)
                      ] }),
                      parseFloat(A.price_monthly) > 0 && /* @__PURE__ */ s.jsx("span", { className: "text-slate-500", children: "/mo" })
                    ] }),
                    A.description && /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: A.description }),
                    /* @__PURE__ */ s.jsx(
                      S,
                      {
                        variant: z && !U ? "outline" : R ? "primary" : "outline",
                        className: `w-full ${z && !U ? "cursor-default opacity-75" : ""}`,
                        onClick: () => te(A),
                        disabled: z && !U || k,
                        children: k && !z ? "Switching..." : se(A)
                      }
                    ),
                    /* @__PURE__ */ s.jsx("div", { className: "border-t border-slate-200" }),
                    A.features && /* @__PURE__ */ s.jsx("ul", { className: "space-y-2", children: A.features.map((N, L) => /* @__PURE__ */ s.jsxs("li", { className: "flex items-start gap-2", children: [
                      /* @__PURE__ */ s.jsx(
                        cl,
                        {
                          className: `w-4 h-4 mt-0.5 flex-shrink-0 ${R || z ? "text-accent-600" : "text-slate-500"}`
                        }
                      ),
                      /* @__PURE__ */ s.jsx("span", { className: "text-sm text-slate-700", children: N })
                    ] }, L)) })
                  ] })
                }
              )
            ]
          },
          A.id ?? A.name
        );
      }) }),
      x.length > 0 && /* @__PURE__ */ s.jsx("div", { className: "flex flex-wrap justify-center gap-6 text-sm text-slate-400 pt-4", children: x.map((A, z) => /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ s.jsx(cl, { className: "w-5 h-5 text-green-400" }),
        /* @__PURE__ */ s.jsx("span", { children: A })
      ] }, z)) }),
      m && m.length > 0 && /* @__PURE__ */ s.jsxs(rn, { children: [
        /* @__PURE__ */ s.jsx("h3", { className: "text-lg font-semibold text-slate-900 mb-4", children: "Frequently Asked Questions" }),
        /* @__PURE__ */ s.jsx("div", { className: "space-y-4", children: m.map((A, z) => /* @__PURE__ */ s.jsxs("div", { children: [
          /* @__PURE__ */ s.jsx("p", { className: "text-sm font-medium text-slate-900 mb-1", children: A.question }),
          /* @__PURE__ */ s.jsx("p", { className: "text-sm text-slate-500", children: A.answer })
        ] }, z)) })
      ] }),
      a && /* @__PURE__ */ s.jsx("div", { className: "text-center", children: /* @__PURE__ */ s.jsxs("p", { className: "text-slate-500 text-sm", children: [
        "Need a custom plan?",
        " ",
        /* @__PURE__ */ s.jsx(
          _,
          {
            to: a,
            className: "text-accent-600 hover:text-primary-300 underline",
            children: "Contact us"
          }
        ),
        " ",
        "for enterprise pricing."
      ] }) })
    ] }) })
  ] });
}
const Gv = "0.1.0";
export {
  hs as Accordion,
  ec as AccordionGroup,
  Ob as AccountDeletedPage,
  Wv as AccountSettingsPage,
  Wb as ActivateProductPage,
  zv as AdminRoute,
  Zt as Alert,
  by as AlertPreferencesSection,
  Fv as AlertProfileEditor,
  Mv as AlertProfileSelector,
  _v as AlertProfilesList,
  Dv as AlertSettingsCard,
  Go as AppHeader,
  Xo as AppNav,
  Dy as AppShell,
  Fd as AuthDivider,
  My as AuthLayout,
  Pi as Badge,
  Fy as BillingBanner,
  mv as Breadcrumbs,
  S as Button,
  Rv as CTASection,
  rn as Card,
  Ai as CardBody,
  Si as CardDescription,
  Jj as CardFooter,
  Ci as CardHeader,
  Ti as CardTitle,
  ws as ConfirmModal,
  Kv as ContactPage,
  Ve as Container,
  wv as CookieConsent,
  xv as DetailGrid,
  pv as DetailRow,
  yy as EmailRecipientsSection,
  Nb as EmailVerificationPage,
  lv as EmptyState,
  Xb as ErrorPage,
  Ev as FAQSection,
  dy as FadeIn,
  Lb as FarewellPage,
  Av as FeatureCard,
  bv as Footer,
  jb as ForgotPasswordPage,
  Xj as FormError,
  Q as FormField,
  et as FormHint,
  re as FormInput,
  J as FormLabel,
  Hm as FormTextarea,
  ua as Heading,
  gy as IntegrationModal,
  fy as IntegrationsList,
  zb as InviteAcceptPage,
  tv as LabelText,
  Bv as LegalList,
  $v as LegalPageLayout,
  Vv as LegalParagraph,
  Iv as LegalSection,
  Ov as LegalSubsection,
  yb as LoginPage,
  vn as Modal,
  nr as ModalFooter,
  qb as NoTeamsPage,
  Hb as NotFoundPage,
  mn as OAuthButton,
  Ei as PageHeader,
  gf as PageSpinner,
  Nv as PlanUsageCard,
  gv as PricingCard,
  Yv as PricingPage,
  Ld as ProtectedRoute,
  yv as PublicHeader,
  vy as QuietHoursSection,
  $b as ReactivateAccountPage,
  ca as RequestTimeoutError,
  vb as ResetPasswordPage,
  jv as RestrictedAction,
  vv as RestrictedButton,
  Uv as SaaSShell,
  Lv as SageChatWidget,
  cf as SearchInput,
  sc as Section,
  kv as SectionHeader,
  ev as SettingsItem,
  Qj as SettingsRow,
  Zj as SettingsSection,
  bb as SignupPage,
  Oe as Skeleton,
  wf as SkeletonAvatar,
  cv as SkeletonButton,
  dv as SkeletonCard,
  hv as SkeletonStatCard,
  uv as SkeletonTableRow,
  mt as SkeletonText,
  vf as SkeletonTitle,
  he as Spinner,
  Tv as StaggerContainer,
  Sv as StaggerItem,
  Nf as StatCard,
  fv as StatsSection,
  Pv as StepCard,
  sv as Table,
  av as TableBody,
  ov as TableCell,
  iv as TableHead,
  nv as TableHeader,
  rv as TableRow,
  Hv as TeamMembersPage,
  Ry as TeamSwitcher,
  fs as Text,
  zm as ThemeProvider,
  yf as Toggle,
  Ub as TransferAcceptPage,
  Ey as UserMenu,
  kb as VerifyEmailRequiredPage,
  $l as addRetryInterceptor,
  Vm as calculateGracePeriodEnd,
  Dm as configureTimeout,
  Lm as createApiClients,
  $m as createAuthApi,
  Uj as createAuthProvider,
  Gj as createBackendContactFormHandler,
  Im as createBillingApi,
  qj as createBillingProvider,
  Vj as createClientWithRetry,
  Yj as createContactFormHandler,
  Kj as createNotificationsApi,
  qm as createSupportApi,
  _m as createTokenManager,
  Wj as createUsersApi,
  Om as deriveRestrictions,
  Ll as extractErrorMessage,
  tt as getErrorMessage,
  Sm as isAxiosError,
  zj as isTimeoutError,
  Ne as useAuth,
  Ds as useBilling,
  qv as useSaaSContext,
  Hj as useTheme,
  Gv as version,
  Bj as withTimeout
};
